import { RESUME, PAUSE, HTTP_UNAUTHORIZED, LOGOUT, CALL_REFRESH, CALL_LOGOUT, REFRESH, PROMPTCLOSE } from '../hooks/timerHooks/constants/index.js';
import { _ as _objectSpread2$1, a as _typeof$1, b as _createForOfIteratorHelper, c as _toConsumableArray, d as _createClass, e as _classCallCheck$1, f as _asyncToGenerator, g as _objectWithoutProperties, h as _slicedToArray, i as _defineProperty$2 } from './_rollupPluginBabelHelpers-509d8909.js';
import { createContext, useEffect, useRef, useCallback, useState, useMemo } from 'react';

var fails = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var descriptors = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, {
    get: function () {
      return 7;
    }
  })[1] != 7;
});

var functionBindNative = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = function () {
    /* empty */
  }.bind(); // eslint-disable-next-line no-prototype-builtins -- safe


  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = functionBindNative && FunctionPrototype.bind.bind(call, call);
var functionUncurryThisRaw = functionBindNative ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};

var toString = functionUncurryThisRaw({}.toString);
var stringSlice = functionUncurryThisRaw(''.slice);

var classofRaw = function (it) {
  return stringSlice(toString(it), 8, -1);
};

var functionUncurryThis = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return functionUncurryThisRaw(fn);
};

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined = function (it) {
  return it === null || it === undefined;
};

var $TypeError = TypeError; // `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible

var requireObjectCoercible = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
  return it;
};

var $Object = Object; // `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject

var toObject = function (argument) {
  return $Object(requireObjectCoercible(argument));
};

var hasOwnProperty = functionUncurryThis({}.hasOwnProperty); // `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe

var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};

var FunctionPrototype$1 = Function.prototype; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

var getDescriptor = descriptors && Object.getOwnPropertyDescriptor;
var EXISTS = hasOwnProperty_1(FunctionPrototype$1, 'name'); // additional protection from minified / mangled / dropped function names

var PROPER = EXISTS && function something() {
  /* empty */
}.name === 'something';

var CONFIGURABLE = EXISTS && (!descriptors || descriptors && getDescriptor(FunctionPrototype$1, 'name').configurable);
var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var check = function (it) {
  return it && it.Math == Math && it;
}; // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028


var global_1 = // eslint-disable-next-line es/no-global-this -- safe
check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
check(typeof self == 'object' && self) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function () {
  return this;
}() || Function('return this')();

var documentAll = typeof document == 'object' && document.all; // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot

var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;
var documentAll_1 = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};

var documentAll$1 = documentAll_1.all; // `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable

var isCallable = documentAll_1.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll$1;
} : function (argument) {
  return typeof argument == 'function';
};

var documentAll$2 = documentAll_1.all;
var isObject = documentAll_1.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll$2;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};

var document$1 = global_1.document; // typeof document.createElement is 'object' in old IE

var EXISTS$1 = isObject(document$1) && isObject(document$1.createElement);

var documentCreateElement = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var ie8DomDefine = !descriptors && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function () {
      return 7;
    }
  }).a != 7;
});

// https://bugs.chromium.org/p/v8/issues/detail?id=3334

var v8PrototypeDefineBug = descriptors && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () {
    /* empty */
  }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var $String = String;
var $TypeError$1 = TypeError; // `Assert: Type(argument) is Object`

var anObject = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError$1($String(argument) + ' is not an object');
};

var call$1 = Function.prototype.call;
var functionCall = functionBindNative ? call$1.bind(call$1) : function () {
  return call$1.apply(call$1, arguments);
};

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

var getBuiltIn = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global_1[namespace]) : global_1[namespace] && global_1[namespace][method];
};

var objectIsPrototypeOf = functionUncurryThis({}.isPrototypeOf);

var engineUserAgent = getBuiltIn('navigator', 'userAgent') || '';

var process = global_1.process;
var Deno$1 = global_1.Deno;
var versions = process && process.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.'); // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us

  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
} // BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0


if (!version && engineUserAgent) {
  match = engineUserAgent.match(/Edge\/(\d+)/);

  if (!match || match[1] >= 74) {
    match = engineUserAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing

var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol(); // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances

  return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && engineV8Version && engineV8Version < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var useSymbolAsUid = symbolConstructorDetection && !Symbol.sham && typeof Symbol.iterator == 'symbol';

var $Object$1 = Object;
var isSymbol = useSymbolAsUid ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && objectIsPrototypeOf($Symbol.prototype, $Object$1(it));
};

var $String$1 = String;

var tryToString = function (argument) {
  try {
    return $String$1(argument);
  } catch (error) {
    return 'Object';
  }
};

var $TypeError$2 = TypeError; // `Assert: IsCallable(argument) is true`

var aCallable = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError$2(tryToString(argument) + ' is not a function');
};

// https://tc39.es/ecma262/#sec-getmethod

var getMethod = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};

var $TypeError$3 = TypeError; // `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive

var ordinaryToPrimitive = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = functionCall(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
  throw $TypeError$3("Can't convert object to primitive value");
};

var isPure = false;

var defineProperty = Object.defineProperty;

var defineGlobalProperty = function (key, value) {
  try {
    defineProperty(global_1, key, {
      value: value,
      configurable: true,
      writable: true
    });
  } catch (error) {
    global_1[key] = value;
  }

  return value;
};

var SHARED = '__core-js_shared__';
var store = global_1[SHARED] || defineGlobalProperty(SHARED, {});
var sharedStore = store;

var shared = createCommonjsModule(function (module) {
  (module.exports = function (key, value) {
    return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: '3.26.0',
    mode:  'global',
    copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
    license: 'https://github.com/zloirock/core-js/blob/v3.26.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
  });
});

var id = 0;
var postfix = Math.random();
var toString$1 = functionUncurryThis(1.0.toString);

var uid = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$1(++id + postfix, 36);
};

var WellKnownSymbolsStore = shared('wks');
var Symbol$1 = global_1.Symbol;
var symbolFor = Symbol$1 && Symbol$1['for'];
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

var wellKnownSymbol = function (name) {
  if (!hasOwnProperty_1(WellKnownSymbolsStore, name) || !(symbolConstructorDetection || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;

    if (symbolConstructorDetection && hasOwnProperty_1(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else if (useSymbolAsUid && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  }

  return WellKnownSymbolsStore[name];
};

var $TypeError$4 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive'); // `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive

var toPrimitive = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;

  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = functionCall(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError$4("Can't convert object to primitive value");
  }

  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

// https://tc39.es/ecma262/#sec-topropertykey

var toPropertyKey = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var $TypeError$5 = TypeError; // eslint-disable-next-line es/no-object-defineproperty -- safe

var $defineProperty = Object.defineProperty; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable'; // `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty

var f = descriptors ? v8PrototypeDefineBug ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);

  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);

    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  }

  return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) {
    /* empty */
  }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError$5('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};
var objectDefineProperty = {
  f: f
};

var FUNCTION_NAME_EXISTS = functionName.EXISTS;
var defineProperty$1 = objectDefineProperty.f;
var FunctionPrototype$2 = Function.prototype;
var functionToString = functionUncurryThis(FunctionPrototype$2.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = functionUncurryThis(nameRE.exec);
var NAME = 'name'; // Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name

if (descriptors && !FUNCTION_NAME_EXISTS) {
  defineProperty$1(FunctionPrototype$2, NAME, {
    configurable: true,
    get: function () {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}

var baseConfiguration = function baseConfiguration(config) {
  return _objectSpread2$1({
    timeout: 1000 * 60 * 10,
    eventsThrottle: 200,
    element: document,
    startOnMount: true,
    crossTab: true,
    syncTimers: 1,
    leaderElection: true,
    debounce: 1800,
    events: ['keydown', 'wheel', 'DOMMouseScroll', 'mousedown', 'mousewheel', 'touchstart', 'touchmove'],
    promptTimeout: 1000 * 60 * 3.5
  }, config);
};

var runtime_1 = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var runtime = function (exports) {

    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};

    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };

    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        prototype[method] = function (arg) {
          return this._invoke(method, arg);
        };
      });
    }

    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;

        if (!(toStringTagSymbol in genFun)) {
          genFun[toStringTagSymbol] = "GeneratorFunction";
        }
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return PromiseImpl.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);

    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };

    exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0) PromiseImpl = Promise;
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined$1) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    Gp[iteratorSymbol] = function () {
      return this;
    };

    Gp.toString = function () {
      return "[object Generator]";
    };

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    exports.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined$1;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    exports.values = values;

    function doneResult() {
      return {
        value: undefined$1,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function (skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function () {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function (exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined$1;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function (type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function (record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function (finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function (tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function (iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined$1;
        }

        return ContinueSentinel;
      }
    }; // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.

    return exports;
  }( // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports );

  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    Function("r", "regeneratorRuntime = r")(runtime);
  }
});

var $propertyIsEnumerable = {}.propertyIsEnumerable; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor; // Nashorn ~ JDK8 bug

var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
  1: 2
}, 1); // `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable

var f$1 = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;
var objectPropertyIsEnumerable = {
  f: f$1
};

var createPropertyDescriptor = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var $Object$2 = Object;
var split = functionUncurryThis(''.split); // fallback for non-array-like ES3 and non-enumerable old V8 strings

var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$2('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) == 'String' ? split(it, '') : $Object$2(it);
} : $Object$2;

var toIndexedObject = function (it) {
  return indexedObject(requireObjectCoercible(it));
};

var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor; // `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor

var f$2 = descriptors ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (ie8DomDefine) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) {
    /* empty */
  }
  if (hasOwnProperty_1(O, P)) return createPropertyDescriptor(!functionCall(objectPropertyIsEnumerable.f, O, P), O[P]);
};
var objectGetOwnPropertyDescriptor = {
  f: f$2
};

var createNonEnumerableProperty = descriptors ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var functionToString$1 = functionUncurryThis(Function.toString); // this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper

if (!isCallable(sharedStore.inspectSource)) {
  sharedStore.inspectSource = function (it) {
    return functionToString$1(it);
  };
}

var inspectSource = sharedStore.inspectSource;

var WeakMap$1 = global_1.WeakMap;
var weakMapBasicDetection = isCallable(WeakMap$1) && /native code/.test(String(WeakMap$1));

var keys = shared('keys');

var sharedKey = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys = {};

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = global_1.TypeError;
var WeakMap$2 = global_1.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;

    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    }

    return state;
  };
};

if (weakMapBasicDetection || sharedStore.state) {
  var store$1 = sharedStore.state || (sharedStore.state = new WeakMap$2());
  /* eslint-disable no-self-assign -- prototype methods protection */

  store$1.get = store$1.get;
  store$1.has = store$1.has;
  store$1.set = store$1.set;
  /* eslint-enable no-self-assign -- prototype methods protection */

  set = function (it, metadata) {
    if (store$1.has(it)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store$1.set(it, metadata);
    return metadata;
  };

  get = function (it) {
    return store$1.get(it) || {};
  };

  has = function (it) {
    return store$1.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;

  set = function (it, metadata) {
    if (hasOwnProperty_1(it, STATE)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };

  get = function (it) {
    return hasOwnProperty_1(it, STATE) ? it[STATE] : {};
  };

  has = function (it) {
    return hasOwnProperty_1(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var makeBuiltIn_1 = createCommonjsModule(function (module) {
  var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
  var enforceInternalState = internalState.enforce;
  var getInternalState = internalState.get; // eslint-disable-next-line es/no-object-defineproperty -- safe

  var defineProperty = Object.defineProperty;
  var CONFIGURABLE_LENGTH = descriptors && !fails(function () {
    return defineProperty(function () {
      /* empty */
    }, 'length', {
      value: 8
    }).length !== 8;
  });
  var TEMPLATE = String(String).split('String');

  var makeBuiltIn = module.exports = function (value, name, options) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }

    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;

    if (!hasOwnProperty_1(value, 'name') || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
      if (descriptors) defineProperty(value, 'name', {
        value: name,
        configurable: true
      });else value.name = name;
    }

    if (CONFIGURABLE_LENGTH && options && hasOwnProperty_1(options, 'arity') && value.length !== options.arity) {
      defineProperty(value, 'length', {
        value: options.arity
      });
    }

    try {
      if (options && hasOwnProperty_1(options, 'constructor') && options.constructor) {
        if (descriptors) defineProperty(value, 'prototype', {
          writable: false
        }); // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
      } else if (value.prototype) value.prototype = undefined;
    } catch (error) {
      /* empty */
    }

    var state = enforceInternalState(value);

    if (!hasOwnProperty_1(state, 'source')) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }

    return value;
  }; // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
  // eslint-disable-next-line no-extend-native -- required


  Function.prototype.toString = makeBuiltIn(function toString() {
    return isCallable(this) && getInternalState(this).source || inspectSource(this);
  }, 'toString');
});

var defineBuiltIn = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn_1(value, name, options);

  if (options.global) {
    if (simple) O[key] = value;else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];else if (O[key]) simple = true;
    } catch (error) {
      /* empty */
    }

    if (simple) O[key] = value;else objectDefineProperty.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  }

  return O;
};

var ceil = Math.ceil;
var floor = Math.floor; // `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe

var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

// https://tc39.es/ecma262/#sec-tointegerorinfinity

var toIntegerOrInfinity = function (argument) {
  var number = +argument; // eslint-disable-next-line no-self-compare -- NaN check

  return number !== number || number === 0 ? 0 : mathTrunc(number);
};

var max = Math.max;
var min = Math.min; // Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).

var toAbsoluteIndex = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

var min$1 = Math.min; // `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength

var toLength = function (argument) {
  return argument > 0 ? min$1(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

// https://tc39.es/ecma262/#sec-lengthofarraylike

var lengthOfArrayLike = function (obj) {
  return toLength(obj.length);
};

var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value; // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check

    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++]; // eslint-disable-next-line no-self-compare -- NaN check

      if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    }
    return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var indexOf = arrayIncludes.indexOf;
var push = functionUncurryThis([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;

  for (key in O) !hasOwnProperty_1(hiddenKeys, key) && hasOwnProperty_1(O, key) && push(result, key); // Don't enum bug & hidden keys


  while (names.length > i) if (hasOwnProperty_1(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }

  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];

var hiddenKeys$1 = enumBugKeys.concat('length', 'prototype'); // `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe

var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal(O, hiddenKeys$1);
};

var objectGetOwnPropertyNames = {
  f: f$3
};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var f$4 = Object.getOwnPropertySymbols;
var objectGetOwnPropertySymbols = {
  f: f$4
};

var concat = functionUncurryThis([].concat); // all object keys, includes non-enumerable and symbols

var ownKeys = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = objectGetOwnPropertyNames.f(anObject(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};

var copyConstructorProperties = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = objectDefineProperty.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];

    if (!hasOwnProperty_1(target, key) && !(exceptions && hasOwnProperty_1(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true : value == NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';
var isForced_1 = isForced;

var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/

var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;

  if (GLOBAL) {
    target = global_1;
  } else if (STATIC) {
    target = global_1[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global_1[TARGET] || {}).prototype;
  }

  if (target) for (key in source) {
    sourceProperty = source[key];

    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];

    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced); // contained in target

    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    } // add a flag to not completely full polyfills


    if (options.sham || targetProperty && targetProperty.sham) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }

    defineBuiltIn(target, key, sourceProperty, options);
  }
};

// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe

var isArray = Array.isArray || function isArray(argument) {
  return classofRaw(argument) == 'Array';
};

var $TypeError$6 = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError$6('Maximum allowed index exceeded');
  return it;
};

var createProperty = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));else object[propertyKey] = value;
};

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};
test[TO_STRING_TAG] = 'z';
var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
var $Object$3 = Object; // ES3 wrong here

var CORRECT_ARGUMENTS = classofRaw(function () {
  return arguments;
}()) == 'Arguments'; // fallback for IE11 Script Access Denied error

var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) {
    /* empty */
  }
}; // getting tag from ES6+ `Object.prototype.toString`


var classof = toStringTagSupport ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
  : typeof (tag = tryGet(O = $Object$3(it), TO_STRING_TAG$1)) == 'string' ? tag // builtinTag case
  : CORRECT_ARGUMENTS ? classofRaw(O) // ES3 arguments fallback
  : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};

var noop = function () {
  /* empty */
};

var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = functionUncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;

  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;

  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction':
      return false;
  }

  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true; // `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor

var isConstructor = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function () {
    called = true;
  }) || called;
}) ? isConstructorLegacy : isConstructorModern;

var SPECIES = wellKnownSymbol('species');
var $Array = Array; // a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate

var arraySpeciesConstructor = function (originalArray) {
  var C;

  if (isArray(originalArray)) {
    C = originalArray.constructor; // cross-realm fallback

    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  }

  return C === undefined ? $Array : C;
};

// https://tc39.es/ecma262/#sec-arrayspeciescreate

var arraySpeciesCreate = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var SPECIES$1 = wellKnownSymbol('species');

var arrayMethodHasSpeciesSupport = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return engineV8Version >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};

    constructor[SPECIES$1] = function () {
      return {
        foo: 1
      };
    };

    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable'); // We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679

var IS_CONCAT_SPREADABLE_SUPPORT = engineV8Version >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});
var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT; // `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species

_export({
  target: 'Array',
  proto: true,
  arity: 1,
  forced: FORCED
}, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;

    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];

      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        doesNotExceedSafeInteger(n + len);

        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }

    A.length = n;
    return A;
  }
});

var bind = functionUncurryThis(functionUncurryThis.bind); // optional / simple context binding

var functionBindContext = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : functionBindNative ? bind(fn, that) : function ()
  /* ...args */
  {
    return fn.apply(that, arguments);
  };
};

var push$1 = functionUncurryThis([].push); // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation

var createMethod$1 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = indexedObject(O);
    var boundFunction = functionBindContext(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;

    for (; length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);

      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
            case 3:
              return true;
            // some

            case 5:
              return value;
            // find

            case 6:
              return index;
            // findIndex

            case 2:
              push$1(target, value);
            // filter
          } else switch (TYPE) {
            case 4:
              return false;
            // every

            case 7:
              push$1(target, value);
            // filterReject
          }
      }
    }

    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$1(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod$1(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod$1(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod$1(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod$1(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod$1(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$1(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod$1(7)
};

var arrayMethodIsStrict = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () {
      return 1;
    }, 1);
  });
};

var $every = arrayIteration.every;
var STRICT_METHOD = arrayMethodIsStrict('every'); // `Array.prototype.every` method
// https://tc39.es/ecma262/#sec-array.prototype.every

_export({
  target: 'Array',
  proto: true,
  forced: !STRICT_METHOD
}, {
  every: function every(callbackfn
  /* , thisArg */
  ) {
    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var $forEach = arrayIteration.forEach;
var STRICT_METHOD$1 = arrayMethodIsStrict('forEach'); // `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach

var arrayForEach = !STRICT_METHOD$1 ? function forEach(callbackfn
/* , thisArg */
) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined); // eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe


_export({
  target: 'Array',
  proto: true,
  forced: [].forEach != arrayForEach
}, {
  forEach: arrayForEach
});

// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe

var objectKeys = Object.keys || function keys(O) {
  return objectKeysInternal(O, enumBugKeys);
};

// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe

var f$5 = descriptors && !v8PrototypeDefineBug ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;

  while (length > index) objectDefineProperty.f(O, key = keys[index++], props[key]);

  return O;
};
var objectDefineProperties = {
  f: f$5
};

var html = getBuiltIn('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () {
  /* empty */
};

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
}; // Create object with fake `null` prototype: use ActiveX Object with cleared prototype


var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak

  return temp;
}; // Create object with fake `null` prototype: use iframe Object with cleared prototype


var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe); // https://github.com/zloirock/core-js/issues/475

  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
}; // Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug


var activeXDocument;

var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) {
    /* ignore */
  }

  NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
  : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH

  var length = enumBugKeys.length;

  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];

  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true; // `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe

var objectCreate = Object.create || function create(O, Properties) {
  var result;

  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null; // add "__proto__" for Object.getPrototypeOf polyfill

    result[IE_PROTO] = O;
  } else result = NullProtoObject();

  return Properties === undefined ? result : objectDefineProperties.f(result, Properties);
};

var defineProperty$2 = objectDefineProperty.f;
var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype; // Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

if (ArrayPrototype[UNSCOPABLES] == undefined) {
  defineProperty$2(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: objectCreate(null)
  });
} // add a key to Array.prototype[@@unscopables]


var addToUnscopables = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var $includes = arrayIncludes.includes; // FF99+ bug

var BROKEN_ON_SPARSE = fails(function () {
  return !Array(1).includes();
}); // `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes

_export({
  target: 'Array',
  proto: true,
  forced: BROKEN_ON_SPARSE
}, {
  includes: function includes(el
  /* , fromIndex = 0 */
  ) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
}); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

addToUnscopables('includes');

/* eslint-disable es/no-array-prototype-indexof -- required for testing */


var $indexOf = arrayIncludes.indexOf;
var nativeIndexOf = functionUncurryThis([].indexOf);
var NEGATIVE_ZERO = !!nativeIndexOf && 1 / nativeIndexOf([1], 1, -0) < 0;
var STRICT_METHOD$2 = arrayMethodIsStrict('indexOf'); // `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof

_export({
  target: 'Array',
  proto: true,
  forced: NEGATIVE_ZERO || !STRICT_METHOD$2
}, {
  indexOf: function indexOf(searchElement
  /* , fromIndex = 0 */
  ) {
    var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
    return NEGATIVE_ZERO // convert -0 to +0
    ? nativeIndexOf(this, searchElement, fromIndex) || 0 : $indexOf(this, searchElement, fromIndex);
  }
});

var iterators = {};

var correctPrototypeGetter = !fails(function () {
  function F() {
    /* empty */
  }

  F.prototype.constructor = null; // eslint-disable-next-line es/no-object-getprototypeof -- required for testing

  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var IE_PROTO$1 = sharedKey('IE_PROTO');
var $Object$4 = Object;
var ObjectPrototype = $Object$4.prototype; // `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe

var objectGetPrototypeOf = correctPrototypeGetter ? $Object$4.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwnProperty_1(object, IE_PROTO$1)) return object[IE_PROTO$1];
  var constructor = object.constructor;

  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  }

  return object instanceof $Object$4 ? ObjectPrototype : null;
};

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false; // `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object

var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */

if ([].keys) {
  arrayIterator = [].keys(); // Safari 8 has buggy iterators w/o `next`

  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;else {
    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {}; // FF44- legacy iterators case

  return IteratorPrototype[ITERATOR].call(test) !== test;
});
if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {}; // `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator

if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};

var defineProperty$3 = objectDefineProperty.f;
var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');

var setToStringTag = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;

  if (target && !hasOwnProperty_1(target, TO_STRING_TAG$2)) {
    defineProperty$3(target, TO_STRING_TAG$2, {
      configurable: true,
      value: TAG
    });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;

var returnThis = function () {
  return this;
};

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, {
    next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next)
  });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false);
  iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};

var $String$2 = String;
var $TypeError$7 = TypeError;

var aPossiblePrototype = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw $TypeError$7("Can't set " + $String$2(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe

var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;

  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = functionUncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) {
    /* empty */
  }

  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var PROPER_FUNCTION_NAME = functionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
var IteratorPrototype$2 = iteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS$1 = iteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$1 = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis$1 = function () {
  return this;
};

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  iteratorCreateConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS$1 && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS:
        return function keys() {
          return new IteratorConstructor(this, KIND);
        };

      case VALUES:
        return function values() {
          return new IteratorConstructor(this, KIND);
        };

      case ENTRIES:
        return function entries() {
          return new IteratorConstructor(this, KIND);
        };
    }

    return function () {
      return new IteratorConstructor(this);
    };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$1] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS$1 && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY; // fix native

  if (anyNativeIterator) {
    CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));

    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if ( objectGetPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype$2) {
        if (objectSetPrototypeOf) {
          objectSetPrototypeOf(CurrentIteratorPrototype, IteratorPrototype$2);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR$1])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR$1, returnThis$1);
        }
      } // Set @@toStringTag to native iterators


      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  } // fix Array.prototype.{ values, @@iterator }.name in V8 / FF


  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if ( CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;

      defaultIterator = function values() {
        return functionCall(nativeIterator, this);
      };
    }
  } // export additional methods


  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else _export({
      target: NAME,
      proto: true,
      forced: BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME
    }, methods);
  } // define iterator


  if ( IterablePrototype[ITERATOR$1] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR$1, defaultIterator, {
      name: DEFAULT
    });
  }

  iterators[NAME] = defaultIterator;
  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject = function (value, done) {
  return {
    value: value,
    done: done
  };
};

var defineProperty$4 = objectDefineProperty.f;
var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = internalState.set;
var getInternalState = internalState.getterFor(ARRAY_ITERATOR); // `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator

var es_array_iterator = iteratorDefine(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated),
    // target
    index: 0,
    // next index
    kind: kind // kind

  }); // `%ArrayIteratorPrototype%.next` method
  // https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;

  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }

  if (kind == 'keys') return createIterResultObject(index, false);
  if (kind == 'values') return createIterResultObject(target[index], false);
  return createIterResultObject([index, target[index]], false);
}, 'values'); // argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject

var values = iterators.Arguments = iterators.Array; // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries'); // V8 ~ Chrome 45- bug

if ( descriptors && values.name !== 'values') try {
  defineProperty$4(values, 'name', {
    value: 'values'
  });
} catch (error) {
  /* empty */
}

var $some = arrayIteration.some;
var STRICT_METHOD$3 = arrayMethodIsStrict('some'); // `Array.prototype.some` method
// https://tc39.es/ecma262/#sec-array.prototype.some

_export({
  target: 'Array',
  proto: true,
  forced: !STRICT_METHOD$3
}, {
  some: function some(callbackfn
  /* , thisArg */
  ) {
    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var $TypeError$8 = TypeError; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor; // Safari < 13 does not throw an error in this case

var SILENT_ON_NON_WRITABLE_LENGTH_SET = descriptors && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;

  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', {
      writable: false
    }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();
var arraySetLength = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor$2(O, 'length').writable) {
    throw $TypeError$8('Cannot set read only .length');
  }

  return O.length = length;
} : function (O, length) {
  return O.length = length;
};

var $TypeError$9 = TypeError;

var deletePropertyOrThrow = function (O, P) {
  if (!delete O[P]) throw $TypeError$9('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');
var max$1 = Math.max;
var min$2 = Math.min; // `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species

_export({
  target: 'Array',
  proto: true,
  forced: !HAS_SPECIES_SUPPORT
}, {
  splice: function splice(start, deleteCount
  /* , ...items */
  ) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;

    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min$2(max$1(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    }

    doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
    A = arraySpeciesCreate(O, actualDeleteCount);

    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }

    A.length = actualDeleteCount;

    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];else deletePropertyOrThrow(O, to);
      }

      for (k = len; k > len - actualDeleteCount + insertCount; k--) deletePropertyOrThrow(O, k - 1);
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];else deletePropertyOrThrow(O, to);
      }
    }

    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }

    arraySetLength(O, len - actualDeleteCount + insertCount);
    return A;
  }
});

var $Array$1 = Array;
var max$2 = Math.max;

var arraySliceSimple = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array$1(max$2(fin - k, 0));

  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);

  result.length = n;
  return result;
};

/* eslint-disable es/no-object-getownpropertynames -- safe */

var $getOwnPropertyNames = objectGetOwnPropertyNames.f;
var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySliceSimple(windowNames);
  }
}; // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window


var f$6 = function getOwnPropertyNames(it) {
  return windowNames && classofRaw(it) == 'Window' ? getWindowNames(it) : $getOwnPropertyNames(toIndexedObject(it));
};

var objectGetOwnPropertyNamesExternal = {
  f: f$6
};

var arrayBufferNonExtensible = fails(function () {
  if (typeof ArrayBuffer == 'function') {
    var buffer = new ArrayBuffer(8); // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe

    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', {
      value: 8
    });
  }
});

var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails(function () {
  $isExtensible(1);
}); // `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible

var objectIsExtensible = FAILS_ON_PRIMITIVES || arrayBufferNonExtensible ? function isExtensible(it) {
  if (!isObject(it)) return false;
  if (arrayBufferNonExtensible && classofRaw(it) == 'ArrayBuffer') return false;
  return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;

var freezing = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});

var internalMetadata = createCommonjsModule(function (module) {
  var defineProperty = objectDefineProperty.f;
  var REQUIRED = false;
  var METADATA = uid('meta');
  var id = 0;

  var setMetadata = function (it) {
    defineProperty(it, METADATA, {
      value: {
        objectID: 'O' + id++,
        // object ID
        weakData: {} // weak collections IDs

      }
    });
  };

  var fastKey = function (it, create) {
    // return a primitive with prefix
    if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;

    if (!hasOwnProperty_1(it, METADATA)) {
      // can't set metadata to uncaught frozen object
      if (!objectIsExtensible(it)) return 'F'; // not necessary to add metadata

      if (!create) return 'E'; // add missing metadata

      setMetadata(it); // return object ID
    }

    return it[METADATA].objectID;
  };

  var getWeakData = function (it, create) {
    if (!hasOwnProperty_1(it, METADATA)) {
      // can't set metadata to uncaught frozen object
      if (!objectIsExtensible(it)) return true; // not necessary to add metadata

      if (!create) return false; // add missing metadata

      setMetadata(it); // return the store of weak collections IDs
    }

    return it[METADATA].weakData;
  }; // add metadata on freeze-family methods calling


  var onFreeze = function (it) {
    if (freezing && REQUIRED && objectIsExtensible(it) && !hasOwnProperty_1(it, METADATA)) setMetadata(it);
    return it;
  };

  var enable = function () {
    meta.enable = function () {
      /* empty */
    };

    REQUIRED = true;
    var getOwnPropertyNames = objectGetOwnPropertyNames.f;
    var splice = functionUncurryThis([].splice);
    var test = {};
    test[METADATA] = 1; // prevent exposing of metadata key

    if (getOwnPropertyNames(test).length) {
      objectGetOwnPropertyNames.f = function (it) {
        var result = getOwnPropertyNames(it);

        for (var i = 0, length = result.length; i < length; i++) {
          if (result[i] === METADATA) {
            splice(result, i, 1);
            break;
          }
        }

        return result;
      };

      _export({
        target: 'Object',
        stat: true,
        forced: true
      }, {
        getOwnPropertyNames: objectGetOwnPropertyNamesExternal.f
      });
    }
  };

  var meta = module.exports = {
    enable: enable,
    fastKey: fastKey,
    getWeakData: getWeakData,
    onFreeze: onFreeze
  };
  hiddenKeys[METADATA] = true;
});
var internalMetadata_1 = internalMetadata.enable;
var internalMetadata_2 = internalMetadata.fastKey;
var internalMetadata_3 = internalMetadata.getWeakData;
var internalMetadata_4 = internalMetadata.onFreeze;

var ITERATOR$2 = wellKnownSymbol('iterator');
var ArrayPrototype$1 = Array.prototype; // check on default Array iterator

var isArrayIteratorMethod = function (it) {
  return it !== undefined && (iterators.Array === it || ArrayPrototype$1[ITERATOR$2] === it);
};

var ITERATOR$3 = wellKnownSymbol('iterator');

var getIteratorMethod = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR$3) || getMethod(it, '@@iterator') || iterators[classof(it)];
};

var $TypeError$a = TypeError;

var getIterator = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(functionCall(iteratorMethod, argument));
  throw $TypeError$a(tryToString(argument) + ' is not iterable');
};

var iteratorClose = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);

  try {
    innerResult = getMethod(iterator, 'return');

    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }

    innerResult = functionCall(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }

  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};

var $TypeError$b = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = functionBindContext(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    }

    return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw $TypeError$b(tryToString(iterable) + ' is not iterable'); // optimisation for array iterators

    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && objectIsPrototypeOf(ResultPrototype, result)) return result;
      }

      return new Result(false);
    }

    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;

  while (!(step = functionCall(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }

    if (typeof result == 'object' && result && objectIsPrototypeOf(ResultPrototype, result)) return result;
  }

  return new Result(false);
};

var $TypeError$c = TypeError;

var anInstance = function (it, Prototype) {
  if (objectIsPrototypeOf(Prototype, it)) return it;
  throw $TypeError$c('Incorrect invocation');
};

var ITERATOR$4 = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return {
        done: !!called++
      };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };

  iteratorWithReturn[ITERATOR$4] = function () {
    return this;
  }; // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing


  Array.from(iteratorWithReturn, function () {
    throw 2;
  });
} catch (error) {
  /* empty */
}

var checkCorrectnessOfIteration = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;

  try {
    var object = {};

    object[ITERATOR$4] = function () {
      return {
        next: function () {
          return {
            done: ITERATION_SUPPORT = true
          };
        }
      };
    };

    exec(object);
  } catch (error) {
    /* empty */
  }

  return ITERATION_SUPPORT;
};

var inheritIfRequired = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if ( // it can work only with native `setPrototypeOf`
  objectSetPrototypeOf && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
  isCallable(NewTarget = dummy.constructor) && NewTarget !== Wrapper && isObject(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) objectSetPrototypeOf($this, NewTargetPrototype);
  return $this;
};

var collection = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global_1[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var uncurriedNativeMethod = functionUncurryThis(NativePrototype[KEY]);
    defineBuiltIn(NativePrototype, KEY, KEY == 'add' ? function add(value) {
      uncurriedNativeMethod(this, value === 0 ? 0 : value);
      return this;
    } : KEY == 'delete' ? function (key) {
      return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
    } : KEY == 'get' ? function get(key) {
      return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
    } : KEY == 'has' ? function has(key) {
      return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
    } : function set(key, value) {
      uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
      return this;
    });
  };

  var REPLACE = isForced_1(CONSTRUCTOR_NAME, !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
    new NativeConstructor().entries().next();
  })));

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    internalMetadata.enable();
  } else if (isForced_1(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor(); // early implementations not supports chaining

    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance; // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false

    var THROWS_ON_PRIMITIVES = fails(function () {
      instance.has(1);
    }); // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing

    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) {
      new NativeConstructor(iterable);
    }); // for early implementations -0 and +0 not the same

    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;

      while (index--) $instance[ADDER](index, index);

      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, NativePrototype);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], {
          that: that,
          AS_ENTRIES: IS_MAP
        });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER); // weak collections should not contains .clear method

    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  _export({
    global: true,
    constructor: true,
    forced: Constructor != NativeConstructor
  }, exported);
  setToStringTag(Constructor, CONSTRUCTOR_NAME);
  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
  return Constructor;
};

var defineBuiltIns = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);

  return target;
};

var SPECIES$2 = wellKnownSymbol('species');

var setSpecies = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = objectDefineProperty.f;

  if (descriptors && Constructor && !Constructor[SPECIES$2]) {
    defineProperty(Constructor, SPECIES$2, {
      configurable: true,
      get: function () {
        return this;
      }
    });
  }
};

var defineProperty$5 = objectDefineProperty.f;
var fastKey = internalMetadata.fastKey;
var setInternalState$1 = internalState.set;
var internalStateGetterFor = internalState.getterFor;
var collectionStrong = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState$1(that, {
        type: CONSTRUCTOR_NAME,
        index: objectCreate(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!descriptors) that.size = 0;
      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], {
        that: that,
        AS_ENTRIES: IS_MAP
      });
    });
    var Prototype = Constructor.prototype;
    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index; // change existing entry

      if (entry) {
        entry.value = value; // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (descriptors) state.size++;else that.size++; // add to index

        if (index !== 'F') state.index[index] = entry;
      }

      return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that); // fast case

      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index]; // frozen object case

      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    defineBuiltIns(Prototype, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;

        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }

        state.first = state.last = undefined;
        if (descriptors) state.size = 0;else that.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);

        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (descriptors) state.size--;else that.size--;
        }

        return !!entry;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function forEach(callbackfn
      /* , that = undefined */
      ) {
        var state = getInternalState(this);
        var boundFunction = functionBindContext(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var entry;

        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this); // revert to the last existing entry

          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });
    defineBuiltIns(Prototype, IS_MAP ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (descriptors) defineProperty$5(Prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return Constructor;
  },
  setStrong: function (Constructor, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME); // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
    // https://tc39.es/ecma262/#sec-map.prototype.entries
    // https://tc39.es/ecma262/#sec-map.prototype.keys
    // https://tc39.es/ecma262/#sec-map.prototype.values
    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
    // https://tc39.es/ecma262/#sec-set.prototype.entries
    // https://tc39.es/ecma262/#sec-set.prototype.keys
    // https://tc39.es/ecma262/#sec-set.prototype.values
    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator

    iteratorDefine(Constructor, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState$1(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last; // revert to the last existing entry

      while (entry && entry.removed) entry = entry.previous; // get next entry


      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return createIterResultObject(undefined, true);
      } // return step by kind


      if (kind == 'keys') return createIterResultObject(entry.key, false);
      if (kind == 'values') return createIterResultObject(entry.value, false);
      return createIterResultObject([entry.key, entry.value], false);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true); // `{ Map, Set }.prototype[@@species]` accessors
    // https://tc39.es/ecma262/#sec-get-map-@@species
    // https://tc39.es/ecma262/#sec-get-set-@@species

    setSpecies(CONSTRUCTOR_NAME);
  }
};

// https://tc39.es/ecma262/#sec-map-objects


collection('Map', function (init) {
  return function Map() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
}, collectionStrong);

// https://tc39.es/ecma262/#sec-thisnumbervalue

var thisNumberValue = functionUncurryThis(1.0.valueOf);

var $String$3 = String;

var toString_1 = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String$3(argument);
};

// a string of all valid unicode whitespaces
var whitespaces = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' + '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var replace = functionUncurryThis(''.replace);
var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$'); // `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation

var createMethod$2 = function (TYPE) {
  return function ($this) {
    var string = toString_1(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod$2(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod$2(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod$2(3)
};

var getOwnPropertyNames = objectGetOwnPropertyNames.f;
var getOwnPropertyDescriptor$3 = objectGetOwnPropertyDescriptor.f;
var defineProperty$6 = objectDefineProperty.f;
var trim = stringTrim.trim;
var NUMBER = 'Number';
var NativeNumber = global_1[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError$2 = global_1.TypeError;
var arraySlice = functionUncurryThis(''.slice);
var charCodeAt = functionUncurryThis(''.charCodeAt); // `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric

var toNumeric = function (value) {
  var primValue = toPrimitive(value, 'number');
  return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
}; // `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber


var toNumber = function (argument) {
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (isSymbol(it)) throw TypeError$2('Cannot convert a Symbol value to a number');

  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = charCodeAt(it, 0);

    if (first === 43 || first === 45) {
      third = charCodeAt(it, 2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (charCodeAt(it, 1)) {
        case 66:
        case 98:
          radix = 2;
          maxCode = 49;
          break;
        // fast equal of /^0b[01]+$/i

        case 79:
        case 111:
          radix = 8;
          maxCode = 55;
          break;
        // fast equal of /^0o[0-7]+$/i

        default:
          return +it;
      }

      digits = arraySlice(it, 2);
      length = digits.length;

      for (index = 0; index < length; index++) {
        code = charCodeAt(digits, index); // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols

        if (code < 48 || code > maxCode) return NaN;
      }

      return parseInt(digits, radix);
    }
  }

  return +it;
}; // `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor


if (isForced_1(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
    var dummy = this; // check on 1..constructor(foo) case

    return objectIsPrototypeOf(NumberPrototype, dummy) && fails(function () {
      thisNumberValue(dummy);
    }) ? inheritIfRequired(Object(n), dummy, NumberWrapper) : n;
  };

  for (var keys$1 = descriptors ? getOwnPropertyNames(NativeNumber) : ( // ES3:
  'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' + // ES2015 (in case, if modules with ES2015 Number statics required before):
  'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' + // ESNext
  'fromString,range').split(','), j = 0, key; keys$1.length > j; j++) {
    if (hasOwnProperty_1(NativeNumber, key = keys$1[j]) && !hasOwnProperty_1(NumberWrapper, key)) {
      defineProperty$6(NumberWrapper, key, getOwnPropertyDescriptor$3(NativeNumber, key));
    }
  }

  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  defineBuiltIn(global_1, NUMBER, NumberWrapper, {
    constructor: true
  });
}

// https://tc39.es/ecma262/#sec-number.max_safe_integer

_export({
  target: 'Number',
  stat: true,
  nonConfigurable: true,
  nonWritable: true
}, {
  MAX_SAFE_INTEGER: 0x1FFFFFFFFFFFFF
});

var nativeGetOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var FAILS_ON_PRIMITIVES$1 = fails(function () {
  nativeGetOwnPropertyDescriptor(1);
});
var FORCED$1 = !descriptors || FAILS_ON_PRIMITIVES$1; // `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor

_export({
  target: 'Object',
  stat: true,
  forced: FORCED$1,
  sham: !descriptors
}, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});

var getOwnPropertyNames$1 = objectGetOwnPropertyNamesExternal.f; // eslint-disable-next-line es/no-object-getownpropertynames -- required for testing

var FAILS_ON_PRIMITIVES$2 = fails(function () {
  return !Object.getOwnPropertyNames(1);
}); // `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames

_export({
  target: 'Object',
  stat: true,
  forced: FAILS_ON_PRIMITIVES$2
}, {
  getOwnPropertyNames: getOwnPropertyNames$1
});

var FAILS_ON_PRIMITIVES$3 = fails(function () {
  objectGetPrototypeOf(1);
}); // `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof

_export({
  target: 'Object',
  stat: true,
  forced: FAILS_ON_PRIMITIVES$3,
  sham: !correctPrototypeGetter
}, {
  getPrototypeOf: function getPrototypeOf(it) {
    return objectGetPrototypeOf(toObject(it));
  }
});

// https://tc39.es/ecma262/#sec-object.prototype.tostring


var objectToString = toStringTagSupport ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};

// https://tc39.es/ecma262/#sec-object.prototype.tostring

if (!toStringTagSupport) {
  defineBuiltIn(Object.prototype, 'toString', objectToString, {
    unsafe: true
  });
}

var engineIsNode = classofRaw(global_1.process) == 'process';

var $TypeError$d = TypeError; // `Assert: IsConstructor(argument) is true`

var aConstructor = function (argument) {
  if (isConstructor(argument)) return argument;
  throw $TypeError$d(tryToString(argument) + ' is not a constructor');
};

var SPECIES$3 = wellKnownSymbol('species'); // `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor

var speciesConstructor = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES$3]) ? defaultConstructor : aConstructor(S);
};

var FunctionPrototype$3 = Function.prototype;
var apply = FunctionPrototype$3.apply;
var call$2 = FunctionPrototype$3.call; // eslint-disable-next-line es/no-reflect -- safe

var functionApply = typeof Reflect == 'object' && Reflect.apply || (functionBindNative ? call$2.bind(apply) : function () {
  return call$2.apply(apply, arguments);
});

var arraySlice$1 = functionUncurryThis([].slice);

var $TypeError$e = TypeError;

var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw $TypeError$e('Not enough arguments');
  return passed;
};

var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(engineUserAgent);

var set$1 = global_1.setImmediate;
var clear = global_1.clearImmediate;
var process$1 = global_1.process;
var Dispatch = global_1.Dispatch;
var Function$1 = global_1.Function;
var MessageChannel$1 = global_1.MessageChannel;
var String$1 = global_1.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global_1.location;
} catch (error) {
  /* empty */
}

var run = function (id) {
  if (hasOwnProperty_1(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global_1.postMessage(String$1(id), $location.protocol + '//' + $location.host);
}; // Node.js 0.9+ & IE10+ has setImmediate, otherwise:


if (!set$1 || !clear) {
  set$1 = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function$1(handler);
    var args = arraySlice$1(arguments, 1);

    queue[++counter] = function () {
      functionApply(fn, undefined, args);
    };

    defer(counter);
    return counter;
  };

  clear = function clearImmediate(id) {
    delete queue[id];
  }; // Node.js 0.8-


  if (engineIsNode) {
    defer = function (id) {
      process$1.nextTick(runner(id));
    }; // Sphere (JS game engine) Dispatch API

  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    }; // Browsers with MessageChannel, includes WebWorkers
    // except iOS - https://github.com/zloirock/core-js/issues/624

  } else if (MessageChannel$1 && !engineIsIos) {
    channel = new MessageChannel$1();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = functionBindContext(port.postMessage, port); // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global_1.addEventListener && isCallable(global_1.postMessage) && !global_1.importScripts && $location && $location.protocol !== 'file:' && !fails(post)) {
    defer = post;
    global_1.addEventListener('message', listener, false); // IE8-
  } else if (ONREADYSTATECHANGE in documentCreateElement('script')) {
    defer = function (id) {
      html.appendChild(documentCreateElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    }; // Rest old browsers

  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task = {
  set: set$1,
  clear: clear
};

var engineIsIosPebble = /ipad|iphone|ipod/i.test(engineUserAgent) && global_1.Pebble !== undefined;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(engineUserAgent);

var getOwnPropertyDescriptor$4 = objectGetOwnPropertyDescriptor.f;
var macrotask = task.set;
var MutationObserver = global_1.MutationObserver || global_1.WebKitMutationObserver;
var document$2 = global_1.document;
var process$2 = global_1.process;
var Promise$1 = global_1.Promise; // Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`

var queueMicrotaskDescriptor = getOwnPropertyDescriptor$4(global_1, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
var flush, head, last, notify, toggle, node, promise, then; // modern engines have queueMicrotask method

if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (engineIsNode && (parent = process$2.domain)) parent.exit();

    while (head) {
      fn = head.fn;
      head = head.next;

      try {
        fn();
      } catch (error) {
        if (head) notify();else last = undefined;
        throw error;
      }
    }

    last = undefined;
    if (parent) parent.enter();
  }; // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898


  if (!engineIsIos && !engineIsNode && !engineIsWebosWebkit && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, {
      characterData: true
    });

    notify = function () {
      node.data = toggle = !toggle;
    }; // environments with maybe non-completely correct, but existent Promise

  } else if (!engineIsIosPebble && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined); // workaround of WebKit ~ iOS Safari 10.1 bug

    promise.constructor = Promise$1;
    then = functionBindContext(promise.then, promise);

    notify = function () {
      then(flush);
    }; // Node.js without promises

  } else if (engineIsNode) {
    notify = function () {
      process$2.nextTick(flush);
    }; // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessage
    // - onreadystatechange
    // - setTimeout

  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask = functionBindContext(macrotask, global_1);

    notify = function () {
      macrotask(flush);
    };
  }
}

var microtask = queueMicrotask || function (fn) {
  var task = {
    fn: fn,
    next: undefined
  };
  if (last) last.next = task;

  if (!head) {
    head = task;
    notify();
  }

  last = task;
};

var hostReportErrors = function (a, b) {
  var console = global_1.console;

  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};

var perform = function (exec) {
  try {
    return {
      error: false,
      value: exec()
    };
  } catch (error) {
    return {
      error: true,
      value: error
    };
  }
};

var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = {
      item: item,
      next: null
    };
    if (this.head) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;

    if (entry) {
      this.head = entry.next;
      if (this.tail === entry) this.tail = null;
      return entry.item;
    }
  }
};
var queue$1 = Queue;

var promiseNativeConstructor = global_1.Promise;

/* global Deno -- Deno case */
var engineIsDeno = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';

var engineIsBrowser = !engineIsDeno && !engineIsNode && typeof window == 'object' && typeof document == 'object';

var NativePromisePrototype = promiseNativeConstructor && promiseNativeConstructor.prototype;
var SPECIES$4 = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(global_1.PromiseRejectionEvent);
var FORCED_PROMISE_CONSTRUCTOR = isForced_1('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(promiseNativeConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(promiseNativeConstructor); // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions

  if (!GLOBAL_CORE_JS_PROMISE && engineV8Version === 66) return true; // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679

  if (!engineV8Version || engineV8Version < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new promiseNativeConstructor(function (resolve) {
      resolve(1);
    });

    var FakePromise = function (exec) {
      exec(function () {
        /* empty */
      }, function () {
        /* empty */
      });
    };

    var constructor = promise.constructor = {};
    constructor[SPECIES$4] = FakePromise;
    SUBCLASSING = promise.then(function () {
      /* empty */
    }) instanceof FakePromise;
    if (!SUBCLASSING) return true; // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  }

  return !GLOBAL_CORE_JS_PROMISE && (engineIsBrowser || engineIsDeno) && !NATIVE_PROMISE_REJECTION_EVENT;
});
var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING: SUBCLASSING
};

var $TypeError$f = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw $TypeError$f('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
}; // `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability


var f$7 = function (C) {
  return new PromiseCapability(C);
};

var newPromiseCapability = {
  f: f$7
};

var task$1 = task.set;
var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT$1 = promiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = promiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = internalState.getterFor(PROMISE);
var setInternalState$2 = internalState.set;
var NativePromisePrototype$1 = promiseNativeConstructor && promiseNativeConstructor.prototype;
var PromiseConstructor = promiseNativeConstructor;
var PromisePrototype = NativePromisePrototype$1;
var TypeError$3 = global_1.TypeError;
var document$3 = global_1.document;
var process$3 = global_1.process;
var newPromiseCapability$1 = newPromiseCapability.f;
var newGenericPromiseCapability = newPromiseCapability$1;
var DISPATCH_EVENT = !!(document$3 && document$3.createEvent && global_1.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen; // helpers

var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;

  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }

      if (handler === true) result = value;else {
        if (domain) domain.enter();
        result = handler(value); // can throw

        if (domain) {
          domain.exit();
          exited = true;
        }
      }

      if (result === reaction.promise) {
        reject(TypeError$3('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        functionCall(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify$1 = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;

    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }

    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;

  if (DISPATCH_EVENT) {
    event = document$3.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global_1.dispatchEvent(event);
  } else event = {
    promise: promise,
    reason: reason
  };

  if (!NATIVE_PROMISE_REJECTION_EVENT$1 && (handler = global_1['on' + name])) handler(event);else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  functionCall(task$1, global_1, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;

    if (IS_UNHANDLED) {
      result = perform(function () {
        if (engineIsNode) {
          process$3.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      }); // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should

      state.rejection = engineIsNode || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  functionCall(task$1, global_1, function () {
    var promise = state.facade;

    if (engineIsNode) {
      process$3.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$1 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify$1(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;

  try {
    if (state.facade === value) throw TypeError$3("Promise can't be resolved itself");
    var then = isThenable(value);

    if (then) {
      microtask(function () {
        var wrapper = {
          done: false
        };

        try {
          functionCall(then, value, bind$1(internalResolve, wrapper, state), bind$1(internalReject, wrapper, state));
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify$1(state, false);
    }
  } catch (error) {
    internalReject({
      done: false
    }, error, state);
  }
}; // constructor polyfill


if (FORCED_PROMISE_CONSTRUCTOR$1) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    functionCall(Internal, this);
    var state = getInternalPromiseState(this);

    try {
      executor(bind$1(internalResolve, state), bind$1(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype; // eslint-disable-next-line no-unused-vars -- required for `.length`

  Internal = function Promise(executor) {
    setInternalState$2(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new queue$1(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  }; // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then


  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability$1(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = engineIsNode ? process$3.domain : undefined;
    if (state.state == PENDING) state.reactions.add(reaction);else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind$1(internalResolve, state);
    this.reject = bind$1(internalReject, state);
  };

  newPromiseCapability.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
  };

  if ( isCallable(promiseNativeConstructor) && NativePromisePrototype$1 !== Object.prototype) {
    nativeThen = NativePromisePrototype$1.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype$1, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          functionCall(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected); // https://github.com/zloirock/core-js/issues/640
      }, {
        unsafe: true
      });
    } // make `.constructor === Promise` work for native promise-based APIs


    try {
      delete NativePromisePrototype$1.constructor;
    } catch (error) {}
    /* empty */
    // make `instanceof Promise` work for native promise-based APIs


    if (objectSetPrototypeOf) {
      objectSetPrototypeOf(NativePromisePrototype$1, PromisePrototype);
    }
  }
}

_export({
  global: true,
  constructor: true,
  wrap: true,
  forced: FORCED_PROMISE_CONSTRUCTOR$1
}, {
  Promise: PromiseConstructor
});
setToStringTag(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$2 || !checkCorrectnessOfIteration(function (iterable) {
  promiseNativeConstructor.all(iterable).then(undefined, function () {
    /* empty */
  });
});

// https://tc39.es/ecma262/#sec-promise.all


_export({
  target: 'Promise',
  stat: true,
  forced: promiseStaticsIncorrectIteration
}, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        functionCall($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;
var NativePromisePrototype$2 = promiseNativeConstructor && promiseNativeConstructor.prototype; // `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch

_export({
  target: 'Promise',
  proto: true,
  forced: FORCED_PROMISE_CONSTRUCTOR$3,
  real: true
}, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
}); // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`

if ( isCallable(promiseNativeConstructor)) {
  var method = getBuiltIn('Promise').prototype['catch'];

  if (NativePromisePrototype$2['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype$2, 'catch', method, {
      unsafe: true
    });
  }
}

// https://tc39.es/ecma262/#sec-promise.race


_export({
  target: 'Promise',
  stat: true,
  forced: promiseStaticsIncorrectIteration
}, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        functionCall($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var FORCED_PROMISE_CONSTRUCTOR$4 = promiseConstructorDetection.CONSTRUCTOR; // `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject

_export({
  target: 'Promise',
  stat: true,
  forced: FORCED_PROMISE_CONSTRUCTOR$4
}, {
  reject: function reject(r) {
    var capability = newPromiseCapability.f(this);
    functionCall(capability.reject, undefined, r);
    return capability.promise;
  }
});

var promiseResolve = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var FORCED_PROMISE_CONSTRUCTOR$5 = promiseConstructorDetection.CONSTRUCTOR;
var PromiseConstructorWrapper = getBuiltIn('Promise');
// https://tc39.es/ecma262/#sec-promise.resolve

_export({
  target: 'Promise',
  stat: true,
  forced:  FORCED_PROMISE_CONSTRUCTOR$5
}, {
  resolve: function resolve(x) {
    return promiseResolve( this, x);
  }
});

// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags


var regexpFlags = function () {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var RegExpPrototype = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype) && !hasOwnProperty_1(R, 'flags') && objectIsPrototypeOf(RegExpPrototype, R) ? functionCall(regexpFlags, R) : flags;
};

var PROPER_FUNCTION_NAME$1 = functionName.PROPER;
var TO_STRING = 'toString';
var RegExpPrototype$1 = RegExp.prototype;
var nativeToString = RegExpPrototype$1[TO_STRING];
var NOT_GENERIC = fails(function () {
  return nativeToString.call({
    source: 'a',
    flags: 'b'
  }) != '/a/b';
}); // FF44- RegExp#toString has a wrong name

var INCORRECT_NAME = PROPER_FUNCTION_NAME$1 && nativeToString.name != TO_STRING; // `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring

if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = toString_1(R.source);
    var flags = toString_1(regexpGetFlags(R));
    return '/' + pattern + '/' + flags;
  }, {
    unsafe: true
  });
}

// https://tc39.es/ecma262/#sec-set-objects


collection('Set', function (init) {
  return function Set() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
}, collectionStrong);

var MATCH = wellKnownSymbol('match'); // `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp

var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classofRaw(it) == 'RegExp');
};

var $TypeError$g = TypeError;

var notARegexp = function (it) {
  if (isRegexp(it)) {
    throw $TypeError$g("The method doesn't accept regular expressions");
  }

  return it;
};

var MATCH$1 = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;

  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH$1] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) {
      /* empty */
    }
  }

  return false;
};

var stringIndexOf = functionUncurryThis(''.indexOf); // `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes

_export({
  target: 'String',
  proto: true,
  forced: !correctIsRegexpLogic('includes')
}, {
  includes: function includes(searchString
  /* , position = 0 */
  ) {
    return !!~stringIndexOf(toString_1(requireObjectCoercible(this)), toString_1(notARegexp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
  }
});

var charAt = functionUncurryThis(''.charAt);
var charCodeAt$1 = functionUncurryThis(''.charCodeAt);
var stringSlice$1 = functionUncurryThis(''.slice);

var createMethod$3 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString_1(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt$1(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = charCodeAt$1(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? charAt(S, position) : first : CONVERT_TO_STRING ? stringSlice$1(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$3(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$3(true)
};

var charAt$1 = stringMultibyte.charAt;
var STRING_ITERATOR = 'String Iterator';
var setInternalState$3 = internalState.set;
var getInternalState$1 = internalState.getterFor(STRING_ITERATOR); // `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator

iteratorDefine(String, 'String', function (iterated) {
  setInternalState$3(this, {
    type: STRING_ITERATOR,
    string: toString_1(iterated),
    index: 0
  }); // `%StringIteratorPrototype%.next` method
  // https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState$1(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt$1(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
});

var getWeakData = internalMetadata.getWeakData;
var setInternalState$4 = internalState.set;
var internalStateGetterFor$1 = internalState.getterFor;
var find = arrayIteration.find;
var findIndex = arrayIteration.findIndex;
var splice = functionUncurryThis([].splice);
var id$1 = 0; // fallback for uncaught frozen keys

var uncaughtFrozenStore = function (store) {
  return store.frozen || (store.frozen = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function () {
  this.entries = [];
};

var findUncaughtFrozen = function (store, key) {
  return find(store.entries, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;else this.entries.push([key, value]);
  },
  'delete': function (key) {
    var index = findIndex(this.entries, function (it) {
      return it[0] === key;
    });
    if (~index) splice(this.entries, index, 1);
    return !!~index;
  }
};
var collectionWeak = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState$4(that, {
        type: CONSTRUCTOR_NAME,
        id: id$1++,
        frozen: undefined
      });
      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], {
        that: that,
        AS_ENTRIES: IS_MAP
      });
    });
    var Prototype = Constructor.prototype;
    var getInternalState = internalStateGetterFor$1(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var data = getWeakData(anObject(key), true);
      if (data === true) uncaughtFrozenStore(state).set(key, value);else data[state.id] = value;
      return that;
    };

    defineBuiltIns(Prototype, {
      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
      'delete': function (key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
        return data && hasOwnProperty_1(data, state.id) && delete data[state.id];
      },
      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
      // https://tc39.es/ecma262/#sec-weakset.prototype.has
      has: function has(key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state).has(key);
        return data && hasOwnProperty_1(data, state.id);
      }
    });
    defineBuiltIns(Prototype, IS_MAP ? {
      // `WeakMap.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
      get: function get(key) {
        var state = getInternalState(this);

        if (isObject(key)) {
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).get(key);
          return data ? data[state.id] : undefined;
        }
      },
      // `WeakMap.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
      set: function set(key, value) {
        return define(this, key, value);
      }
    } : {
      // `WeakSet.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-weakset.prototype.add
      add: function add(value) {
        return define(this, value, true);
      }
    });
    return Constructor;
  }
};

var enforceInternalState = internalState.enforce;
var IS_IE11 = !global_1.ActiveXObject && 'ActiveXObject' in global_1;
var InternalWeakMap;

var wrapper = function (init) {
  return function WeakMap() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
}; // `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor


var $WeakMap = collection('WeakMap', wrapper, collectionWeak); // IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485

if (weakMapBasicDetection && IS_IE11) {
  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
  internalMetadata.enable();
  var WeakMapPrototype = $WeakMap.prototype;
  var nativeDelete = functionUncurryThis(WeakMapPrototype['delete']);
  var nativeHas = functionUncurryThis(WeakMapPrototype.has);
  var nativeGet = functionUncurryThis(WeakMapPrototype.get);
  var nativeSet = functionUncurryThis(WeakMapPrototype.set);
  defineBuiltIns(WeakMapPrototype, {
    'delete': function (key) {
      if (isObject(key) && !objectIsExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeDelete(this, key) || state.frozen['delete'](key);
      }

      return nativeDelete(this, key);
    },
    has: function has(key) {
      if (isObject(key) && !objectIsExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas(this, key) || state.frozen.has(key);
      }

      return nativeHas(this, key);
    },
    get: function get(key) {
      if (isObject(key) && !objectIsExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas(this, key) ? nativeGet(this, key) : state.frozen.get(key);
      }

      return nativeGet(this, key);
    },
    set: function set(key, value) {
      if (isObject(key) && !objectIsExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        nativeHas(this, key) ? nativeSet(this, key, value) : state.frozen.set(key, value);
      } else nativeSet(this, key, value);

      return this;
    }
  });
}

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;
var domTokenListPrototype = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== arrayForEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', arrayForEach);
  } catch (error) {
    CollectionPrototype.forEach = arrayForEach;
  }
};

for (var COLLECTION_NAME in domIterables) {
  if (domIterables[COLLECTION_NAME]) {
    handlePrototype(global_1[COLLECTION_NAME] && global_1[COLLECTION_NAME].prototype);
  }
}

handlePrototype(domTokenListPrototype);

var ITERATOR$5 = wellKnownSymbol('iterator');
var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');
var ArrayValues = es_array_iterator.values;

var handlePrototype$1 = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$5] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR$5, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$5] = ArrayValues;
    }

    if (!CollectionPrototype[TO_STRING_TAG$3]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$3, COLLECTION_NAME);
    }

    if (domIterables[COLLECTION_NAME]) for (var METHOD_NAME in es_array_iterator) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== es_array_iterator[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, es_array_iterator[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = es_array_iterator[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME$1 in domIterables) {
  handlePrototype$1(global_1[COLLECTION_NAME$1] && global_1[COLLECTION_NAME$1].prototype, COLLECTION_NAME$1);
}

handlePrototype$1(domTokenListPrototype, 'DOMTokenList');

var ITERATOR$6 = wellKnownSymbol('iterator');
var urlConstructorDetection = !fails(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return isPure && !url.toJSON || !searchParams.sort || url.href !== 'http://a/c%20d?a=1&c=3' || searchParams.get('c') !== '3' || String(new URLSearchParams('?a=1')) !== 'a=1' || !searchParams[ITERATOR$6] // throws in Edge
  || new URL('https://a@b').username !== 'a' || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b' // not punycoded in Edge
  || new URL('http://тест').host !== 'xn--e1aybc' // not escaped in Chrome 62-
  || new URL('http://a#б').hash !== '#%D0%B1' // fails in Chrome 66-
  || result !== 'a1c3' // throws in Safari
  || new URL('http://x', undefined).host !== 'x';
});

var defineBuiltInAccessor = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn_1(descriptor.get, name, {
    getter: true
  });
  if (descriptor.set) makeBuiltIn_1(descriptor.set, name, {
    setter: true
  });
  return objectDefineProperty.f(target, name, descriptor);
};

var $assign = Object.assign; // eslint-disable-next-line es/no-object-defineproperty -- required for testing

var defineProperty$7 = Object.defineProperty;
var concat$1 = functionUncurryThis([].concat); // `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign

var objectAssign = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (descriptors && $assign({
    b: 1
  }, $assign(defineProperty$7({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$7(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), {
    b: 2
  })).b !== 1) return true; // should work with symbols and should have deterministic property order (V8 bug)

  var A = {};
  var B = {}; // eslint-disable-next-line es/no-symbol -- safe

  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) {
    B[chr] = chr;
  });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  var propertyIsEnumerable = objectPropertyIsEnumerable.f;

  while (argumentsLength > index) {
    var S = indexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$1(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;

    while (length > j) {
      key = keys[j++];
      if (!descriptors || functionCall(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  }

  return T;
} : $assign;

var callWithSafeIterationClosing = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};

var $Array$2 = Array; // `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from

var arrayFrom = function from(arrayLike
/* , mapfn = undefined, thisArg = undefined */
) {
  var O = toObject(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = functionBindContext(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value; // if the target is not iterable or it's an array with the default iterator - use a simple case

  if (iteratorMethod && !(this === $Array$2 && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];

    for (; !(step = functionCall(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array$2(length);

    for (; length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }

  result.length = index;
  return result;
};

var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1

var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80

var delimiter = '-'; // '\x2D'

var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars

var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators

var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;
var $RangeError = RangeError;
var exec$1 = functionUncurryThis(regexSeparators.exec);
var floor$1 = Math.floor;
var fromCharCode = String.fromCharCode;
var charCodeAt$2 = functionUncurryThis(''.charCodeAt);
var join = functionUncurryThis([].join);
var push$2 = functionUncurryThis([].push);
var replace$1 = functionUncurryThis(''.replace);
var split$1 = functionUncurryThis(''.split);
var toLowerCase = functionUncurryThis(''.toLowerCase);
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */

var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;

  while (counter < length) {
    var value = charCodeAt$2(string, counter++);

    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = charCodeAt$2(string, counter++);

      if ((extra & 0xFC00) == 0xDC00) {
        // Low surrogate.
        push$2(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        push$2(output, value);
        counter--;
      }
    } else {
      push$2(output, value);
    }
  }

  return output;
};
/**
 * Converts a digit/integer into a basic code point.
 */


var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */


var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor$1(delta / damp) : delta >> 1;
  delta += floor$1(delta / numPoints);

  while (delta > baseMinusTMin * tMax >> 1) {
    delta = floor$1(delta / baseMinusTMin);
    k += base;
  }

  return floor$1(k + (baseMinusTMin + 1) * delta / (delta + skew));
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */


var encode = function (input) {
  var output = []; // Convert the input in UCS-2 to an array of Unicode code points.

  input = ucs2decode(input); // Cache the length.

  var inputLength = input.length; // Initialize the state.

  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue; // Handle the basic code points.

  for (i = 0; i < input.length; i++) {
    currentValue = input[i];

    if (currentValue < 0x80) {
      push$2(output, fromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.

  var handledCPCount = basicLength; // number of code points that have been handled;
  // Finish the basic string with a delimiter unless it's empty.

  if (basicLength) {
    push$2(output, delimiter);
  } // Main encoding loop:


  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];

      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    } // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.


    var handledCPCountPlusOne = handledCPCount + 1;

    if (m - n > floor$1((maxInt - delta) / handledCPCountPlusOne)) {
      throw $RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];

      if (currentValue < n && ++delta > maxInt) {
        throw $RangeError(OVERFLOW_ERROR);
      }

      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        var k = base;

        while (true) {
          var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          push$2(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor$1(qMinusT / baseMinusT);
          k += base;
        }

        push$2(output, fromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        handledCPCount++;
      }
    }

    delta++;
    n++;
  }

  return join(output, '');
};

var stringPunycodeToAscii = function (input) {
  var encoded = [];
  var labels = split$1(replace$1(toLowerCase(input), regexSeparators, '\u002E'), '.');
  var i, label;

  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    push$2(encoded, exec$1(regexNonASCII, label) ? 'xn--' + encode(label) : label);
  }

  return join(encoded, '.');
};

var floor$2 = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor$2(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(array, mergeSort(arraySliceSimple(array, 0, middle), comparefn), mergeSort(arraySliceSimple(array, middle), comparefn), comparefn);
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];

    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }

    if (j !== i++) array[j] = element;
  }

  return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
  }

  return array;
};

var arraySort = mergeSort;

var ITERATOR$7 = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState$5 = internalState.set;
var getInternalParamsState = internalState.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = internalState.getterFor(URL_SEARCH_PARAMS_ITERATOR); // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

var getOwnPropertyDescriptor$5 = Object.getOwnPropertyDescriptor; // Avoid NodeJS experimental warning

var safeGetBuiltIn = function (name) {
  if (!descriptors) return global_1[name];
  var descriptor = getOwnPropertyDescriptor$5(global_1, name);
  return descriptor && descriptor.value;
};

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp$1 = global_1.RegExp;
var TypeError$4 = global_1.TypeError;
var decodeURIComponent = global_1.decodeURIComponent;
var encodeURIComponent$1 = global_1.encodeURIComponent;
var charAt$2 = functionUncurryThis(''.charAt);
var join$1 = functionUncurryThis([].join);
var push$3 = functionUncurryThis([].push);
var replace$2 = functionUncurryThis(''.replace);
var shift = functionUncurryThis([].shift);
var splice$1 = functionUncurryThis([].splice);
var split$2 = functionUncurryThis(''.split);
var stringSlice$2 = functionUncurryThis(''.slice);
var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp$1('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = replace$2(it, plus, ' ');
  var bytes = 4;

  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = replace$2(result, percentSequence(bytes--), percentDecode);
    }

    return result;
  }
};

var find$1 = /[!'()~]|%20/g;
var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace$2(encodeURIComponent$1(it), find$1, replacer);
};

var URLSearchParamsIterator = iteratorCreateConstructor(function Iterator(params, kind) {
  setInternalState$5(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;

  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  }

  return step;
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject(init)) this.parseObject(init);else this.parseQuery(typeof init == 'string' ? charAt$2(init, 0) === '?' ? stringSlice$2(init, 1) : init : toString_1(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;

      while (!(step = functionCall(next, iterator)).done) {
        entryIterator = getIterator(anObject(step.value));
        entryNext = entryIterator.next;
        if ((first = functionCall(entryNext, entryIterator)).done || (second = functionCall(entryNext, entryIterator)).done || !functionCall(entryNext, entryIterator).done) throw TypeError$4('Expected sequence with length 2');
        push$3(this.entries, {
          key: toString_1(first.value),
          value: toString_1(second.value)
        });
      }
    } else for (var key in object) if (hasOwnProperty_1(object, key)) {
      push$3(this.entries, {
        key: key,
        value: toString_1(object[key])
      });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var attributes = split$2(query, '&');
      var index = 0;
      var attribute, entry;

      while (index < attributes.length) {
        attribute = attributes[index++];

        if (attribute.length) {
          entry = split$2(attribute, '=');
          push$3(this.entries, {
            key: deserialize(shift(entry)),
            value: deserialize(join$1(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;

    while (index < entries.length) {
      entry = entries[index++];
      push$3(result, serialize(entry.key) + '=' + serialize(entry.value));
    }

    return join$1(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
}; // `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams

var URLSearchParamsConstructor = function URLSearchParams()
/* init */
{
  anInstance(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  setInternalState$5(this, new URLSearchParamsState(init));
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;
defineBuiltIns(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    push$3(state.entries, {
      key: toString_1(name),
      value: toString_1(value)
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = toString_1(name);
    var index = 0;

    while (index < entries.length) {
      if (entries[index].key === key) splice$1(entries, index, 1);else index++;
    }

    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = toString_1(name);
    var index = 0;

    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }

    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = toString_1(name);
    var result = [];
    var index = 0;

    for (; index < entries.length; index++) {
      if (entries[index].key === key) push$3(result, entries[index].value);
    }

    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = toString_1(name);
    var index = 0;

    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }

    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = toString_1(name);
    var val = toString_1(value);
    var index = 0;
    var entry;

    for (; index < entries.length; index++) {
      entry = entries[index];

      if (entry.key === key) {
        if (found) splice$1(entries, index--, 1);else {
          found = true;
          entry.value = val;
        }
      }
    }

    if (!found) push$3(entries, {
      key: key,
      value: val
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback
  /* , thisArg */
  ) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = functionBindContext(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;

    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, {
  enumerable: true
}); // `URLSearchParams.prototype[@@iterator]` method

defineBuiltIn(URLSearchParamsPrototype, ITERATOR$7, URLSearchParamsPrototype.entries, {
  name: 'entries'
}); // `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior

defineBuiltIn(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, {
  enumerable: true
});
setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);
_export({
  global: true,
  constructor: true,
  forced: !urlConstructorDetection
}, {
  URLSearchParams: URLSearchParamsConstructor
}); // Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`

if (!urlConstructorDetection && isCallable(Headers)) {
  var headersHas = functionUncurryThis(HeadersPrototype.has);
  var headersSet = functionUncurryThis(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject(init)) {
      var body = init.body;
      var headers;

      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();

        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }

        return objectCreate(init, {
          body: createPropertyDescriptor(0, toString_1(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    }

    return init;
  };

  if (isCallable(nativeFetch)) {
    _export({
      global: true,
      enumerable: true,
      dontCallGetSet: true,
      forced: true
    }, {
      fetch: function fetch(input
      /* , init */
      ) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(NativeRequest)) {
    var RequestConstructor = function Request(input
    /* , init */
    ) {
      anInstance(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;
    _export({
      global: true,
      constructor: true,
      dontCallGetSet: true,
      forced: true
    }, {
      Request: RequestConstructor
    });
  }
}

var web_urlSearchParams_constructor = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};

var codeAt = stringMultibyte.codeAt;
var setInternalState$6 = internalState.set;
var getInternalURLState = internalState.getterFor('URL');
var URLSearchParams$1 = web_urlSearchParams_constructor.URLSearchParams;
var getInternalSearchParamsState = web_urlSearchParams_constructor.getState;
var NativeURL = global_1.URL;
var TypeError$5 = global_1.TypeError;
var parseInt$1 = global_1.parseInt;
var floor$3 = Math.floor;
var pow = Math.pow;
var charAt$3 = functionUncurryThis(''.charAt);
var exec$2 = functionUncurryThis(/./.exec);
var join$2 = functionUncurryThis([].join);
var numberToString = functionUncurryThis(1.0.toString);
var pop = functionUncurryThis([].pop);
var push$4 = functionUncurryThis([].push);
var replace$3 = functionUncurryThis(''.replace);
var shift$1 = functionUncurryThis([].shift);
var split$3 = functionUncurryThis(''.split);
var stringSlice$3 = functionUncurryThis(''.slice);
var toLowerCase$1 = functionUncurryThis(''.toLowerCase);
var unshift = functionUncurryThis([].unshift);
var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';
var ALPHA = /[a-z]/i; // eslint-disable-next-line regexp/no-obscure-range -- safe

var ALPHANUMERIC = /[\d+-.a-z]/i;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */

var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+|[\u0000-\u0020]+$/g;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */

var EOF; // https://url.spec.whatwg.org/#ipv4-number-parser

var parseIPv4 = function (input) {
  var parts = split$3(input, '.');
  var partsLength, numbers, index, part, radix, number, ipv4;

  if (parts.length && parts[parts.length - 1] == '') {
    parts.length--;
  }

  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];

  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;

    if (part.length > 1 && charAt$3(part, 0) == '0') {
      radix = exec$2(HEX_START, part) ? 16 : 8;
      part = stringSlice$3(part, radix == 8 ? 1 : 2);
    }

    if (part === '') {
      number = 0;
    } else {
      if (!exec$2(radix == 10 ? DEC : radix == 8 ? OCT : HEX, part)) return input;
      number = parseInt$1(part, radix);
    }

    push$4(numbers, number);
  }

  for (index = 0; index < partsLength; index++) {
    number = numbers[index];

    if (index == partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }

  ipv4 = pop(numbers);

  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }

  return ipv4;
}; // https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO


var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function () {
    return charAt$3(input, pointer);
  };

  if (chr() == ':') {
    if (charAt$3(input, 1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }

  while (chr()) {
    if (pieceIndex == 8) return;

    if (chr() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }

    value = length = 0;

    while (length < 4 && exec$2(HEX, chr())) {
      value = value * 16 + parseInt$1(chr(), 16);
      pointer++;
      length++;
    }

    if (chr() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;

      while (chr()) {
        ipv4Piece = null;

        if (numbersSeen > 0) {
          if (chr() == '.' && numbersSeen < 4) pointer++;else return;
        }

        if (!exec$2(DIGIT, chr())) return;

        while (exec$2(DIGIT, chr())) {
          number = parseInt$1(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;else if (ipv4Piece == 0) return;else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }

        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }

      if (numbersSeen != 4) return;
      break;
    } else if (chr() == ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;

    address[pieceIndex++] = value;
  }

  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;

    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;

  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;

  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }

      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }

  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }

  return maxIndex;
}; // https://url.spec.whatwg.org/#host-serializing


var serializeHost = function (host) {
  var result, index, compress, ignore0; // ipv4

  if (typeof host == 'number') {
    result = [];

    for (index = 0; index < 4; index++) {
      unshift(result, host % 256);
      host = floor$3(host / 256);
    }

    return join$2(result, '.'); // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);

    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;

      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += numberToString(host[index], 16);
        if (index < 7) result += ':';
      }
    }

    return '[' + result + ']';
  }

  return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = objectAssign({}, C0ControlPercentEncodeSet, {
  ' ': 1,
  '"': 1,
  '<': 1,
  '>': 1,
  '`': 1
});
var pathPercentEncodeSet = objectAssign({}, fragmentPercentEncodeSet, {
  '#': 1,
  '?': 1,
  '{': 1,
  '}': 1
});
var userinfoPercentEncodeSet = objectAssign({}, pathPercentEncodeSet, {
  '/': 1,
  ':': 1,
  ';': 1,
  '=': 1,
  '@': 1,
  '[': 1,
  '\\': 1,
  ']': 1,
  '^': 1,
  '|': 1
});

var percentEncode = function (chr, set) {
  var code = codeAt(chr, 0);
  return code > 0x20 && code < 0x7F && !hasOwnProperty_1(set, chr) ? chr : encodeURIComponent(chr);
}; // https://url.spec.whatwg.org/#special-scheme


var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
}; // https://url.spec.whatwg.org/#windows-drive-letter

var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length == 2 && exec$2(ALPHA, charAt$3(string, 0)) && ((second = charAt$3(string, 1)) == ':' || !normalized && second == '|');
}; // https://url.spec.whatwg.org/#start-with-a-windows-drive-letter


var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(stringSlice$3(string, 0, 2)) && (string.length == 2 || (third = charAt$3(string, 2)) === '/' || third === '\\' || third === '?' || third === '#');
}; // https://url.spec.whatwg.org/#single-dot-path-segment


var isSingleDot = function (segment) {
  return segment === '.' || toLowerCase$1(segment) === '%2e';
}; // https://url.spec.whatwg.org/#double-dot-path-segment


var isDoubleDot = function (segment) {
  segment = toLowerCase$1(segment);
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
}; // States:


var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

var URLState = function (url, isBase, base) {
  var urlString = toString_1(url);
  var baseState, failure, searchParams;

  if (isBase) {
    failure = this.parse(urlString);
    if (failure) throw TypeError$5(failure);
    this.searchParams = null;
  } else {
    if (base !== undefined) baseState = new URLState(base, true);
    failure = this.parse(urlString, null, baseState);
    if (failure) throw TypeError$5(failure);
    searchParams = getInternalSearchParamsState(new URLSearchParams$1());
    searchParams.bindURL(this);
    this.searchParams = searchParams;
  }
};

URLState.prototype = {
  type: 'URL',
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function (input, stateOverride, base) {
    var url = this;
    var state = stateOverride || SCHEME_START;
    var pointer = 0;
    var buffer = '';
    var seenAt = false;
    var seenBracket = false;
    var seenPasswordToken = false;
    var codePoints, chr, bufferCodePoints, failure;
    input = toString_1(input);

    if (!stateOverride) {
      url.scheme = '';
      url.username = '';
      url.password = '';
      url.host = null;
      url.port = null;
      url.path = [];
      url.query = null;
      url.fragment = null;
      url.cannotBeABaseURL = false;
      input = replace$3(input, LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, '');
    }

    input = replace$3(input, TAB_AND_NEW_LINE, '');
    codePoints = arrayFrom(input);

    while (pointer <= codePoints.length) {
      chr = codePoints[pointer];

      switch (state) {
        case SCHEME_START:
          if (chr && exec$2(ALPHA, chr)) {
            buffer += toLowerCase$1(chr);
            state = SCHEME;
          } else if (!stateOverride) {
            state = NO_SCHEME;
            continue;
          } else return INVALID_SCHEME;

          break;

        case SCHEME:
          if (chr && (exec$2(ALPHANUMERIC, chr) || chr == '+' || chr == '-' || chr == '.')) {
            buffer += toLowerCase$1(chr);
          } else if (chr == ':') {
            if (stateOverride && (url.isSpecial() != hasOwnProperty_1(specialSchemes, buffer) || buffer == 'file' && (url.includesCredentials() || url.port !== null) || url.scheme == 'file' && !url.host)) return;
            url.scheme = buffer;

            if (stateOverride) {
              if (url.isSpecial() && specialSchemes[url.scheme] == url.port) url.port = null;
              return;
            }

            buffer = '';

            if (url.scheme == 'file') {
              state = FILE;
            } else if (url.isSpecial() && base && base.scheme == url.scheme) {
              state = SPECIAL_RELATIVE_OR_AUTHORITY;
            } else if (url.isSpecial()) {
              state = SPECIAL_AUTHORITY_SLASHES;
            } else if (codePoints[pointer + 1] == '/') {
              state = PATH_OR_AUTHORITY;
              pointer++;
            } else {
              url.cannotBeABaseURL = true;
              push$4(url.path, '');
              state = CANNOT_BE_A_BASE_URL_PATH;
            }
          } else if (!stateOverride) {
            buffer = '';
            state = NO_SCHEME;
            pointer = 0;
            continue;
          } else return INVALID_SCHEME;

          break;

        case NO_SCHEME:
          if (!base || base.cannotBeABaseURL && chr != '#') return INVALID_SCHEME;

          if (base.cannotBeABaseURL && chr == '#') {
            url.scheme = base.scheme;
            url.path = arraySliceSimple(base.path);
            url.query = base.query;
            url.fragment = '';
            url.cannotBeABaseURL = true;
            state = FRAGMENT;
            break;
          }

          state = base.scheme == 'file' ? FILE : RELATIVE;
          continue;

        case SPECIAL_RELATIVE_OR_AUTHORITY:
          if (chr == '/' && codePoints[pointer + 1] == '/') {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
            pointer++;
          } else {
            state = RELATIVE;
            continue;
          }

          break;

        case PATH_OR_AUTHORITY:
          if (chr == '/') {
            state = AUTHORITY;
            break;
          } else {
            state = PATH;
            continue;
          }

        case RELATIVE:
          url.scheme = base.scheme;

          if (chr == EOF) {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySliceSimple(base.path);
            url.query = base.query;
          } else if (chr == '/' || chr == '\\' && url.isSpecial()) {
            state = RELATIVE_SLASH;
          } else if (chr == '?') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySliceSimple(base.path);
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySliceSimple(base.path);
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySliceSimple(base.path);
            url.path.length--;
            state = PATH;
            continue;
          }

          break;

        case RELATIVE_SLASH:
          if (url.isSpecial() && (chr == '/' || chr == '\\')) {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          } else if (chr == '/') {
            state = AUTHORITY;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            state = PATH;
            continue;
          }

          break;

        case SPECIAL_AUTHORITY_SLASHES:
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          if (chr != '/' || charAt$3(buffer, pointer + 1) != '/') continue;
          pointer++;
          break;

        case SPECIAL_AUTHORITY_IGNORE_SLASHES:
          if (chr != '/' && chr != '\\') {
            state = AUTHORITY;
            continue;
          }

          break;

        case AUTHORITY:
          if (chr == '@') {
            if (seenAt) buffer = '%40' + buffer;
            seenAt = true;
            bufferCodePoints = arrayFrom(buffer);

            for (var i = 0; i < bufferCodePoints.length; i++) {
              var codePoint = bufferCodePoints[i];

              if (codePoint == ':' && !seenPasswordToken) {
                seenPasswordToken = true;
                continue;
              }

              var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
              if (seenPasswordToken) url.password += encodedCodePoints;else url.username += encodedCodePoints;
            }

            buffer = '';
          } else if (chr == EOF || chr == '/' || chr == '?' || chr == '#' || chr == '\\' && url.isSpecial()) {
            if (seenAt && buffer == '') return INVALID_AUTHORITY;
            pointer -= arrayFrom(buffer).length + 1;
            buffer = '';
            state = HOST;
          } else buffer += chr;

          break;

        case HOST:
        case HOSTNAME:
          if (stateOverride && url.scheme == 'file') {
            state = FILE_HOST;
            continue;
          } else if (chr == ':' && !seenBracket) {
            if (buffer == '') return INVALID_HOST;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PORT;
            if (stateOverride == HOSTNAME) return;
          } else if (chr == EOF || chr == '/' || chr == '?' || chr == '#' || chr == '\\' && url.isSpecial()) {
            if (url.isSpecial() && buffer == '') return INVALID_HOST;
            if (stateOverride && buffer == '' && (url.includesCredentials() || url.port !== null)) return;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PATH_START;
            if (stateOverride) return;
            continue;
          } else {
            if (chr == '[') seenBracket = true;else if (chr == ']') seenBracket = false;
            buffer += chr;
          }

          break;

        case PORT:
          if (exec$2(DIGIT, chr)) {
            buffer += chr;
          } else if (chr == EOF || chr == '/' || chr == '?' || chr == '#' || chr == '\\' && url.isSpecial() || stateOverride) {
            if (buffer != '') {
              var port = parseInt$1(buffer, 10);
              if (port > 0xFFFF) return INVALID_PORT;
              url.port = url.isSpecial() && port === specialSchemes[url.scheme] ? null : port;
              buffer = '';
            }

            if (stateOverride) return;
            state = PATH_START;
            continue;
          } else return INVALID_PORT;

          break;

        case FILE:
          url.scheme = 'file';
          if (chr == '/' || chr == '\\') state = FILE_SLASH;else if (base && base.scheme == 'file') {
            if (chr == EOF) {
              url.host = base.host;
              url.path = arraySliceSimple(base.path);
              url.query = base.query;
            } else if (chr == '?') {
              url.host = base.host;
              url.path = arraySliceSimple(base.path);
              url.query = '';
              state = QUERY;
            } else if (chr == '#') {
              url.host = base.host;
              url.path = arraySliceSimple(base.path);
              url.query = base.query;
              url.fragment = '';
              state = FRAGMENT;
            } else {
              if (!startsWithWindowsDriveLetter(join$2(arraySliceSimple(codePoints, pointer), ''))) {
                url.host = base.host;
                url.path = arraySliceSimple(base.path);
                url.shortenPath();
              }

              state = PATH;
              continue;
            }
          } else {
            state = PATH;
            continue;
          }
          break;

        case FILE_SLASH:
          if (chr == '/' || chr == '\\') {
            state = FILE_HOST;
            break;
          }

          if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(join$2(arraySliceSimple(codePoints, pointer), ''))) {
            if (isWindowsDriveLetter(base.path[0], true)) push$4(url.path, base.path[0]);else url.host = base.host;
          }

          state = PATH;
          continue;

        case FILE_HOST:
          if (chr == EOF || chr == '/' || chr == '\\' || chr == '?' || chr == '#') {
            if (!stateOverride && isWindowsDriveLetter(buffer)) {
              state = PATH;
            } else if (buffer == '') {
              url.host = '';
              if (stateOverride) return;
              state = PATH_START;
            } else {
              failure = url.parseHost(buffer);
              if (failure) return failure;
              if (url.host == 'localhost') url.host = '';
              if (stateOverride) return;
              buffer = '';
              state = PATH_START;
            }

            continue;
          } else buffer += chr;

          break;

        case PATH_START:
          if (url.isSpecial()) {
            state = PATH;
            if (chr != '/' && chr != '\\') continue;
          } else if (!stateOverride && chr == '?') {
            url.query = '';
            state = QUERY;
          } else if (!stateOverride && chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            state = PATH;
            if (chr != '/') continue;
          }

          break;

        case PATH:
          if (chr == EOF || chr == '/' || chr == '\\' && url.isSpecial() || !stateOverride && (chr == '?' || chr == '#')) {
            if (isDoubleDot(buffer)) {
              url.shortenPath();

              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                push$4(url.path, '');
              }
            } else if (isSingleDot(buffer)) {
              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                push$4(url.path, '');
              }
            } else {
              if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
                if (url.host) url.host = '';
                buffer = charAt$3(buffer, 0) + ':'; // normalize windows drive letter
              }

              push$4(url.path, buffer);
            }

            buffer = '';

            if (url.scheme == 'file' && (chr == EOF || chr == '?' || chr == '#')) {
              while (url.path.length > 1 && url.path[0] === '') {
                shift$1(url.path);
              }
            }

            if (chr == '?') {
              url.query = '';
              state = QUERY;
            } else if (chr == '#') {
              url.fragment = '';
              state = FRAGMENT;
            }
          } else {
            buffer += percentEncode(chr, pathPercentEncodeSet);
          }

          break;

        case CANNOT_BE_A_BASE_URL_PATH:
          if (chr == '?') {
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
          }

          break;

        case QUERY:
          if (!stateOverride && chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            if (chr == "'" && url.isSpecial()) url.query += '%27';else if (chr == '#') url.query += '%23';else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
          }

          break;

        case FRAGMENT:
          if (chr != EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
          break;
      }

      pointer++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function (input) {
    var result, codePoints, index;

    if (charAt$3(input, 0) == '[') {
      if (charAt$3(input, input.length - 1) != ']') return INVALID_HOST;
      result = parseIPv6(stringSlice$3(input, 1, -1));
      if (!result) return INVALID_HOST;
      this.host = result; // opaque host
    } else if (!this.isSpecial()) {
      if (exec$2(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
      result = '';
      codePoints = arrayFrom(input);

      for (index = 0; index < codePoints.length; index++) {
        result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
      }

      this.host = result;
    } else {
      input = stringPunycodeToAscii(input);
      if (exec$2(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
      result = parseIPv4(input);
      if (result === null) return INVALID_HOST;
      this.host = result;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function () {
    return !this.host || this.cannotBeABaseURL || this.scheme == 'file';
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function () {
    return this.username != '' || this.password != '';
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function () {
    return hasOwnProperty_1(specialSchemes, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function () {
    var path = this.path;
    var pathSize = path.length;

    if (pathSize && (this.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
      path.length--;
    }
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function () {
    var url = this;
    var scheme = url.scheme;
    var username = url.username;
    var password = url.password;
    var host = url.host;
    var port = url.port;
    var path = url.path;
    var query = url.query;
    var fragment = url.fragment;
    var output = scheme + ':';

    if (host !== null) {
      output += '//';

      if (url.includesCredentials()) {
        output += username + (password ? ':' + password : '') + '@';
      }

      output += serializeHost(host);
      if (port !== null) output += ':' + port;
    } else if (scheme == 'file') output += '//';

    output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join$2(path, '/') : '';
    if (query !== null) output += '?' + query;
    if (fragment !== null) output += '#' + fragment;
    return output;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function (href) {
    var failure = this.parse(href);
    if (failure) throw TypeError$5(failure);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function () {
    var scheme = this.scheme;
    var port = this.port;
    if (scheme == 'blob') try {
      return new URLConstructor(scheme.path[0]).origin;
    } catch (error) {
      return 'null';
    }
    if (scheme == 'file' || !this.isSpecial()) return 'null';
    return scheme + '://' + serializeHost(this.host) + (port !== null ? ':' + port : '');
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function () {
    return this.scheme + ':';
  },
  setProtocol: function (protocol) {
    this.parse(toString_1(protocol) + ':', SCHEME_START);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function () {
    return this.username;
  },
  setUsername: function (username) {
    var codePoints = arrayFrom(toString_1(username));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.username = '';

    for (var i = 0; i < codePoints.length; i++) {
      this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function () {
    return this.password;
  },
  setPassword: function (password) {
    var codePoints = arrayFrom(toString_1(password));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.password = '';

    for (var i = 0; i < codePoints.length; i++) {
      this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function () {
    var host = this.host;
    var port = this.port;
    return host === null ? '' : port === null ? serializeHost(host) : serializeHost(host) + ':' + port;
  },
  setHost: function (host) {
    if (this.cannotBeABaseURL) return;
    this.parse(host, HOST);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function () {
    var host = this.host;
    return host === null ? '' : serializeHost(host);
  },
  setHostname: function (hostname) {
    if (this.cannotBeABaseURL) return;
    this.parse(hostname, HOSTNAME);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function () {
    var port = this.port;
    return port === null ? '' : toString_1(port);
  },
  setPort: function (port) {
    if (this.cannotHaveUsernamePasswordPort()) return;
    port = toString_1(port);
    if (port == '') this.port = null;else this.parse(port, PORT);
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function () {
    var path = this.path;
    return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join$2(path, '/') : '';
  },
  setPathname: function (pathname) {
    if (this.cannotBeABaseURL) return;
    this.path = [];
    this.parse(pathname, PATH_START);
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function () {
    var query = this.query;
    return query ? '?' + query : '';
  },
  setSearch: function (search) {
    search = toString_1(search);

    if (search == '') {
      this.query = null;
    } else {
      if ('?' == charAt$3(search, 0)) search = stringSlice$3(search, 1);
      this.query = '';
      this.parse(search, QUERY);
    }

    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function () {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function () {
    var fragment = this.fragment;
    return fragment ? '#' + fragment : '';
  },
  setHash: function (hash) {
    hash = toString_1(hash);

    if (hash == '') {
      this.fragment = null;
      return;
    }

    if ('#' == charAt$3(hash, 0)) hash = stringSlice$3(hash, 1);
    this.fragment = '';
    this.parse(hash, FRAGMENT);
  },
  update: function () {
    this.query = this.searchParams.serialize() || null;
  }
}; // `URL` constructor
// https://url.spec.whatwg.org/#url-class

var URLConstructor = function URL(url
/* , base */
) {
  var that = anInstance(this, URLPrototype);
  var base = validateArgumentsLength(arguments.length, 1) > 1 ? arguments[1] : undefined;
  var state = setInternalState$6(that, new URLState(url, false, base));

  if (!descriptors) {
    that.href = state.serialize();
    that.origin = state.getOrigin();
    that.protocol = state.getProtocol();
    that.username = state.getUsername();
    that.password = state.getPassword();
    that.host = state.getHost();
    that.hostname = state.getHostname();
    that.port = state.getPort();
    that.pathname = state.getPathname();
    that.search = state.getSearch();
    that.searchParams = state.getSearchParams();
    that.hash = state.getHash();
  }
};

var URLPrototype = URLConstructor.prototype;

var accessorDescriptor = function (getter, setter) {
  return {
    get: function () {
      return getInternalURLState(this)[getter]();
    },
    set: setter && function (value) {
      return getInternalURLState(this)[setter](value);
    },
    configurable: true,
    enumerable: true
  };
};

if (descriptors) {
  // `URL.prototype.href` accessors pair
  // https://url.spec.whatwg.org/#dom-url-href
  defineBuiltInAccessor(URLPrototype, 'href', accessorDescriptor('serialize', 'setHref')); // `URL.prototype.origin` getter
  // https://url.spec.whatwg.org/#dom-url-origin

  defineBuiltInAccessor(URLPrototype, 'origin', accessorDescriptor('getOrigin')); // `URL.prototype.protocol` accessors pair
  // https://url.spec.whatwg.org/#dom-url-protocol

  defineBuiltInAccessor(URLPrototype, 'protocol', accessorDescriptor('getProtocol', 'setProtocol')); // `URL.prototype.username` accessors pair
  // https://url.spec.whatwg.org/#dom-url-username

  defineBuiltInAccessor(URLPrototype, 'username', accessorDescriptor('getUsername', 'setUsername')); // `URL.prototype.password` accessors pair
  // https://url.spec.whatwg.org/#dom-url-password

  defineBuiltInAccessor(URLPrototype, 'password', accessorDescriptor('getPassword', 'setPassword')); // `URL.prototype.host` accessors pair
  // https://url.spec.whatwg.org/#dom-url-host

  defineBuiltInAccessor(URLPrototype, 'host', accessorDescriptor('getHost', 'setHost')); // `URL.prototype.hostname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hostname

  defineBuiltInAccessor(URLPrototype, 'hostname', accessorDescriptor('getHostname', 'setHostname')); // `URL.prototype.port` accessors pair
  // https://url.spec.whatwg.org/#dom-url-port

  defineBuiltInAccessor(URLPrototype, 'port', accessorDescriptor('getPort', 'setPort')); // `URL.prototype.pathname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-pathname

  defineBuiltInAccessor(URLPrototype, 'pathname', accessorDescriptor('getPathname', 'setPathname')); // `URL.prototype.search` accessors pair
  // https://url.spec.whatwg.org/#dom-url-search

  defineBuiltInAccessor(URLPrototype, 'search', accessorDescriptor('getSearch', 'setSearch')); // `URL.prototype.searchParams` getter
  // https://url.spec.whatwg.org/#dom-url-searchparams

  defineBuiltInAccessor(URLPrototype, 'searchParams', accessorDescriptor('getSearchParams')); // `URL.prototype.hash` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hash

  defineBuiltInAccessor(URLPrototype, 'hash', accessorDescriptor('getHash', 'setHash'));
} // `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson


defineBuiltIn(URLPrototype, 'toJSON', function toJSON() {
  return getInternalURLState(this).serialize();
}, {
  enumerable: true
}); // `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior

defineBuiltIn(URLPrototype, 'toString', function toString() {
  return getInternalURLState(this).serialize();
}, {
  enumerable: true
});

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL; // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL

  if (nativeCreateObjectURL) defineBuiltIn(URLConstructor, 'createObjectURL', functionBindContext(nativeCreateObjectURL, NativeURL)); // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL

  if (nativeRevokeObjectURL) defineBuiltIn(URLConstructor, 'revokeObjectURL', functionBindContext(nativeRevokeObjectURL, NativeURL));
}

setToStringTag(URLConstructor, 'URL');
_export({
  global: true,
  constructor: true,
  forced: !urlConstructorDetection,
  sham: !descriptors
}, {
  URL: URLConstructor
});

var ct = Object.create,
    Ie = Object.defineProperty;
var mt = Object.getOwnPropertyDescriptor;
var dt = Object.getOwnPropertyNames;
var pt = Object.getPrototypeOf,
    ft = Object.prototype.hasOwnProperty;

var ht = function ht(t) {
  return Ie(t, "__esModule", {
    value: !0
  });
};

var vt = function vt(t, e) {
  return function () {
    return e || t((e = {
      exports: {}
    }).exports, e), e.exports;
  };
};

var Tt = function Tt(t, e, n) {
  if (e && _typeof$1(e) == "object" || typeof e == "function") {
    var _iterator = _createForOfIteratorHelper(dt(e)),
        _step;

    try {
      var _loop = function _loop() {
        var r = _step.value;
        !ft.call(t, r) && r !== "default" && Ie(t, r, {
          get: function get() {
            return e[r];
          },
          enumerable: !(n = mt(e, r)) || n.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return t;
},
    It = function It(t) {
  return Tt(ht(Ie(t != null ? ct(pt(t)) : {}, "default", t && t.__esModule && "default" in t ? {
    get: function get() {
      return t.default;
    },
    enumerable: !0
  } : {
    value: t,
    enumerable: !0
  })), t);
};

var Ue = vt(function (ie, Fe) {
  (function (t, e) {
    _typeof$1(ie) == "object" && typeof Fe != "undefined" ? e(ie) : typeof define == "function" && define.amd ? define(["exports"], e) : (t = typeof globalThis != "undefined" ? globalThis : t || self, e(t.fastUniqueNumbers = {}));
  })(ie, function (t) {

    var e = function e(p) {
      return function (h) {
        var o = p(h);
        return h.add(o), o;
      };
    },
        n = function n(p) {
      return function (h, o) {
        return p.set(h, o), o;
      };
    },
        r = Number.MAX_SAFE_INTEGER === void 0 ? 9007199254740991 : Number.MAX_SAFE_INTEGER,
        a = 536870912,
        u = a * 2,
        b = function b(p, h) {
      return function (o) {
        var x = h.get(o),
            M = x === void 0 ? o.size : x < u ? x + 1 : 0;
        if (!o.has(M)) return p(o, M);

        if (o.size < a) {
          for (; o.has(M);) {
            M = Math.floor(Math.random() * u);
          }

          return p(o, M);
        }

        if (o.size > r) throw new Error("Congratulations, you created a collection of unique numbers which uses all available integers!");

        for (; o.has(M);) {
          M = Math.floor(Math.random() * r);
        }

        return p(o, M);
      };
    },
        W = new WeakMap(),
        ee = n(W),
        m = b(ee, W),
        c = e(m);

    t.addUniqueNumber = c, t.generateUniqueNumber = m, Object.defineProperty(t, "__esModule", {
      value: !0
    });
  });
});
var K = It(Ue());

var We = function We(t) {
  return t.method !== void 0 && t.method === "call";
};

var Be = function Be(t) {
  return t.error === null && typeof t.id == "number";
};

var Ve = function Ve(t) {
  var e = new Map([[0, function () {}]]),
      n = new Map([[0, function () {}]]),
      r = new Map(),
      a = new Worker(t);
  return a.addEventListener("message", function (_ref) {
    var m = _ref.data;

    if (We(m)) {
      var _m$params = m.params,
          c = _m$params.timerId,
          d = _m$params.timerType;

      if (d === "interval") {
        var p = e.get(c);

        if (typeof p == "number") {
          var h = r.get(p);
          if (h === void 0 || h.timerId !== c || h.timerType !== d) throw new Error("The timer is in an undefined state.");
        } else if (typeof p != "undefined") p();else throw new Error("The timer is in an undefined state.");
      } else if (d === "timeout") {
        var _p = n.get(c);

        if (typeof _p == "number") {
          var _h = r.get(_p);

          if (_h === void 0 || _h.timerId !== c || _h.timerType !== d) throw new Error("The timer is in an undefined state.");
        } else if (typeof _p != "undefined") _p(), n.delete(c);else throw new Error("The timer is in an undefined state.");
      }
    } else if (Be(m)) {
      var _c = m.id,
          _d = r.get(_c);

      if (_d === void 0) throw new Error("The timer is in an undefined state.");
      var _p2 = _d.timerId,
          _h2 = _d.timerType;
      r.delete(_c), _h2 === "interval" ? e.delete(_p2) : n.delete(_p2);
    } else {
      var _c2 = m.error.message;
      throw new Error(_c2);
    }
  }), {
    clearInterval: function clearInterval(m) {
      var c = (0, K.generateUniqueNumber)(r);
      r.set(c, {
        timerId: m,
        timerType: "interval"
      }), e.set(m, c), a.postMessage({
        id: c,
        method: "clear",
        params: {
          timerId: m,
          timerType: "interval"
        }
      });
    },
    clearTimeout: function clearTimeout(m) {
      var c = (0, K.generateUniqueNumber)(r);
      r.set(c, {
        timerId: m,
        timerType: "timeout"
      }), n.set(m, c), a.postMessage({
        id: c,
        method: "clear",
        params: {
          timerId: m,
          timerType: "timeout"
        }
      });
    },
    setInterval: function setInterval(m, c) {
      var d = (0, K.generateUniqueNumber)(e);
      return e.set(d, function () {
        m(), typeof e.get(d) == "function" && a.postMessage({
          id: null,
          method: "set",
          params: {
            delay: c,
            now: performance.now(),
            timerId: d,
            timerType: "interval"
          }
        });
      }), a.postMessage({
        id: null,
        method: "set",
        params: {
          delay: c,
          now: performance.now(),
          timerId: d,
          timerType: "interval"
        }
      }), d;
    },
    setTimeout: function setTimeout(m, c) {
      var d = (0, K.generateUniqueNumber)(n);
      return n.set(d, m), a.postMessage({
        id: null,
        method: "set",
        params: {
          delay: c,
          now: performance.now(),
          timerId: d,
          timerType: "timeout"
        }
      }), d;
    }
  };
};

var Q = null,
    He = function He(t, e) {
  return function () {
    if (Q !== null) return Q;
    var n = new Blob([e], {
      type: "application/javascript; charset=utf-8"
    }),
        r = URL.createObjectURL(n);
    return Q = t(r), Q.setTimeout(function () {
      return URL.revokeObjectURL(r);
    }, 0), Q;
  };
};

var Ge = "(()=>{\"use strict\";const e=new Map,t=new Map,r=(e,t)=>{let r,o;const i=performance.now();r=i,o=e-Math.max(0,i-t);return{expected:r+o,remainingDelay:o}},o=(e,t,r,i)=>{const s=performance.now();s>r?postMessage({id:null,method:\"call\",params:{timerId:t,timerType:i}}):e.set(t,setTimeout(o,r-s,e,t,r,i))};addEventListener(\"message\",(i=>{let{data:s}=i;try{if(\"clear\"===s.method){const{id:r,params:{timerId:o,timerType:i}}=s;if(\"interval\"===i)(t=>{const r=e.get(t);if(void 0===r)throw new Error('There is no interval scheduled with the given id \"'.concat(t,'\".'));clearTimeout(r),e.delete(t)})(o),postMessage({error:null,id:r});else{if(\"timeout\"!==i)throw new Error('The given type \"'.concat(i,'\" is not supported'));(e=>{const r=t.get(e);if(void 0===r)throw new Error('There is no timeout scheduled with the given id \"'.concat(e,'\".'));clearTimeout(r),t.delete(e)})(o),postMessage({error:null,id:r})}}else{if(\"set\"!==s.method)throw new Error('The given method \"'.concat(s.method,'\" is not supported'));{const{params:{delay:i,now:n,timerId:a,timerType:d}}=s;if(\"interval\"===d)((t,i,s)=>{const{expected:n,remainingDelay:a}=r(t,s);e.set(i,setTimeout(o,a,e,i,n,\"interval\"))})(i,a,n);else{if(\"timeout\"!==d)throw new Error('The given type \"'.concat(d,'\" is not supported'));((e,i,s)=>{const{expected:n,remainingDelay:a}=r(e,s);t.set(i,setTimeout(o,a,t,i,n,\"timeout\"))})(i,a,n)}}}}catch(e){postMessage({error:{message:e.message},id:s.id,result:null})}}))})();";

var se = He(Ve, Ge),
    qe = function qe(t) {
  return se().clearInterval(t);
},
    je = function je(t) {
  return se().clearTimeout(t);
},
    Ye = function Ye(t, e) {
  return se().setInterval(t, e);
},
    Je = function Je(t, e) {
  return se().setTimeout(t, e);
};

var w = (typeof window == "undefined" ? "undefined" : typeof window === "undefined" ? "undefined" : _typeof$1(window)) == "object";
var T = {
  setTimeout: w ? setTimeout.bind(window) : setTimeout,
  clearTimeout: w ? clearTimeout.bind(window) : clearTimeout,
  setInterval: w ? setInterval.bind(window) : setInterval,
  clearInterval: w ? clearInterval.bind(window) : clearInterval
},
    Z = {
  setTimeout: Je,
  clearTimeout: je,
  setInterval: Ye,
  clearInterval: qe
};

function ze(t) {
  T.setTimeout = t.setTimeout, T.clearTimeout = t.clearTimeout, T.setInterval = t.setInterval, T.clearInterval = t.clearInterval;
}

var Y = {},
    Xe = /*#__PURE__*/function () {
  function Xe(e) {
    _classCallCheck$1(this, Xe);

    this.closed = !1;
    this.mc = new MessageChannel();
    this.name = e, Y[e] = Y[e] || [], Y[e].push(this), this.mc.port1.start(), this.mc.port2.start(), this.onStorage = this.onStorage.bind(this), window.addEventListener("storage", this.onStorage);
  }

  _createClass(Xe, [{
    key: "onStorage",
    value: function onStorage(e) {
      if (e.storageArea !== window.localStorage || e.key.substring(0, this.name.length) !== this.name || e.newValue === null) return;
      var n = JSON.parse(e.newValue);
      this.mc.port2.postMessage(n);
    }
  }, {
    key: "postMessage",
    value: function postMessage(e) {
      var _this = this;

      if (this.closed) throw new Error("InvalidStateError");
      var n = JSON.stringify(e),
          r = "".concat(this.name, ":").concat(String(Date.now())).concat(String(Math.random()));
      window.localStorage.setItem(r, n), T.setTimeout(function () {
        window.localStorage.removeItem(r);
      }, 500), Y[this.name].forEach(function (a) {
        a !== _this && a.mc.port2.postMessage(JSON.parse(n));
      });
    }
  }, {
    key: "close",
    value: function close() {
      if (this.closed) return;
      this.closed = !0, this.mc.port1.close(), this.mc.port2.close(), window.removeEventListener("storage", this.onStorage);
      var e = Y[this.name].indexOf(this);
      Y[this.name].splice(e, 1);
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(e, n) {
      return this.mc.port1.addEventListener(e, n);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(e, n) {
      return this.mc.port1.removeEventListener(e, n);
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(e) {
      return this.mc.port1.dispatchEvent(e);
    }
  }, {
    key: "onmessage",
    get: function get() {
      return this.mc.port1.onmessage;
    },
    set: function set(e) {
      this.mc.port1.onmessage = e;
    }
  }, {
    key: "onmessageerror",
    get: function get() {
      return this.mc.port1.onmessageerror;
    },
    set: function set(e) {
      this.mc.port1.onmessageerror = e;
    }
  }]);

  return Xe;
}(),
    $e = typeof window == "undefined" ? void 0 : typeof window.BroadcastChannel == "function" ? window.BroadcastChannel : Xe;

function Ke() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return new Promise(function (e) {
    return T.setTimeout(e, t);
  });
}

function ae() {
  return Math.random().toString(36).substring(2);
}

var l;

(function (o) {
  o[o.APPLY = 0] = "APPLY", o[o.TELL = 1] = "TELL", o[o.CLOSE = 2] = "CLOSE", o[o.REGISTER = 3] = "REGISTER", o[o.DEREGISTER = 4] = "DEREGISTER", o[o.IDLE = 5] = "IDLE", o[o.ACTIVE = 6] = "ACTIVE", o[o.PROMPT = 7] = "PROMPT", o[o.START = 8] = "START", o[o.RESET = 9] = "RESET", o[o.ACTIVATE = 10] = "ACTIVATE", o[o.PAUSE = 11] = "PAUSE", o[o.RESUME = 12] = "RESUME", o[o.MESSAGE = 13] = "MESSAGE";
})(l || (l = {}));

var Ee = /*#__PURE__*/function () {
  function Ee(e, n) {
    _classCallCheck$1(this, Ee);

    this.token = ae();
    this.isLeader = !1;
    this.isDead = !1;
    this.isApplying = !1;
    this.reApply = !1;
    this.intervals = [];
    this.listeners = [];
    this.channel = e, this.options = n, this.apply = this.apply.bind(this), this.awaitLeadership = this.awaitLeadership.bind(this), this.sendAction = this.sendAction.bind(this);
  }

  _createClass(Ee, [{
    key: "apply",
    value: function () {
      var _apply = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var e, n;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.isLeader || this.isDead)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", !1);

              case 2:
                if (!this.isApplying) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", (this.reApply = !0, !1));

              case 4:
                this.isApplying = !0;
                e = !1, n = function n(r) {
                  var _r$data = r.data,
                      a = _r$data.token,
                      u = _r$data.action;
                  a !== _this2.token && (u === l.APPLY && a > _this2.token && (e = !0), u === l.TELL && (e = !0));
                };
                this.channel.addEventListener("message", n);
                _context.prev = 7;
                this.sendAction(l.APPLY);
                _context.next = 11;
                return Ke(this.options.responseTime);

              case 11:
                this.channel.removeEventListener("message", n);
                this.isApplying = !1;
                return _context.abrupt("return", e ? this.reApply ? this.apply() : !1 : (this.assumeLead(), !0));

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](7);
                return _context.abrupt("return", !1);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 16]]);
      }));

      function apply() {
        return _apply.apply(this, arguments);
      }

      return apply;
    }()
  }, {
    key: "awaitLeadership",
    value: function awaitLeadership() {
      var _this3 = this;

      if (this.isLeader) return Promise.resolve();
      var e = !1,
          n = null;
      return new Promise(function (r) {
        var a = function a() {
          if (e) return;
          e = !0, T.clearInterval(n);

          var b = _this3.intervals.indexOf(n);

          _this3.intervals.splice(b, 1), _this3.channel.removeEventListener("message", u), r();
        };

        n = T.setInterval(function () {
          _this3.apply().then(function () {
            _this3.isLeader && a();
          });
        }, _this3.options.fallbackInterval), _this3.intervals.push(n);

        var u = function u(b) {
          var W = b.data.action;
          W === l.CLOSE && _this3.apply().then(function () {
            _this3.isLeader && a();
          });
        };

        _this3.channel.addEventListener("message", u);
      });
    }
  }, {
    key: "sendAction",
    value: function sendAction(e) {
      this.channel.postMessage({
        action: e,
        token: this.token
      });
    }
  }, {
    key: "assumeLead",
    value: function assumeLead() {
      var _this4 = this;

      this.isLeader = !0;

      var e = function e(n) {
        var r = n.data.action;
        r === l.APPLY && _this4.sendAction(l.TELL);
      };

      return this.channel.addEventListener("message", e), this.listeners.push(e), this.sendAction(l.TELL);
    }
  }, {
    key: "waitForLeadership",
    value: function waitForLeadership() {
      return this.deferred ? this.deferred : (this.deferred = this.awaitLeadership(), this.deferred);
    }
  }, {
    key: "close",
    value: function close() {
      var _this5 = this;

      this.isDead || (this.isDead = !0, this.isLeader = !1, this.sendAction(l.CLOSE), this.listeners.forEach(function (e) {
        return _this5.channel.removeEventListener("message", e);
      }), this.intervals.forEach(function (e) {
        return T.clearInterval(e);
      }));
    }
  }]);

  return Ee;
}();

var k;

(function (r) {
  r[r.PROMPTED = 0] = "PROMPTED", r[r.ACTIVE = 1] = "ACTIVE", r[r.IDLE = 2] = "IDLE";
})(k || (k = {}));

var be = /*#__PURE__*/function () {
  function be(e) {
    var _this6 = this;

    _classCallCheck$1(this, be);

    this.token = ae();
    this.registry = new Map();
    this.allIdle = !1;
    var n = e.channelName;

    if (this.options = e, this.channel = new $e(n), this.registry.set(this.token, 1), e.leaderElection) {
      var r = {
        fallbackInterval: 2e3,
        responseTime: 100
      };
      this.elector = new Ee(this.channel, r), this.elector.waitForLeadership();
    }

    this.channel.addEventListener("message", function (r) {
      var _r$data2 = r.data,
          a = _r$data2.action,
          u = _r$data2.token,
          b = _r$data2.data;

      switch (a) {
        case l.REGISTER:
          _this6.registry.set(u, 2);

          break;

        case l.DEREGISTER:
          _this6.registry.delete(u);

          break;

        case l.IDLE:
          _this6.idle(u);

          break;

        case l.ACTIVE:
          _this6.active(u);

          break;

        case l.PROMPT:
          _this6.prompt(u);

          break;

        case l.START:
          _this6.start(u);

          break;

        case l.RESET:
          _this6.reset(u);

          break;

        case l.ACTIVATE:
          _this6.activate(u);

          break;

        case l.PAUSE:
          _this6.pause(u);

          break;

        case l.RESUME:
          _this6.resume(u);

          break;

        case l.MESSAGE:
          _this6.options.onMessage(b);

          break;
      }
    }), this.send(l.REGISTER);
  }

  _createClass(be, [{
    key: "prompt",
    value: function prompt() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.token;
      this.registry.set(e, 0);

      var n = _toConsumableArray(this.registry.values()).every(function (r) {
        return r === 0;
      });

      e === this.token && this.send(l.PROMPT), n && this.options.onPrompt();
    }
  }, {
    key: "idle",
    value: function idle() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.token;
      this.registry.set(e, 2);

      var n = _toConsumableArray(this.registry.values()).every(function (r) {
        return r === 2;
      });

      e === this.token && this.send(l.IDLE), !this.allIdle && n && (this.allIdle = !0, this.options.onIdle());
    }
  }, {
    key: "active",
    value: function active() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.token;
      this.allIdle = !1, this.registry.set(e, 1);

      var n = _toConsumableArray(this.registry.values()).some(function (r) {
        return r === 1;
      });

      e === this.token && this.send(l.ACTIVE), n && this.options.onActive();
    }
  }, {
    key: "start",
    value: function start() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.token;
      this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send(l.START) : this.options.start(!0);
    }
  }, {
    key: "reset",
    value: function reset() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.token;
      this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send(l.RESET) : this.options.reset(!0);
    }
  }, {
    key: "activate",
    value: function activate() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.token;
      this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send(l.ACTIVATE) : this.options.activate(!0);
    }
  }, {
    key: "pause",
    value: function pause() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.token;
      e === this.token ? this.send(l.PAUSE) : this.options.pause(!0);
    }
  }, {
    key: "resume",
    value: function resume() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.token;
      e === this.token ? this.send(l.RESUME) : this.options.resume(!0);
    }
  }, {
    key: "message",
    value: function message(e) {
      try {
        this.channel.postMessage({
          action: l.MESSAGE,
          token: this.token,
          data: e
        });
      } catch (_unused2) {}
    }
  }, {
    key: "send",
    value: function send(e) {
      try {
        this.channel.postMessage({
          action: e,
          token: this.token
        });
      } catch (_unused3) {}
    }
  }, {
    key: "close",
    value: function close() {
      this.options.leaderElection && this.elector.close(), this.send(l.DEREGISTER), this.channel.close();
    }
  }, {
    key: "isLeader",
    get: function get() {
      if (!this.elector) throw new Error("\u274C Leader election is not enabled. To Enable it set the \"leaderElection\" property to true.");
      return this.elector.isLeader;
    }
  }]);

  return be;
}();

var Qe = w ? document : null,
    ge = ["mousemove", "keydown", "wheel", "DOMMouseScroll", "mousewheel", "mousedown", "touchstart", "touchmove", "MSPointerDown", "MSPointerMove", "visibilitychange"];

function F(t) {
  var e = useRef(t);
  return useEffect(function () {
    e.current = t;
  }, [t]), e;
}

function Ze(t, e) {
  var n;

  function r() {
    for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
      a[_key] = arguments[_key];
    }

    n && clearTimeout(n), n = setTimeout(function () {
      t.apply(void 0, a), n = null;
    }, e);
  }

  return r.cancel = function () {
    clearTimeout(n);
  }, r;
}

function le(t, e) {
  var n = 0;
  return function () {
    var a = new Date().getTime();
    if (!(a - n < e)) return n = a, t.apply(void 0, arguments);
  };
}

var E = function E() {
  return w ? performance.now() : Date.now();
};

function $() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$timeout = _ref2.timeout,
      t = _ref2$timeout === void 0 ? 1e3 * 60 * 20 : _ref2$timeout,
      _ref2$promptTimeout = _ref2.promptTimeout,
      e = _ref2$promptTimeout === void 0 ? 0 : _ref2$promptTimeout,
      _ref2$element = _ref2.element,
      n = _ref2$element === void 0 ? Qe : _ref2$element,
      _ref2$events = _ref2.events,
      r = _ref2$events === void 0 ? ge : _ref2$events,
      _ref2$timers = _ref2.timers,
      a = _ref2$timers === void 0 ? void 0 : _ref2$timers,
      _ref2$immediateEvents = _ref2.immediateEvents,
      u = _ref2$immediateEvents === void 0 ? [] : _ref2$immediateEvents,
      _ref2$onPrompt = _ref2.onPrompt,
      b = _ref2$onPrompt === void 0 ? function () {} : _ref2$onPrompt,
      _ref2$onIdle = _ref2.onIdle,
      W = _ref2$onIdle === void 0 ? function () {} : _ref2$onIdle,
      _ref2$onActive = _ref2.onActive,
      ee = _ref2$onActive === void 0 ? function () {} : _ref2$onActive,
      _ref2$onAction = _ref2.onAction,
      m = _ref2$onAction === void 0 ? function () {} : _ref2$onAction,
      _ref2$onMessage = _ref2.onMessage,
      c = _ref2$onMessage === void 0 ? function () {} : _ref2$onMessage,
      _ref2$debounce = _ref2.debounce,
      d = _ref2$debounce === void 0 ? 0 : _ref2$debounce,
      _ref2$throttle = _ref2.throttle,
      p = _ref2$throttle === void 0 ? 0 : _ref2$throttle,
      _ref2$eventsThrottle = _ref2.eventsThrottle,
      h = _ref2$eventsThrottle === void 0 ? 200 : _ref2$eventsThrottle,
      _ref2$startOnMount = _ref2.startOnMount,
      o = _ref2$startOnMount === void 0 ? !0 : _ref2$startOnMount,
      _ref2$startManually = _ref2.startManually,
      x = _ref2$startManually === void 0 ? !1 : _ref2$startManually,
      _ref2$stopOnIdle = _ref2.stopOnIdle,
      M = _ref2$stopOnIdle === void 0 ? !1 : _ref2$stopOnIdle,
      _ref2$crossTab = _ref2.crossTab,
      G = _ref2$crossTab === void 0 ? !1 : _ref2$crossTab,
      _ref2$name = _ref2.name,
      we = _ref2$name === void 0 ? "idle-timer" : _ref2$name,
      _ref2$syncTimers = _ref2.syncTimers,
      J = _ref2$syncTimers === void 0 ? 0 : _ref2$syncTimers,
      _ref2$leaderElection = _ref2.leaderElection,
      ye = _ref2$leaderElection === void 0 ? !1 : _ref2$leaderElection;

  var q = useRef(E()),
      Le = useRef(Date.now()),
      te = useRef(E()),
      D = useRef(null),
      N = useRef(null),
      z = useRef(0),
      v = useRef(!0),
      A = useRef(!1),
      B = useRef(!0),
      X = useRef(!1),
      g = useRef(!1),
      y = useRef(0),
      R = useRef(0),
      O = useRef(null),
      s = useRef(null),
      C = F(t),
      re = F(e),
      et = F(M),
      ke = useRef(u),
      ce = useRef(n),
      me = useRef(_toConsumableArray(new Set([].concat(_toConsumableArray(r), _toConsumableArray(u))).values())),
      xe = F(W),
      de = F(ee),
      Me = F(b),
      ne = F(c),
      L = useRef();
  useEffect(function () {
    L.current && L.current.cancel && L.current.cancel(), d > 0 ? L.current = Ze(m, d) : p > 0 ? L.current = le(m, p) : L.current = m;
  }, [m, p, d]);
  var Pe = useRef();
  useEffect(function () {
    G && J && (Pe.current = le(function () {
      s.current.active();
    }, J));
  }, [G, J]);

  var P = function P() {
    O.current !== null && (T.clearTimeout(O.current), O.current = null);
  },
      V = function V(i) {
    var S = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
    P(), O.current = T.setTimeout(fe, i || C.current), S && (N.current = E());
  },
      Se = function Se(i) {
    y.current = 0, R.current = E(), g.current = !0, V(re.current, !1), Me.current(i);
  },
      Ae = function Ae() {
    P(), v.current = !0, D.current = E(), et.current ? H() : g.current && (R.current = 0, g.current = !1), xe.current();
  },
      pe = function pe(i) {
    P(), g.current = !1, R.current = 0, v.current = !1, z.current += E() - D.current, _(), V(), de.current(i);
  },
      fe = function fe(i) {
    if (!v.current) {
      if (L.current.cancel && L.current.cancel(), re.current > 0 && !g.current) {
        s.current ? s.current.prompt() : Se(i);
        return;
      }

      s.current ? s.current.idle() : Ae();
      return;
    }

    s.current ? s.current.active() : pe(i);
  },
      Re = function Re(i) {
    if (L.current(i), g.current) return;

    if (P(), !v.current && ke.current.includes(i.type)) {
      fe(i);
      return;
    }

    var S = E() - N.current;

    if (v.current && !M || !v.current && S > C.current) {
      fe(i);
      return;
    }

    A.current = !1, y.current = 0, R.current = 0, V(), G && J && Pe.current();
  },
      oe = useRef();

  useEffect(function () {
    var i = X.current;
    i && H(), h > 0 ? oe.current = le(Re, h) : oe.current = Re, i && _();
  }, [h, G, J]);

  var _ = function _() {
    !w || X.current || (me.current.forEach(function (i) {
      ce.current.addEventListener(i, oe.current, {
        capture: !0,
        passive: !0
      });
    }), X.current = !0);
  },
      H = function H() {
    var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
    !w || (X.current || i) && (me.current.forEach(function (S) {
      ce.current.removeEventListener(S, oe.current, {
        capture: !0
      });
    }), X.current = !1);
  },
      j = useCallback(function (i) {
    P(), _(), v.current = !1, g.current = !1, A.current = !1, y.current = 0, R.current = 0, s.current && !i && s.current.start(), V();
  }, [O, v, C, s]),
      he = useCallback(function (i) {
    P(), _(), v.current = !1, g.current = !1, A.current = !1, y.current = 0, R.current = 0, q.current = E(), te.current = E(), s.current && !i && s.current.reset(), x || V();
  }, [O, v, C, x, s]),
      Oe = useCallback(function (i) {
    P(), _(), (v.current || g.current) && pe(), v.current = !1, g.current = !1, A.current = !1, y.current = 0, R.current = 0, te.current = E(), s.current && !i && s.current.activate(), V();
  }, [O, v, C, s]),
      ve = useCallback(function () {
    var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
    return A.current ? !1 : (y.current = Ce(), A.current = !0, H(), P(), s.current && !i && s.current.pause(), !0);
  }, [O, s]),
      Te = useCallback(function () {
    var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
    return A.current ? (A.current = !1, g.current || _(), v.current || V(y.current), R.current && (R.current = E()), s.current && !i && s.current.resume(), !0) : !1;
  }, [O, C, y, s]),
      tt = useCallback(function (i, S) {
    s.current ? (S && ne.current(i), s.current.message(i)) : S && ne.current(i);
  }, [c]),
      rt = useCallback(function () {
    return v.current;
  }, [v]),
      nt = useCallback(function () {
    return g.current;
  }, [g]),
      ot = useCallback(function () {
    if (!s.current) throw new Error("\u274C Cross Tab feature is not enabled. To enable it set the \"crossTab\" property to true.");
    return s.current.isLeader;
  }, [s]),
      it = useCallback(function () {
    if (!s.current) throw new Error("\u274C Cross Tab feature is not enabled. To enable it set the \"crossTab\" property to true.");
    return s.current.token;
  }, [s]),
      Ce = useCallback(function () {
    if (A.current) return y.current;

    var i = y.current ? y.current : re.current + C.current,
        S = N.current ? E() - N.current : 0,
        _e = Math.ceil(i - S);

    return _e < 0 ? 0 : Math.abs(_e);
  }, [C, re, g, y, N]),
      st = useCallback(function () {
    return Math.round(E() - te.current);
  }, [te]),
      De = useCallback(function () {
    return Math.round(E() - q.current);
  }, [q]),
      at = useCallback(function () {
    return D.current ? new Date(Le.current - q.current + D.current) : null;
  }, [D]),
      lt = useCallback(function () {
    return N.current ? new Date(Le.current - q.current + N.current) : null;
  }, [N]),
      Ne = useCallback(function () {
    return v.current ? Math.round(E() - D.current + z.current) : Math.round(z.current);
  }, [D, z]),
      ut = useCallback(function () {
    var i = Math.round(De() - Ne());
    return i >= 0 ? i : 0;
  }, [q, D, z]);

  return useEffect(function () {
    if (d > 0 && p > 0) throw new Error("\u274C onAction can either be throttled or debounced, not both.");
    a && ze(a);

    var i = function i() {
      s.current && s.current.close(), L.current.cancel && L.current.cancel(), P(), H(!0);
    };

    return w && window.addEventListener("beforeunload", i), function () {
      w && window.removeEventListener("beforeunload", i), s.current && s.current.close(), L.current.cancel && L.current.cancel(), P(), H(!0);
    };
  }, []), useEffect(function () {
    s.current && s.current.close(), G ? s.current = new be({
      channelName: we,
      leaderElection: ye,
      onPrompt: function onPrompt() {
        Se();
      },
      onIdle: function onIdle() {
        Ae();
      },
      onActive: function onActive() {
        pe();
      },
      onMessage: ne.current,
      start: j,
      reset: he,
      activate: Oe,
      pause: ve,
      resume: Te
    }) : s.current = null;
  }, [G, we, ye, Me, xe, de, ne, j, he, ve, Te]), useEffect(function () {
    P(), H(!0), B.current || (A.current = !0, v.current = !0, y.current = 0), !x && (o ? j() : _());
  }, [x, o, B]), useEffect(function () {
    if (!B.current) {
      var i = _toConsumableArray(new Set([].concat(_toConsumableArray(r), _toConsumableArray(u))).values());

      if (H(), me.current = i, ce.current = n, ke.current = u, x) return;
      o ? j() : _();
    }
  }, [n, JSON.stringify(r), JSON.stringify(u), B, x, o]), useEffect(function () {
    if (B.current) B.current = !1;else {
      if (C.current = t, x) return;
      v.current && (de.current(), s.current && s.current.active()), j();
    }
  }, [t, s, x, B, v]), {
    message: tt,
    start: j,
    reset: he,
    activate: Oe,
    pause: ve,
    resume: Te,
    isIdle: rt,
    isPrompted: nt,
    isLeader: ot,
    getTabId: it,
    getRemainingTime: Ce,
    getElapsedTime: st,
    getTotalElapsedTime: De,
    getLastIdleTime: at,
    getLastActiveTime: lt,
    getTotalIdleTime: Ne,
    getTotalActiveTime: ut
  };
}
var ue = createContext(null);

var St = ue.Consumer;

var createDispatch = function createDispatch(message) {
  return function (action) {
    var toSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return message({
      action: action
    }, toSelf);
  };
};

function useForceLogOutOnTime(config, listener) {
  var _useIdleTimer = $(_objectSpread2$1(_objectSpread2$1({}, config), {}, {
    crossTab: true,
    onMessage: function () {
      var _onMessage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = data.action.type;
                _context.next = _context.t0 === RESUME ? 3 : _context.t0 === PAUSE ? 5 : 7;
                break;

              case 3:
                otherProps.resume();
                return _context.abrupt("break", 7);

              case 5:
                otherProps.pause();
                return _context.abrupt("break", 7);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function onMessage(_x) {
        return _onMessage.apply(this, arguments);
      }

      return onMessage;
    }(),
    timers: Z
  })),
      message = _useIdleTimer.message,
      otherProps = _objectWithoutProperties(_useIdleTimer, ["message"]);

  if (!config.name) config.name = 'force-logout-token-timer';
  var dispatch = createDispatch(message);

  var getIdleTimeInSecond = function getIdleTimeInSecond() {
    var _otherProps$getLastAc;

    var getLastActiveTime = ((_otherProps$getLastAc = otherProps.getLastActiveTime()) === null || _otherProps$getLastAc === void 0 ? void 0 : _otherProps$getLastAc.getTime()) || 0;
    return Math.floor((Date.now() - getLastActiveTime) / 1000);
  };

  var isForceLogout = function isForceLogout() {
    return getIdleTimeInSecond() > config.timeout / 1000;
  };

  var showInfo = function showInfo() {
    return {
      userIdleFor: getIdleTimeInSecond(),
      isForceLogout: isForceLogout()
    };
  };

  return _objectSpread2$1({
    dispatch: dispatch,
    isForceLogout: isForceLogout,
    showInfo: showInfo
  }, otherProps);
}

var verifyTimerProps = function verifyTimerProps(props) {
  if (!props.timeout || typeof props.timeout !== 'number') {
    throw new TypeError('invalid timeout');
  }
};

var defaultValue = {
  timeout: 30000,
  name: 'force-logout-timer',
  interval: 1000,
  currentDomain: '',
  onRefreshToken: function onRefreshToken() {},
  onForcedLogout: function onForcedLogout() {},
  onIdlePrompt: function onIdlePrompt() {}
};

function useLogout() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultValue;
  verifyTimerProps(props);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      info = _useState2[0],
      setInfo = _useState2[1];

  var config = baseConfiguration({
    timeout: props.timeout,
    name: props.name
  });

  var _useForceLogOutOnTime = useForceLogOutOnTime(config),
      isForceLogout = _useForceLogOutOnTime.isForceLogout,
      showInfo = _useForceLogOutOnTime.showInfo,
      isLeader = _useForceLogOutOnTime.isLeader;

  useEffect(function () {
    var timer = setInterval(function () {
      setInfo(_objectSpread2$1(_objectSpread2$1({}, showInfo()), {}, {
        isLeader: isLeader()
      }));
      callForceLogOutCallback(timer);
    }, props.interval);
    return function () {
      return clearInterval(timer);
    };
  }, [isForceLogout, props.interval]);
  return {
    info: info
  };

  function callForceLogOutCallback(timer) {
    if (isForceLogout()) {
      props.onForcedLogout();
      clearInterval(timer);
    }
  }
}

var f$8 = wellKnownSymbol;
var wellKnownSymbolWrapped = {
  f: f$8
};

var path = global_1;

var defineProperty$8 = objectDefineProperty.f;

var wellKnownSymbolDefine = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwnProperty_1(Symbol, NAME)) defineProperty$8(Symbol, NAME, {
    value: wellKnownSymbolWrapped.f(NAME)
  });
};

var symbolDefineToPrimitive = function () {
  var Symbol = getBuiltIn('Symbol');
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return functionCall(valueOf, this);
    }, {
      arity: 1
    });
  }
};

var $forEach$1 = arrayIteration.forEach;
var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE$1 = 'prototype';
var setInternalState$7 = internalState.set;
var getInternalState$2 = internalState.getterFor(SYMBOL);
var ObjectPrototype$1 = Object[PROTOTYPE$1];
var $Symbol = global_1.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE$1];
var TypeError$6 = global_1.TypeError;
var QObject = global_1.QObject;
var nativeGetOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var nativeDefineProperty = objectDefineProperty.f;
var nativeGetOwnPropertyNames = objectGetOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = objectPropertyIsEnumerable.f;
var push$5 = functionUncurryThis([].push);
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var WellKnownSymbolsStore$1 = shared('wks'); // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173

var USE_SETTER = !QObject || !QObject[PROTOTYPE$1] || !QObject[PROTOTYPE$1].findChild; // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687

var setSymbolDescriptor = descriptors && fails(function () {
  return objectCreate(nativeDefineProperty({}, 'a', {
    get: function () {
      return nativeDefineProperty(this, 'a', {
        value: 7
      }).a;
    }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor$1(ObjectPrototype$1, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype$1[P];
  nativeDefineProperty(O, P, Attributes);

  if (ObjectPrototypeDescriptor && O !== ObjectPrototype$1) {
    nativeDefineProperty(ObjectPrototype$1, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = objectCreate(SymbolPrototype);
  setInternalState$7(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!descriptors) symbol.description = description;
  return symbol;
};

var $defineProperty$1 = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype$1) $defineProperty$1(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);

  if (hasOwnProperty_1(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwnProperty_1(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwnProperty_1(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = objectCreate(Attributes, {
        enumerable: createPropertyDescriptor(0, false)
      });
    }

    return setSymbolDescriptor(O, key, Attributes);
  }

  return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach$1(keys, function (key) {
    if (!descriptors || functionCall($propertyIsEnumerable$1, properties, key)) $defineProperty$1(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? objectCreate(O) : $defineProperties(objectCreate(O), Properties);
};

var $propertyIsEnumerable$1 = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = functionCall(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype$1 && hasOwnProperty_1(AllSymbols, P) && !hasOwnProperty_1(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwnProperty_1(this, P) || !hasOwnProperty_1(AllSymbols, P) || hasOwnProperty_1(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor$2 = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype$1 && hasOwnProperty_1(AllSymbols, key) && !hasOwnProperty_1(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor$1(it, key);

  if (descriptor && hasOwnProperty_1(AllSymbols, key) && !(hasOwnProperty_1(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }

  return descriptor;
};

var $getOwnPropertyNames$1 = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach$1(names, function (key) {
    if (!hasOwnProperty_1(AllSymbols, key) && !hasOwnProperty_1(hiddenKeys, key)) push$5(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function (O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype$1;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach$1(names, function (key) {
    if (hasOwnProperty_1(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwnProperty_1(ObjectPrototype$1, key))) {
      push$5(result, AllSymbols[key]);
    }
  });
  return result;
}; // `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor


if (!symbolConstructorDetection) {
  $Symbol = function Symbol() {
    if (objectIsPrototypeOf(SymbolPrototype, this)) throw TypeError$6('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : toString_1(arguments[0]);
    var tag = uid(description);

    var setter = function (value) {
      if (this === ObjectPrototype$1) functionCall(setter, ObjectPrototypeSymbols, value);
      if (hasOwnProperty_1(this, HIDDEN) && hasOwnProperty_1(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };

    if (descriptors && USE_SETTER) setSymbolDescriptor(ObjectPrototype$1, tag, {
      configurable: true,
      set: setter
    });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE$1];
  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
    return getInternalState$2(this).tag;
  });
  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });
  objectPropertyIsEnumerable.f = $propertyIsEnumerable$1;
  objectDefineProperty.f = $defineProperty$1;
  objectDefineProperties.f = $defineProperties;
  objectGetOwnPropertyDescriptor.f = $getOwnPropertyDescriptor$2;
  objectGetOwnPropertyNames.f = objectGetOwnPropertyNamesExternal.f = $getOwnPropertyNames$1;
  objectGetOwnPropertySymbols.f = $getOwnPropertySymbols;

  wellKnownSymbolWrapped.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (descriptors) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState$2(this).description;
      }
    });

    {
      defineBuiltIn(ObjectPrototype$1, 'propertyIsEnumerable', $propertyIsEnumerable$1, {
        unsafe: true
      });
    }
  }
}

_export({
  global: true,
  constructor: true,
  wrap: true,
  forced: !symbolConstructorDetection,
  sham: !symbolConstructorDetection
}, {
  Symbol: $Symbol
});
$forEach$1(objectKeys(WellKnownSymbolsStore$1), function (name) {
  wellKnownSymbolDefine(name);
});
_export({
  target: SYMBOL,
  stat: true,
  forced: !symbolConstructorDetection
}, {
  useSetter: function () {
    USE_SETTER = true;
  },
  useSimple: function () {
    USE_SETTER = false;
  }
});
_export({
  target: 'Object',
  stat: true,
  forced: !symbolConstructorDetection,
  sham: !descriptors
}, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty$1,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor$2
});
_export({
  target: 'Object',
  stat: true,
  forced: !symbolConstructorDetection
}, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames$1
}); // `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive

symbolDefineToPrimitive(); // `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag

setToStringTag($Symbol, SYMBOL);
hiddenKeys[HIDDEN] = true;

/* eslint-disable es/no-symbol -- safe */

var symbolRegistryDetection = symbolConstructorDetection && !!Symbol['for'] && !!Symbol.keyFor;

var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry'); // `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for

_export({
  target: 'Symbol',
  stat: true,
  forced: !symbolRegistryDetection
}, {
  'for': function (key) {
    var string = toString_1(key);
    if (hasOwnProperty_1(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  }
});

var SymbolToStringRegistry$1 = shared('symbol-to-string-registry'); // `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor

_export({
  target: 'Symbol',
  stat: true,
  forced: !symbolRegistryDetection
}, {
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(tryToString(sym) + ' is not a symbol');
    if (hasOwnProperty_1(SymbolToStringRegistry$1, sym)) return SymbolToStringRegistry$1[sym];
  }
});

var $stringify = getBuiltIn('JSON', 'stringify');
var exec$3 = functionUncurryThis(/./.exec);
var charAt$4 = functionUncurryThis(''.charAt);
var charCodeAt$3 = functionUncurryThis(''.charCodeAt);
var replace$4 = functionUncurryThis(''.replace);
var numberToString$1 = functionUncurryThis(1.0.toString);
var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;
var WRONG_SYMBOLS_CONVERSION = !symbolConstructorDetection || fails(function () {
  var symbol = getBuiltIn('Symbol')(); // MS Edge converts symbol values to JSON as {}

  return $stringify([symbol]) != '[null]' // WebKit converts symbol values to JSON as null
  || $stringify({
    a: symbol
  }) != '{}' // V8 throws on boxed symbols
  || $stringify(Object(symbol)) != '{}';
}); // https://github.com/tc39/proposal-well-formed-stringify

var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"' || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice$1(arguments);
  var $replacer = replacer;
  if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined

  if (!isArray(replacer)) replacer = function (key, value) {
    if (isCallable($replacer)) value = functionCall($replacer, this, key, value);
    if (!isSymbol(value)) return value;
  };
  args[1] = replacer;
  return functionApply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt$4(string, offset - 1);
  var next = charAt$4(string, offset + 1);

  if (exec$3(low, match) && !exec$3(hi, next) || exec$3(hi, match) && !exec$3(low, prev)) {
    return '\\u' + numberToString$1(charCodeAt$3(match, 0), 16);
  }

  return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  _export({
    target: 'JSON',
    stat: true,
    arity: 3,
    forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE
  }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice$1(arguments);
      var result = functionApply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace$4(result, tester, fixIllFormed) : result;
    }
  });
}

// https://bugs.chromium.org/p/v8/issues/detail?id=3443

var FORCED$2 = !symbolConstructorDetection || fails(function () {
  objectGetOwnPropertySymbols.f(1);
}); // `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols

_export({
  target: 'Object',
  stat: true,
  forced: FORCED$2
}, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
  }
});

var defineProperty$9 = objectDefineProperty.f;
var NativeSymbol = global_1.Symbol;
var SymbolPrototype$1 = NativeSymbol && NativeSymbol.prototype;

if (descriptors && isCallable(NativeSymbol) && (!('description' in SymbolPrototype$1) || // Safari 12 bug
NativeSymbol().description !== undefined)) {
  var EmptyStringDescriptionStore = {}; // wrap Symbol constructor for correct work with undefined description

  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString_1(arguments[0]);
    var result = objectIsPrototypeOf(SymbolPrototype$1, this) ? new NativeSymbol(description) // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
    : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype$1;
  SymbolPrototype$1.constructor = SymbolWrapper;
  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var thisSymbolValue = functionUncurryThis(SymbolPrototype$1.valueOf);
  var symbolDescriptiveString = functionUncurryThis(SymbolPrototype$1.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace$5 = functionUncurryThis(''.replace);
  var stringSlice$4 = functionUncurryThis(''.slice);
  defineProperty$9(SymbolPrototype$1, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwnProperty_1(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice$4(string, 7, -1) : replace$5(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });
  _export({
    global: true,
    constructor: true,
    forced: true
  }, {
    Symbol: SymbolWrapper
  });
}

// https://tc39.es/ecma262/#sec-symbol.iterator

wellKnownSymbolDefine('iterator');

var $filter = arrayIteration.filter;
var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport('filter'); // `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species

_export({
  target: 'Array',
  proto: true,
  forced: !HAS_SPECIES_SUPPORT$1
}, {
  filter: function filter(callbackfn
  /* , thisArg */
  ) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
}); // `Array.from` method
// https://tc39.es/ecma262/#sec-array.from

_export({
  target: 'Array',
  stat: true,
  forced: INCORRECT_ITERATION
}, {
  from: arrayFrom
});

var nativeJoin = functionUncurryThis([].join);
var ES3_STRINGS = indexedObject != Object;
var STRICT_METHOD$4 = arrayMethodIsStrict('join', ','); // `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join

_export({
  target: 'Array',
  proto: true,
  forced: ES3_STRINGS || !STRICT_METHOD$4
}, {
  join: function join(separator) {
    return nativeJoin(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});

var HAS_SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport('slice');
var SPECIES$5 = wellKnownSymbol('species');
var $Array$3 = Array;
var max$3 = Math.max; // `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects

_export({
  target: 'Array',
  proto: true,
  forced: !HAS_SPECIES_SUPPORT$2
}, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length); // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible

    var Constructor, result, n;

    if (isArray(O)) {
      Constructor = O.constructor; // cross-realm fallback

      if (isConstructor(Constructor) && (Constructor === $Array$3 || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES$5];
        if (Constructor === null) Constructor = undefined;
      }

      if (Constructor === $Array$3 || Constructor === undefined) {
        return arraySlice$1(O, k, fin);
      }
    }

    result = new (Constructor === undefined ? $Array$3 : Constructor)(max$3(fin - k, 0));

    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);

    result.length = n;
    return result;
  }
});

var firefox = engineUserAgent.match(/firefox\/(\d+)/i);
var engineFfVersion = !!firefox && +firefox[1];

var engineIsIeOrEdge = /MSIE|Trident/.test(engineUserAgent);

var webkit = engineUserAgent.match(/AppleWebKit\/(\d+)\./);
var engineWebkitVersion = !!webkit && +webkit[1];

var test$1 = [];
var nativeSort = functionUncurryThis(test$1.sort);
var push$6 = functionUncurryThis(test$1.push); // IE8-

var FAILS_ON_UNDEFINED = fails(function () {
  test$1.sort(undefined);
}); // V8 bug

var FAILS_ON_NULL = fails(function () {
  test$1.sort(null);
}); // Old WebKit

var STRICT_METHOD$5 = arrayMethodIsStrict('sort');
var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (engineV8Version) return engineV8Version < 70;
  if (engineFfVersion && engineFfVersion > 3) return;
  if (engineIsIeOrEdge) return true;
  if (engineWebkitVersion) return engineWebkitVersion < 603;
  var result = '';
  var code, chr, value, index; // generate an array with more 512 elements (Chakra and old V8 fails only in this case)

  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66:
      case 69:
      case 70:
      case 72:
        value = 3;
        break;

      case 68:
      case 71:
        value = 4;
        break;

      default:
        value = 2;
    }

    for (index = 0; index < 47; index++) {
      test$1.push({
        k: chr + index,
        v: value
      });
    }
  }

  test$1.sort(function (a, b) {
    return b.v - a.v;
  });

  for (index = 0; index < test$1.length; index++) {
    chr = test$1[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});
var FORCED$3 = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD$5 || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString_1(x) > toString_1(y) ? 1 : -1;
  };
}; // `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort


_export({
  target: 'Array',
  proto: true,
  forced: FORCED$3
}, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);
    var array = toObject(this);
    if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);
    var items = [];
    var arrayLength = lengthOfArrayLike(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push$6(items, array[index]);
    }

    arraySort(items, getSortCompare(comparefn));
    itemsLength = lengthOfArrayLike(items);
    index = 0;

    while (index < itemsLength) array[index] = items[index++];

    while (index < arrayLength) deletePropertyOrThrow(array, index++);

    return array;
  }
});

var FORCED$4 = fails(function () {
  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({
    toISOString: function () {
      return 1;
    }
  }) !== 1;
}); // `Date.prototype.toJSON` method
// https://tc39.es/ecma262/#sec-date.prototype.tojson

_export({
  target: 'Date',
  proto: true,
  arity: 1,
  forced: FORCED$4
}, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O, 'number');
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});

// https://tc39.es/ecma262/#sec-math.trunc

_export({
  target: 'Math',
  stat: true
}, {
  trunc: mathTrunc
});

// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing

_export({
  target: 'Object',
  stat: true,
  arity: 2,
  forced: Object.assign !== objectAssign
}, {
  assign: objectAssign
});

// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors

_export({
  target: 'Object',
  stat: true,
  sham: !descriptors
}, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;

    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }

    return result;
  }
});

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
var sameValue = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

// https://tc39.es/ecma262/#sec-object.is

_export({
  target: 'Object',
  stat: true
}, {
  is: sameValue
});

var FAILS_ON_PRIMITIVES$4 = fails(function () {
  objectKeys(1);
}); // `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys

_export({
  target: 'Object',
  stat: true,
  forced: FAILS_ON_PRIMITIVES$4
}, {
  keys: function keys(it) {
    return objectKeys(toObject(it));
  }
});

var OPTIONAL_ARGUMENTS_LIST = !fails(function () {
  // eslint-disable-next-line es/no-reflect -- required for testing
  Reflect.apply(function () {
    /* empty */
  });
}); // `Reflect.apply` method
// https://tc39.es/ecma262/#sec-reflect.apply

_export({
  target: 'Reflect',
  stat: true,
  forced: OPTIONAL_ARGUMENTS_LIST
}, {
  apply: function apply(target, thisArgument, argumentsList) {
    return functionApply(aCallable(target), thisArgument, anObject(argumentsList));
  }
});

var $RegExp = global_1.RegExp;
var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
}); // UC Browser bug
// https://github.com/zloirock/core-js/issues/1008

var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp('a', 'y').sticky;
});
var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});
var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};

var defineProperty$a = objectDefineProperty.f;

var proxyAccessor = function (Target, Source, key) {
  key in Target || defineProperty$a(Target, key, {
    configurable: true,
    get: function () {
      return Source[key];
    },
    set: function (it) {
      Source[key] = it;
    }
  });
};

var $RegExp$1 = global_1.RegExp;
var regexpUnsupportedDotAll = fails(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});

var $RegExp$2 = global_1.RegExp;
var regexpUnsupportedNcg = fails(function () {
  var re = $RegExp$2('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' || 'b'.replace(re, '$<a>c') !== 'bc';
});

var getOwnPropertyNames$2 = objectGetOwnPropertyNames.f;
var enforceInternalState$1 = internalState.enforce;
var MATCH$2 = wellKnownSymbol('match');
var NativeRegExp = global_1.RegExp;
var RegExpPrototype$2 = NativeRegExp.prototype;
var SyntaxError$1 = global_1.SyntaxError;
var exec$4 = functionUncurryThis(RegExpPrototype$2.exec);
var charAt$5 = functionUncurryThis(''.charAt);
var replace$6 = functionUncurryThis(''.replace);
var stringIndexOf$1 = functionUncurryThis(''.indexOf);
var stringSlice$5 = functionUncurryThis(''.slice); // TODO: Use only proper RegExpIdentifierName

var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g; // "new" should create a new object, old webkit bug

var CORRECT_NEW = new NativeRegExp(re1) !== re1;
var MISSED_STICKY$1 = regexpStickyHelpers.MISSED_STICKY;
var UNSUPPORTED_Y$1 = regexpStickyHelpers.UNSUPPORTED_Y;
var BASE_FORCED = descriptors && (!CORRECT_NEW || MISSED_STICKY$1 || regexpUnsupportedDotAll || regexpUnsupportedNcg || fails(function () {
  re2[MATCH$2] = false; // RegExp constructor can alter flags and IsRegExp works correct with @@match

  return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
}));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;

  for (; index <= length; index++) {
    chr = charAt$5(string, index);

    if (chr === '\\') {
      result += chr + charAt$5(string, ++index);
      continue;
    }

    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      }

      result += chr;
    }
  }

  return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;

  for (; index <= length; index++) {
    chr = charAt$5(string, index);

    if (chr === '\\') {
      chr = chr + charAt$5(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;

      case chr === '(':
        if (exec$4(IS_NCG, stringSlice$5(string, index + 1))) {
          index += 2;
          ncg = true;
        }

        result += chr;
        groupid++;
        continue;

      case chr === '>' && ncg:
        if (groupname === '' || hasOwnProperty_1(names, groupname)) {
          throw new SyntaxError$1('Invalid capture group name');
        }

        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }

    if (ncg) groupname += chr;else result += chr;
  }

  return [result, named];
}; // `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor


if (isForced_1('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = objectIsPrototypeOf(RegExpPrototype$2, this);
    var patternIsRegExp = isRegexp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || objectIsPrototypeOf(RegExpPrototype$2, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = regexpGetFlags(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString_1(pattern);
    flags = flags === undefined ? '' : toString_1(flags);
    rawPattern = pattern;

    if (regexpUnsupportedDotAll && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf$1(flags, 's') > -1;
      if (dotAll) flags = replace$6(flags, /s/g, '');
    }

    rawFlags = flags;

    if (MISSED_STICKY$1 && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf$1(flags, 'y') > -1;
      if (sticky && UNSUPPORTED_Y$1) flags = replace$6(flags, /y/g, '');
    }

    if (regexpUnsupportedNcg) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype$2, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState$1(result);

      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }

      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) {
      /* empty */
    }
    return result;
  };

  for (var keys$2 = getOwnPropertyNames$2(NativeRegExp), index = 0; keys$2.length > index;) {
    proxyAccessor(RegExpWrapper, NativeRegExp, keys$2[index++]);
  }

  RegExpPrototype$2.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype$2;
  defineBuiltIn(global_1, 'RegExp', RegExpWrapper, {
    constructor: true
  });
} // https://tc39.es/ecma262/#sec-get-regexp-@@species


setSpecies('RegExp');

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */

/* eslint-disable regexp/no-useless-quantifier -- testing */


var getInternalState$3 = internalState.get;
var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$6 = functionUncurryThis(''.charAt);
var indexOf$1 = functionUncurryThis(''.indexOf);
var replace$7 = functionUncurryThis(''.replace);
var stringSlice$6 = functionUncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = function () {
  var re1 = /a/;
  var re2 = /b*/g;
  functionCall(nativeExec, re1, 'a');
  functionCall(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();

var UNSUPPORTED_Y$2 = regexpStickyHelpers.BROKEN_CARET; // nonparticipating capturing group, copied from es5-shim's String#split patch.

var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$2 || regexpUnsupportedDotAll || regexpUnsupportedNcg;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState$3(re);
    var str = toString_1(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = functionCall(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y$2 && re.sticky;
    var flags = functionCall(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$7(flags, 'y', '');

      if (indexOf$1(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$6(str, re.lastIndex); // Support anchored sticky behavior.

      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$6(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      } // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.


      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }

    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = functionCall(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$6(match.input, charsAdded);
        match[0] = stringSlice$6(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }

    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      functionCall(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = objectCreate(null);

      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec = patchedExec;

// https://tc39.es/ecma262/#sec-regexp.prototype.exec


_export({
  target: 'RegExp',
  proto: true,
  forced: /./.exec !== regexpExec
}, {
  exec: regexpExec
});

var RegExp$2 = global_1.RegExp;
var RegExpPrototype$3 = RegExp$2.prototype;
var FORCED$5 = descriptors && fails(function () {
  var INDICES_SUPPORT = true;

  try {
    RegExp$2('.', 'd');
  } catch (error) {
    INDICES_SUPPORT = false;
  }

  var O = {}; // modern V8 bug

  var calls = '';
  var expected = INDICES_SUPPORT ? 'dgimsy' : 'gimsy';

  var addGetter = function (key, chr) {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(O, key, {
      get: function () {
        calls += chr;
        return true;
      }
    });
  };

  var pairs = {
    dotAll: 's',
    global: 'g',
    ignoreCase: 'i',
    multiline: 'm',
    sticky: 'y'
  };
  if (INDICES_SUPPORT) pairs.hasIndices = 'd';

  for (var key in pairs) addGetter(key, pairs[key]); // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe


  var result = Object.getOwnPropertyDescriptor(RegExpPrototype$3, 'flags').get.call(O);
  return result !== expected || calls !== expected;
}); // `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags

if (FORCED$5) defineBuiltInAccessor(RegExpPrototype$3, 'flags', {
  configurable: true,
  get: regexpFlags
});

var SPECIES$6 = wellKnownSymbol('species');
var RegExpPrototype$4 = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);
  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};

    O[SYMBOL] = function () {
      return 7;
    };

    return ''[KEY](O) != 7;
  });
  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {}; // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.

      re.constructor = {};

      re.constructor[SPECIES$6] = function () {
        return re;
      };

      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
    var uncurriedNativeRegExpMethod = functionUncurryThis(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = functionUncurryThis(nativeMethod);
      var $exec = regexp.exec;

      if ($exec === regexpExec || $exec === RegExpPrototype$4.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return {
            done: true,
            value: uncurriedNativeRegExpMethod(regexp, str, arg2)
          };
        }

        return {
          done: true,
          value: uncurriedNativeMethod(str, regexp, arg2)
        };
      }

      return {
        done: false
      };
    });
    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype$4, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype$4[SYMBOL], 'sham', true);
};

var charAt$7 = stringMultibyte.charAt; // `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex

var advanceStringIndex = function (S, index, unicode) {
  return index + (unicode ? charAt$7(S, index).length : 1);
};

var $TypeError$h = TypeError; // `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec

var regexpExecAbstract = function (R, S) {
  var exec = R.exec;

  if (isCallable(exec)) {
    var result = functionCall(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }

  if (classofRaw(R) === 'RegExp') return functionCall(regexpExec, R, S);
  throw $TypeError$h('RegExp#exec called on incompatible receiver');
};

fixRegexpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [// `String.prototype.match` method
  // https://tc39.es/ecma262/#sec-string.prototype.match
  function match(regexp) {
    var O = requireObjectCoercible(this);
    var matcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, MATCH);
    return matcher ? functionCall(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString_1(O));
  }, // `RegExp.prototype[@@match]` method
  // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
  function (string) {
    var rx = anObject(this);
    var S = toString_1(string);
    var res = maybeCallNative(nativeMatch, rx, S);
    if (res.done) return res.value;
    if (!rx.global) return regexpExecAbstract(rx, S);
    var fullUnicode = rx.unicode;
    rx.lastIndex = 0;
    var A = [];
    var n = 0;
    var result;

    while ((result = regexpExecAbstract(rx, S)) !== null) {
      var matchStr = toString_1(result[0]);
      A[n] = matchStr;
      if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      n++;
    }

    return n === 0 ? null : A;
  }];
});

var floor$4 = Math.floor;
var charAt$8 = functionUncurryThis(''.charAt);
var replace$8 = functionUncurryThis(''.replace);
var stringSlice$7 = functionUncurryThis(''.slice);
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g; // `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution

var getSubstitution = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;

  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }

  return replace$8(replacement, symbols, function (match, ch) {
    var capture;

    switch (charAt$8(ch, 0)) {
      case '$':
        return '$';

      case '&':
        return matched;

      case '`':
        return stringSlice$7(str, 0, position);

      case "'":
        return stringSlice$7(str, tailPos);

      case '<':
        capture = namedCaptures[stringSlice$7(ch, 1, -1)];
        break;

      default:
        // \d\d?
        var n = +ch;
        if (n === 0) return match;

        if (n > m) {
          var f = floor$4(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt$8(ch, 1) : captures[f - 1] + charAt$8(ch, 1);
          return match;
        }

        capture = captures[n - 1];
    }

    return capture === undefined ? '' : capture;
  });
};

var REPLACE = wellKnownSymbol('replace');
var max$4 = Math.max;
var min$3 = Math.min;
var concat$2 = functionUncurryThis([].concat);
var push$7 = functionUncurryThis([].push);
var stringIndexOf$2 = functionUncurryThis(''.indexOf);
var stringSlice$8 = functionUncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
}; // IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0


var REPLACE_KEEPS_$0 = function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
}(); // Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string


var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }

  return false;
}();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;

  re.exec = function () {
    var result = [];
    result.groups = {
      a: '7'
    };
    return result;
  }; // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive


  return ''.replace(re, '$<a>') !== '7';
}); // @@replace logic

fixRegexpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';
  return [// `String.prototype.replace` method
  // https://tc39.es/ecma262/#sec-string.prototype.replace
  function replace(searchValue, replaceValue) {
    var O = requireObjectCoercible(this);
    var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
    return replacer ? functionCall(replacer, searchValue, O, replaceValue) : functionCall(nativeReplace, toString_1(O), searchValue, replaceValue);
  }, // `RegExp.prototype[@@replace]` method
  // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
  function (string, replaceValue) {
    var rx = anObject(this);
    var S = toString_1(string);

    if (typeof replaceValue == 'string' && stringIndexOf$2(replaceValue, UNSAFE_SUBSTITUTE) === -1 && stringIndexOf$2(replaceValue, '$<') === -1) {
      var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
      if (res.done) return res.value;
    }

    var functionalReplace = isCallable(replaceValue);
    if (!functionalReplace) replaceValue = toString_1(replaceValue);
    var global = rx.global;

    if (global) {
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
    }

    var results = [];

    while (true) {
      var result = regexpExecAbstract(rx, S);
      if (result === null) break;
      push$7(results, result);
      if (!global) break;
      var matchStr = toString_1(result[0]);
      if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
    }

    var accumulatedResult = '';
    var nextSourcePosition = 0;

    for (var i = 0; i < results.length; i++) {
      result = results[i];
      var matched = toString_1(result[0]);
      var position = max$4(min$3(toIntegerOrInfinity(result.index), S.length), 0);
      var captures = []; // NOTE: This is equivalent to
      //   captures = result.slice(1).map(maybeToString)
      // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
      // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
      // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.

      for (var j = 1; j < result.length; j++) push$7(captures, maybeToString(result[j]));

      var namedCaptures = result.groups;

      if (functionalReplace) {
        var replacerArgs = concat$2([matched], captures, position, S);
        if (namedCaptures !== undefined) push$7(replacerArgs, namedCaptures);
        var replacement = toString_1(functionApply(replaceValue, undefined, replacerArgs));
      } else {
        replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
      }

      if (position >= nextSourcePosition) {
        accumulatedResult += stringSlice$8(S, nextSourcePosition, position) + replacement;
        nextSourcePosition = position + matched.length;
      }
    }

    return accumulatedResult + stringSlice$8(S, nextSourcePosition);
  }];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

fixRegexpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [// `String.prototype.search` method
  // https://tc39.es/ecma262/#sec-string.prototype.search
  function search(regexp) {
    var O = requireObjectCoercible(this);
    var searcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, SEARCH);
    return searcher ? functionCall(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString_1(O));
  }, // `RegExp.prototype[@@search]` method
  // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
  function (string) {
    var rx = anObject(this);
    var S = toString_1(string);
    var res = maybeCallNative(nativeSearch, rx, S);
    if (res.done) return res.value;
    var previousLastIndex = rx.lastIndex;
    if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
    var result = regexpExecAbstract(rx, S);
    if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
    return result === null ? -1 : result.index;
  }];
});

var UNSUPPORTED_Y$3 = regexpStickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min$4 = Math.min;
var $push = [].push;
var exec$5 = functionUncurryThis(/./.exec);
var push$8 = functionUncurryThis($push);
var stringSlice$9 = functionUncurryThis(''.slice); // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;

  re.exec = function () {
    return originalExec.apply(this, arguments);
  };

  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
}); // @@split logic

fixRegexpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;

  if ('abbc'.split(/(b)*/)[1] == 'c' || // eslint-disable-next-line regexp/no-empty-group -- required for testing
  'test'.split(/(?:)/, -1).length != 4 || 'ab'.split(/(?:ab)*/).length != 2 || '.'.split(/(.?)(.?)/).length != 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
  '.'.split(/()()/).length > 1 || ''.split(/.?/).length) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString_1(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string]; // If `separator` is not a regex, use native split

      if (!isRegexp(separator)) {
        return functionCall(nativeSplit, string, separator, lim);
      }

      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
      var lastLastIndex = 0; // Make `global` and avoid `lastIndex` issues by working with a copy

      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;

      while (match = functionCall(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;

        if (lastIndex > lastLastIndex) {
          push$8(output, stringSlice$9(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) functionApply($push, output, arraySliceSimple(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }

        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }

      if (lastLastIndex === string.length) {
        if (lastLength || !exec$5(separatorCopy, '')) push$8(output, '');
      } else push$8(output, stringSlice$9(string, lastLastIndex));

      return output.length > lim ? arraySliceSimple(output, 0, lim) : output;
    }; // Chakra, V8

  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : functionCall(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [// `String.prototype.split` method
  // https://tc39.es/ecma262/#sec-string.prototype.split
  function split(separator, limit) {
    var O = requireObjectCoercible(this);
    var splitter = isNullOrUndefined(separator) ? undefined : getMethod(separator, SPLIT);
    return splitter ? functionCall(splitter, separator, O, limit) : functionCall(internalSplit, toString_1(O), separator, limit);
  }, // `RegExp.prototype[@@split]` method
  // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
  //
  // NOTE: This cannot be properly polyfilled in engines that don't support
  // the 'y' flag.
  function (string, limit) {
    var rx = anObject(this);
    var S = toString_1(string);
    var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
    if (res.done) return res.value;
    var C = speciesConstructor(rx, RegExp);
    var unicodeMatching = rx.unicode;
    var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + (UNSUPPORTED_Y$3 ? 'g' : 'y'); // ^(? + rx + ) is needed, in combination with some S slicing, to
    // simulate the 'y' flag.

    var splitter = new C(UNSUPPORTED_Y$3 ? '^(?:' + rx.source + ')' : rx, flags);
    var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
    if (lim === 0) return [];
    if (S.length === 0) return regexpExecAbstract(splitter, S) === null ? [S] : [];
    var p = 0;
    var q = 0;
    var A = [];

    while (q < S.length) {
      splitter.lastIndex = UNSUPPORTED_Y$3 ? 0 : q;
      var z = regexpExecAbstract(splitter, UNSUPPORTED_Y$3 ? stringSlice$9(S, q) : S);
      var e;

      if (z === null || (e = min$4(toLength(splitter.lastIndex + (UNSUPPORTED_Y$3 ? q : 0)), S.length)) === p) {
        q = advanceStringIndex(S, q, unicodeMatching);
      } else {
        push$8(A, stringSlice$9(S, p, q));
        if (A.length === lim) return A;

        for (var i = 1; i <= z.length - 1; i++) {
          push$8(A, z[i]);
          if (A.length === lim) return A;
        }

        q = p = e;
      }
    }

    push$8(A, stringSlice$9(S, p));
    return A;
  }];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y$3);

// https://url.spec.whatwg.org/#dom-url-tojson


_export({
  target: 'URL',
  proto: true,
  enumerable: true
}, {
  toJSON: function toJSON() {
    return functionCall(URL.prototype.toString, this);
  }
});

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule$1(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var check$1 = function check(it) {
  return it && it.Math == Math && it;
}; // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028


var global_1$1 = // eslint-disable-next-line es/no-global-this -- safe
check$1((typeof globalThis === "undefined" ? "undefined" : _typeof$1(globalThis)) == 'object' && globalThis) || check$1((typeof window === "undefined" ? "undefined" : _typeof$1(window)) == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
check$1((typeof self === "undefined" ? "undefined" : _typeof$1(self)) == 'object' && self) || check$1(_typeof$1(commonjsGlobal$1) == 'object' && commonjsGlobal$1) || // eslint-disable-next-line no-new-func -- fallback
function () {
  return this;
}() || Function('return this')();

var fails$1 = function fails(exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var descriptors$1 = !fails$1(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, {
    get: function get() {
      return 7;
    }
  })[1] != 7;
});
var functionBindNative$1 = !fails$1(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = function () {
    /* empty */
  }.bind(); // eslint-disable-next-line no-prototype-builtins -- safe


  return typeof test != 'function' || test.hasOwnProperty('prototype');
});
var call$3 = Function.prototype.call;
var functionCall$1 = functionBindNative$1 ? call$3.bind(call$3) : function () {
  return call$3.apply(call$3, arguments);
};
var $propertyIsEnumerable$2 = {}.propertyIsEnumerable; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

var getOwnPropertyDescriptor$6 = Object.getOwnPropertyDescriptor; // Nashorn ~ JDK8 bug

var NASHORN_BUG$1 = getOwnPropertyDescriptor$6 && !$propertyIsEnumerable$2.call({
  1: 2
}, 1); // `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable

var f$9 = NASHORN_BUG$1 ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$6(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable$2;
var objectPropertyIsEnumerable$1 = {
  f: f$9
};

var createPropertyDescriptor$1 = function createPropertyDescriptor(bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var FunctionPrototype$4 = Function.prototype;
var call$1$1 = FunctionPrototype$4.call;
var uncurryThisWithBind$1 = functionBindNative$1 && FunctionPrototype$4.bind.bind(call$1$1, call$1$1);
var functionUncurryThisRaw$1 = functionBindNative$1 ? uncurryThisWithBind$1 : function (fn) {
  return function () {
    return call$1$1.apply(fn, arguments);
  };
};
var toString$2 = functionUncurryThisRaw$1({}.toString);
var stringSlice$a = functionUncurryThisRaw$1(''.slice);

var classofRaw$1 = function classofRaw(it) {
  return stringSlice$a(toString$2(it), 8, -1);
};

var functionUncurryThis$1 = function functionUncurryThis(fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw$1(fn) === 'Function') return functionUncurryThisRaw$1(fn);
};

var $Object$5 = Object;
var split$4 = functionUncurryThis$1(''.split); // fallback for non-array-like ES3 and non-enumerable old V8 strings

var indexedObject$1 = fails$1(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$5('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw$1(it) == 'String' ? split$4(it, '') : $Object$5(it);
} : $Object$5; // we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec

var isNullOrUndefined$1 = function isNullOrUndefined(it) {
  return it === null || it === undefined;
};

var $TypeError$i = TypeError; // `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible

var requireObjectCoercible$1 = function requireObjectCoercible(it) {
  if (isNullOrUndefined$1(it)) throw $TypeError$i("Can't call method on " + it);
  return it;
};

var toIndexedObject$1 = function toIndexedObject(it) {
  return indexedObject$1(requireObjectCoercible$1(it));
};

var documentAll$3 = (typeof document === "undefined" ? "undefined" : _typeof$1(document)) == 'object' && document.all; // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot

var IS_HTMLDDA$1 = typeof documentAll$3 == 'undefined' && documentAll$3 !== undefined;
var documentAll_1$1 = {
  all: documentAll$3,
  IS_HTMLDDA: IS_HTMLDDA$1
};
var documentAll$1$1 = documentAll_1$1.all; // `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable

var isCallable$1 = documentAll_1$1.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll$1$1;
} : function (argument) {
  return typeof argument == 'function';
};
var documentAll$2$1 = documentAll_1$1.all;
var isObject$1 = documentAll_1$1.IS_HTMLDDA ? function (it) {
  return _typeof$1(it) == 'object' ? it !== null : isCallable$1(it) || it === documentAll$2$1;
} : function (it) {
  return _typeof$1(it) == 'object' ? it !== null : isCallable$1(it);
};

var aFunction$1 = function aFunction(argument) {
  return isCallable$1(argument) ? argument : undefined;
};

var getBuiltIn$1 = function getBuiltIn(namespace, method) {
  return arguments.length < 2 ? aFunction$1(global_1$1[namespace]) : global_1$1[namespace] && global_1$1[namespace][method];
};

var objectIsPrototypeOf$1 = functionUncurryThis$1({}.isPrototypeOf);
var engineUserAgent$1 = getBuiltIn$1('navigator', 'userAgent') || '';
var process$4 = global_1$1.process;
var Deno$1$1 = global_1$1.Deno;
var versions$1 = process$4 && process$4.versions || Deno$1$1 && Deno$1$1.version;
var v8$1 = versions$1 && versions$1.v8;
var match$1, version$1;

if (v8$1) {
  match$1 = v8$1.split('.'); // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us

  version$1 = match$1[0] > 0 && match$1[0] < 4 ? 1 : +(match$1[0] + match$1[1]);
} // BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0


if (!version$1 && engineUserAgent$1) {
  match$1 = engineUserAgent$1.match(/Edge\/(\d+)/);

  if (!match$1 || match$1[1] >= 74) {
    match$1 = engineUserAgent$1.match(/Chrome\/(\d+)/);
    if (match$1) version$1 = +match$1[1];
  }
}

var engineV8Version$1 = version$1;
/* eslint-disable es/no-symbol -- required for testing */
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing

var symbolConstructorDetection$1 = !!Object.getOwnPropertySymbols && !fails$1(function () {
  var symbol = Symbol(); // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances

  return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && engineV8Version$1 && engineV8Version$1 < 41;
});
/* eslint-disable es/no-symbol -- required for testing */

var useSymbolAsUid$1 = symbolConstructorDetection$1 && !Symbol.sham && _typeof$1(Symbol.iterator) == 'symbol';
var $Object$1$1 = Object;
var isSymbol$1 = useSymbolAsUid$1 ? function (it) {
  return _typeof$1(it) == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$1('Symbol');
  return isCallable$1($Symbol) && objectIsPrototypeOf$1($Symbol.prototype, $Object$1$1(it));
};
var $String$4 = String;

var tryToString$1 = function tryToString(argument) {
  try {
    return $String$4(argument);
  } catch (error) {
    return 'Object';
  }
};

var $TypeError$1$1 = TypeError; // `Assert: IsCallable(argument) is true`

var aCallable$1 = function aCallable(argument) {
  if (isCallable$1(argument)) return argument;
  throw $TypeError$1$1(tryToString$1(argument) + ' is not a function');
}; // https://tc39.es/ecma262/#sec-getmethod


var getMethod$1 = function getMethod(V, P) {
  var func = V[P];
  return isNullOrUndefined$1(func) ? undefined : aCallable$1(func);
};

var $TypeError$2$1 = TypeError; // `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive

var ordinaryToPrimitive$1 = function ordinaryToPrimitive(input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$1(fn = input.toString) && !isObject$1(val = functionCall$1(fn, input))) return val;
  if (isCallable$1(fn = input.valueOf) && !isObject$1(val = functionCall$1(fn, input))) return val;
  if (pref !== 'string' && isCallable$1(fn = input.toString) && !isObject$1(val = functionCall$1(fn, input))) return val;
  throw $TypeError$2$1("Can't convert object to primitive value");
};

var isPure$1 = false;
var defineProperty$b = Object.defineProperty;

var defineGlobalProperty$1 = function defineGlobalProperty(key, value) {
  try {
    defineProperty$b(global_1$1, key, {
      value: value,
      configurable: true,
      writable: true
    });
  } catch (error) {
    global_1$1[key] = value;
  }

  return value;
};

var SHARED$1 = '__core-js_shared__';
var store$2 = global_1$1[SHARED$1] || defineGlobalProperty$1(SHARED$1, {});
var sharedStore$1 = store$2;
var shared$1 = createCommonjsModule$1(function (module) {
  (module.exports = function (key, value) {
    return sharedStore$1[key] || (sharedStore$1[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: '3.26.0',
    mode: 'global',
    copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
    license: 'https://github.com/zloirock/core-js/blob/v3.26.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
  });
});
var $Object$2$1 = Object; // `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject

var toObject$1 = function toObject(argument) {
  return $Object$2$1(requireObjectCoercible$1(argument));
};

var hasOwnProperty$1 = functionUncurryThis$1({}.hasOwnProperty); // `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe

var hasOwnProperty_1$1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty$1(toObject$1(it), key);
};

var id$2 = 0;
var postfix$1 = Math.random();
var toString$1$1 = functionUncurryThis$1(1.0.toString);

var uid$1 = function uid(key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$1$1(++id$2 + postfix$1, 36);
};

var WellKnownSymbolsStore$2 = shared$1('wks');
var Symbol$1$1 = global_1$1.Symbol;
var symbolFor$1 = Symbol$1$1 && Symbol$1$1['for'];
var createWellKnownSymbol$1 = useSymbolAsUid$1 ? Symbol$1$1 : Symbol$1$1 && Symbol$1$1.withoutSetter || uid$1;

var wellKnownSymbol$1 = function wellKnownSymbol(name) {
  if (!hasOwnProperty_1$1(WellKnownSymbolsStore$2, name) || !(symbolConstructorDetection$1 || typeof WellKnownSymbolsStore$2[name] == 'string')) {
    var description = 'Symbol.' + name;

    if (symbolConstructorDetection$1 && hasOwnProperty_1$1(Symbol$1$1, name)) {
      WellKnownSymbolsStore$2[name] = Symbol$1$1[name];
    } else if (useSymbolAsUid$1 && symbolFor$1) {
      WellKnownSymbolsStore$2[name] = symbolFor$1(description);
    } else {
      WellKnownSymbolsStore$2[name] = createWellKnownSymbol$1(description);
    }
  }

  return WellKnownSymbolsStore$2[name];
};

var $TypeError$3$1 = TypeError;
var TO_PRIMITIVE$1 = wellKnownSymbol$1('toPrimitive'); // `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive

var toPrimitive$1 = function toPrimitive(input, pref) {
  if (!isObject$1(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$1(input, TO_PRIMITIVE$1);
  var result;

  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = functionCall$1(exoticToPrim, input, pref);
    if (!isObject$1(result) || isSymbol$1(result)) return result;
    throw $TypeError$3$1("Can't convert object to primitive value");
  }

  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive$1(input, pref);
}; // https://tc39.es/ecma262/#sec-topropertykey


var toPropertyKey$1 = function toPropertyKey(argument) {
  var key = toPrimitive$1(argument, 'string');
  return isSymbol$1(key) ? key : key + '';
};

var document$1$1 = global_1$1.document; // typeof document.createElement is 'object' in old IE

var EXISTS$2 = isObject$1(document$1$1) && isObject$1(document$1$1.createElement);

var documentCreateElement$1 = function documentCreateElement(it) {
  return EXISTS$2 ? document$1$1.createElement(it) : {};
};

var ie8DomDefine$1 = !descriptors$1 && !fails$1(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(documentCreateElement$1('div'), 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
});
var $getOwnPropertyDescriptor$3 = Object.getOwnPropertyDescriptor; // `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor

var f$1$1 = descriptors$1 ? $getOwnPropertyDescriptor$3 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$1(O);
  P = toPropertyKey$1(P);
  if (ie8DomDefine$1) try {
    return $getOwnPropertyDescriptor$3(O, P);
  } catch (error) {
    /* empty */
  }
  if (hasOwnProperty_1$1(O, P)) return createPropertyDescriptor$1(!functionCall$1(objectPropertyIsEnumerable$1.f, O, P), O[P]);
};
var objectGetOwnPropertyDescriptor$1 = {
  f: f$1$1
}; // https://bugs.chromium.org/p/v8/issues/detail?id=3334

var v8PrototypeDefineBug$1 = descriptors$1 && fails$1(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () {
    /* empty */
  }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});
var $String$1$1 = String;
var $TypeError$4$1 = TypeError; // `Assert: Type(argument) is Object`

var anObject$1 = function anObject(argument) {
  if (isObject$1(argument)) return argument;
  throw $TypeError$4$1($String$1$1(argument) + ' is not an object');
};

var $TypeError$5$1 = TypeError; // eslint-disable-next-line es/no-object-defineproperty -- safe

var $defineProperty$2 = Object.defineProperty; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

var $getOwnPropertyDescriptor$1$1 = Object.getOwnPropertyDescriptor;
var ENUMERABLE$1 = 'enumerable';
var CONFIGURABLE$2 = 'configurable';
var WRITABLE$1 = 'writable'; // `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty

var f$2$1 = descriptors$1 ? v8PrototypeDefineBug$1 ? function defineProperty(O, P, Attributes) {
  anObject$1(O);
  P = toPropertyKey$1(P);
  anObject$1(Attributes);

  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE$1 in Attributes && !Attributes[WRITABLE$1]) {
    var current = $getOwnPropertyDescriptor$1$1(O, P);

    if (current && current[WRITABLE$1]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$2 in Attributes ? Attributes[CONFIGURABLE$2] : current[CONFIGURABLE$2],
        enumerable: ENUMERABLE$1 in Attributes ? Attributes[ENUMERABLE$1] : current[ENUMERABLE$1],
        writable: false
      };
    }
  }

  return $defineProperty$2(O, P, Attributes);
} : $defineProperty$2 : function defineProperty(O, P, Attributes) {
  anObject$1(O);
  P = toPropertyKey$1(P);
  anObject$1(Attributes);
  if (ie8DomDefine$1) try {
    return $defineProperty$2(O, P, Attributes);
  } catch (error) {
    /* empty */
  }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError$5$1('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};
var objectDefineProperty$1 = {
  f: f$2$1
};
var createNonEnumerableProperty$1 = descriptors$1 ? function (object, key, value) {
  return objectDefineProperty$1.f(object, key, createPropertyDescriptor$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};
var FunctionPrototype$1$1 = Function.prototype; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

var getDescriptor$1 = descriptors$1 && Object.getOwnPropertyDescriptor;
var EXISTS$1$1 = hasOwnProperty_1$1(FunctionPrototype$1$1, 'name'); // additional protection from minified / mangled / dropped function names

var PROPER$1 = EXISTS$1$1 && function something() {
  /* empty */
}.name === 'something';

var CONFIGURABLE$1$1 = EXISTS$1$1 && (!descriptors$1 || descriptors$1 && getDescriptor$1(FunctionPrototype$1$1, 'name').configurable);
var functionName$1 = {
  EXISTS: EXISTS$1$1,
  PROPER: PROPER$1,
  CONFIGURABLE: CONFIGURABLE$1$1
};
var functionToString$2 = functionUncurryThis$1(Function.toString); // this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper

if (!isCallable$1(sharedStore$1.inspectSource)) {
  sharedStore$1.inspectSource = function (it) {
    return functionToString$2(it);
  };
}

var inspectSource$1 = sharedStore$1.inspectSource;
var WeakMap$3 = global_1$1.WeakMap;
var weakMapBasicDetection$1 = isCallable$1(WeakMap$3) && /native code/.test(String(WeakMap$3));
var keys$3 = shared$1('keys');

var sharedKey$1 = function sharedKey(key) {
  return keys$3[key] || (keys$3[key] = uid$1(key));
};

var hiddenKeys$2 = {};
var OBJECT_ALREADY_INITIALIZED$1 = 'Object already initialized';
var TypeError$1$1 = global_1$1.TypeError;
var WeakMap$1$1 = global_1$1.WeakMap;
var set$2, get$1, has$1;

var enforce$1 = function enforce(it) {
  return has$1(it) ? get$1(it) : set$2(it, {});
};

var getterFor$1 = function getterFor(TYPE) {
  return function (it) {
    var state;

    if (!isObject$1(it) || (state = get$1(it)).type !== TYPE) {
      throw TypeError$1$1('Incompatible receiver, ' + TYPE + ' required');
    }

    return state;
  };
};

if (weakMapBasicDetection$1 || sharedStore$1.state) {
  var store$1$1 = sharedStore$1.state || (sharedStore$1.state = new WeakMap$1$1());
  /* eslint-disable no-self-assign -- prototype methods protection */

  store$1$1.get = store$1$1.get;
  store$1$1.has = store$1$1.has;
  store$1$1.set = store$1$1.set;
  /* eslint-enable no-self-assign -- prototype methods protection */

  set$2 = function set(it, metadata) {
    if (store$1$1.has(it)) throw TypeError$1$1(OBJECT_ALREADY_INITIALIZED$1);
    metadata.facade = it;
    store$1$1.set(it, metadata);
    return metadata;
  };

  get$1 = function get(it) {
    return store$1$1.get(it) || {};
  };

  has$1 = function has(it) {
    return store$1$1.has(it);
  };
} else {
  var STATE$1 = sharedKey$1('state');
  hiddenKeys$2[STATE$1] = true;

  set$2 = function set(it, metadata) {
    if (hasOwnProperty_1$1(it, STATE$1)) throw TypeError$1$1(OBJECT_ALREADY_INITIALIZED$1);
    metadata.facade = it;
    createNonEnumerableProperty$1(it, STATE$1, metadata);
    return metadata;
  };

  get$1 = function get(it) {
    return hasOwnProperty_1$1(it, STATE$1) ? it[STATE$1] : {};
  };

  has$1 = function has(it) {
    return hasOwnProperty_1$1(it, STATE$1);
  };
}

var internalState$1 = {
  set: set$2,
  get: get$1,
  has: has$1,
  enforce: enforce$1,
  getterFor: getterFor$1
};
var makeBuiltIn_1$1 = createCommonjsModule$1(function (module) {
  var CONFIGURABLE_FUNCTION_NAME = functionName$1.CONFIGURABLE;
  var enforceInternalState = internalState$1.enforce;
  var getInternalState = internalState$1.get; // eslint-disable-next-line es/no-object-defineproperty -- safe

  var defineProperty = Object.defineProperty;
  var CONFIGURABLE_LENGTH = descriptors$1 && !fails$1(function () {
    return defineProperty(function () {
      /* empty */
    }, 'length', {
      value: 8
    }).length !== 8;
  });
  var TEMPLATE = String(String).split('String');

  var makeBuiltIn = module.exports = function (value, name, options) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }

    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;

    if (!hasOwnProperty_1$1(value, 'name') || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
      if (descriptors$1) defineProperty(value, 'name', {
        value: name,
        configurable: true
      });else value.name = name;
    }

    if (CONFIGURABLE_LENGTH && options && hasOwnProperty_1$1(options, 'arity') && value.length !== options.arity) {
      defineProperty(value, 'length', {
        value: options.arity
      });
    }

    try {
      if (options && hasOwnProperty_1$1(options, 'constructor') && options.constructor) {
        if (descriptors$1) defineProperty(value, 'prototype', {
          writable: false
        }); // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
      } else if (value.prototype) value.prototype = undefined;
    } catch (error) {
      /* empty */
    }

    var state = enforceInternalState(value);

    if (!hasOwnProperty_1$1(state, 'source')) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }

    return value;
  }; // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
  // eslint-disable-next-line no-extend-native -- required


  Function.prototype.toString = makeBuiltIn(function toString() {
    return isCallable$1(this) && getInternalState(this).source || inspectSource$1(this);
  }, 'toString');
});

var defineBuiltIn$1 = function defineBuiltIn(O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$1(value)) makeBuiltIn_1$1(value, name, options);

  if (options.global) {
    if (simple) O[key] = value;else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];else if (O[key]) simple = true;
    } catch (error) {
      /* empty */
    }

    if (simple) O[key] = value;else objectDefineProperty$1.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  }

  return O;
};

var ceil$1 = Math.ceil;
var floor$5 = Math.floor; // `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe

var mathTrunc$1 = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$5 : ceil$1)(n);
}; // https://tc39.es/ecma262/#sec-tointegerorinfinity


var toIntegerOrInfinity$1 = function toIntegerOrInfinity(argument) {
  var number = +argument; // eslint-disable-next-line no-self-compare -- NaN check

  return number !== number || number === 0 ? 0 : mathTrunc$1(number);
};

var max$5 = Math.max;
var min$5 = Math.min; // Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).

var toAbsoluteIndex$1 = function toAbsoluteIndex(index, length) {
  var integer = toIntegerOrInfinity$1(index);
  return integer < 0 ? max$5(integer + length, 0) : min$5(integer, length);
};

var min$1$1 = Math.min; // `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength

var toLength$1 = function toLength(argument) {
  return argument > 0 ? min$1$1(toIntegerOrInfinity$1(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
}; // https://tc39.es/ecma262/#sec-lengthofarraylike


var lengthOfArrayLike$1 = function lengthOfArrayLike(obj) {
  return toLength$1(obj.length);
};

var createMethod$4 = function createMethod(IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$1($this);
    var length = lengthOfArrayLike$1(O);
    var index = toAbsoluteIndex$1(fromIndex, length);
    var value; // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check

    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++]; // eslint-disable-next-line no-self-compare -- NaN check

      if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    }
    return !IS_INCLUDES && -1;
  };
};

var arrayIncludes$1 = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$4(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$4(false)
};
var indexOf$2 = arrayIncludes$1.indexOf;
var push$9 = functionUncurryThis$1([].push);

var objectKeysInternal$1 = function objectKeysInternal(object, names) {
  var O = toIndexedObject$1(object);
  var i = 0;
  var result = [];
  var key;

  for (key in O) {
    !hasOwnProperty_1$1(hiddenKeys$2, key) && hasOwnProperty_1$1(O, key) && push$9(result, key);
  } // Don't enum bug & hidden keys


  while (names.length > i) {
    if (hasOwnProperty_1$1(O, key = names[i++])) {
      ~indexOf$2(result, key) || push$9(result, key);
    }
  }

  return result;
}; // IE8- don't enum bug keys


var enumBugKeys$1 = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];
var hiddenKeys$1$1 = enumBugKeys$1.concat('length', 'prototype'); // `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe

var f$3$1 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal$1(O, hiddenKeys$1$1);
};

var objectGetOwnPropertyNames$1 = {
  f: f$3$1
}; // eslint-disable-next-line es/no-object-getownpropertysymbols -- safe

var f$4$1 = Object.getOwnPropertySymbols;
var objectGetOwnPropertySymbols$1 = {
  f: f$4$1
};
var concat$3 = functionUncurryThis$1([].concat); // all object keys, includes non-enumerable and symbols

var ownKeys$1 = getBuiltIn$1('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = objectGetOwnPropertyNames$1.f(anObject$1(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols$1.f;
  return getOwnPropertySymbols ? concat$3(keys, getOwnPropertySymbols(it)) : keys;
};

var copyConstructorProperties$1 = function copyConstructorProperties(target, source, exceptions) {
  var keys = ownKeys$1(source);
  var defineProperty = objectDefineProperty$1.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor$1.f;

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];

    if (!hasOwnProperty_1$1(target, key) && !(exceptions && hasOwnProperty_1$1(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var replacement$1 = /#|\.prototype\./;

var isForced$1 = function isForced(feature, detection) {
  var value = data$1[normalize$1(feature)];
  return value == POLYFILL$1 ? true : value == NATIVE$1 ? false : isCallable$1(detection) ? fails$1(detection) : !!detection;
};

var normalize$1 = isForced$1.normalize = function (string) {
  return String(string).replace(replacement$1, '.').toLowerCase();
};

var data$1 = isForced$1.data = {};
var NATIVE$1 = isForced$1.NATIVE = 'N';
var POLYFILL$1 = isForced$1.POLYFILL = 'P';
var isForced_1$1 = isForced$1;
var getOwnPropertyDescriptor$1$1 = objectGetOwnPropertyDescriptor$1.f;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/

var _export$1 = function _export(options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;

  if (GLOBAL) {
    target = global_1$1;
  } else if (STATIC) {
    target = global_1$1[TARGET] || defineGlobalProperty$1(TARGET, {});
  } else {
    target = (global_1$1[TARGET] || {}).prototype;
  }

  if (target) for (key in source) {
    sourceProperty = source[key];

    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$1$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];

    FORCED = isForced_1$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced); // contained in target

    if (!FORCED && targetProperty !== undefined) {
      if (_typeof$1(sourceProperty) == _typeof$1(targetProperty)) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    } // add a flag to not completely full polyfills


    if (options.sham || targetProperty && targetProperty.sham) {
      createNonEnumerableProperty$1(sourceProperty, 'sham', true);
    }

    defineBuiltIn$1(target, key, sourceProperty, options);
  }
};

var TO_STRING_TAG$4 = wellKnownSymbol$1('toStringTag');
var test$2 = {};
test$2[TO_STRING_TAG$4] = 'z';
var toStringTagSupport$1 = String(test$2) === '[object z]';
var TO_STRING_TAG$1$1 = wellKnownSymbol$1('toStringTag');
var $Object$3$1 = Object; // ES3 wrong here

var CORRECT_ARGUMENTS$1 = classofRaw$1(function () {
  return arguments;
}()) == 'Arguments'; // fallback for IE11 Script Access Denied error

var tryGet$1 = function tryGet(it, key) {
  try {
    return it[key];
  } catch (error) {
    /* empty */
  }
}; // getting tag from ES6+ `Object.prototype.toString`


var classof$1 = toStringTagSupport$1 ? classofRaw$1 : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
  : typeof (tag = tryGet$1(O = $Object$3$1(it), TO_STRING_TAG$1$1)) == 'string' ? tag // builtinTag case
  : CORRECT_ARGUMENTS$1 ? classofRaw$1(O) // ES3 arguments fallback
  : (result = classofRaw$1(O)) == 'Object' && isCallable$1(O.callee) ? 'Arguments' : result;
};
var $String$2$1 = String;

var toString_1$1 = function toString_1(argument) {
  if (classof$1(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String$2$1(argument);
}; // https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe


var objectKeys$1 = Object.keys || function keys(O) {
  return objectKeysInternal$1(O, enumBugKeys$1);
}; // https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe


var f$5$1 = descriptors$1 && !v8PrototypeDefineBug$1 ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$1(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;

  while (length > index) {
    objectDefineProperty$1.f(O, key = keys[index++], props[key]);
  }

  return O;
};
var objectDefineProperties$1 = {
  f: f$5$1
};
var html$1 = getBuiltIn$1('document', 'documentElement');
/* global ActiveXObject -- old IE, WSH */

var GT$1 = '>';
var LT$1 = '<';
var PROTOTYPE$2 = 'prototype';
var SCRIPT$1 = 'script';
var IE_PROTO$2 = sharedKey$1('IE_PROTO');

var EmptyConstructor$1 = function EmptyConstructor() {
  /* empty */
};

var scriptTag$1 = function scriptTag(content) {
  return LT$1 + SCRIPT$1 + GT$1 + content + LT$1 + '/' + SCRIPT$1 + GT$1;
}; // Create object with fake `null` prototype: use ActiveX Object with cleared prototype


var NullProtoObjectViaActiveX$1 = function NullProtoObjectViaActiveX(activeXDocument) {
  activeXDocument.write(scriptTag$1(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak

  return temp;
}; // Create object with fake `null` prototype: use iframe Object with cleared prototype


var NullProtoObjectViaIFrame$1 = function NullProtoObjectViaIFrame() {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT$1 + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe); // https://github.com/zloirock/core-js/issues/475

  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag$1('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
}; // Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug


var activeXDocument$1;

var _NullProtoObject2 = function NullProtoObject() {
  try {
    activeXDocument$1 = new ActiveXObject('htmlfile');
  } catch (error) {
    /* ignore */
  }

  _NullProtoObject2 = typeof document != 'undefined' ? document.domain && activeXDocument$1 ? NullProtoObjectViaActiveX$1(activeXDocument$1) // old IE
  : NullProtoObjectViaIFrame$1() : NullProtoObjectViaActiveX$1(activeXDocument$1); // WSH

  var length = enumBugKeys$1.length;

  while (length--) {
    delete _NullProtoObject2[PROTOTYPE$2][enumBugKeys$1[length]];
  }

  return _NullProtoObject2();
};

hiddenKeys$2[IE_PROTO$2] = true; // `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe

var objectCreate$1 = Object.create || function create(O, Properties) {
  var result;

  if (O !== null) {
    EmptyConstructor$1[PROTOTYPE$2] = anObject$1(O);
    result = new EmptyConstructor$1();
    EmptyConstructor$1[PROTOTYPE$2] = null; // add "__proto__" for Object.getPrototypeOf polyfill

    result[IE_PROTO$2] = O;
  } else result = _NullProtoObject2();

  return Properties === undefined ? result : objectDefineProperties$1.f(result, Properties);
};

var createProperty$1 = function createProperty(object, key, value) {
  var propertyKey = toPropertyKey$1(key);
  if (propertyKey in object) objectDefineProperty$1.f(object, propertyKey, createPropertyDescriptor$1(0, value));else object[propertyKey] = value;
};

var $Array$4 = Array;
var max$1$1 = Math.max;

var arraySliceSimple$1 = function arraySliceSimple(O, start, end) {
  var length = lengthOfArrayLike$1(O);
  var k = toAbsoluteIndex$1(start, length);
  var fin = toAbsoluteIndex$1(end === undefined ? length : end, length);
  var result = $Array$4(max$1$1(fin - k, 0));

  for (var n = 0; k < fin; k++, n++) {
    createProperty$1(result, n, O[k]);
  }

  result.length = n;
  return result;
};
/* eslint-disable es/no-object-getownpropertynames -- safe */


var $getOwnPropertyNames$2 = objectGetOwnPropertyNames$1.f;
var windowNames$1 = (typeof window === "undefined" ? "undefined" : _typeof$1(window)) == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

var getWindowNames$1 = function getWindowNames(it) {
  try {
    return $getOwnPropertyNames$2(it);
  } catch (error) {
    return arraySliceSimple$1(windowNames$1);
  }
}; // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window


var f$6$1 = function getOwnPropertyNames(it) {
  return windowNames$1 && classofRaw$1(it) == 'Window' ? getWindowNames$1(it) : $getOwnPropertyNames$2(toIndexedObject$1(it));
};

var objectGetOwnPropertyNamesExternal$1 = {
  f: f$6$1
};
var f$7$1 = wellKnownSymbol$1;
var wellKnownSymbolWrapped$1 = {
  f: f$7$1
};
var path$1 = global_1$1;
var defineProperty$1$1 = objectDefineProperty$1.f;

var wellKnownSymbolDefine$1 = function wellKnownSymbolDefine(NAME) {
  var _Symbol = path$1.Symbol || (path$1.Symbol = {});

  if (!hasOwnProperty_1$1(_Symbol, NAME)) defineProperty$1$1(_Symbol, NAME, {
    value: wellKnownSymbolWrapped$1.f(NAME)
  });
};

var symbolDefineToPrimitive$1 = function symbolDefineToPrimitive() {
  var _Symbol2 = getBuiltIn$1('Symbol');

  var SymbolPrototype = _Symbol2 && _Symbol2.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol$1('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn$1(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return functionCall$1(valueOf, this);
    }, {
      arity: 1
    });
  }
};

var defineProperty$2$1 = objectDefineProperty$1.f;
var TO_STRING_TAG$2$1 = wellKnownSymbol$1('toStringTag');

var setToStringTag$1 = function setToStringTag(target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;

  if (target && !hasOwnProperty_1$1(target, TO_STRING_TAG$2$1)) {
    defineProperty$2$1(target, TO_STRING_TAG$2$1, {
      configurable: true,
      value: TAG
    });
  }
};

var bind$2 = functionUncurryThis$1(functionUncurryThis$1.bind); // optional / simple context binding

var functionBindContext$1 = function functionBindContext(fn, that) {
  aCallable$1(fn);
  return that === undefined ? fn : functionBindNative$1 ? bind$2(fn, that) : function ()
  /* ...args */
  {
    return fn.apply(that, arguments);
  };
}; // https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe


var isArray$1 = Array.isArray || function isArray(argument) {
  return classofRaw$1(argument) == 'Array';
};

var noop$1 = function noop() {
  /* empty */
};

var empty$1 = [];
var construct$1 = getBuiltIn$1('Reflect', 'construct');
var constructorRegExp$1 = /^\s*(?:class|function)\b/;
var exec$6 = functionUncurryThis$1(constructorRegExp$1.exec);
var INCORRECT_TO_STRING$1 = !constructorRegExp$1.exec(noop$1);

var isConstructorModern$1 = function isConstructor(argument) {
  if (!isCallable$1(argument)) return false;

  try {
    construct$1(noop$1, empty$1, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy$1 = function isConstructor(argument) {
  if (!isCallable$1(argument)) return false;

  switch (classof$1(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction':
      return false;
  }

  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING$1 || !!exec$6(constructorRegExp$1, inspectSource$1(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy$1.sham = true; // `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor

var isConstructor$1 = !construct$1 || fails$1(function () {
  var called;
  return isConstructorModern$1(isConstructorModern$1.call) || !isConstructorModern$1(Object) || !isConstructorModern$1(function () {
    called = true;
  }) || called;
}) ? isConstructorLegacy$1 : isConstructorModern$1;
var SPECIES$7 = wellKnownSymbol$1('species');
var $Array$1$1 = Array; // a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate

var arraySpeciesConstructor$1 = function arraySpeciesConstructor(originalArray) {
  var C;

  if (isArray$1(originalArray)) {
    C = originalArray.constructor; // cross-realm fallback

    if (isConstructor$1(C) && (C === $Array$1$1 || isArray$1(C.prototype))) C = undefined;else if (isObject$1(C)) {
      C = C[SPECIES$7];
      if (C === null) C = undefined;
    }
  }

  return C === undefined ? $Array$1$1 : C;
}; // https://tc39.es/ecma262/#sec-arrayspeciescreate


var arraySpeciesCreate$1 = function arraySpeciesCreate(originalArray, length) {
  return new (arraySpeciesConstructor$1(originalArray))(length === 0 ? 0 : length);
};

var push$1$1 = functionUncurryThis$1([].push); // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation

var createMethod$1$1 = function createMethod$1(TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject$1($this);
    var self = indexedObject$1(O);
    var boundFunction = functionBindContext$1(callbackfn, that);
    var length = lengthOfArrayLike$1(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate$1;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;

    for (; length > index; index++) {
      if (NO_HOLES || index in self) {
        value = self[index];
        result = boundFunction(value, index, O);

        if (TYPE) {
          if (IS_MAP) target[index] = result; // map
          else if (result) switch (TYPE) {
              case 3:
                return true;
              // some

              case 5:
                return value;
              // find

              case 6:
                return index;
              // findIndex

              case 2:
                push$1$1(target, value);
              // filter
            } else switch (TYPE) {
              case 4:
                return false;
              // every

              case 7:
                push$1$1(target, value);
              // filterReject
            }
        }
      }
    }

    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration$1 = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$1$1(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod$1$1(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod$1$1(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod$1$1(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod$1$1(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod$1$1(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$1$1(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod$1$1(7)
};
var $forEach$2 = arrayIteration$1.forEach;
var HIDDEN$1 = sharedKey$1('hidden');
var SYMBOL$1 = 'Symbol';
var PROTOTYPE$1$1 = 'prototype';
var setInternalState$8 = internalState$1.set;
var getInternalState$4 = internalState$1.getterFor(SYMBOL$1);
var ObjectPrototype$2 = Object[PROTOTYPE$1$1];
var $Symbol$1 = global_1$1.Symbol;
var SymbolPrototype$2 = $Symbol$1 && $Symbol$1[PROTOTYPE$1$1];
var TypeError$2$1 = global_1$1.TypeError;
var QObject$1 = global_1$1.QObject;
var nativeGetOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor$1.f;
var nativeDefineProperty$1 = objectDefineProperty$1.f;
var nativeGetOwnPropertyNames$1 = objectGetOwnPropertyNamesExternal$1.f;
var nativePropertyIsEnumerable$1 = objectPropertyIsEnumerable$1.f;
var push$2$1 = functionUncurryThis$1([].push);
var AllSymbols$1 = shared$1('symbols');
var ObjectPrototypeSymbols$1 = shared$1('op-symbols');
var WellKnownSymbolsStore$1$1 = shared$1('wks'); // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173

var USE_SETTER$1 = !QObject$1 || !QObject$1[PROTOTYPE$1$1] || !QObject$1[PROTOTYPE$1$1].findChild; // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687

var setSymbolDescriptor$1 = descriptors$1 && fails$1(function () {
  return objectCreate$1(nativeDefineProperty$1({}, 'a', {
    get: function get() {
      return nativeDefineProperty$1(this, 'a', {
        value: 7
      }).a;
    }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor$2(ObjectPrototype$2, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype$2[P];
  nativeDefineProperty$1(O, P, Attributes);

  if (ObjectPrototypeDescriptor && O !== ObjectPrototype$2) {
    nativeDefineProperty$1(ObjectPrototype$2, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty$1;

var wrap$1 = function wrap(tag, description) {
  var symbol = AllSymbols$1[tag] = objectCreate$1(SymbolPrototype$2);
  setInternalState$8(symbol, {
    type: SYMBOL$1,
    tag: tag,
    description: description
  });
  if (!descriptors$1) symbol.description = description;
  return symbol;
};

var $defineProperty$1$1 = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype$2) $defineProperty$1$1(ObjectPrototypeSymbols$1, P, Attributes);
  anObject$1(O);
  var key = toPropertyKey$1(P);
  anObject$1(Attributes);

  if (hasOwnProperty_1$1(AllSymbols$1, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwnProperty_1$1(O, HIDDEN$1)) nativeDefineProperty$1(O, HIDDEN$1, createPropertyDescriptor$1(1, {}));
      O[HIDDEN$1][key] = true;
    } else {
      if (hasOwnProperty_1$1(O, HIDDEN$1) && O[HIDDEN$1][key]) O[HIDDEN$1][key] = false;
      Attributes = objectCreate$1(Attributes, {
        enumerable: createPropertyDescriptor$1(0, false)
      });
    }

    return setSymbolDescriptor$1(O, key, Attributes);
  }

  return nativeDefineProperty$1(O, key, Attributes);
};

var $defineProperties$1 = function defineProperties(O, Properties) {
  anObject$1(O);
  var properties = toIndexedObject$1(Properties);
  var keys = objectKeys$1(properties).concat($getOwnPropertySymbols$1(properties));
  $forEach$2(keys, function (key) {
    if (!descriptors$1 || functionCall$1($propertyIsEnumerable$1$1, properties, key)) $defineProperty$1$1(O, key, properties[key]);
  });
  return O;
};

var $create$1 = function create(O, Properties) {
  return Properties === undefined ? objectCreate$1(O) : $defineProperties$1(objectCreate$1(O), Properties);
};

var $propertyIsEnumerable$1$1 = function propertyIsEnumerable(V) {
  var P = toPropertyKey$1(V);
  var enumerable = functionCall$1(nativePropertyIsEnumerable$1, this, P);
  if (this === ObjectPrototype$2 && hasOwnProperty_1$1(AllSymbols$1, P) && !hasOwnProperty_1$1(ObjectPrototypeSymbols$1, P)) return false;
  return enumerable || !hasOwnProperty_1$1(this, P) || !hasOwnProperty_1$1(AllSymbols$1, P) || hasOwnProperty_1$1(this, HIDDEN$1) && this[HIDDEN$1][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor$2$1 = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject$1(O);
  var key = toPropertyKey$1(P);
  if (it === ObjectPrototype$2 && hasOwnProperty_1$1(AllSymbols$1, key) && !hasOwnProperty_1$1(ObjectPrototypeSymbols$1, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor$2(it, key);

  if (descriptor && hasOwnProperty_1$1(AllSymbols$1, key) && !(hasOwnProperty_1$1(it, HIDDEN$1) && it[HIDDEN$1][key])) {
    descriptor.enumerable = true;
  }

  return descriptor;
};

var $getOwnPropertyNames$1$1 = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames$1(toIndexedObject$1(O));
  var result = [];
  $forEach$2(names, function (key) {
    if (!hasOwnProperty_1$1(AllSymbols$1, key) && !hasOwnProperty_1$1(hiddenKeys$2, key)) push$2$1(result, key);
  });
  return result;
};

var $getOwnPropertySymbols$1 = function $getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype$2;
  var names = nativeGetOwnPropertyNames$1(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols$1 : toIndexedObject$1(O));
  var result = [];
  $forEach$2(names, function (key) {
    if (hasOwnProperty_1$1(AllSymbols$1, key) && (!IS_OBJECT_PROTOTYPE || hasOwnProperty_1$1(ObjectPrototype$2, key))) {
      push$2$1(result, AllSymbols$1[key]);
    }
  });
  return result;
}; // `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor


if (!symbolConstructorDetection$1) {
  $Symbol$1 = function _Symbol3() {
    if (objectIsPrototypeOf$1(SymbolPrototype$2, this)) throw TypeError$2$1('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : toString_1$1(arguments[0]);
    var tag = uid$1(description);

    var setter = function setter(value) {
      if (this === ObjectPrototype$2) functionCall$1(setter, ObjectPrototypeSymbols$1, value);
      if (hasOwnProperty_1$1(this, HIDDEN$1) && hasOwnProperty_1$1(this[HIDDEN$1], tag)) this[HIDDEN$1][tag] = false;
      setSymbolDescriptor$1(this, tag, createPropertyDescriptor$1(1, value));
    };

    if (descriptors$1 && USE_SETTER$1) setSymbolDescriptor$1(ObjectPrototype$2, tag, {
      configurable: true,
      set: setter
    });
    return wrap$1(tag, description);
  };

  SymbolPrototype$2 = $Symbol$1[PROTOTYPE$1$1];
  defineBuiltIn$1(SymbolPrototype$2, 'toString', function toString() {
    return getInternalState$4(this).tag;
  });
  defineBuiltIn$1($Symbol$1, 'withoutSetter', function (description) {
    return wrap$1(uid$1(description), description);
  });
  objectPropertyIsEnumerable$1.f = $propertyIsEnumerable$1$1;
  objectDefineProperty$1.f = $defineProperty$1$1;
  objectDefineProperties$1.f = $defineProperties$1;
  objectGetOwnPropertyDescriptor$1.f = $getOwnPropertyDescriptor$2$1;
  objectGetOwnPropertyNames$1.f = objectGetOwnPropertyNamesExternal$1.f = $getOwnPropertyNames$1$1;
  objectGetOwnPropertySymbols$1.f = $getOwnPropertySymbols$1;

  wellKnownSymbolWrapped$1.f = function (name) {
    return wrap$1(wellKnownSymbol$1(name), name);
  };

  if (descriptors$1) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty$1(SymbolPrototype$2, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState$4(this).description;
      }
    });
    {
      defineBuiltIn$1(ObjectPrototype$2, 'propertyIsEnumerable', $propertyIsEnumerable$1$1, {
        unsafe: true
      });
    }
  }
}

_export$1({
  global: true,
  constructor: true,
  wrap: true,
  forced: !symbolConstructorDetection$1,
  sham: !symbolConstructorDetection$1
}, {
  Symbol: $Symbol$1
});

$forEach$2(objectKeys$1(WellKnownSymbolsStore$1$1), function (name) {
  wellKnownSymbolDefine$1(name);
});

_export$1({
  target: SYMBOL$1,
  stat: true,
  forced: !symbolConstructorDetection$1
}, {
  useSetter: function useSetter() {
    USE_SETTER$1 = true;
  },
  useSimple: function useSimple() {
    USE_SETTER$1 = false;
  }
});

_export$1({
  target: 'Object',
  stat: true,
  forced: !symbolConstructorDetection$1,
  sham: !descriptors$1
}, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create$1,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty$1$1,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties$1,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor$2$1
});

_export$1({
  target: 'Object',
  stat: true,
  forced: !symbolConstructorDetection$1
}, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames$1$1
}); // `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive


symbolDefineToPrimitive$1(); // `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag

setToStringTag$1($Symbol$1, SYMBOL$1);
hiddenKeys$2[HIDDEN$1] = true;
/* eslint-disable es/no-symbol -- safe */

var symbolRegistryDetection$1 = symbolConstructorDetection$1 && !!Symbol['for'] && !!Symbol.keyFor;
var StringToSymbolRegistry$1 = shared$1('string-to-symbol-registry');
var SymbolToStringRegistry$2 = shared$1('symbol-to-string-registry'); // `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for

_export$1({
  target: 'Symbol',
  stat: true,
  forced: !symbolRegistryDetection$1
}, {
  'for': function _for(key) {
    var string = toString_1$1(key);
    if (hasOwnProperty_1$1(StringToSymbolRegistry$1, string)) return StringToSymbolRegistry$1[string];
    var symbol = getBuiltIn$1('Symbol')(string);
    StringToSymbolRegistry$1[string] = symbol;
    SymbolToStringRegistry$2[symbol] = string;
    return symbol;
  }
});

var SymbolToStringRegistry$1$1 = shared$1('symbol-to-string-registry'); // `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor

_export$1({
  target: 'Symbol',
  stat: true,
  forced: !symbolRegistryDetection$1
}, {
  keyFor: function keyFor(sym) {
    if (!isSymbol$1(sym)) throw TypeError(tryToString$1(sym) + ' is not a symbol');
    if (hasOwnProperty_1$1(SymbolToStringRegistry$1$1, sym)) return SymbolToStringRegistry$1$1[sym];
  }
});

var FunctionPrototype$2$1 = Function.prototype;
var apply$1 = FunctionPrototype$2$1.apply;
var call$2$1 = FunctionPrototype$2$1.call; // eslint-disable-next-line es/no-reflect -- safe

var functionApply$1 = (typeof Reflect === "undefined" ? "undefined" : _typeof$1(Reflect)) == 'object' && Reflect.apply || (functionBindNative$1 ? call$2$1.bind(apply$1) : function () {
  return call$2$1.apply(apply$1, arguments);
});
var arraySlice$2 = functionUncurryThis$1([].slice);
var $stringify$1 = getBuiltIn$1('JSON', 'stringify');
var exec$1$1 = functionUncurryThis$1(/./.exec);
var charAt$9 = functionUncurryThis$1(''.charAt);
var charCodeAt$4 = functionUncurryThis$1(''.charCodeAt);
var replace$9 = functionUncurryThis$1(''.replace);
var numberToString$2 = functionUncurryThis$1(1.0.toString);
var tester$1 = /[\uD800-\uDFFF]/g;
var low$1 = /^[\uD800-\uDBFF]$/;
var hi$1 = /^[\uDC00-\uDFFF]$/;
var WRONG_SYMBOLS_CONVERSION$1 = !symbolConstructorDetection$1 || fails$1(function () {
  var symbol = getBuiltIn$1('Symbol')(); // MS Edge converts symbol values to JSON as {}

  return $stringify$1([symbol]) != '[null]' // WebKit converts symbol values to JSON as null
  || $stringify$1({
    a: symbol
  }) != '{}' // V8 throws on boxed symbols
  || $stringify$1(Object(symbol)) != '{}';
}); // https://github.com/tc39/proposal-well-formed-stringify

var ILL_FORMED_UNICODE$1 = fails$1(function () {
  return $stringify$1("\uDF06\uD834") !== "\"\\udf06\\ud834\"" || $stringify$1("\uDEAD") !== "\"\\udead\"";
});

var stringifyWithSymbolsFix$1 = function stringifyWithSymbolsFix(it, replacer) {
  var args = arraySlice$2(arguments);
  var $replacer = replacer;
  if (!isObject$1(replacer) && it === undefined || isSymbol$1(it)) return; // IE8 returns string on undefined

  if (!isArray$1(replacer)) replacer = function replacer(key, value) {
    if (isCallable$1($replacer)) value = functionCall$1($replacer, this, key, value);
    if (!isSymbol$1(value)) return value;
  };
  args[1] = replacer;
  return functionApply$1($stringify$1, null, args);
};

var fixIllFormed$1 = function fixIllFormed(match, offset, string) {
  var prev = charAt$9(string, offset - 1);
  var next = charAt$9(string, offset + 1);

  if (exec$1$1(low$1, match) && !exec$1$1(hi$1, next) || exec$1$1(hi$1, match) && !exec$1$1(low$1, prev)) {
    return "\\u" + numberToString$2(charCodeAt$4(match, 0), 16);
  }

  return match;
};

if ($stringify$1) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  _export$1({
    target: 'JSON',
    stat: true,
    arity: 3,
    forced: WRONG_SYMBOLS_CONVERSION$1 || ILL_FORMED_UNICODE$1
  }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice$2(arguments);
      var result = functionApply$1(WRONG_SYMBOLS_CONVERSION$1 ? stringifyWithSymbolsFix$1 : $stringify$1, null, args);
      return ILL_FORMED_UNICODE$1 && typeof result == 'string' ? replace$9(result, tester$1, fixIllFormed$1) : result;
    }
  });
} // https://bugs.chromium.org/p/v8/issues/detail?id=3443


var FORCED$6 = !symbolConstructorDetection$1 || fails$1(function () {
  objectGetOwnPropertySymbols$1.f(1);
}); // `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols

_export$1({
  target: 'Object',
  stat: true,
  forced: FORCED$6
}, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = objectGetOwnPropertySymbols$1.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject$1(it)) : [];
  }
});

var defineProperty$3$1 = objectDefineProperty$1.f;
var NativeSymbol$1 = global_1$1.Symbol;
var SymbolPrototype$1$1 = NativeSymbol$1 && NativeSymbol$1.prototype;

if (descriptors$1 && isCallable$1(NativeSymbol$1) && (!('description' in SymbolPrototype$1$1) || // Safari 12 bug
NativeSymbol$1().description !== undefined)) {
  var EmptyStringDescriptionStore$1 = {}; // wrap Symbol constructor for correct work with undefined description

  var SymbolWrapper$1 = function _Symbol4() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString_1$1(arguments[0]);
    var result = objectIsPrototypeOf$1(SymbolPrototype$1$1, this) ? new NativeSymbol$1(description) // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
    : description === undefined ? NativeSymbol$1() : NativeSymbol$1(description);
    if (description === '') EmptyStringDescriptionStore$1[result] = true;
    return result;
  };

  copyConstructorProperties$1(SymbolWrapper$1, NativeSymbol$1);
  SymbolWrapper$1.prototype = SymbolPrototype$1$1;
  SymbolPrototype$1$1.constructor = SymbolWrapper$1;
  var NATIVE_SYMBOL$1 = String(NativeSymbol$1('test')) == 'Symbol(test)';
  var thisSymbolValue$1 = functionUncurryThis$1(SymbolPrototype$1$1.valueOf);
  var symbolDescriptiveString$1 = functionUncurryThis$1(SymbolPrototype$1$1.toString);
  var regexp$1 = /^Symbol\((.*)\)[^)]+$/;
  var replace$1$1 = functionUncurryThis$1(''.replace);
  var stringSlice$1$1 = functionUncurryThis$1(''.slice);
  defineProperty$3$1(SymbolPrototype$1$1, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue$1(this);
      if (hasOwnProperty_1$1(EmptyStringDescriptionStore$1, symbol)) return '';
      var string = symbolDescriptiveString$1(symbol);
      var desc = NATIVE_SYMBOL$1 ? stringSlice$1$1(string, 7, -1) : replace$1$1(string, regexp$1, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  _export$1({
    global: true,
    constructor: true,
    forced: true
  }, {
    Symbol: SymbolWrapper$1
  });
} // https://tc39.es/ecma262/#sec-symbol.iterator


wellKnownSymbolDefine$1('iterator');
var $TypeError$6$1 = TypeError;
var MAX_SAFE_INTEGER$1 = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger$1 = function doesNotExceedSafeInteger(it) {
  if (it > MAX_SAFE_INTEGER$1) throw $TypeError$6$1('Maximum allowed index exceeded');
  return it;
};

var SPECIES$1$1 = wellKnownSymbol$1('species');

var arrayMethodHasSpeciesSupport$1 = function arrayMethodHasSpeciesSupport(METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return engineV8Version$1 >= 51 || !fails$1(function () {
    var array = [];
    var constructor = array.constructor = {};

    constructor[SPECIES$1$1] = function () {
      return {
        foo: 1
      };
    };

    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var IS_CONCAT_SPREADABLE$1 = wellKnownSymbol$1('isConcatSpreadable'); // We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679

var IS_CONCAT_SPREADABLE_SUPPORT$1 = engineV8Version$1 >= 51 || !fails$1(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE$1] = false;
  return array.concat()[0] !== array;
});
var SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport$1('concat');

var isConcatSpreadable$1 = function isConcatSpreadable(O) {
  if (!isObject$1(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE$1];
  return spreadable !== undefined ? !!spreadable : isArray$1(O);
};

var FORCED$1$1 = !IS_CONCAT_SPREADABLE_SUPPORT$1 || !SPECIES_SUPPORT$1; // `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species

_export$1({
  target: 'Array',
  proto: true,
  arity: 1,
  forced: FORCED$1$1
}, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject$1(this);
    var A = arraySpeciesCreate$1(O, 0);
    var n = 0;
    var i, k, length, len, E;

    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];

      if (isConcatSpreadable$1(E)) {
        len = lengthOfArrayLike$1(E);
        doesNotExceedSafeInteger$1(n + len);

        for (k = 0; k < len; k++, n++) {
          if (k in E) createProperty$1(A, n, E[k]);
        }
      } else {
        doesNotExceedSafeInteger$1(n + 1);
        createProperty$1(A, n++, E);
      }
    }

    A.length = n;
    return A;
  }
});

var iteratorClose$1 = function iteratorClose(iterator, kind, value) {
  var innerResult, innerError;
  anObject$1(iterator);

  try {
    innerResult = getMethod$1(iterator, 'return');

    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }

    innerResult = functionCall$1(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }

  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$1(innerResult);
  return value;
};

var callWithSafeIterationClosing$1 = function callWithSafeIterationClosing(iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$1(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose$1(iterator, 'throw', error);
  }
};

var iterators$1 = {};
var ITERATOR$8 = wellKnownSymbol$1('iterator');
var ArrayPrototype$2 = Array.prototype; // check on default Array iterator

var isArrayIteratorMethod$1 = function isArrayIteratorMethod(it) {
  return it !== undefined && (iterators$1.Array === it || ArrayPrototype$2[ITERATOR$8] === it);
};

var ITERATOR$1$1 = wellKnownSymbol$1('iterator');

var getIteratorMethod$1 = function getIteratorMethod(it) {
  if (!isNullOrUndefined$1(it)) return getMethod$1(it, ITERATOR$1$1) || getMethod$1(it, '@@iterator') || iterators$1[classof$1(it)];
};

var $TypeError$7$1 = TypeError;

var getIterator$1 = function getIterator(argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$1(argument) : usingIterator;
  if (aCallable$1(iteratorMethod)) return anObject$1(functionCall$1(iteratorMethod, argument));
  throw $TypeError$7$1(tryToString$1(argument) + ' is not iterable');
};

var $Array$2$1 = Array; // `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from

var arrayFrom$1 = function from(arrayLike
/* , mapfn = undefined, thisArg = undefined */
) {
  var O = toObject$1(arrayLike);
  var IS_CONSTRUCTOR = isConstructor$1(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = functionBindContext$1(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod$1(O);
  var index = 0;
  var length, result, step, iterator, next, value; // if the target is not iterable or it's an array with the default iterator - use a simple case

  if (iteratorMethod && !(this === $Array$2$1 && isArrayIteratorMethod$1(iteratorMethod))) {
    iterator = getIterator$1(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];

    for (; !(step = functionCall$1(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing$1(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty$1(result, index, value);
    }
  } else {
    length = lengthOfArrayLike$1(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array$2$1(length);

    for (; length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty$1(result, index, value);
    }
  }

  result.length = index;
  return result;
};

var ITERATOR$2$1 = wellKnownSymbol$1('iterator');
var SAFE_CLOSING$1 = false;

try {
  var called$1 = 0;
  var iteratorWithReturn$1 = {
    next: function next() {
      return {
        done: !!called$1++
      };
    },
    'return': function _return() {
      SAFE_CLOSING$1 = true;
    }
  };

  iteratorWithReturn$1[ITERATOR$2$1] = function () {
    return this;
  }; // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing


  Array.from(iteratorWithReturn$1, function () {
    throw 2;
  });
} catch (error) {
  /* empty */
}

var checkCorrectnessOfIteration$1 = function checkCorrectnessOfIteration(exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING$1) return false;
  var ITERATION_SUPPORT = false;

  try {
    var object = {};

    object[ITERATOR$2$1] = function () {
      return {
        next: function next() {
          return {
            done: ITERATION_SUPPORT = true
          };
        }
      };
    };

    exec(object);
  } catch (error) {
    /* empty */
  }

  return ITERATION_SUPPORT;
};

var INCORRECT_ITERATION$1 = !checkCorrectnessOfIteration$1(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
}); // `Array.from` method
// https://tc39.es/ecma262/#sec-array.from

_export$1({
  target: 'Array',
  stat: true,
  forced: INCORRECT_ITERATION$1
}, {
  from: arrayFrom$1
});

var arrayMethodIsStrict$1 = function arrayMethodIsStrict(METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$1(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () {
      return 1;
    }, 1);
  });
};
/* eslint-disable es/no-array-prototype-indexof -- required for testing */


var $indexOf$1 = arrayIncludes$1.indexOf;
var nativeIndexOf$1 = functionUncurryThis$1([].indexOf);
var NEGATIVE_ZERO$1 = !!nativeIndexOf$1 && 1 / nativeIndexOf$1([1], 1, -0) < 0;
var STRICT_METHOD$6 = arrayMethodIsStrict$1('indexOf'); // `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof

_export$1({
  target: 'Array',
  proto: true,
  forced: NEGATIVE_ZERO$1 || !STRICT_METHOD$6
}, {
  indexOf: function indexOf(searchElement
  /* , fromIndex = 0 */
  ) {
    var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
    return NEGATIVE_ZERO$1 // convert -0 to +0
    ? nativeIndexOf$1(this, searchElement, fromIndex) || 0 : $indexOf$1(this, searchElement, fromIndex);
  }
});

var defineProperty$4$1 = objectDefineProperty$1.f;
var UNSCOPABLES$1 = wellKnownSymbol$1('unscopables');
var ArrayPrototype$1$1 = Array.prototype; // Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

if (ArrayPrototype$1$1[UNSCOPABLES$1] == undefined) {
  defineProperty$4$1(ArrayPrototype$1$1, UNSCOPABLES$1, {
    configurable: true,
    value: objectCreate$1(null)
  });
} // add a key to Array.prototype[@@unscopables]


var addToUnscopables$1 = function addToUnscopables(key) {
  ArrayPrototype$1$1[UNSCOPABLES$1][key] = true;
};

var correctPrototypeGetter$1 = !fails$1(function () {
  function F() {
    /* empty */
  }

  F.prototype.constructor = null; // eslint-disable-next-line es/no-object-getprototypeof -- required for testing

  return Object.getPrototypeOf(new F()) !== F.prototype;
});
var IE_PROTO$1$1 = sharedKey$1('IE_PROTO');
var $Object$4$1 = Object;
var ObjectPrototype$1$1 = $Object$4$1.prototype; // `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe

var objectGetPrototypeOf$1 = correctPrototypeGetter$1 ? $Object$4$1.getPrototypeOf : function (O) {
  var object = toObject$1(O);
  if (hasOwnProperty_1$1(object, IE_PROTO$1$1)) return object[IE_PROTO$1$1];
  var constructor = object.constructor;

  if (isCallable$1(constructor) && object instanceof constructor) {
    return constructor.prototype;
  }

  return object instanceof $Object$4$1 ? ObjectPrototype$1$1 : null;
};
var ITERATOR$3$1 = wellKnownSymbol$1('iterator');
var BUGGY_SAFARI_ITERATORS$2 = false; // `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object

var IteratorPrototype$3, PrototypeOfArrayIteratorPrototype$1, arrayIterator$1;
/* eslint-disable es/no-array-prototype-keys -- safe */

if ([].keys) {
  arrayIterator$1 = [].keys(); // Safari 8 has buggy iterators w/o `next`

  if (!('next' in arrayIterator$1)) BUGGY_SAFARI_ITERATORS$2 = true;else {
    PrototypeOfArrayIteratorPrototype$1 = objectGetPrototypeOf$1(objectGetPrototypeOf$1(arrayIterator$1));
    if (PrototypeOfArrayIteratorPrototype$1 !== Object.prototype) IteratorPrototype$3 = PrototypeOfArrayIteratorPrototype$1;
  }
}

var NEW_ITERATOR_PROTOTYPE$1 = !isObject$1(IteratorPrototype$3) || fails$1(function () {
  var test = {}; // FF44- legacy iterators case

  return IteratorPrototype$3[ITERATOR$3$1].call(test) !== test;
});
if (NEW_ITERATOR_PROTOTYPE$1) IteratorPrototype$3 = {}; // `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator

if (!isCallable$1(IteratorPrototype$3[ITERATOR$3$1])) {
  defineBuiltIn$1(IteratorPrototype$3, ITERATOR$3$1, function () {
    return this;
  });
}

var iteratorsCore$1 = {
  IteratorPrototype: IteratorPrototype$3,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$2
};
var IteratorPrototype$1$1 = iteratorsCore$1.IteratorPrototype;

var returnThis$2 = function returnThis() {
  return this;
};

var iteratorCreateConstructor$1 = function iteratorCreateConstructor(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = objectCreate$1(IteratorPrototype$1$1, {
    next: createPropertyDescriptor$1(+!ENUMERABLE_NEXT, next)
  });
  setToStringTag$1(IteratorConstructor, TO_STRING_TAG, false);
  iterators$1[TO_STRING_TAG] = returnThis$2;
  return IteratorConstructor;
};

var $String$3$1 = String;
var $TypeError$8$1 = TypeError;

var aPossiblePrototype$1 = function aPossiblePrototype(argument) {
  if (_typeof$1(argument) == 'object' || isCallable$1(argument)) return argument;
  throw $TypeError$8$1("Can't set " + $String$3$1(argument) + ' as a prototype');
};
/* eslint-disable no-proto -- safe */
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe


var objectSetPrototypeOf$1 = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;

  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = functionUncurryThis$1(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) {
    /* empty */
  }

  return function setPrototypeOf(O, proto) {
    anObject$1(O);
    aPossiblePrototype$1(proto);
    if (CORRECT_SETTER) setter(O, proto);else O.__proto__ = proto;
    return O;
  };
}() : undefined);
var PROPER_FUNCTION_NAME$2 = functionName$1.PROPER;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName$1.CONFIGURABLE;
var IteratorPrototype$2$1 = iteratorsCore$1.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS$1$1 = iteratorsCore$1.BUGGY_SAFARI_ITERATORS;
var ITERATOR$4$1 = wellKnownSymbol$1('iterator');
var KEYS$1 = 'keys';
var VALUES$1 = 'values';
var ENTRIES$1 = 'entries';

var returnThis$1$1 = function returnThis$1() {
  return this;
};

var iteratorDefine$1 = function iteratorDefine(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  iteratorCreateConstructor$1(IteratorConstructor, NAME, next);

  var getIterationMethod = function getIterationMethod(KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS$1$1 && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS$1:
        return function keys() {
          return new IteratorConstructor(this, KIND);
        };

      case VALUES$1:
        return function values() {
          return new IteratorConstructor(this, KIND);
        };

      case ENTRIES$1:
        return function entries() {
          return new IteratorConstructor(this, KIND);
        };
    }

    return function () {
      return new IteratorConstructor(this);
    };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$4$1] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS$1$1 && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY; // fix native

  if (anyNativeIterator) {
    CurrentIteratorPrototype = objectGetPrototypeOf$1(anyNativeIterator.call(new Iterable()));

    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (objectGetPrototypeOf$1(CurrentIteratorPrototype) !== IteratorPrototype$2$1) {
        if (objectSetPrototypeOf$1) {
          objectSetPrototypeOf$1(CurrentIteratorPrototype, IteratorPrototype$2$1);
        } else if (!isCallable$1(CurrentIteratorPrototype[ITERATOR$4$1])) {
          defineBuiltIn$1(CurrentIteratorPrototype, ITERATOR$4$1, returnThis$1$1);
        }
      } // Set @@toStringTag to native iterators


      setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  } // fix Array.prototype.{ values, @@iterator }.name in V8 / FF


  if (PROPER_FUNCTION_NAME$2 && DEFAULT == VALUES$1 && nativeIterator && nativeIterator.name !== VALUES$1) {
    if (CONFIGURABLE_FUNCTION_NAME$1) {
      createNonEnumerableProperty$1(IterablePrototype, 'name', VALUES$1);
    } else {
      INCORRECT_VALUES_NAME = true;

      defaultIterator = function values() {
        return functionCall$1(nativeIterator, this);
      };
    }
  } // export additional methods


  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES$1),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS$1),
      entries: getIterationMethod(ENTRIES$1)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS$1$1 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$1(IterablePrototype, KEY, methods[KEY]);
      }
    } else _export$1({
      target: NAME,
      proto: true,
      forced: BUGGY_SAFARI_ITERATORS$1$1 || INCORRECT_VALUES_NAME
    }, methods);
  } // define iterator


  if (IterablePrototype[ITERATOR$4$1] !== defaultIterator) {
    defineBuiltIn$1(IterablePrototype, ITERATOR$4$1, defaultIterator, {
      name: DEFAULT
    });
  }

  iterators$1[NAME] = defaultIterator;
  return methods;
}; // `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject


var createIterResultObject$1 = function createIterResultObject(value, done) {
  return {
    value: value,
    done: done
  };
};

var defineProperty$5$1 = objectDefineProperty$1.f;
var ARRAY_ITERATOR$1 = 'Array Iterator';
var setInternalState$1$1 = internalState$1.set;
var getInternalState$1$1 = internalState$1.getterFor(ARRAY_ITERATOR$1); // `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator

var es_array_iterator$1 = iteratorDefine$1(Array, 'Array', function (iterated, kind) {
  setInternalState$1$1(this, {
    type: ARRAY_ITERATOR$1,
    target: toIndexedObject$1(iterated),
    // target
    index: 0,
    // next index
    kind: kind // kind

  }); // `%ArrayIteratorPrototype%.next` method
  // https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1$1(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;

  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject$1(undefined, true);
  }

  if (kind == 'keys') return createIterResultObject$1(index, false);
  if (kind == 'values') return createIterResultObject$1(target[index], false);
  return createIterResultObject$1([index, target[index]], false);
}, 'values'); // argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject

var values$1 = iterators$1.Arguments = iterators$1.Array; // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

addToUnscopables$1('keys');
addToUnscopables$1('values');
addToUnscopables$1('entries'); // V8 ~ Chrome 45- bug

if (descriptors$1 && values$1.name !== 'values') try {
  defineProperty$5$1(values$1, 'name', {
    value: 'values'
  });
} catch (error) {
  /* empty */
}
var nativeJoin$1 = functionUncurryThis$1([].join);
var ES3_STRINGS$1 = indexedObject$1 != Object;
var STRICT_METHOD$1$1 = arrayMethodIsStrict$1('join', ','); // `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join

_export$1({
  target: 'Array',
  proto: true,
  forced: ES3_STRINGS$1 || !STRICT_METHOD$1$1
}, {
  join: function join(separator) {
    return nativeJoin$1(toIndexedObject$1(this), separator === undefined ? ',' : separator);
  }
});

var HAS_SPECIES_SUPPORT$3 = arrayMethodHasSpeciesSupport$1('slice');
var SPECIES$2$1 = wellKnownSymbol$1('species');
var $Array$3$1 = Array;
var max$2$1 = Math.max; // `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects

_export$1({
  target: 'Array',
  proto: true,
  forced: !HAS_SPECIES_SUPPORT$3
}, {
  slice: function slice(start, end) {
    var O = toIndexedObject$1(this);
    var length = lengthOfArrayLike$1(O);
    var k = toAbsoluteIndex$1(start, length);
    var fin = toAbsoluteIndex$1(end === undefined ? length : end, length); // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible

    var Constructor, result, n;

    if (isArray$1(O)) {
      Constructor = O.constructor; // cross-realm fallback

      if (isConstructor$1(Constructor) && (Constructor === $Array$3$1 || isArray$1(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject$1(Constructor)) {
        Constructor = Constructor[SPECIES$2$1];
        if (Constructor === null) Constructor = undefined;
      }

      if (Constructor === $Array$3$1 || Constructor === undefined) {
        return arraySlice$2(O, k, fin);
      }
    }

    result = new (Constructor === undefined ? $Array$3$1 : Constructor)(max$2$1(fin - k, 0));

    for (n = 0; k < fin; k++, n++) {
      if (k in O) createProperty$1(result, n, O[k]);
    }

    result.length = n;
    return result;
  }
});

var FUNCTION_NAME_EXISTS$1 = functionName$1.EXISTS;
var defineProperty$6$1 = objectDefineProperty$1.f;
var FunctionPrototype$3$1 = Function.prototype;
var functionToString$1$1 = functionUncurryThis$1(FunctionPrototype$3$1.toString);
var nameRE$1 = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec$1 = functionUncurryThis$1(nameRE$1.exec);
var NAME$1 = 'name'; // Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name

if (descriptors$1 && !FUNCTION_NAME_EXISTS$1) {
  defineProperty$6$1(FunctionPrototype$3$1, NAME$1, {
    configurable: true,
    get: function get() {
      try {
        return regExpExec$1(nameRE$1, functionToString$1$1(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
} // https://tc39.es/ecma262/#sec-math.trunc


_export$1({
  target: 'Math',
  stat: true
}, {
  trunc: mathTrunc$1
});

var nativeGetOwnPropertyDescriptor$1$1 = objectGetOwnPropertyDescriptor$1.f;
var FAILS_ON_PRIMITIVES$5 = fails$1(function () {
  nativeGetOwnPropertyDescriptor$1$1(1);
});
var FORCED$2$1 = !descriptors$1 || FAILS_ON_PRIMITIVES$5; // `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor

_export$1({
  target: 'Object',
  stat: true,
  forced: FORCED$2$1,
  sham: !descriptors$1
}, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor$1$1(toIndexedObject$1(it), key);
  }
});

var getOwnPropertyNames$3 = objectGetOwnPropertyNamesExternal$1.f; // eslint-disable-next-line es/no-object-getownpropertynames -- required for testing

var FAILS_ON_PRIMITIVES$1$1 = fails$1(function () {
  return !Object.getOwnPropertyNames(1);
}); // `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames

_export$1({
  target: 'Object',
  stat: true,
  forced: FAILS_ON_PRIMITIVES$1$1
}, {
  getOwnPropertyNames: getOwnPropertyNames$3
}); // https://tc39.es/ecma262/#sec-object.prototype.tostring


var objectToString$1 = toStringTagSupport$1 ? {}.toString : function toString() {
  return '[object ' + classof$1(this) + ']';
}; // https://tc39.es/ecma262/#sec-object.prototype.tostring

if (!toStringTagSupport$1) {
  defineBuiltIn$1(Object.prototype, 'toString', objectToString$1, {
    unsafe: true
  });
}

var engineIsNode$1 = classofRaw$1(global_1$1.process) == 'process';
var SPECIES$3$1 = wellKnownSymbol$1('species');

var setSpecies$1 = function setSpecies(CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$1(CONSTRUCTOR_NAME);
  var defineProperty = objectDefineProperty$1.f;

  if (descriptors$1 && Constructor && !Constructor[SPECIES$3$1]) {
    defineProperty(Constructor, SPECIES$3$1, {
      configurable: true,
      get: function get() {
        return this;
      }
    });
  }
};

var $TypeError$9$1 = TypeError;

var anInstance$1 = function anInstance(it, Prototype) {
  if (objectIsPrototypeOf$1(Prototype, it)) return it;
  throw $TypeError$9$1('Incorrect invocation');
};

var $TypeError$a$1 = TypeError; // `Assert: IsConstructor(argument) is true`

var aConstructor$1 = function aConstructor(argument) {
  if (isConstructor$1(argument)) return argument;
  throw $TypeError$a$1(tryToString$1(argument) + ' is not a constructor');
};

var SPECIES$4$1 = wellKnownSymbol$1('species'); // `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor

var speciesConstructor$1 = function speciesConstructor(O, defaultConstructor) {
  var C = anObject$1(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined$1(S = anObject$1(C)[SPECIES$4$1]) ? defaultConstructor : aConstructor$1(S);
};

var $TypeError$b$1 = TypeError;

var validateArgumentsLength$1 = function validateArgumentsLength(passed, required) {
  if (passed < required) throw $TypeError$b$1('Not enough arguments');
  return passed;
};

var engineIsIos$1 = /(?:ipad|iphone|ipod).*applewebkit/i.test(engineUserAgent$1);
var set$1$1 = global_1$1.setImmediate;
var clear$1 = global_1$1.clearImmediate;
var process$1$1 = global_1$1.process;
var Dispatch$1 = global_1$1.Dispatch;
var Function$1$1 = global_1$1.Function;
var MessageChannel$2 = global_1$1.MessageChannel;
var String$1$1 = global_1$1.String;
var counter$1 = 0;
var queue$2 = {};
var ONREADYSTATECHANGE$1 = 'onreadystatechange';
var $location$1, defer$1, channel$1, port$1;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location$1 = global_1$1.location;
} catch (error) {
  /* empty */
}

var run$1 = function run(id) {
  if (hasOwnProperty_1$1(queue$2, id)) {
    var fn = queue$2[id];
    delete queue$2[id];
    fn();
  }
};

var runner$1 = function runner(id) {
  return function () {
    run$1(id);
  };
};

var listener$1 = function listener(event) {
  run$1(event.data);
};

var post$1 = function post(id) {
  // old engines have not location.origin
  global_1$1.postMessage(String$1$1(id), $location$1.protocol + '//' + $location$1.host);
}; // Node.js 0.9+ & IE10+ has setImmediate, otherwise:


if (!set$1$1 || !clear$1) {
  set$1$1 = function setImmediate(handler) {
    validateArgumentsLength$1(arguments.length, 1);
    var fn = isCallable$1(handler) ? handler : Function$1$1(handler);
    var args = arraySlice$2(arguments, 1);

    queue$2[++counter$1] = function () {
      functionApply$1(fn, undefined, args);
    };

    defer$1(counter$1);
    return counter$1;
  };

  clear$1 = function clearImmediate(id) {
    delete queue$2[id];
  }; // Node.js 0.8-


  if (engineIsNode$1) {
    defer$1 = function defer(id) {
      process$1$1.nextTick(runner$1(id));
    }; // Sphere (JS game engine) Dispatch API

  } else if (Dispatch$1 && Dispatch$1.now) {
    defer$1 = function defer(id) {
      Dispatch$1.now(runner$1(id));
    }; // Browsers with MessageChannel, includes WebWorkers
    // except iOS - https://github.com/zloirock/core-js/issues/624

  } else if (MessageChannel$2 && !engineIsIos$1) {
    channel$1 = new MessageChannel$2();
    port$1 = channel$1.port2;
    channel$1.port1.onmessage = listener$1;
    defer$1 = functionBindContext$1(port$1.postMessage, port$1); // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global_1$1.addEventListener && isCallable$1(global_1$1.postMessage) && !global_1$1.importScripts && $location$1 && $location$1.protocol !== 'file:' && !fails$1(post$1)) {
    defer$1 = post$1;
    global_1$1.addEventListener('message', listener$1, false); // IE8-
  } else if (ONREADYSTATECHANGE$1 in documentCreateElement$1('script')) {
    defer$1 = function defer(id) {
      html$1.appendChild(documentCreateElement$1('script'))[ONREADYSTATECHANGE$1] = function () {
        html$1.removeChild(this);
        run$1(id);
      };
    }; // Rest old browsers

  } else {
    defer$1 = function defer(id) {
      setTimeout(runner$1(id), 0);
    };
  }
}

var task$2 = {
  set: set$1$1,
  clear: clear$1
};
var engineIsIosPebble$1 = /ipad|iphone|ipod/i.test(engineUserAgent$1) && global_1$1.Pebble !== undefined;
var engineIsWebosWebkit$1 = /web0s(?!.*chrome)/i.test(engineUserAgent$1);
var getOwnPropertyDescriptor$2$1 = objectGetOwnPropertyDescriptor$1.f;
var macrotask$1 = task$2.set;
var MutationObserver$1 = global_1$1.MutationObserver || global_1$1.WebKitMutationObserver;
var document$2$1 = global_1$1.document;
var process$2$1 = global_1$1.process;
var Promise$1$1 = global_1$1.Promise; // Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`

var queueMicrotaskDescriptor$1 = getOwnPropertyDescriptor$2$1(global_1$1, 'queueMicrotask');
var queueMicrotask$1 = queueMicrotaskDescriptor$1 && queueMicrotaskDescriptor$1.value;
var flush$1, head$1, last$1, notify$2, toggle$1, node$1, promise$1, then$1; // modern engines have queueMicrotask method

if (!queueMicrotask$1) {
  flush$1 = function flush() {
    var parent, fn;
    if (engineIsNode$1 && (parent = process$2$1.domain)) parent.exit();

    while (head$1) {
      fn = head$1.fn;
      head$1 = head$1.next;

      try {
        fn();
      } catch (error) {
        if (head$1) notify$2();else last$1 = undefined;
        throw error;
      }
    }

    last$1 = undefined;
    if (parent) parent.enter();
  }; // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898


  if (!engineIsIos$1 && !engineIsNode$1 && !engineIsWebosWebkit$1 && MutationObserver$1 && document$2$1) {
    toggle$1 = true;
    node$1 = document$2$1.createTextNode('');
    new MutationObserver$1(flush$1).observe(node$1, {
      characterData: true
    });

    notify$2 = function notify() {
      node$1.data = toggle$1 = !toggle$1;
    }; // environments with maybe non-completely correct, but existent Promise

  } else if (!engineIsIosPebble$1 && Promise$1$1 && Promise$1$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise$1 = Promise$1$1.resolve(undefined); // workaround of WebKit ~ iOS Safari 10.1 bug

    promise$1.constructor = Promise$1$1;
    then$1 = functionBindContext$1(promise$1.then, promise$1);

    notify$2 = function notify() {
      then$1(flush$1);
    }; // Node.js without promises

  } else if (engineIsNode$1) {
    notify$2 = function notify() {
      process$2$1.nextTick(flush$1);
    }; // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessage
    // - onreadystatechange
    // - setTimeout

  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask$1 = functionBindContext$1(macrotask$1, global_1$1);

    notify$2 = function notify() {
      macrotask$1(flush$1);
    };
  }
}

var microtask$1 = queueMicrotask$1 || function (fn) {
  var task = {
    fn: fn,
    next: undefined
  };
  if (last$1) last$1.next = task;

  if (!head$1) {
    head$1 = task;
    notify$2();
  }

  last$1 = task;
};

var hostReportErrors$1 = function hostReportErrors(a, b) {
  var console = global_1$1.console;

  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};

var perform$1 = function perform(exec) {
  try {
    return {
      error: false,
      value: exec()
    };
  } catch (error) {
    return {
      error: true,
      value: error
    };
  }
};

var Queue$1 = function Queue() {
  this.head = null;
  this.tail = null;
};

Queue$1.prototype = {
  add: function add(item) {
    var entry = {
      item: item,
      next: null
    };
    if (this.head) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
  },
  get: function get() {
    var entry = this.head;

    if (entry) {
      this.head = entry.next;
      if (this.tail === entry) this.tail = null;
      return entry.item;
    }
  }
};
var queue$1$1 = Queue$1;
var promiseNativeConstructor$1 = global_1$1.Promise;
/* global Deno -- Deno case */

var engineIsDeno$1 = (typeof Deno === "undefined" ? "undefined" : _typeof$1(Deno)) == 'object' && Deno && _typeof$1(Deno.version) == 'object';
var engineIsBrowser$1 = !engineIsDeno$1 && !engineIsNode$1 && (typeof window === "undefined" ? "undefined" : _typeof$1(window)) == 'object' && (typeof document === "undefined" ? "undefined" : _typeof$1(document)) == 'object';
var NativePromisePrototype$3 = promiseNativeConstructor$1 && promiseNativeConstructor$1.prototype;
var SPECIES$5$1 = wellKnownSymbol$1('species');
var SUBCLASSING$1 = false;
var NATIVE_PROMISE_REJECTION_EVENT$2 = isCallable$1(global_1$1.PromiseRejectionEvent);
var FORCED_PROMISE_CONSTRUCTOR$6 = isForced_1$1('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource$1(promiseNativeConstructor$1);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(promiseNativeConstructor$1); // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions

  if (!GLOBAL_CORE_JS_PROMISE && engineV8Version$1 === 66) return true; // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679

  if (!engineV8Version$1 || engineV8Version$1 < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new promiseNativeConstructor$1(function (resolve) {
      resolve(1);
    });

    var FakePromise = function FakePromise(exec) {
      exec(function () {
        /* empty */
      }, function () {
        /* empty */
      });
    };

    var constructor = promise.constructor = {};
    constructor[SPECIES$5$1] = FakePromise;
    SUBCLASSING$1 = promise.then(function () {
      /* empty */
    }) instanceof FakePromise;
    if (!SUBCLASSING$1) return true; // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  }

  return !GLOBAL_CORE_JS_PROMISE && (engineIsBrowser$1 || engineIsDeno$1) && !NATIVE_PROMISE_REJECTION_EVENT$2;
});
var promiseConstructorDetection$1 = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$6,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$2,
  SUBCLASSING: SUBCLASSING$1
};
var $TypeError$c$1 = TypeError;

var PromiseCapability$1 = function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw $TypeError$c$1('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$1(resolve);
  this.reject = aCallable$1(reject);
}; // `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability


var f$8$1 = function f$8(C) {
  return new PromiseCapability$1(C);
};

var newPromiseCapability$2 = {
  f: f$8$1
};
var task$1$1 = task$2.set;
var PROMISE$1 = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$1$1 = promiseConstructorDetection$1.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT$1$1 = promiseConstructorDetection$1.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING$1 = promiseConstructorDetection$1.SUBCLASSING;
var getInternalPromiseState$1 = internalState$1.getterFor(PROMISE$1);
var setInternalState$2$1 = internalState$1.set;
var NativePromisePrototype$1$1 = promiseNativeConstructor$1 && promiseNativeConstructor$1.prototype;
var PromiseConstructor$1 = promiseNativeConstructor$1;
var PromisePrototype$1 = NativePromisePrototype$1$1;
var TypeError$3$1 = global_1$1.TypeError;
var document$3$1 = global_1$1.document;
var process$3$1 = global_1$1.process;
var newPromiseCapability$1$1 = newPromiseCapability$2.f;
var newGenericPromiseCapability$1 = newPromiseCapability$1$1;
var DISPATCH_EVENT$1 = !!(document$3$1 && document$3$1.createEvent && global_1$1.dispatchEvent);
var UNHANDLED_REJECTION$1 = 'unhandledrejection';
var REJECTION_HANDLED$1 = 'rejectionhandled';
var PENDING$1 = 0;
var FULFILLED$1 = 1;
var REJECTED$1 = 2;
var HANDLED$1 = 1;
var UNHANDLED$1 = 2;
var Internal$1, OwnPromiseCapability$1, PromiseWrapper$1, nativeThen$1; // helpers

var isThenable$1 = function isThenable(it) {
  var then;
  return isObject$1(it) && isCallable$1(then = it.then) ? then : false;
};

var callReaction$1 = function callReaction(reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED$1;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;

  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED$1) onHandleUnhandled$1(state);
        state.rejection = HANDLED$1;
      }

      if (handler === true) result = value;else {
        if (domain) domain.enter();
        result = handler(value); // can throw

        if (domain) {
          domain.exit();
          exited = true;
        }
      }

      if (result === reaction.promise) {
        reject(TypeError$3$1('Promise-chain cycle'));
      } else if (then = isThenable$1(result)) {
        functionCall$1(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify$1$1 = function notify$1(state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask$1(function () {
    var reactions = state.reactions;
    var reaction;

    while (reaction = reactions.get()) {
      callReaction$1(reaction, state);
    }

    state.notified = false;
    if (isReject && !state.rejection) onUnhandled$1(state);
  });
};

var dispatchEvent$1 = function dispatchEvent(name, promise, reason) {
  var event, handler;

  if (DISPATCH_EVENT$1) {
    event = document$3$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global_1$1.dispatchEvent(event);
  } else event = {
    promise: promise,
    reason: reason
  };

  if (!NATIVE_PROMISE_REJECTION_EVENT$1$1 && (handler = global_1$1['on' + name])) handler(event);else if (name === UNHANDLED_REJECTION$1) hostReportErrors$1('Unhandled promise rejection', reason);
};

var onUnhandled$1 = function onUnhandled(state) {
  functionCall$1(task$1$1, global_1$1, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled$1(state);
    var result;

    if (IS_UNHANDLED) {
      result = perform$1(function () {
        if (engineIsNode$1) {
          process$3$1.emit('unhandledRejection', value, promise);
        } else dispatchEvent$1(UNHANDLED_REJECTION$1, promise, value);
      }); // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should

      state.rejection = engineIsNode$1 || isUnhandled$1(state) ? UNHANDLED$1 : HANDLED$1;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled$1 = function isUnhandled(state) {
  return state.rejection !== HANDLED$1 && !state.parent;
};

var onHandleUnhandled$1 = function onHandleUnhandled(state) {
  functionCall$1(task$1$1, global_1$1, function () {
    var promise = state.facade;

    if (engineIsNode$1) {
      process$3$1.emit('rejectionHandled', promise);
    } else dispatchEvent$1(REJECTION_HANDLED$1, promise, state.value);
  });
};

var bind$1$1 = function bind$1(fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject$1 = function internalReject(state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED$1;
  notify$1$1(state, true);
};

var internalResolve$1 = function internalResolve(state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;

  try {
    if (state.facade === value) throw TypeError$3$1("Promise can't be resolved itself");
    var then = isThenable$1(value);

    if (then) {
      microtask$1(function () {
        var wrapper = {
          done: false
        };

        try {
          functionCall$1(then, value, bind$1$1(internalResolve, wrapper, state), bind$1$1(internalReject$1, wrapper, state));
        } catch (error) {
          internalReject$1(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED$1;
      notify$1$1(state, false);
    }
  } catch (error) {
    internalReject$1({
      done: false
    }, error, state);
  }
}; // constructor polyfill


if (FORCED_PROMISE_CONSTRUCTOR$1$1) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor$1 = function Promise(executor) {
    anInstance$1(this, PromisePrototype$1);
    aCallable$1(executor);
    functionCall$1(Internal$1, this);
    var state = getInternalPromiseState$1(this);

    try {
      executor(bind$1$1(internalResolve$1, state), bind$1$1(internalReject$1, state));
    } catch (error) {
      internalReject$1(state, error);
    }
  };

  PromisePrototype$1 = PromiseConstructor$1.prototype; // eslint-disable-next-line no-unused-vars -- required for `.length`

  Internal$1 = function Promise(executor) {
    setInternalState$2$1(this, {
      type: PROMISE$1,
      done: false,
      notified: false,
      parent: false,
      reactions: new queue$1$1(),
      rejection: false,
      state: PENDING$1,
      value: undefined
    });
  }; // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then


  Internal$1.prototype = defineBuiltIn$1(PromisePrototype$1, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState$1(this);
    var reaction = newPromiseCapability$1$1(speciesConstructor$1(this, PromiseConstructor$1));
    state.parent = true;
    reaction.ok = isCallable$1(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable$1(onRejected) && onRejected;
    reaction.domain = engineIsNode$1 ? process$3$1.domain : undefined;
    if (state.state == PENDING$1) state.reactions.add(reaction);else microtask$1(function () {
      callReaction$1(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability$1 = function OwnPromiseCapability() {
    var promise = new Internal$1();
    var state = getInternalPromiseState$1(promise);
    this.promise = promise;
    this.resolve = bind$1$1(internalResolve$1, state);
    this.reject = bind$1$1(internalReject$1, state);
  };

  newPromiseCapability$2.f = newPromiseCapability$1$1 = function newPromiseCapability$1(C) {
    return C === PromiseConstructor$1 || C === PromiseWrapper$1 ? new OwnPromiseCapability$1(C) : newGenericPromiseCapability$1(C);
  };

  if (isCallable$1(promiseNativeConstructor$1) && NativePromisePrototype$1$1 !== Object.prototype) {
    nativeThen$1 = NativePromisePrototype$1$1.then;

    if (!NATIVE_PROMISE_SUBCLASSING$1) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn$1(NativePromisePrototype$1$1, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor$1(function (resolve, reject) {
          functionCall$1(nativeThen$1, that, resolve, reject);
        }).then(onFulfilled, onRejected); // https://github.com/zloirock/core-js/issues/640
      }, {
        unsafe: true
      });
    } // make `.constructor === Promise` work for native promise-based APIs


    try {
      delete NativePromisePrototype$1$1.constructor;
    } catch (error) {}
    /* empty */
    // make `instanceof Promise` work for native promise-based APIs


    if (objectSetPrototypeOf$1) {
      objectSetPrototypeOf$1(NativePromisePrototype$1$1, PromisePrototype$1);
    }
  }
}

_export$1({
  global: true,
  constructor: true,
  wrap: true,
  forced: FORCED_PROMISE_CONSTRUCTOR$1$1
}, {
  Promise: PromiseConstructor$1
});

setToStringTag$1(PromiseConstructor$1, PROMISE$1, false);
setSpecies$1(PROMISE$1);
var $TypeError$d$1 = TypeError;

var Result$1 = function Result(stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype$1 = Result$1.prototype;

var iterate$1 = function iterate(iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = functionBindContext$1(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function stop(condition) {
    if (iterator) iteratorClose$1(iterator, 'normal', condition);
    return new Result$1(true, condition);
  };

  var callFn = function callFn(value) {
    if (AS_ENTRIES) {
      anObject$1(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    }

    return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod$1(iterable);
    if (!iterFn) throw $TypeError$d$1(tryToString$1(iterable) + ' is not iterable'); // optimisation for array iterators

    if (isArrayIteratorMethod$1(iterFn)) {
      for (index = 0, length = lengthOfArrayLike$1(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && objectIsPrototypeOf$1(ResultPrototype$1, result)) return result;
      }

      return new Result$1(false);
    }

    iterator = getIterator$1(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;

  while (!(step = functionCall$1(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose$1(iterator, 'throw', error);
    }

    if (_typeof$1(result) == 'object' && result && objectIsPrototypeOf$1(ResultPrototype$1, result)) return result;
  }

  return new Result$1(false);
};

var FORCED_PROMISE_CONSTRUCTOR$2$1 = promiseConstructorDetection$1.CONSTRUCTOR;
var promiseStaticsIncorrectIteration$1 = FORCED_PROMISE_CONSTRUCTOR$2$1 || !checkCorrectnessOfIteration$1(function (iterable) {
  promiseNativeConstructor$1.all(iterable).then(undefined, function () {
    /* empty */
  });
}); // https://tc39.es/ecma262/#sec-promise.all

_export$1({
  target: 'Promise',
  stat: true,
  forced: promiseStaticsIncorrectIteration$1
}, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability$2.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aCallable$1(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$1(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        functionCall$1($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var FORCED_PROMISE_CONSTRUCTOR$3$1 = promiseConstructorDetection$1.CONSTRUCTOR;
var NativePromisePrototype$2$1 = promiseNativeConstructor$1 && promiseNativeConstructor$1.prototype; // `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch

_export$1({
  target: 'Promise',
  proto: true,
  forced: FORCED_PROMISE_CONSTRUCTOR$3$1,
  real: true
}, {
  'catch': function _catch(onRejected) {
    return this.then(undefined, onRejected);
  }
}); // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`


if (isCallable$1(promiseNativeConstructor$1)) {
  var method$1 = getBuiltIn$1('Promise').prototype['catch'];

  if (NativePromisePrototype$2$1['catch'] !== method$1) {
    defineBuiltIn$1(NativePromisePrototype$2$1, 'catch', method$1, {
      unsafe: true
    });
  }
} // https://tc39.es/ecma262/#sec-promise.race


_export$1({
  target: 'Promise',
  stat: true,
  forced: promiseStaticsIncorrectIteration$1
}, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability$2.f(C);
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aCallable$1(C.resolve);
      iterate$1(iterable, function (promise) {
        functionCall$1($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var FORCED_PROMISE_CONSTRUCTOR$4$1 = promiseConstructorDetection$1.CONSTRUCTOR; // `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject

_export$1({
  target: 'Promise',
  stat: true,
  forced: FORCED_PROMISE_CONSTRUCTOR$4$1
}, {
  reject: function reject(r) {
    var capability = newPromiseCapability$2.f(this);
    functionCall$1(capability.reject, undefined, r);
    return capability.promise;
  }
});

var promiseResolve$1 = function promiseResolve(C, x) {
  anObject$1(C);
  if (isObject$1(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability$2.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var FORCED_PROMISE_CONSTRUCTOR$5$1 = promiseConstructorDetection$1.CONSTRUCTOR;
var PromiseConstructorWrapper$1 = getBuiltIn$1('Promise'); // https://tc39.es/ecma262/#sec-promise.resolve

_export$1({
  target: 'Promise',
  stat: true,
  forced: FORCED_PROMISE_CONSTRUCTOR$5$1
}, {
  resolve: function resolve(x) {
    return promiseResolve$1(this, x);
  }
});

var OPTIONAL_ARGUMENTS_LIST$1 = !fails$1(function () {
  // eslint-disable-next-line es/no-reflect -- required for testing
  Reflect.apply(function () {
    /* empty */
  });
}); // `Reflect.apply` method
// https://tc39.es/ecma262/#sec-reflect.apply

_export$1({
  target: 'Reflect',
  stat: true,
  forced: OPTIONAL_ARGUMENTS_LIST$1
}, {
  apply: function apply(target, thisArgument, argumentsList) {
    return functionApply$1(aCallable$1(target), thisArgument, anObject$1(argumentsList));
  }
}); // https://tc39.es/ecma262/#sec-get-regexp.prototype.flags


var regexpFlags$1 = function regexpFlags() {
  var that = anObject$1(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var $RegExp$3 = global_1$1.RegExp;
var UNSUPPORTED_Y$4 = fails$1(function () {
  var re = $RegExp$3('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
}); // UC Browser bug
// https://github.com/zloirock/core-js/issues/1008

var MISSED_STICKY$2 = UNSUPPORTED_Y$4 || fails$1(function () {
  return !$RegExp$3('a', 'y').sticky;
});
var BROKEN_CARET$1 = UNSUPPORTED_Y$4 || fails$1(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$3('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});
var regexpStickyHelpers$1 = {
  BROKEN_CARET: BROKEN_CARET$1,
  MISSED_STICKY: MISSED_STICKY$2,
  UNSUPPORTED_Y: UNSUPPORTED_Y$4
};
var $RegExp$1$1 = global_1$1.RegExp;
var regexpUnsupportedDotAll$1 = fails$1(function () {
  var re = $RegExp$1$1('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});
var $RegExp$2$1 = global_1$1.RegExp;
var regexpUnsupportedNcg$1 = fails$1(function () {
  var re = $RegExp$2$1('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' || 'b'.replace(re, '$<a>c') !== 'bc';
});
/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */

/* eslint-disable regexp/no-useless-quantifier -- testing */

var getInternalState$2$1 = internalState$1.get;
var nativeReplace$1 = shared$1('native-string-replace', String.prototype.replace);
var nativeExec$1 = RegExp.prototype.exec;
var patchedExec$1 = nativeExec$1;
var charAt$1$1 = functionUncurryThis$1(''.charAt);
var indexOf$1$1 = functionUncurryThis$1(''.indexOf);
var replace$2$1 = functionUncurryThis$1(''.replace);
var stringSlice$2$1 = functionUncurryThis$1(''.slice);

var UPDATES_LAST_INDEX_WRONG$1 = function () {
  var re1 = /a/;
  var re2 = /b*/g;
  functionCall$1(nativeExec$1, re1, 'a');
  functionCall$1(nativeExec$1, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();

var UNSUPPORTED_Y$1$1 = regexpStickyHelpers$1.BROKEN_CARET; // nonparticipating capturing group, copied from es5-shim's String#split patch.

var NPCG_INCLUDED$1 = /()??/.exec('')[1] !== undefined;
var PATCH$1 = UPDATES_LAST_INDEX_WRONG$1 || NPCG_INCLUDED$1 || UNSUPPORTED_Y$1$1 || regexpUnsupportedDotAll$1 || regexpUnsupportedNcg$1;

if (PATCH$1) {
  patchedExec$1 = function exec(string) {
    var re = this;
    var state = getInternalState$2$1(re);
    var str = toString_1$1(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = functionCall$1(patchedExec$1, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y$1$1 && re.sticky;
    var flags = functionCall$1(regexpFlags$1, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$2$1(flags, 'y', '');

      if (indexOf$1$1(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$2$1(str, re.lastIndex); // Support anchored sticky behavior.

      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$1$1(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      } // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.


      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED$1) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }

    if (UPDATES_LAST_INDEX_WRONG$1) lastIndex = re.lastIndex;
    match = functionCall$1(nativeExec$1, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$2$1(match.input, charsAdded);
        match[0] = stringSlice$2$1(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG$1 && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }

    if (NPCG_INCLUDED$1 && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      functionCall$1(nativeReplace$1, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = objectCreate$1(null);

      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$1 = patchedExec$1; // https://tc39.es/ecma262/#sec-regexp.prototype.exec

_export$1({
  target: 'RegExp',
  proto: true,
  forced: /./.exec !== regexpExec$1
}, {
  exec: regexpExec$1
});

var RegExpPrototype$5 = RegExp.prototype;

var regexpGetFlags$1 = function regexpGetFlags(R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$5) && !hasOwnProperty_1$1(R, 'flags') && objectIsPrototypeOf$1(RegExpPrototype$5, R) ? functionCall$1(regexpFlags$1, R) : flags;
};

var PROPER_FUNCTION_NAME$1$1 = functionName$1.PROPER;
var TO_STRING$1 = 'toString';
var RegExpPrototype$1$1 = RegExp.prototype;
var nativeToString$1 = RegExpPrototype$1$1[TO_STRING$1];
var NOT_GENERIC$1 = fails$1(function () {
  return nativeToString$1.call({
    source: 'a',
    flags: 'b'
  }) != '/a/b';
}); // FF44- RegExp#toString has a wrong name

var INCORRECT_NAME$1 = PROPER_FUNCTION_NAME$1$1 && nativeToString$1.name != TO_STRING$1; // `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring

if (NOT_GENERIC$1 || INCORRECT_NAME$1) {
  defineBuiltIn$1(RegExp.prototype, TO_STRING$1, function toString() {
    var R = anObject$1(this);
    var pattern = toString_1$1(R.source);
    var flags = toString_1$1(regexpGetFlags$1(R));
    return '/' + pattern + '/' + flags;
  }, {
    unsafe: true
  });
}

var charAt$2$1 = functionUncurryThis$1(''.charAt);
var charCodeAt$1$1 = functionUncurryThis$1(''.charCodeAt);
var stringSlice$3$1 = functionUncurryThis$1(''.slice);

var createMethod$2$1 = function createMethod$2(CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString_1$1(requireObjectCoercible$1($this));
    var position = toIntegerOrInfinity$1(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt$1$1(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = charCodeAt$1$1(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? charAt$2$1(S, position) : first : CONVERT_TO_STRING ? stringSlice$3$1(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte$1 = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$2$1(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$2$1(true)
};
var charAt$3$1 = stringMultibyte$1.charAt;
var STRING_ITERATOR$1 = 'String Iterator';
var setInternalState$3$1 = internalState$1.set;
var getInternalState$3$1 = internalState$1.getterFor(STRING_ITERATOR$1); // `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator

iteratorDefine$1(String, 'String', function (iterated) {
  setInternalState$3$1(this, {
    type: STRING_ITERATOR$1,
    string: toString_1$1(iterated),
    index: 0
  }); // `%StringIteratorPrototype%.next` method
  // https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState$3$1(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject$1(undefined, true);
  point = charAt$3$1(string, index);
  state.index += point.length;
  return createIterResultObject$1(point, false);
});
var SPECIES$6$1 = wellKnownSymbol$1('species');
var RegExpPrototype$2$1 = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic$1 = function fixRegexpWellKnownSymbolLogic(KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$1(KEY);
  var DELEGATES_TO_SYMBOL = !fails$1(function () {
    // String methods call symbol-named RegEp methods
    var O = {};

    O[SYMBOL] = function () {
      return 7;
    };

    return ''[KEY](O) != 7;
  });
  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$1(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {}; // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.

      re.constructor = {};

      re.constructor[SPECIES$6$1] = function () {
        return re;
      };

      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
    var uncurriedNativeRegExpMethod = functionUncurryThis$1(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = functionUncurryThis$1(nativeMethod);
      var $exec = regexp.exec;

      if ($exec === regexpExec$1 || $exec === RegExpPrototype$2$1.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return {
            done: true,
            value: uncurriedNativeRegExpMethod(regexp, str, arg2)
          };
        }

        return {
          done: true,
          value: uncurriedNativeMethod(str, regexp, arg2)
        };
      }

      return {
        done: false
      };
    });
    defineBuiltIn$1(String.prototype, KEY, methods[0]);
    defineBuiltIn$1(RegExpPrototype$2$1, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty$1(RegExpPrototype$2$1[SYMBOL], 'sham', true);
};

var charAt$4$1 = stringMultibyte$1.charAt; // `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex

var advanceStringIndex$1 = function advanceStringIndex(S, index, unicode) {
  return index + (unicode ? charAt$4$1(S, index).length : 1);
};

var $TypeError$e$1 = TypeError; // `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec

var regexpExecAbstract$1 = function regexpExecAbstract(R, S) {
  var exec = R.exec;

  if (isCallable$1(exec)) {
    var result = functionCall$1(exec, R, S);
    if (result !== null) anObject$1(result);
    return result;
  }

  if (classofRaw$1(R) === 'RegExp') return functionCall$1(regexpExec$1, R, S);
  throw $TypeError$e$1('RegExp#exec called on incompatible receiver');
};

fixRegexpWellKnownSymbolLogic$1('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [// `String.prototype.match` method
  // https://tc39.es/ecma262/#sec-string.prototype.match
  function match(regexp) {
    var O = requireObjectCoercible$1(this);
    var matcher = isNullOrUndefined$1(regexp) ? undefined : getMethod$1(regexp, MATCH);
    return matcher ? functionCall$1(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString_1$1(O));
  }, // `RegExp.prototype[@@match]` method
  // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
  function (string) {
    var rx = anObject$1(this);
    var S = toString_1$1(string);
    var res = maybeCallNative(nativeMatch, rx, S);
    if (res.done) return res.value;
    if (!rx.global) return regexpExecAbstract$1(rx, S);
    var fullUnicode = rx.unicode;
    rx.lastIndex = 0;
    var A = [];
    var n = 0;
    var result;

    while ((result = regexpExecAbstract$1(rx, S)) !== null) {
      var matchStr = toString_1$1(result[0]);
      A[n] = matchStr;
      if (matchStr === '') rx.lastIndex = advanceStringIndex$1(S, toLength$1(rx.lastIndex), fullUnicode);
      n++;
    }

    return n === 0 ? null : A;
  }];
});
var floor$1$1 = Math.floor;
var charAt$5$1 = functionUncurryThis$1(''.charAt);
var replace$3$1 = functionUncurryThis$1(''.replace);
var stringSlice$4$1 = functionUncurryThis$1(''.slice);
var SUBSTITUTION_SYMBOLS$1 = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED$1 = /\$([$&'`]|\d{1,2})/g; // `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution

var getSubstitution$1 = function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED$1;

  if (namedCaptures !== undefined) {
    namedCaptures = toObject$1(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS$1;
  }

  return replace$3$1(replacement, symbols, function (match, ch) {
    var capture;

    switch (charAt$5$1(ch, 0)) {
      case '$':
        return '$';

      case '&':
        return matched;

      case '`':
        return stringSlice$4$1(str, 0, position);

      case "'":
        return stringSlice$4$1(str, tailPos);

      case '<':
        capture = namedCaptures[stringSlice$4$1(ch, 1, -1)];
        break;

      default:
        // \d\d?
        var n = +ch;
        if (n === 0) return match;

        if (n > m) {
          var f = floor$1$1(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt$5$1(ch, 1) : captures[f - 1] + charAt$5$1(ch, 1);
          return match;
        }

        capture = captures[n - 1];
    }

    return capture === undefined ? '' : capture;
  });
};

var REPLACE$1 = wellKnownSymbol$1('replace');
var max$3$1 = Math.max;
var min$2$1 = Math.min;
var concat$1$1 = functionUncurryThis$1([].concat);
var push$3$1 = functionUncurryThis$1([].push);
var stringIndexOf$3 = functionUncurryThis$1(''.indexOf);
var stringSlice$5$1 = functionUncurryThis$1(''.slice);

var maybeToString$1 = function maybeToString(it) {
  return it === undefined ? it : String(it);
}; // IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0


var REPLACE_KEEPS_$0$1 = function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
}(); // Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string


var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE$1 = function () {
  if (/./[REPLACE$1]) {
    return /./[REPLACE$1]('a', '$0') === '';
  }

  return false;
}();

var REPLACE_SUPPORTS_NAMED_GROUPS$1 = !fails$1(function () {
  var re = /./;

  re.exec = function () {
    var result = [];
    result.groups = {
      a: '7'
    };
    return result;
  }; // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive


  return ''.replace(re, '$<a>') !== '7';
}); // @@replace logic

fixRegexpWellKnownSymbolLogic$1('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE$1 ? '$' : '$0';
  return [// `String.prototype.replace` method
  // https://tc39.es/ecma262/#sec-string.prototype.replace
  function replace(searchValue, replaceValue) {
    var O = requireObjectCoercible$1(this);
    var replacer = isNullOrUndefined$1(searchValue) ? undefined : getMethod$1(searchValue, REPLACE$1);
    return replacer ? functionCall$1(replacer, searchValue, O, replaceValue) : functionCall$1(nativeReplace, toString_1$1(O), searchValue, replaceValue);
  }, // `RegExp.prototype[@@replace]` method
  // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
  function (string, replaceValue) {
    var rx = anObject$1(this);
    var S = toString_1$1(string);

    if (typeof replaceValue == 'string' && stringIndexOf$3(replaceValue, UNSAFE_SUBSTITUTE) === -1 && stringIndexOf$3(replaceValue, '$<') === -1) {
      var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
      if (res.done) return res.value;
    }

    var functionalReplace = isCallable$1(replaceValue);
    if (!functionalReplace) replaceValue = toString_1$1(replaceValue);
    var global = rx.global;

    if (global) {
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
    }

    var results = [];

    while (true) {
      var result = regexpExecAbstract$1(rx, S);
      if (result === null) break;
      push$3$1(results, result);
      if (!global) break;
      var matchStr = toString_1$1(result[0]);
      if (matchStr === '') rx.lastIndex = advanceStringIndex$1(S, toLength$1(rx.lastIndex), fullUnicode);
    }

    var accumulatedResult = '';
    var nextSourcePosition = 0;

    for (var i = 0; i < results.length; i++) {
      result = results[i];
      var matched = toString_1$1(result[0]);
      var position = max$3$1(min$2$1(toIntegerOrInfinity$1(result.index), S.length), 0);
      var captures = []; // NOTE: This is equivalent to
      //   captures = result.slice(1).map(maybeToString)
      // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
      // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
      // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.

      for (var j = 1; j < result.length; j++) {
        push$3$1(captures, maybeToString$1(result[j]));
      }

      var namedCaptures = result.groups;

      if (functionalReplace) {
        var replacerArgs = concat$1$1([matched], captures, position, S);
        if (namedCaptures !== undefined) push$3$1(replacerArgs, namedCaptures);
        var replacement = toString_1$1(functionApply$1(replaceValue, undefined, replacerArgs));
      } else {
        replacement = getSubstitution$1(matched, S, position, captures, namedCaptures, replaceValue);
      }

      if (position >= nextSourcePosition) {
        accumulatedResult += stringSlice$5$1(S, nextSourcePosition, position) + replacement;
        nextSourcePosition = position + matched.length;
      }
    }

    return accumulatedResult + stringSlice$5$1(S, nextSourcePosition);
  }];
}, !REPLACE_SUPPORTS_NAMED_GROUPS$1 || !REPLACE_KEEPS_$0$1 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE$1);
var MATCH$3 = wellKnownSymbol$1('match'); // `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp

var isRegexp$1 = function isRegexp(it) {
  var isRegExp;
  return isObject$1(it) && ((isRegExp = it[MATCH$3]) !== undefined ? !!isRegExp : classofRaw$1(it) == 'RegExp');
};

var UNSUPPORTED_Y$2$1 = regexpStickyHelpers$1.UNSUPPORTED_Y;
var MAX_UINT32$1 = 0xFFFFFFFF;
var min$3$1 = Math.min;
var $push$1 = [].push;
var exec$2$1 = functionUncurryThis$1(/./.exec);
var push$4$1 = functionUncurryThis$1($push$1);
var stringSlice$6$1 = functionUncurryThis$1(''.slice); // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC$1 = !fails$1(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;

  re.exec = function () {
    return originalExec.apply(this, arguments);
  };

  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
}); // @@split logic

fixRegexpWellKnownSymbolLogic$1('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;

  if ('abbc'.split(/(b)*/)[1] == 'c' || // eslint-disable-next-line regexp/no-empty-group -- required for testing
  'test'.split(/(?:)/, -1).length != 4 || 'ab'.split(/(?:ab)*/).length != 2 || '.'.split(/(.?)(.?)/).length != 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
  '.'.split(/()()/).length > 1 || ''.split(/.?/).length) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function internalSplit(separator, limit) {
      var string = toString_1$1(requireObjectCoercible$1(this));
      var lim = limit === undefined ? MAX_UINT32$1 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string]; // If `separator` is not a regex, use native split

      if (!isRegexp$1(separator)) {
        return functionCall$1(nativeSplit, string, separator, lim);
      }

      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
      var lastLastIndex = 0; // Make `global` and avoid `lastIndex` issues by working with a copy

      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;

      while (match = functionCall$1(regexpExec$1, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;

        if (lastIndex > lastLastIndex) {
          push$4$1(output, stringSlice$6$1(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) functionApply$1($push$1, output, arraySliceSimple$1(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }

        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }

      if (lastLastIndex === string.length) {
        if (lastLength || !exec$2$1(separatorCopy, '')) push$4$1(output, '');
      } else push$4$1(output, stringSlice$6$1(string, lastLastIndex));

      return output.length > lim ? arraySliceSimple$1(output, 0, lim) : output;
    }; // Chakra, V8

  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function internalSplit(separator, limit) {
      return separator === undefined && limit === 0 ? [] : functionCall$1(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [// `String.prototype.split` method
  // https://tc39.es/ecma262/#sec-string.prototype.split
  function split(separator, limit) {
    var O = requireObjectCoercible$1(this);
    var splitter = isNullOrUndefined$1(separator) ? undefined : getMethod$1(separator, SPLIT);
    return splitter ? functionCall$1(splitter, separator, O, limit) : functionCall$1(internalSplit, toString_1$1(O), separator, limit);
  }, // `RegExp.prototype[@@split]` method
  // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
  //
  // NOTE: This cannot be properly polyfilled in engines that don't support
  // the 'y' flag.
  function (string, limit) {
    var rx = anObject$1(this);
    var S = toString_1$1(string);
    var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
    if (res.done) return res.value;
    var C = speciesConstructor$1(rx, RegExp);
    var unicodeMatching = rx.unicode;
    var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + (UNSUPPORTED_Y$2$1 ? 'g' : 'y'); // ^(? + rx + ) is needed, in combination with some S slicing, to
    // simulate the 'y' flag.

    var splitter = new C(UNSUPPORTED_Y$2$1 ? '^(?:' + rx.source + ')' : rx, flags);
    var lim = limit === undefined ? MAX_UINT32$1 : limit >>> 0;
    if (lim === 0) return [];
    if (S.length === 0) return regexpExecAbstract$1(splitter, S) === null ? [S] : [];
    var p = 0;
    var q = 0;
    var A = [];

    while (q < S.length) {
      splitter.lastIndex = UNSUPPORTED_Y$2$1 ? 0 : q;
      var z = regexpExecAbstract$1(splitter, UNSUPPORTED_Y$2$1 ? stringSlice$6$1(S, q) : S);
      var e;

      if (z === null || (e = min$3$1(toLength$1(splitter.lastIndex + (UNSUPPORTED_Y$2$1 ? q : 0)), S.length)) === p) {
        q = advanceStringIndex$1(S, q, unicodeMatching);
      } else {
        push$4$1(A, stringSlice$6$1(S, p, q));
        if (A.length === lim) return A;

        for (var i = 1; i <= z.length - 1; i++) {
          push$4$1(A, z[i]);
          if (A.length === lim) return A;
        }

        q = p = e;
      }
    }

    push$4$1(A, stringSlice$6$1(S, p));
    return A;
  }];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC$1, UNSUPPORTED_Y$2$1); // iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods

var domIterables$1 = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};
var classList$1 = documentCreateElement$1('span').classList;
var DOMTokenListPrototype$1 = classList$1 && classList$1.constructor && classList$1.constructor.prototype;
var domTokenListPrototype$1 = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;
var ITERATOR$5$1 = wellKnownSymbol$1('iterator');
var TO_STRING_TAG$3$1 = wellKnownSymbol$1('toStringTag');
var ArrayValues$1 = es_array_iterator$1.values;

var handlePrototype$2 = function handlePrototype(CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$5$1] !== ArrayValues$1) try {
      createNonEnumerableProperty$1(CollectionPrototype, ITERATOR$5$1, ArrayValues$1);
    } catch (error) {
      CollectionPrototype[ITERATOR$5$1] = ArrayValues$1;
    }

    if (!CollectionPrototype[TO_STRING_TAG$3$1]) {
      createNonEnumerableProperty$1(CollectionPrototype, TO_STRING_TAG$3$1, COLLECTION_NAME);
    }

    if (domIterables$1[COLLECTION_NAME]) for (var METHOD_NAME in es_array_iterator$1) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== es_array_iterator$1[METHOD_NAME]) try {
        createNonEnumerableProperty$1(CollectionPrototype, METHOD_NAME, es_array_iterator$1[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = es_array_iterator$1[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME$2 in domIterables$1) {
  handlePrototype$2(global_1$1[COLLECTION_NAME$2] && global_1$1[COLLECTION_NAME$2].prototype, COLLECTION_NAME$2);
}

handlePrototype$2(domTokenListPrototype$1, 'DOMTokenList');
var commonjsGlobal$1$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule$1$1(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var check$1$1 = function check(it) {
  return it && it.Math == Math && it;
}; // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028


var global_1$1$1 = // eslint-disable-next-line es/no-global-this -- safe
check$1$1((typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) == 'object' && globalThis) || check$1$1((typeof window === "undefined" ? "undefined" : _typeof(window)) == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
check$1$1((typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self) || check$1$1(_typeof(commonjsGlobal$1$1) == 'object' && commonjsGlobal$1$1) || // eslint-disable-next-line no-new-func -- fallback
function () {
  return this;
}() || Function('return this')();

var fails$1$1 = function fails(exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var descriptors$1$1 = !fails$1$1(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, {
    get: function get() {
      return 7;
    }
  })[1] != 7;
});
var functionBindNative$1$1 = !fails$1$1(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = function () {
    /* empty */
  }.bind(); // eslint-disable-next-line no-prototype-builtins -- safe


  return typeof test != 'function' || test.hasOwnProperty('prototype');
});
var call$3$1 = Function.prototype.call;
var functionCall$1$1 = functionBindNative$1$1 ? call$3$1.bind(call$3$1) : function () {
  return call$3$1.apply(call$3$1, arguments);
};
var $propertyIsEnumerable$2$1 = {}.propertyIsEnumerable; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

var getOwnPropertyDescriptor$3$1 = Object.getOwnPropertyDescriptor; // Nashorn ~ JDK8 bug

var NASHORN_BUG$1$1 = getOwnPropertyDescriptor$3$1 && !$propertyIsEnumerable$2$1.call({
  1: 2
}, 1); // `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable

var f$9$1 = NASHORN_BUG$1$1 ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$3$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable$2$1;
var objectPropertyIsEnumerable$1$1 = {
  f: f$9$1
};

var createPropertyDescriptor$1$1 = function createPropertyDescriptor(bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var FunctionPrototype$4$1 = Function.prototype;
var call$1$1$1 = FunctionPrototype$4$1.call;
var uncurryThisWithBind$1$1 = functionBindNative$1$1 && FunctionPrototype$4$1.bind.bind(call$1$1$1, call$1$1$1);
var functionUncurryThisRaw$1$1 = functionBindNative$1$1 ? uncurryThisWithBind$1$1 : function (fn) {
  return function () {
    return call$1$1$1.apply(fn, arguments);
  };
};
var toString$2$1 = functionUncurryThisRaw$1$1({}.toString);
var stringSlice$7$1 = functionUncurryThisRaw$1$1(''.slice);

var classofRaw$1$1 = function classofRaw(it) {
  return stringSlice$7$1(toString$2$1(it), 8, -1);
};

var functionUncurryThis$1$1 = function functionUncurryThis(fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw$1$1(fn) === 'Function') return functionUncurryThisRaw$1$1(fn);
};

var $Object$5$1 = Object;
var split$1$1 = functionUncurryThis$1$1(''.split); // fallback for non-array-like ES3 and non-enumerable old V8 strings

var indexedObject$1$1 = fails$1$1(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$5$1('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw$1$1(it) == 'String' ? split$1$1(it, '') : $Object$5$1(it);
} : $Object$5$1; // we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec

var isNullOrUndefined$1$1 = function isNullOrUndefined(it) {
  return it === null || it === undefined;
};

var $TypeError$f$1 = TypeError; // `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible

var requireObjectCoercible$1$1 = function requireObjectCoercible(it) {
  if (isNullOrUndefined$1$1(it)) throw $TypeError$f$1("Can't call method on " + it);
  return it;
};

var toIndexedObject$1$1 = function toIndexedObject(it) {
  return indexedObject$1$1(requireObjectCoercible$1$1(it));
};

var documentAll$3$1 = (typeof document === "undefined" ? "undefined" : _typeof(document)) == 'object' && document.all; // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot

var IS_HTMLDDA$1$1 = typeof documentAll$3$1 == 'undefined' && documentAll$3$1 !== undefined;
var documentAll_1$1$1 = {
  all: documentAll$3$1,
  IS_HTMLDDA: IS_HTMLDDA$1$1
};
var documentAll$1$1$1 = documentAll_1$1$1.all; // `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable

var isCallable$1$1 = documentAll_1$1$1.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll$1$1$1;
} : function (argument) {
  return typeof argument == 'function';
};
var documentAll$2$1$1 = documentAll_1$1$1.all;
var isObject$1$1 = documentAll_1$1$1.IS_HTMLDDA ? function (it) {
  return _typeof(it) == 'object' ? it !== null : isCallable$1$1(it) || it === documentAll$2$1$1;
} : function (it) {
  return _typeof(it) == 'object' ? it !== null : isCallable$1$1(it);
};

var aFunction$1$1 = function aFunction(argument) {
  return isCallable$1$1(argument) ? argument : undefined;
};

var getBuiltIn$1$1 = function getBuiltIn(namespace, method) {
  return arguments.length < 2 ? aFunction$1$1(global_1$1$1[namespace]) : global_1$1$1[namespace] && global_1$1$1[namespace][method];
};

var objectIsPrototypeOf$1$1 = functionUncurryThis$1$1({}.isPrototypeOf);
var engineUserAgent$1$1 = getBuiltIn$1$1('navigator', 'userAgent') || '';
var process$4$1 = global_1$1$1.process;
var Deno$1$1$1 = global_1$1$1.Deno;
var versions$1$1 = process$4$1 && process$4$1.versions || Deno$1$1$1 && Deno$1$1$1.version;
var v8$1$1 = versions$1$1 && versions$1$1.v8;
var match$1$1, version$1$1;

if (v8$1$1) {
  match$1$1 = v8$1$1.split('.'); // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us

  version$1$1 = match$1$1[0] > 0 && match$1$1[0] < 4 ? 1 : +(match$1$1[0] + match$1$1[1]);
} // BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0


if (!version$1$1 && engineUserAgent$1$1) {
  match$1$1 = engineUserAgent$1$1.match(/Edge\/(\d+)/);

  if (!match$1$1 || match$1$1[1] >= 74) {
    match$1$1 = engineUserAgent$1$1.match(/Chrome\/(\d+)/);
    if (match$1$1) version$1$1 = +match$1$1[1];
  }
}

var engineV8Version$1$1 = version$1$1;
/* eslint-disable es/no-symbol -- required for testing */
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing

var symbolConstructorDetection$1$1 = !!Object.getOwnPropertySymbols && !fails$1$1(function () {
  var symbol = Symbol(); // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances

  return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && engineV8Version$1$1 && engineV8Version$1$1 < 41;
});
/* eslint-disable es/no-symbol -- required for testing */

var useSymbolAsUid$1$1 = symbolConstructorDetection$1$1 && !Symbol.sham && _typeof(Symbol.iterator) == 'symbol';
var $Object$1$1$1 = Object;
var isSymbol$1$1 = useSymbolAsUid$1$1 ? function (it) {
  return _typeof(it) == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$1$1('Symbol');
  return isCallable$1$1($Symbol) && objectIsPrototypeOf$1$1($Symbol.prototype, $Object$1$1$1(it));
};
var $String$4$1 = String;

var tryToString$1$1 = function tryToString(argument) {
  try {
    return $String$4$1(argument);
  } catch (error) {
    return 'Object';
  }
};

var $TypeError$1$1$1 = TypeError; // `Assert: IsCallable(argument) is true`

var aCallable$1$1 = function aCallable(argument) {
  if (isCallable$1$1(argument)) return argument;
  throw $TypeError$1$1$1(tryToString$1$1(argument) + ' is not a function');
}; // https://tc39.es/ecma262/#sec-getmethod


var getMethod$1$1 = function getMethod(V, P) {
  var func = V[P];
  return isNullOrUndefined$1$1(func) ? undefined : aCallable$1$1(func);
};

var $TypeError$2$1$1 = TypeError; // `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive

var ordinaryToPrimitive$1$1 = function ordinaryToPrimitive(input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$1$1(fn = input.toString) && !isObject$1$1(val = functionCall$1$1(fn, input))) return val;
  if (isCallable$1$1(fn = input.valueOf) && !isObject$1$1(val = functionCall$1$1(fn, input))) return val;
  if (pref !== 'string' && isCallable$1$1(fn = input.toString) && !isObject$1$1(val = functionCall$1$1(fn, input))) return val;
  throw $TypeError$2$1$1("Can't convert object to primitive value");
};

var defineProperty$7$1 = Object.defineProperty;

var defineGlobalProperty$1$1 = function defineGlobalProperty(key, value) {
  try {
    defineProperty$7$1(global_1$1$1, key, {
      value: value,
      configurable: true,
      writable: true
    });
  } catch (error) {
    global_1$1$1[key] = value;
  }

  return value;
};

var SHARED$1$1 = '__core-js_shared__';
var store$2$1 = global_1$1$1[SHARED$1$1] || defineGlobalProperty$1$1(SHARED$1$1, {});
var sharedStore$1$1 = store$2$1;
var shared$1$1 = createCommonjsModule$1$1(function (module) {
  (module.exports = function (key, value) {
    return sharedStore$1$1[key] || (sharedStore$1$1[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: '3.26.0',
    mode: 'global',
    copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
    license: 'https://github.com/zloirock/core-js/blob/v3.26.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
  });
});
var $Object$2$1$1 = Object; // `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject

var toObject$1$1 = function toObject(argument) {
  return $Object$2$1$1(requireObjectCoercible$1$1(argument));
};

var hasOwnProperty$1$1 = functionUncurryThis$1$1({}.hasOwnProperty); // `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe

var hasOwnProperty_1$1$1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty$1$1(toObject$1$1(it), key);
};

var id$1$1 = 0;
var postfix$1$1 = Math.random();
var toString$1$1$1 = functionUncurryThis$1$1(1.0.toString);

var uid$1$1 = function uid(key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$1$1$1(++id$1$1 + postfix$1$1, 36);
};

var WellKnownSymbolsStore$2$1 = shared$1$1('wks');
var Symbol$1$1$1 = global_1$1$1.Symbol;
var symbolFor$1$1 = Symbol$1$1$1 && Symbol$1$1$1['for'];
var createWellKnownSymbol$1$1 = useSymbolAsUid$1$1 ? Symbol$1$1$1 : Symbol$1$1$1 && Symbol$1$1$1.withoutSetter || uid$1$1;

var wellKnownSymbol$1$1 = function wellKnownSymbol(name) {
  if (!hasOwnProperty_1$1$1(WellKnownSymbolsStore$2$1, name) || !(symbolConstructorDetection$1$1 || typeof WellKnownSymbolsStore$2$1[name] == 'string')) {
    var description = 'Symbol.' + name;

    if (symbolConstructorDetection$1$1 && hasOwnProperty_1$1$1(Symbol$1$1$1, name)) {
      WellKnownSymbolsStore$2$1[name] = Symbol$1$1$1[name];
    } else if (useSymbolAsUid$1$1 && symbolFor$1$1) {
      WellKnownSymbolsStore$2$1[name] = symbolFor$1$1(description);
    } else {
      WellKnownSymbolsStore$2$1[name] = createWellKnownSymbol$1$1(description);
    }
  }

  return WellKnownSymbolsStore$2$1[name];
};

var $TypeError$3$1$1 = TypeError;
var TO_PRIMITIVE$1$1 = wellKnownSymbol$1$1('toPrimitive'); // `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive

var toPrimitive$1$1 = function toPrimitive(input, pref) {
  if (!isObject$1$1(input) || isSymbol$1$1(input)) return input;
  var exoticToPrim = getMethod$1$1(input, TO_PRIMITIVE$1$1);
  var result;

  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = functionCall$1$1(exoticToPrim, input, pref);
    if (!isObject$1$1(result) || isSymbol$1$1(result)) return result;
    throw $TypeError$3$1$1("Can't convert object to primitive value");
  }

  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive$1$1(input, pref);
}; // https://tc39.es/ecma262/#sec-topropertykey


var toPropertyKey$1$1 = function toPropertyKey(argument) {
  var key = toPrimitive$1$1(argument, 'string');
  return isSymbol$1$1(key) ? key : key + '';
};

var document$1$1$1 = global_1$1$1.document; // typeof document.createElement is 'object' in old IE

var EXISTS$2$1 = isObject$1$1(document$1$1$1) && isObject$1$1(document$1$1$1.createElement);

var documentCreateElement$1$1 = function documentCreateElement(it) {
  return EXISTS$2$1 ? document$1$1$1.createElement(it) : {};
};

var ie8DomDefine$1$1 = !descriptors$1$1 && !fails$1$1(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(documentCreateElement$1$1('div'), 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
});
var $getOwnPropertyDescriptor$3$1 = Object.getOwnPropertyDescriptor; // `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor

var f$1$1$1 = descriptors$1$1 ? $getOwnPropertyDescriptor$3$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$1$1(O);
  P = toPropertyKey$1$1(P);
  if (ie8DomDefine$1$1) try {
    return $getOwnPropertyDescriptor$3$1(O, P);
  } catch (error) {
    /* empty */
  }
  if (hasOwnProperty_1$1$1(O, P)) return createPropertyDescriptor$1$1(!functionCall$1$1(objectPropertyIsEnumerable$1$1.f, O, P), O[P]);
};
var objectGetOwnPropertyDescriptor$1$1 = {
  f: f$1$1$1
}; // https://bugs.chromium.org/p/v8/issues/detail?id=3334

var v8PrototypeDefineBug$1$1 = descriptors$1$1 && fails$1$1(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () {
    /* empty */
  }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});
var $String$1$1$1 = String;
var $TypeError$4$1$1 = TypeError; // `Assert: Type(argument) is Object`

var anObject$1$1 = function anObject(argument) {
  if (isObject$1$1(argument)) return argument;
  throw $TypeError$4$1$1($String$1$1$1(argument) + ' is not an object');
};

var $TypeError$5$1$1 = TypeError; // eslint-disable-next-line es/no-object-defineproperty -- safe

var $defineProperty$2$1 = Object.defineProperty; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

var $getOwnPropertyDescriptor$1$1$1 = Object.getOwnPropertyDescriptor;
var ENUMERABLE$1$1 = 'enumerable';
var CONFIGURABLE$2$1 = 'configurable';
var WRITABLE$1$1 = 'writable'; // `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty

var f$2$1$1 = descriptors$1$1 ? v8PrototypeDefineBug$1$1 ? function defineProperty(O, P, Attributes) {
  anObject$1$1(O);
  P = toPropertyKey$1$1(P);
  anObject$1$1(Attributes);

  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE$1$1 in Attributes && !Attributes[WRITABLE$1$1]) {
    var current = $getOwnPropertyDescriptor$1$1$1(O, P);

    if (current && current[WRITABLE$1$1]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$2$1 in Attributes ? Attributes[CONFIGURABLE$2$1] : current[CONFIGURABLE$2$1],
        enumerable: ENUMERABLE$1$1 in Attributes ? Attributes[ENUMERABLE$1$1] : current[ENUMERABLE$1$1],
        writable: false
      };
    }
  }

  return $defineProperty$2$1(O, P, Attributes);
} : $defineProperty$2$1 : function defineProperty(O, P, Attributes) {
  anObject$1$1(O);
  P = toPropertyKey$1$1(P);
  anObject$1$1(Attributes);
  if (ie8DomDefine$1$1) try {
    return $defineProperty$2$1(O, P, Attributes);
  } catch (error) {
    /* empty */
  }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError$5$1$1('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};
var objectDefineProperty$1$1 = {
  f: f$2$1$1
};
var createNonEnumerableProperty$1$1 = descriptors$1$1 ? function (object, key, value) {
  return objectDefineProperty$1$1.f(object, key, createPropertyDescriptor$1$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};
var FunctionPrototype$1$1$1 = Function.prototype; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

var getDescriptor$1$1 = descriptors$1$1 && Object.getOwnPropertyDescriptor;
var EXISTS$1$1$1 = hasOwnProperty_1$1$1(FunctionPrototype$1$1$1, 'name'); // additional protection from minified / mangled / dropped function names

var PROPER$1$1 = EXISTS$1$1$1 && function something() {
  /* empty */
}.name === 'something';

var CONFIGURABLE$1$1$1 = EXISTS$1$1$1 && (!descriptors$1$1 || descriptors$1$1 && getDescriptor$1$1(FunctionPrototype$1$1$1, 'name').configurable);
var functionName$1$1 = {
  EXISTS: EXISTS$1$1$1,
  PROPER: PROPER$1$1,
  CONFIGURABLE: CONFIGURABLE$1$1$1
};
var functionToString$2$1 = functionUncurryThis$1$1(Function.toString); // this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper

if (!isCallable$1$1(sharedStore$1$1.inspectSource)) {
  sharedStore$1$1.inspectSource = function (it) {
    return functionToString$2$1(it);
  };
}

var inspectSource$1$1 = sharedStore$1$1.inspectSource;
var WeakMap$2$1 = global_1$1$1.WeakMap;
var weakMapBasicDetection$1$1 = isCallable$1$1(WeakMap$2$1) && /native code/.test(String(WeakMap$2$1));
var keys$1$1 = shared$1$1('keys');

var sharedKey$1$1 = function sharedKey(key) {
  return keys$1$1[key] || (keys$1$1[key] = uid$1$1(key));
};

var hiddenKeys$2$1 = {};
var OBJECT_ALREADY_INITIALIZED$1$1 = 'Object already initialized';
var TypeError$1$1$1 = global_1$1$1.TypeError;
var WeakMap$1$1$1 = global_1$1$1.WeakMap;
var set$2$1, get$1$1, has$1$1;

var enforce$1$1 = function enforce(it) {
  return has$1$1(it) ? get$1$1(it) : set$2$1(it, {});
};

var getterFor$1$1 = function getterFor(TYPE) {
  return function (it) {
    var state;

    if (!isObject$1$1(it) || (state = get$1$1(it)).type !== TYPE) {
      throw TypeError$1$1$1('Incompatible receiver, ' + TYPE + ' required');
    }

    return state;
  };
};

if (weakMapBasicDetection$1$1 || sharedStore$1$1.state) {
  var store$1$1$1 = sharedStore$1$1.state || (sharedStore$1$1.state = new WeakMap$1$1$1());
  /* eslint-disable no-self-assign -- prototype methods protection */

  store$1$1$1.get = store$1$1$1.get;
  store$1$1$1.has = store$1$1$1.has;
  store$1$1$1.set = store$1$1$1.set;
  /* eslint-enable no-self-assign -- prototype methods protection */

  set$2$1 = function set(it, metadata) {
    if (store$1$1$1.has(it)) throw TypeError$1$1$1(OBJECT_ALREADY_INITIALIZED$1$1);
    metadata.facade = it;
    store$1$1$1.set(it, metadata);
    return metadata;
  };

  get$1$1 = function get(it) {
    return store$1$1$1.get(it) || {};
  };

  has$1$1 = function has(it) {
    return store$1$1$1.has(it);
  };
} else {
  var STATE$1$1 = sharedKey$1$1('state');
  hiddenKeys$2$1[STATE$1$1] = true;

  set$2$1 = function set(it, metadata) {
    if (hasOwnProperty_1$1$1(it, STATE$1$1)) throw TypeError$1$1$1(OBJECT_ALREADY_INITIALIZED$1$1);
    metadata.facade = it;
    createNonEnumerableProperty$1$1(it, STATE$1$1, metadata);
    return metadata;
  };

  get$1$1 = function get(it) {
    return hasOwnProperty_1$1$1(it, STATE$1$1) ? it[STATE$1$1] : {};
  };

  has$1$1 = function has(it) {
    return hasOwnProperty_1$1$1(it, STATE$1$1);
  };
}

var internalState$1$1 = {
  set: set$2$1,
  get: get$1$1,
  has: has$1$1,
  enforce: enforce$1$1,
  getterFor: getterFor$1$1
};
var makeBuiltIn_1$1$1 = createCommonjsModule$1$1(function (module) {
  var CONFIGURABLE_FUNCTION_NAME = functionName$1$1.CONFIGURABLE;
  var enforceInternalState = internalState$1$1.enforce;
  var getInternalState = internalState$1$1.get; // eslint-disable-next-line es/no-object-defineproperty -- safe

  var defineProperty = Object.defineProperty;
  var CONFIGURABLE_LENGTH = descriptors$1$1 && !fails$1$1(function () {
    return defineProperty(function () {
      /* empty */
    }, 'length', {
      value: 8
    }).length !== 8;
  });
  var TEMPLATE = String(String).split('String');

  var makeBuiltIn = module.exports = function (value, name, options) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }

    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;

    if (!hasOwnProperty_1$1$1(value, 'name') || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
      if (descriptors$1$1) defineProperty(value, 'name', {
        value: name,
        configurable: true
      });else value.name = name;
    }

    if (CONFIGURABLE_LENGTH && options && hasOwnProperty_1$1$1(options, 'arity') && value.length !== options.arity) {
      defineProperty(value, 'length', {
        value: options.arity
      });
    }

    try {
      if (options && hasOwnProperty_1$1$1(options, 'constructor') && options.constructor) {
        if (descriptors$1$1) defineProperty(value, 'prototype', {
          writable: false
        }); // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
      } else if (value.prototype) value.prototype = undefined;
    } catch (error) {
      /* empty */
    }

    var state = enforceInternalState(value);

    if (!hasOwnProperty_1$1$1(state, 'source')) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }

    return value;
  }; // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
  // eslint-disable-next-line no-extend-native -- required


  Function.prototype.toString = makeBuiltIn(function toString() {
    return isCallable$1$1(this) && getInternalState(this).source || inspectSource$1$1(this);
  }, 'toString');
});

var defineBuiltIn$1$1 = function defineBuiltIn(O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$1$1(value)) makeBuiltIn_1$1$1(value, name, options);

  if (options.global) {
    if (simple) O[key] = value;else defineGlobalProperty$1$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];else if (O[key]) simple = true;
    } catch (error) {
      /* empty */
    }

    if (simple) O[key] = value;else objectDefineProperty$1$1.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  }

  return O;
};

var ceil$1$1 = Math.ceil;
var floor$2$1 = Math.floor; // `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe

var mathTrunc$1$1 = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$2$1 : ceil$1$1)(n);
}; // https://tc39.es/ecma262/#sec-tointegerorinfinity


var toIntegerOrInfinity$1$1 = function toIntegerOrInfinity(argument) {
  var number = +argument; // eslint-disable-next-line no-self-compare -- NaN check

  return number !== number || number === 0 ? 0 : mathTrunc$1$1(number);
};

var max$4$1 = Math.max;
var min$4$1 = Math.min; // Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).

var toAbsoluteIndex$1$1 = function toAbsoluteIndex(index, length) {
  var integer = toIntegerOrInfinity$1$1(index);
  return integer < 0 ? max$4$1(integer + length, 0) : min$4$1(integer, length);
};

var min$1$1$1 = Math.min; // `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength

var toLength$1$1 = function toLength(argument) {
  return argument > 0 ? min$1$1$1(toIntegerOrInfinity$1$1(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
}; // https://tc39.es/ecma262/#sec-lengthofarraylike


var lengthOfArrayLike$1$1 = function lengthOfArrayLike(obj) {
  return toLength$1$1(obj.length);
};

var createMethod$3$1 = function createMethod(IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$1$1($this);
    var length = lengthOfArrayLike$1$1(O);
    var index = toAbsoluteIndex$1$1(fromIndex, length);
    var value; // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check

    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++]; // eslint-disable-next-line no-self-compare -- NaN check

      if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    }
    return !IS_INCLUDES && -1;
  };
};

var arrayIncludes$1$1 = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$3$1(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$3$1(false)
};
var indexOf$2$1 = arrayIncludes$1$1.indexOf;
var push$5$1 = functionUncurryThis$1$1([].push);

var objectKeysInternal$1$1 = function objectKeysInternal(object, names) {
  var O = toIndexedObject$1$1(object);
  var i = 0;
  var result = [];
  var key;

  for (key in O) {
    !hasOwnProperty_1$1$1(hiddenKeys$2$1, key) && hasOwnProperty_1$1$1(O, key) && push$5$1(result, key);
  } // Don't enum bug & hidden keys


  while (names.length > i) {
    if (hasOwnProperty_1$1$1(O, key = names[i++])) {
      ~indexOf$2$1(result, key) || push$5$1(result, key);
    }
  }

  return result;
}; // IE8- don't enum bug keys


var enumBugKeys$1$1 = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];
var hiddenKeys$1$1$1 = enumBugKeys$1$1.concat('length', 'prototype'); // `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe

var f$3$1$1 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal$1$1(O, hiddenKeys$1$1$1);
};

var objectGetOwnPropertyNames$1$1 = {
  f: f$3$1$1
}; // eslint-disable-next-line es/no-object-getownpropertysymbols -- safe

var f$4$1$1 = Object.getOwnPropertySymbols;
var objectGetOwnPropertySymbols$1$1 = {
  f: f$4$1$1
};
var concat$2$1 = functionUncurryThis$1$1([].concat); // all object keys, includes non-enumerable and symbols

var ownKeys$1$1 = getBuiltIn$1$1('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = objectGetOwnPropertyNames$1$1.f(anObject$1$1(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols$1$1.f;
  return getOwnPropertySymbols ? concat$2$1(keys, getOwnPropertySymbols(it)) : keys;
};

var copyConstructorProperties$1$1 = function copyConstructorProperties(target, source, exceptions) {
  var keys = ownKeys$1$1(source);
  var defineProperty = objectDefineProperty$1$1.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor$1$1.f;

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];

    if (!hasOwnProperty_1$1$1(target, key) && !(exceptions && hasOwnProperty_1$1$1(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var replacement$1$1 = /#|\.prototype\./;

var isForced$1$1 = function isForced(feature, detection) {
  var value = data$1$1[normalize$1$1(feature)];
  return value == POLYFILL$1$1 ? true : value == NATIVE$1$1 ? false : isCallable$1$1(detection) ? fails$1$1(detection) : !!detection;
};

var normalize$1$1 = isForced$1$1.normalize = function (string) {
  return String(string).replace(replacement$1$1, '.').toLowerCase();
};

var data$1$1 = isForced$1$1.data = {};
var NATIVE$1$1 = isForced$1$1.NATIVE = 'N';
var POLYFILL$1$1 = isForced$1$1.POLYFILL = 'P';
var isForced_1$1$1 = isForced$1$1;
var getOwnPropertyDescriptor$1$1$1 = objectGetOwnPropertyDescriptor$1$1.f;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/

var _export$1$1 = function _export(options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;

  if (GLOBAL) {
    target = global_1$1$1;
  } else if (STATIC) {
    target = global_1$1$1[TARGET] || defineGlobalProperty$1$1(TARGET, {});
  } else {
    target = (global_1$1$1[TARGET] || {}).prototype;
  }

  if (target) for (key in source) {
    sourceProperty = source[key];

    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$1$1$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];

    FORCED = isForced_1$1$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced); // contained in target

    if (!FORCED && targetProperty !== undefined) {
      if (_typeof(sourceProperty) == _typeof(targetProperty)) continue;
      copyConstructorProperties$1$1(sourceProperty, targetProperty);
    } // add a flag to not completely full polyfills


    if (options.sham || targetProperty && targetProperty.sham) {
      createNonEnumerableProperty$1$1(sourceProperty, 'sham', true);
    }

    defineBuiltIn$1$1(target, key, sourceProperty, options);
  }
}; // https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe


var isArray$1$1 = Array.isArray || function isArray(argument) {
  return classofRaw$1$1(argument) == 'Array';
};

var $TypeError$6$1$1 = TypeError;
var MAX_SAFE_INTEGER$1$1 = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger$1$1 = function doesNotExceedSafeInteger(it) {
  if (it > MAX_SAFE_INTEGER$1$1) throw $TypeError$6$1$1('Maximum allowed index exceeded');
  return it;
};

var createProperty$1$1 = function createProperty(object, key, value) {
  var propertyKey = toPropertyKey$1$1(key);
  if (propertyKey in object) objectDefineProperty$1$1.f(object, propertyKey, createPropertyDescriptor$1$1(0, value));else object[propertyKey] = value;
};

var TO_STRING_TAG$4$1 = wellKnownSymbol$1$1('toStringTag');
var test$1$1 = {};
test$1$1[TO_STRING_TAG$4$1] = 'z';
var toStringTagSupport$1$1 = String(test$1$1) === '[object z]';
var TO_STRING_TAG$1$1$1 = wellKnownSymbol$1$1('toStringTag');
var $Object$3$1$1 = Object; // ES3 wrong here

var CORRECT_ARGUMENTS$1$1 = classofRaw$1$1(function () {
  return arguments;
}()) == 'Arguments'; // fallback for IE11 Script Access Denied error

var tryGet$1$1 = function tryGet(it, key) {
  try {
    return it[key];
  } catch (error) {
    /* empty */
  }
}; // getting tag from ES6+ `Object.prototype.toString`


var classof$1$1 = toStringTagSupport$1$1 ? classofRaw$1$1 : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
  : typeof (tag = tryGet$1$1(O = $Object$3$1$1(it), TO_STRING_TAG$1$1$1)) == 'string' ? tag // builtinTag case
  : CORRECT_ARGUMENTS$1$1 ? classofRaw$1$1(O) // ES3 arguments fallback
  : (result = classofRaw$1$1(O)) == 'Object' && isCallable$1$1(O.callee) ? 'Arguments' : result;
};

var noop$1$1 = function noop() {
  /* empty */
};

var empty$1$1 = [];
var construct$1$1 = getBuiltIn$1$1('Reflect', 'construct');
var constructorRegExp$1$1 = /^\s*(?:class|function)\b/;
var exec$3$1 = functionUncurryThis$1$1(constructorRegExp$1$1.exec);
var INCORRECT_TO_STRING$1$1 = !constructorRegExp$1$1.exec(noop$1$1);

var isConstructorModern$1$1 = function isConstructor(argument) {
  if (!isCallable$1$1(argument)) return false;

  try {
    construct$1$1(noop$1$1, empty$1$1, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy$1$1 = function isConstructor(argument) {
  if (!isCallable$1$1(argument)) return false;

  switch (classof$1$1(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction':
      return false;
  }

  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING$1$1 || !!exec$3$1(constructorRegExp$1$1, inspectSource$1$1(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy$1$1.sham = true; // `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor

var isConstructor$1$1 = !construct$1$1 || fails$1$1(function () {
  var called;
  return isConstructorModern$1$1(isConstructorModern$1$1.call) || !isConstructorModern$1$1(Object) || !isConstructorModern$1$1(function () {
    called = true;
  }) || called;
}) ? isConstructorLegacy$1$1 : isConstructorModern$1$1;
var SPECIES$7$1 = wellKnownSymbol$1$1('species');
var $Array$4$1 = Array; // a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate

var arraySpeciesConstructor$1$1 = function arraySpeciesConstructor(originalArray) {
  var C;

  if (isArray$1$1(originalArray)) {
    C = originalArray.constructor; // cross-realm fallback

    if (isConstructor$1$1(C) && (C === $Array$4$1 || isArray$1$1(C.prototype))) C = undefined;else if (isObject$1$1(C)) {
      C = C[SPECIES$7$1];
      if (C === null) C = undefined;
    }
  }

  return C === undefined ? $Array$4$1 : C;
}; // https://tc39.es/ecma262/#sec-arrayspeciescreate


var arraySpeciesCreate$1$1 = function arraySpeciesCreate(originalArray, length) {
  return new (arraySpeciesConstructor$1$1(originalArray))(length === 0 ? 0 : length);
};

var SPECIES$1$1$1 = wellKnownSymbol$1$1('species');

var arrayMethodHasSpeciesSupport$1$1 = function arrayMethodHasSpeciesSupport(METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return engineV8Version$1$1 >= 51 || !fails$1$1(function () {
    var array = [];
    var constructor = array.constructor = {};

    constructor[SPECIES$1$1$1] = function () {
      return {
        foo: 1
      };
    };

    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var IS_CONCAT_SPREADABLE$1$1 = wellKnownSymbol$1$1('isConcatSpreadable'); // We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679

var IS_CONCAT_SPREADABLE_SUPPORT$1$1 = engineV8Version$1$1 >= 51 || !fails$1$1(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE$1$1] = false;
  return array.concat()[0] !== array;
});
var SPECIES_SUPPORT$1$1 = arrayMethodHasSpeciesSupport$1$1('concat');

var isConcatSpreadable$1$1 = function isConcatSpreadable(O) {
  if (!isObject$1$1(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE$1$1];
  return spreadable !== undefined ? !!spreadable : isArray$1$1(O);
};

var FORCED$3$1 = !IS_CONCAT_SPREADABLE_SUPPORT$1$1 || !SPECIES_SUPPORT$1$1; // `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species

_export$1$1({
  target: 'Array',
  proto: true,
  arity: 1,
  forced: FORCED$3$1
}, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject$1$1(this);
    var A = arraySpeciesCreate$1$1(O, 0);
    var n = 0;
    var i, k, length, len, E;

    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];

      if (isConcatSpreadable$1$1(E)) {
        len = lengthOfArrayLike$1$1(E);
        doesNotExceedSafeInteger$1$1(n + len);

        for (k = 0; k < len; k++, n++) {
          if (k in E) createProperty$1$1(A, n, E[k]);
        }
      } else {
        doesNotExceedSafeInteger$1$1(n + 1);
        createProperty$1$1(A, n++, E);
      }
    }

    A.length = n;
    return A;
  }
});

var html$1$1 = getBuiltIn$1$1('document', 'documentElement');
var iterators$1$1 = {};
var defineProperty$1$1$1 = objectDefineProperty$1$1.f;
var TO_STRING_TAG$2$1$1 = wellKnownSymbol$1$1('toStringTag');

var setToStringTag$1$1 = function setToStringTag(target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;

  if (target && !hasOwnProperty_1$1$1(target, TO_STRING_TAG$2$1$1)) {
    defineProperty$1$1$1(target, TO_STRING_TAG$2$1$1, {
      configurable: true,
      value: TAG
    });
  }
};

var $String$2$1$1 = String;
var $TypeError$7$1$1 = TypeError;

var aPossiblePrototype$1$1 = function aPossiblePrototype(argument) {
  if (_typeof(argument) == 'object' || isCallable$1$1(argument)) return argument;
  throw $TypeError$7$1$1("Can't set " + $String$2$1$1(argument) + ' as a prototype');
};
/* eslint-disable no-proto -- safe */
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe


var objectSetPrototypeOf$1$1 = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;

  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = functionUncurryThis$1$1(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) {
    /* empty */
  }

  return function setPrototypeOf(O, proto) {
    anObject$1$1(O);
    aPossiblePrototype$1$1(proto);
    if (CORRECT_SETTER) setter(O, proto);else O.__proto__ = proto;
    return O;
  };
}() : undefined); // https://tc39.es/ecma262/#sec-object.prototype.tostring

var objectToString$1$1 = toStringTagSupport$1$1 ? {}.toString : function toString() {
  return '[object ' + classof$1$1(this) + ']';
}; // https://tc39.es/ecma262/#sec-object.prototype.tostring

if (!toStringTagSupport$1$1) {
  defineBuiltIn$1$1(Object.prototype, 'toString', objectToString$1$1, {
    unsafe: true
  });
}

var bind$2$1 = functionUncurryThis$1$1(functionUncurryThis$1$1.bind); // optional / simple context binding

var functionBindContext$1$1 = function functionBindContext(fn, that) {
  aCallable$1$1(fn);
  return that === undefined ? fn : functionBindNative$1$1 ? bind$2$1(fn, that) : function ()
  /* ...args */
  {
    return fn.apply(that, arguments);
  };
};

var $TypeError$8$1$1 = TypeError;

var anInstance$1$1 = function anInstance(it, Prototype) {
  if (objectIsPrototypeOf$1$1(Prototype, it)) return it;
  throw $TypeError$8$1$1('Incorrect invocation');
};

var iteratorClose$1$1 = function iteratorClose(iterator, kind, value) {
  var innerResult, innerError;
  anObject$1$1(iterator);

  try {
    innerResult = getMethod$1$1(iterator, 'return');

    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }

    innerResult = functionCall$1$1(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }

  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$1$1(innerResult);
  return value;
};

var ITERATOR$6$1 = wellKnownSymbol$1$1('iterator');
var ArrayPrototype$2$1 = Array.prototype; // check on default Array iterator

var isArrayIteratorMethod$1$1 = function isArrayIteratorMethod(it) {
  return it !== undefined && (iterators$1$1.Array === it || ArrayPrototype$2$1[ITERATOR$6$1] === it);
};

var ITERATOR$1$1$1 = wellKnownSymbol$1$1('iterator');

var getIteratorMethod$1$1 = function getIteratorMethod(it) {
  if (!isNullOrUndefined$1$1(it)) return getMethod$1$1(it, ITERATOR$1$1$1) || getMethod$1$1(it, '@@iterator') || iterators$1$1[classof$1$1(it)];
};

var $TypeError$9$1$1 = TypeError;

var getIterator$1$1 = function getIterator(argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$1$1(argument) : usingIterator;
  if (aCallable$1$1(iteratorMethod)) return anObject$1$1(functionCall$1$1(iteratorMethod, argument));
  throw $TypeError$9$1$1(tryToString$1$1(argument) + ' is not iterable');
};

var $TypeError$a$1$1 = TypeError;

var validateArgumentsLength$1$1 = function validateArgumentsLength(passed, required) {
  if (passed < required) throw $TypeError$a$1$1('Not enough arguments');
  return passed;
};

var engineIsNode$1$1 = classofRaw$1$1(global_1$1$1.process) == 'process';
var SPECIES$2$1$1 = wellKnownSymbol$1$1('species');

var setSpecies$1$1 = function setSpecies(CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$1$1(CONSTRUCTOR_NAME);
  var defineProperty = objectDefineProperty$1$1.f;

  if (descriptors$1$1 && Constructor && !Constructor[SPECIES$2$1$1]) {
    defineProperty(Constructor, SPECIES$2$1$1, {
      configurable: true,
      get: function get() {
        return this;
      }
    });
  }
};

var $TypeError$b$1$1 = TypeError; // `Assert: IsConstructor(argument) is true`

var aConstructor$1$1 = function aConstructor(argument) {
  if (isConstructor$1$1(argument)) return argument;
  throw $TypeError$b$1$1(tryToString$1$1(argument) + ' is not a constructor');
};

var SPECIES$3$1$1 = wellKnownSymbol$1$1('species'); // `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor

var speciesConstructor$1$1 = function speciesConstructor(O, defaultConstructor) {
  var C = anObject$1$1(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined$1$1(S = anObject$1$1(C)[SPECIES$3$1$1]) ? defaultConstructor : aConstructor$1$1(S);
};

var FunctionPrototype$2$1$1 = Function.prototype;
var apply$1$1 = FunctionPrototype$2$1$1.apply;
var call$2$1$1 = FunctionPrototype$2$1$1.call; // eslint-disable-next-line es/no-reflect -- safe

var functionApply$1$1 = (typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) == 'object' && Reflect.apply || (functionBindNative$1$1 ? call$2$1$1.bind(apply$1$1) : function () {
  return call$2$1$1.apply(apply$1$1, arguments);
});
var arraySlice$1$1 = functionUncurryThis$1$1([].slice);
var engineIsIos$1$1 = /(?:ipad|iphone|ipod).*applewebkit/i.test(engineUserAgent$1$1);
var set$1$1$1 = global_1$1$1.setImmediate;
var clear$1$1 = global_1$1$1.clearImmediate;
var process$1$1$1 = global_1$1$1.process;
var Dispatch$1$1 = global_1$1$1.Dispatch;
var Function$1$1$1 = global_1$1$1.Function;
var MessageChannel$1$1 = global_1$1$1.MessageChannel;
var String$1$1$1 = global_1$1$1.String;
var counter$1$1 = 0;
var queue$2$1 = {};
var ONREADYSTATECHANGE$1$1 = 'onreadystatechange';
var $location$1$1, defer$1$1, channel$1$1, port$1$1;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location$1$1 = global_1$1$1.location;
} catch (error) {
  /* empty */
}

var run$1$1 = function run(id) {
  if (hasOwnProperty_1$1$1(queue$2$1, id)) {
    var fn = queue$2$1[id];
    delete queue$2$1[id];
    fn();
  }
};

var runner$1$1 = function runner(id) {
  return function () {
    run$1$1(id);
  };
};

var listener$1$1 = function listener(event) {
  run$1$1(event.data);
};

var post$1$1 = function post(id) {
  // old engines have not location.origin
  global_1$1$1.postMessage(String$1$1$1(id), $location$1$1.protocol + '//' + $location$1$1.host);
}; // Node.js 0.9+ & IE10+ has setImmediate, otherwise:


if (!set$1$1$1 || !clear$1$1) {
  set$1$1$1 = function setImmediate(handler) {
    validateArgumentsLength$1$1(arguments.length, 1);
    var fn = isCallable$1$1(handler) ? handler : Function$1$1$1(handler);
    var args = arraySlice$1$1(arguments, 1);

    queue$2$1[++counter$1$1] = function () {
      functionApply$1$1(fn, undefined, args);
    };

    defer$1$1(counter$1$1);
    return counter$1$1;
  };

  clear$1$1 = function clearImmediate(id) {
    delete queue$2$1[id];
  }; // Node.js 0.8-


  if (engineIsNode$1$1) {
    defer$1$1 = function defer(id) {
      process$1$1$1.nextTick(runner$1$1(id));
    }; // Sphere (JS game engine) Dispatch API

  } else if (Dispatch$1$1 && Dispatch$1$1.now) {
    defer$1$1 = function defer(id) {
      Dispatch$1$1.now(runner$1$1(id));
    }; // Browsers with MessageChannel, includes WebWorkers
    // except iOS - https://github.com/zloirock/core-js/issues/624

  } else if (MessageChannel$1$1 && !engineIsIos$1$1) {
    channel$1$1 = new MessageChannel$1$1();
    port$1$1 = channel$1$1.port2;
    channel$1$1.port1.onmessage = listener$1$1;
    defer$1$1 = functionBindContext$1$1(port$1$1.postMessage, port$1$1); // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global_1$1$1.addEventListener && isCallable$1$1(global_1$1$1.postMessage) && !global_1$1$1.importScripts && $location$1$1 && $location$1$1.protocol !== 'file:' && !fails$1$1(post$1$1)) {
    defer$1$1 = post$1$1;
    global_1$1$1.addEventListener('message', listener$1$1, false); // IE8-
  } else if (ONREADYSTATECHANGE$1$1 in documentCreateElement$1$1('script')) {
    defer$1$1 = function defer(id) {
      html$1$1.appendChild(documentCreateElement$1$1('script'))[ONREADYSTATECHANGE$1$1] = function () {
        html$1$1.removeChild(this);
        run$1$1(id);
      };
    }; // Rest old browsers

  } else {
    defer$1$1 = function defer(id) {
      setTimeout(runner$1$1(id), 0);
    };
  }
}

var task$2$1 = {
  set: set$1$1$1,
  clear: clear$1$1
};
var engineIsIosPebble$1$1 = /ipad|iphone|ipod/i.test(engineUserAgent$1$1) && global_1$1$1.Pebble !== undefined;
var engineIsWebosWebkit$1$1 = /web0s(?!.*chrome)/i.test(engineUserAgent$1$1);
var getOwnPropertyDescriptor$2$1$1 = objectGetOwnPropertyDescriptor$1$1.f;
var macrotask$1$1 = task$2$1.set;
var MutationObserver$1$1 = global_1$1$1.MutationObserver || global_1$1$1.WebKitMutationObserver;
var document$2$1$1 = global_1$1$1.document;
var process$2$1$1 = global_1$1$1.process;
var Promise$1$1$1 = global_1$1$1.Promise; // Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`

var queueMicrotaskDescriptor$1$1 = getOwnPropertyDescriptor$2$1$1(global_1$1$1, 'queueMicrotask');
var queueMicrotask$1$1 = queueMicrotaskDescriptor$1$1 && queueMicrotaskDescriptor$1$1.value;
var flush$1$1, head$1$1, last$1$1, notify$2$1, toggle$1$1, node$1$1, promise$1$1, then$1$1; // modern engines have queueMicrotask method

if (!queueMicrotask$1$1) {
  flush$1$1 = function flush() {
    var parent, fn;
    if (engineIsNode$1$1 && (parent = process$2$1$1.domain)) parent.exit();

    while (head$1$1) {
      fn = head$1$1.fn;
      head$1$1 = head$1$1.next;

      try {
        fn();
      } catch (error) {
        if (head$1$1) notify$2$1();else last$1$1 = undefined;
        throw error;
      }
    }

    last$1$1 = undefined;
    if (parent) parent.enter();
  }; // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898


  if (!engineIsIos$1$1 && !engineIsNode$1$1 && !engineIsWebosWebkit$1$1 && MutationObserver$1$1 && document$2$1$1) {
    toggle$1$1 = true;
    node$1$1 = document$2$1$1.createTextNode('');
    new MutationObserver$1$1(flush$1$1).observe(node$1$1, {
      characterData: true
    });

    notify$2$1 = function notify() {
      node$1$1.data = toggle$1$1 = !toggle$1$1;
    }; // environments with maybe non-completely correct, but existent Promise

  } else if (!engineIsIosPebble$1$1 && Promise$1$1$1 && Promise$1$1$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise$1$1 = Promise$1$1$1.resolve(undefined); // workaround of WebKit ~ iOS Safari 10.1 bug

    promise$1$1.constructor = Promise$1$1$1;
    then$1$1 = functionBindContext$1$1(promise$1$1.then, promise$1$1);

    notify$2$1 = function notify() {
      then$1$1(flush$1$1);
    }; // Node.js without promises

  } else if (engineIsNode$1$1) {
    notify$2$1 = function notify() {
      process$2$1$1.nextTick(flush$1$1);
    }; // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessage
    // - onreadystatechange
    // - setTimeout

  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask$1$1 = functionBindContext$1$1(macrotask$1$1, global_1$1$1);

    notify$2$1 = function notify() {
      macrotask$1$1(flush$1$1);
    };
  }
}

var microtask$1$1 = queueMicrotask$1$1 || function (fn) {
  var task = {
    fn: fn,
    next: undefined
  };
  if (last$1$1) last$1$1.next = task;

  if (!head$1$1) {
    head$1$1 = task;
    notify$2$1();
  }

  last$1$1 = task;
};

var hostReportErrors$1$1 = function hostReportErrors(a, b) {
  var console = global_1$1$1.console;

  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};

var perform$1$1 = function perform(exec) {
  try {
    return {
      error: false,
      value: exec()
    };
  } catch (error) {
    return {
      error: true,
      value: error
    };
  }
};

var Queue$1$1 = function Queue() {
  this.head = null;
  this.tail = null;
};

Queue$1$1.prototype = {
  add: function add(item) {
    var entry = {
      item: item,
      next: null
    };
    if (this.head) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
  },
  get: function get() {
    var entry = this.head;

    if (entry) {
      this.head = entry.next;
      if (this.tail === entry) this.tail = null;
      return entry.item;
    }
  }
};
var queue$1$1$1 = Queue$1$1;
var promiseNativeConstructor$1$1 = global_1$1$1.Promise;
/* global Deno -- Deno case */

var engineIsDeno$1$1 = (typeof Deno === "undefined" ? "undefined" : _typeof(Deno)) == 'object' && Deno && _typeof(Deno.version) == 'object';
var engineIsBrowser$1$1 = !engineIsDeno$1$1 && !engineIsNode$1$1 && (typeof window === "undefined" ? "undefined" : _typeof(window)) == 'object' && (typeof document === "undefined" ? "undefined" : _typeof(document)) == 'object';
var NativePromisePrototype$3$1 = promiseNativeConstructor$1$1 && promiseNativeConstructor$1$1.prototype;
var SPECIES$4$1$1 = wellKnownSymbol$1$1('species');
var SUBCLASSING$1$1 = false;
var NATIVE_PROMISE_REJECTION_EVENT$2$1 = isCallable$1$1(global_1$1$1.PromiseRejectionEvent);
var FORCED_PROMISE_CONSTRUCTOR$6$1 = isForced_1$1$1('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource$1$1(promiseNativeConstructor$1$1);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(promiseNativeConstructor$1$1); // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions

  if (!GLOBAL_CORE_JS_PROMISE && engineV8Version$1$1 === 66) return true; // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679

  if (!engineV8Version$1$1 || engineV8Version$1$1 < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new promiseNativeConstructor$1$1(function (resolve) {
      resolve(1);
    });

    var FakePromise = function FakePromise(exec) {
      exec(function () {
        /* empty */
      }, function () {
        /* empty */
      });
    };

    var constructor = promise.constructor = {};
    constructor[SPECIES$4$1$1] = FakePromise;
    SUBCLASSING$1$1 = promise.then(function () {
      /* empty */
    }) instanceof FakePromise;
    if (!SUBCLASSING$1$1) return true; // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  }

  return !GLOBAL_CORE_JS_PROMISE && (engineIsBrowser$1$1 || engineIsDeno$1$1) && !NATIVE_PROMISE_REJECTION_EVENT$2$1;
});
var promiseConstructorDetection$1$1 = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$6$1,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$2$1,
  SUBCLASSING: SUBCLASSING$1$1
};
var $TypeError$c$1$1 = TypeError;

var PromiseCapability$1$1 = function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw $TypeError$c$1$1('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$1$1(resolve);
  this.reject = aCallable$1$1(reject);
}; // `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability


var f$5$1$1 = function f$5(C) {
  return new PromiseCapability$1$1(C);
};

var newPromiseCapability$2$1 = {
  f: f$5$1$1
};
var task$1$1$1 = task$2$1.set;
var PROMISE$1$1 = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$1$1$1 = promiseConstructorDetection$1$1.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT$1$1$1 = promiseConstructorDetection$1$1.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING$1$1 = promiseConstructorDetection$1$1.SUBCLASSING;
var getInternalPromiseState$1$1 = internalState$1$1.getterFor(PROMISE$1$1);
var setInternalState$4$1 = internalState$1$1.set;
var NativePromisePrototype$1$1$1 = promiseNativeConstructor$1$1 && promiseNativeConstructor$1$1.prototype;
var PromiseConstructor$1$1 = promiseNativeConstructor$1$1;
var PromisePrototype$1$1 = NativePromisePrototype$1$1$1;
var TypeError$2$1$1 = global_1$1$1.TypeError;
var document$3$1$1 = global_1$1$1.document;
var process$3$1$1 = global_1$1$1.process;
var newPromiseCapability$1$1$1 = newPromiseCapability$2$1.f;
var newGenericPromiseCapability$1$1 = newPromiseCapability$1$1$1;
var DISPATCH_EVENT$1$1 = !!(document$3$1$1 && document$3$1$1.createEvent && global_1$1$1.dispatchEvent);
var UNHANDLED_REJECTION$1$1 = 'unhandledrejection';
var REJECTION_HANDLED$1$1 = 'rejectionhandled';
var PENDING$1$1 = 0;
var FULFILLED$1$1 = 1;
var REJECTED$1$1 = 2;
var HANDLED$1$1 = 1;
var UNHANDLED$1$1 = 2;
var Internal$1$1, OwnPromiseCapability$1$1, PromiseWrapper$1$1, nativeThen$1$1; // helpers

var isThenable$1$1 = function isThenable(it) {
  var then;
  return isObject$1$1(it) && isCallable$1$1(then = it.then) ? then : false;
};

var callReaction$1$1 = function callReaction(reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED$1$1;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;

  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED$1$1) onHandleUnhandled$1$1(state);
        state.rejection = HANDLED$1$1;
      }

      if (handler === true) result = value;else {
        if (domain) domain.enter();
        result = handler(value); // can throw

        if (domain) {
          domain.exit();
          exited = true;
        }
      }

      if (result === reaction.promise) {
        reject(TypeError$2$1$1('Promise-chain cycle'));
      } else if (then = isThenable$1$1(result)) {
        functionCall$1$1(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify$1$1$1 = function notify$1(state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask$1$1(function () {
    var reactions = state.reactions;
    var reaction;

    while (reaction = reactions.get()) {
      callReaction$1$1(reaction, state);
    }

    state.notified = false;
    if (isReject && !state.rejection) onUnhandled$1$1(state);
  });
};

var dispatchEvent$1$1 = function dispatchEvent(name, promise, reason) {
  var event, handler;

  if (DISPATCH_EVENT$1$1) {
    event = document$3$1$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global_1$1$1.dispatchEvent(event);
  } else event = {
    promise: promise,
    reason: reason
  };

  if (!NATIVE_PROMISE_REJECTION_EVENT$1$1$1 && (handler = global_1$1$1['on' + name])) handler(event);else if (name === UNHANDLED_REJECTION$1$1) hostReportErrors$1$1('Unhandled promise rejection', reason);
};

var onUnhandled$1$1 = function onUnhandled(state) {
  functionCall$1$1(task$1$1$1, global_1$1$1, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled$1$1(state);
    var result;

    if (IS_UNHANDLED) {
      result = perform$1$1(function () {
        if (engineIsNode$1$1) {
          process$3$1$1.emit('unhandledRejection', value, promise);
        } else dispatchEvent$1$1(UNHANDLED_REJECTION$1$1, promise, value);
      }); // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should

      state.rejection = engineIsNode$1$1 || isUnhandled$1$1(state) ? UNHANDLED$1$1 : HANDLED$1$1;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled$1$1 = function isUnhandled(state) {
  return state.rejection !== HANDLED$1$1 && !state.parent;
};

var onHandleUnhandled$1$1 = function onHandleUnhandled(state) {
  functionCall$1$1(task$1$1$1, global_1$1$1, function () {
    var promise = state.facade;

    if (engineIsNode$1$1) {
      process$3$1$1.emit('rejectionHandled', promise);
    } else dispatchEvent$1$1(REJECTION_HANDLED$1$1, promise, state.value);
  });
};

var bind$1$1$1 = function bind$1(fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject$1$1 = function internalReject(state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED$1$1;
  notify$1$1$1(state, true);
};

var internalResolve$1$1 = function internalResolve(state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;

  try {
    if (state.facade === value) throw TypeError$2$1$1("Promise can't be resolved itself");
    var then = isThenable$1$1(value);

    if (then) {
      microtask$1$1(function () {
        var wrapper = {
          done: false
        };

        try {
          functionCall$1$1(then, value, bind$1$1$1(internalResolve, wrapper, state), bind$1$1$1(internalReject$1$1, wrapper, state));
        } catch (error) {
          internalReject$1$1(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED$1$1;
      notify$1$1$1(state, false);
    }
  } catch (error) {
    internalReject$1$1({
      done: false
    }, error, state);
  }
}; // constructor polyfill


if (FORCED_PROMISE_CONSTRUCTOR$1$1$1) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor$1$1 = function Promise(executor) {
    anInstance$1$1(this, PromisePrototype$1$1);
    aCallable$1$1(executor);
    functionCall$1$1(Internal$1$1, this);
    var state = getInternalPromiseState$1$1(this);

    try {
      executor(bind$1$1$1(internalResolve$1$1, state), bind$1$1$1(internalReject$1$1, state));
    } catch (error) {
      internalReject$1$1(state, error);
    }
  };

  PromisePrototype$1$1 = PromiseConstructor$1$1.prototype; // eslint-disable-next-line no-unused-vars -- required for `.length`

  Internal$1$1 = function Promise(executor) {
    setInternalState$4$1(this, {
      type: PROMISE$1$1,
      done: false,
      notified: false,
      parent: false,
      reactions: new queue$1$1$1(),
      rejection: false,
      state: PENDING$1$1,
      value: undefined
    });
  }; // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then


  Internal$1$1.prototype = defineBuiltIn$1$1(PromisePrototype$1$1, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState$1$1(this);
    var reaction = newPromiseCapability$1$1$1(speciesConstructor$1$1(this, PromiseConstructor$1$1));
    state.parent = true;
    reaction.ok = isCallable$1$1(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable$1$1(onRejected) && onRejected;
    reaction.domain = engineIsNode$1$1 ? process$3$1$1.domain : undefined;
    if (state.state == PENDING$1$1) state.reactions.add(reaction);else microtask$1$1(function () {
      callReaction$1$1(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability$1$1 = function OwnPromiseCapability() {
    var promise = new Internal$1$1();
    var state = getInternalPromiseState$1$1(promise);
    this.promise = promise;
    this.resolve = bind$1$1$1(internalResolve$1$1, state);
    this.reject = bind$1$1$1(internalReject$1$1, state);
  };

  newPromiseCapability$2$1.f = newPromiseCapability$1$1$1 = function newPromiseCapability$1(C) {
    return C === PromiseConstructor$1$1 || C === PromiseWrapper$1$1 ? new OwnPromiseCapability$1$1(C) : newGenericPromiseCapability$1$1(C);
  };

  if (isCallable$1$1(promiseNativeConstructor$1$1) && NativePromisePrototype$1$1$1 !== Object.prototype) {
    nativeThen$1$1 = NativePromisePrototype$1$1$1.then;

    if (!NATIVE_PROMISE_SUBCLASSING$1$1) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn$1$1(NativePromisePrototype$1$1$1, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor$1$1(function (resolve, reject) {
          functionCall$1$1(nativeThen$1$1, that, resolve, reject);
        }).then(onFulfilled, onRejected); // https://github.com/zloirock/core-js/issues/640
      }, {
        unsafe: true
      });
    } // make `.constructor === Promise` work for native promise-based APIs


    try {
      delete NativePromisePrototype$1$1$1.constructor;
    } catch (error) {}
    /* empty */
    // make `instanceof Promise` work for native promise-based APIs


    if (objectSetPrototypeOf$1$1) {
      objectSetPrototypeOf$1$1(NativePromisePrototype$1$1$1, PromisePrototype$1$1);
    }
  }
}

_export$1$1({
  global: true,
  constructor: true,
  wrap: true,
  forced: FORCED_PROMISE_CONSTRUCTOR$1$1$1
}, {
  Promise: PromiseConstructor$1$1
});

setToStringTag$1$1(PromiseConstructor$1$1, PROMISE$1$1, false);
setSpecies$1$1(PROMISE$1$1);
var $TypeError$d$1$1 = TypeError;

var Result$1$1 = function Result(stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype$1$1 = Result$1$1.prototype;

var iterate$1$1 = function iterate(iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = functionBindContext$1$1(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function stop(condition) {
    if (iterator) iteratorClose$1$1(iterator, 'normal', condition);
    return new Result$1$1(true, condition);
  };

  var callFn = function callFn(value) {
    if (AS_ENTRIES) {
      anObject$1$1(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    }

    return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod$1$1(iterable);
    if (!iterFn) throw $TypeError$d$1$1(tryToString$1$1(iterable) + ' is not iterable'); // optimisation for array iterators

    if (isArrayIteratorMethod$1$1(iterFn)) {
      for (index = 0, length = lengthOfArrayLike$1$1(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && objectIsPrototypeOf$1$1(ResultPrototype$1$1, result)) return result;
      }

      return new Result$1$1(false);
    }

    iterator = getIterator$1$1(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;

  while (!(step = functionCall$1$1(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose$1$1(iterator, 'throw', error);
    }

    if (_typeof(result) == 'object' && result && objectIsPrototypeOf$1$1(ResultPrototype$1$1, result)) return result;
  }

  return new Result$1$1(false);
};

var ITERATOR$2$1$1 = wellKnownSymbol$1$1('iterator');
var SAFE_CLOSING$1$1 = false;

try {
  var called$1$1 = 0;
  var iteratorWithReturn$1$1 = {
    next: function next() {
      return {
        done: !!called$1$1++
      };
    },
    'return': function _return() {
      SAFE_CLOSING$1$1 = true;
    }
  };

  iteratorWithReturn$1$1[ITERATOR$2$1$1] = function () {
    return this;
  }; // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing


  Array.from(iteratorWithReturn$1$1, function () {
    throw 2;
  });
} catch (error) {
  /* empty */
}

var checkCorrectnessOfIteration$1$1 = function checkCorrectnessOfIteration(exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING$1$1) return false;
  var ITERATION_SUPPORT = false;

  try {
    var object = {};

    object[ITERATOR$2$1$1] = function () {
      return {
        next: function next() {
          return {
            done: ITERATION_SUPPORT = true
          };
        }
      };
    };

    exec(object);
  } catch (error) {
    /* empty */
  }

  return ITERATION_SUPPORT;
};

var FORCED_PROMISE_CONSTRUCTOR$2$1$1 = promiseConstructorDetection$1$1.CONSTRUCTOR;
var promiseStaticsIncorrectIteration$1$1 = FORCED_PROMISE_CONSTRUCTOR$2$1$1 || !checkCorrectnessOfIteration$1$1(function (iterable) {
  promiseNativeConstructor$1$1.all(iterable).then(undefined, function () {
    /* empty */
  });
}); // https://tc39.es/ecma262/#sec-promise.all

_export$1$1({
  target: 'Promise',
  stat: true,
  forced: promiseStaticsIncorrectIteration$1$1
}, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability$2$1.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$1$1(function () {
      var $promiseResolve = aCallable$1$1(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$1$1(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        functionCall$1$1($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var FORCED_PROMISE_CONSTRUCTOR$3$1$1 = promiseConstructorDetection$1$1.CONSTRUCTOR;
var NativePromisePrototype$2$1$1 = promiseNativeConstructor$1$1 && promiseNativeConstructor$1$1.prototype; // `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch

_export$1$1({
  target: 'Promise',
  proto: true,
  forced: FORCED_PROMISE_CONSTRUCTOR$3$1$1,
  real: true
}, {
  'catch': function _catch(onRejected) {
    return this.then(undefined, onRejected);
  }
}); // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`


if (isCallable$1$1(promiseNativeConstructor$1$1)) {
  var method$1$1 = getBuiltIn$1$1('Promise').prototype['catch'];

  if (NativePromisePrototype$2$1$1['catch'] !== method$1$1) {
    defineBuiltIn$1$1(NativePromisePrototype$2$1$1, 'catch', method$1$1, {
      unsafe: true
    });
  }
} // https://tc39.es/ecma262/#sec-promise.race


_export$1$1({
  target: 'Promise',
  stat: true,
  forced: promiseStaticsIncorrectIteration$1$1
}, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability$2$1.f(C);
    var reject = capability.reject;
    var result = perform$1$1(function () {
      var $promiseResolve = aCallable$1$1(C.resolve);
      iterate$1$1(iterable, function (promise) {
        functionCall$1$1($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var FORCED_PROMISE_CONSTRUCTOR$4$1$1 = promiseConstructorDetection$1$1.CONSTRUCTOR; // `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject

_export$1$1({
  target: 'Promise',
  stat: true,
  forced: FORCED_PROMISE_CONSTRUCTOR$4$1$1
}, {
  reject: function reject(r) {
    var capability = newPromiseCapability$2$1.f(this);
    functionCall$1$1(capability.reject, undefined, r);
    return capability.promise;
  }
});

var promiseResolve$1$1 = function promiseResolve(C, x) {
  anObject$1$1(C);
  if (isObject$1$1(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability$2$1.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var FORCED_PROMISE_CONSTRUCTOR$5$1$1 = promiseConstructorDetection$1$1.CONSTRUCTOR;
var PromiseConstructorWrapper$1$1 = getBuiltIn$1$1('Promise'); // https://tc39.es/ecma262/#sec-promise.resolve

_export$1$1({
  target: 'Promise',
  stat: true,
  forced: FORCED_PROMISE_CONSTRUCTOR$5$1$1
}, {
  resolve: function resolve(x) {
    return promiseResolve$1$1(this, x);
  }
});

var FetchHandlerStatusCode;
/**
 * fetch handler
 *
 * statusCode
 * -1 = fetch error
 * -2 = read stream error
 * -3 = parse json error
 * -10 = timeout
 * @param input
 * @param requestInit
 * @param timeout in millisecond
 */

(function (FetchHandlerStatusCode) {
  FetchHandlerStatusCode[FetchHandlerStatusCode["FetchError"] = -1] = "FetchError";
  FetchHandlerStatusCode[FetchHandlerStatusCode["ReadTextError"] = -2] = "ReadTextError";
  FetchHandlerStatusCode[FetchHandlerStatusCode["JsonParseError"] = -3] = "JsonParseError";
  FetchHandlerStatusCode[FetchHandlerStatusCode["TimeoutError"] = -10] = "TimeoutError";
})(FetchHandlerStatusCode || (FetchHandlerStatusCode = {}));

var fetchHandler = function fetchHandler(input, requestInit, timeout) {
  return new Promise(function (resolve) {
    var timer = setTimeout(function () {
      resolve({
        error: new Error("".concat(input, ": request timeout")),
        statusCode: FetchHandlerStatusCode.TimeoutError,
        success: false
      });
    }, timeout);
    fetch(input, requestInit).then(function (response) {
      // cancel timer
      clearTimeout(timer);
      response.text() // transform to json object
      .then(function (raw) {
        try {
          // consider http status 5xx to error
          if (response.status >= 500) {
            resolve({
              error: new Error(raw),
              statusCode: response.status,
              success: response.ok
            });
          }

          resolve({
            data: JSON.parse(raw),
            statusCode: response.status,
            success: response.ok
          });
        } catch (error) {
          if (error instanceof SyntaxError || error instanceof TypeError) {
            error.message = "".concat(error, ";\n response: ").concat(raw, ";\n statusCode: ").concat(response.status);
            resolve({
              error: error,
              statusCode: FetchHandlerStatusCode.JsonParseError,
              success: false
            });
          }

          throw error;
        }
      }) // handle general error
      .catch(function (error) {
        return resolve({
          error: error,
          statusCode: FetchHandlerStatusCode.ReadTextError,
          success: false
        });
      });
    }) // handle fetch error
    .catch(function (error) {
      // cancel timer
      clearTimeout(timer);
      resolve({
        error: error,
        statusCode: FetchHandlerStatusCode.FetchError,
        success: false
      });
    });
  });
};

var $forEach$1$1 = arrayIteration$1.forEach;
var STRICT_METHOD$2$1 = arrayMethodIsStrict$1('forEach'); // `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach

var arrayForEach$1 = !STRICT_METHOD$2$1 ? function forEach(callbackfn
/* , thisArg */
) {
  return $forEach$1$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined); // eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach; // https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe

_export$1({
  target: 'Array',
  proto: true,
  forced: [].forEach != arrayForEach$1
}, {
  forEach: arrayForEach$1
});

var $TypeError$g$1 = TypeError;

var deletePropertyOrThrow$1 = function deletePropertyOrThrow(O, P) {
  if (!delete O[P]) throw $TypeError$g$1('Cannot delete property ' + tryToString$1(P) + ' of ' + tryToString$1(O));
};

var floor$3$1 = Math.floor;

var mergeSort$1 = function mergeSort(array, comparefn) {
  var length = array.length;
  var middle = floor$3$1(length / 2);
  return length < 8 ? insertionSort$1(array, comparefn) : merge$1(array, mergeSort(arraySliceSimple$1(array, 0, middle), comparefn), mergeSort(arraySliceSimple$1(array, middle), comparefn), comparefn);
};

var insertionSort$1 = function insertionSort(array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];

    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }

    if (j !== i++) array[j] = element;
  }

  return array;
};

var merge$1 = function merge(array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
  }

  return array;
};

var arraySort$1 = mergeSort$1;
var firefox$1 = engineUserAgent$1.match(/firefox\/(\d+)/i);
var engineFfVersion$1 = !!firefox$1 && +firefox$1[1];
var engineIsIeOrEdge$1 = /MSIE|Trident/.test(engineUserAgent$1);
var webkit$1 = engineUserAgent$1.match(/AppleWebKit\/(\d+)\./);
var engineWebkitVersion$1 = !!webkit$1 && +webkit$1[1];
var test$2$1 = [];
var nativeSort$1 = functionUncurryThis$1(test$2$1.sort);
var push$6$1 = functionUncurryThis$1(test$2$1.push); // IE8-

var FAILS_ON_UNDEFINED$1 = fails$1(function () {
  test$2$1.sort(undefined);
}); // V8 bug

var FAILS_ON_NULL$1 = fails$1(function () {
  test$2$1.sort(null);
}); // Old WebKit

var STRICT_METHOD$3$1 = arrayMethodIsStrict$1('sort');
var STABLE_SORT$1 = !fails$1(function () {
  // feature detection can be too slow, so check engines versions
  if (engineV8Version$1) return engineV8Version$1 < 70;
  if (engineFfVersion$1 && engineFfVersion$1 > 3) return;
  if (engineIsIeOrEdge$1) return true;
  if (engineWebkitVersion$1) return engineWebkitVersion$1 < 603;
  var result = '';
  var code, chr, value, index; // generate an array with more 512 elements (Chakra and old V8 fails only in this case)

  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66:
      case 69:
      case 70:
      case 72:
        value = 3;
        break;

      case 68:
      case 71:
        value = 4;
        break;

      default:
        value = 2;
    }

    for (index = 0; index < 47; index++) {
      test$2$1.push({
        k: chr + index,
        v: value
      });
    }
  }

  test$2$1.sort(function (a, b) {
    return b.v - a.v;
  });

  for (index = 0; index < test$2$1.length; index++) {
    chr = test$2$1[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});
var FORCED$4$1 = FAILS_ON_UNDEFINED$1 || !FAILS_ON_NULL$1 || !STRICT_METHOD$3$1 || !STABLE_SORT$1;

var getSortCompare$1 = function getSortCompare(comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString_1$1(x) > toString_1$1(y) ? 1 : -1;
  };
}; // `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort


_export$1({
  target: 'Array',
  proto: true,
  forced: FORCED$4$1
}, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable$1(comparefn);
    var array = toObject$1(this);
    if (STABLE_SORT$1) return comparefn === undefined ? nativeSort$1(array) : nativeSort$1(array, comparefn);
    var items = [];
    var arrayLength = lengthOfArrayLike$1(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push$6$1(items, array[index]);
    }

    arraySort$1(items, getSortCompare$1(comparefn));
    itemsLength = lengthOfArrayLike$1(items);
    index = 0;

    while (index < itemsLength) {
      array[index] = items[index++];
    }

    while (index < arrayLength) {
      deletePropertyOrThrow$1(array, index++);
    }

    return array;
  }
});

var $TypeError$h$1 = TypeError; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

var getOwnPropertyDescriptor$4$1 = Object.getOwnPropertyDescriptor; // Safari < 13 does not throw an error in this case

var SILENT_ON_NON_WRITABLE_LENGTH_SET$1 = descriptors$1 && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;

  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', {
      writable: false
    }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();
var arraySetLength$1 = SILENT_ON_NON_WRITABLE_LENGTH_SET$1 ? function (O, length) {
  if (isArray$1(O) && !getOwnPropertyDescriptor$4$1(O, 'length').writable) {
    throw $TypeError$h$1('Cannot set read only .length');
  }

  return O.length = length;
} : function (O, length) {
  return O.length = length;
};
var HAS_SPECIES_SUPPORT$1$1 = arrayMethodHasSpeciesSupport$1('splice');
var max$5$1 = Math.max;
var min$5$1 = Math.min; // `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species

_export$1({
  target: 'Array',
  proto: true,
  forced: !HAS_SPECIES_SUPPORT$1$1
}, {
  splice: function splice(start, deleteCount
  /* , ...items */
  ) {
    var O = toObject$1(this);
    var len = lengthOfArrayLike$1(O);
    var actualStart = toAbsoluteIndex$1(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;

    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min$5$1(max$5$1(toIntegerOrInfinity$1(deleteCount), 0), len - actualStart);
    }

    doesNotExceedSafeInteger$1(len + insertCount - actualDeleteCount);
    A = arraySpeciesCreate$1(O, actualDeleteCount);

    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty$1(A, k, O[from]);
    }

    A.length = actualDeleteCount;

    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];else deletePropertyOrThrow$1(O, to);
      }

      for (k = len; k > len - actualDeleteCount + insertCount; k--) {
        deletePropertyOrThrow$1(O, k - 1);
      }
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];else deletePropertyOrThrow$1(O, to);
      }
    }

    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }

    arraySetLength$1(O, len - actualDeleteCount + insertCount);
    return A;
  }
});

var FORCED$5$1 = fails$1(function () {
  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({
    toISOString: function toISOString() {
      return 1;
    }
  }) !== 1;
}); // `Date.prototype.toJSON` method
// https://tc39.es/ecma262/#sec-date.prototype.tojson

_export$1({
  target: 'Date',
  proto: true,
  arity: 1,
  forced: FORCED$5$1
}, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  toJSON: function toJSON(key) {
    var O = toObject$1(this);
    var pv = toPrimitive$1(O, 'number');
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});

var $assign$1 = Object.assign; // eslint-disable-next-line es/no-object-defineproperty -- required for testing

var defineProperty$8$1 = Object.defineProperty;
var concat$3$1 = functionUncurryThis$1([].concat); // `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign

var objectAssign$1 = !$assign$1 || fails$1(function () {
  // should have correct order of operations (Edge bug)
  if (descriptors$1 && $assign$1({
    b: 1
  }, $assign$1(defineProperty$8$1({}, 'a', {
    enumerable: true,
    get: function get() {
      defineProperty$8$1(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), {
    b: 2
  })).b !== 1) return true; // should work with symbols and should have deterministic property order (V8 bug)

  var A = {};
  var B = {}; // eslint-disable-next-line es/no-symbol -- safe

  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) {
    B[chr] = chr;
  });
  return $assign$1({}, A)[symbol] != 7 || objectKeys$1($assign$1({}, B)).join('') != alphabet;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$1(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = objectGetOwnPropertySymbols$1.f;
  var propertyIsEnumerable = objectPropertyIsEnumerable$1.f;

  while (argumentsLength > index) {
    var S = indexedObject$1(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$3$1(objectKeys$1(S), getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;

    while (length > j) {
      key = keys[j++];
      if (!descriptors$1 || functionCall$1(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  }

  return T;
} : $assign$1; // https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing

_export$1({
  target: 'Object',
  stat: true,
  arity: 2,
  forced: Object.assign !== objectAssign$1
}, {
  assign: objectAssign$1
});

var FAILS_ON_PRIMITIVES$2$1 = fails$1(function () {
  objectGetPrototypeOf$1(1);
}); // `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof

_export$1({
  target: 'Object',
  stat: true,
  forced: FAILS_ON_PRIMITIVES$2$1,
  sham: !correctPrototypeGetter$1
}, {
  getPrototypeOf: function getPrototypeOf(it) {
    return objectGetPrototypeOf$1(toObject$1(it));
  }
});

var FAILS_ON_PRIMITIVES$3$1 = fails$1(function () {
  objectKeys$1(1);
}); // `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys

_export$1({
  target: 'Object',
  stat: true,
  forced: FAILS_ON_PRIMITIVES$3$1
}, {
  keys: function keys(it) {
    return objectKeys$1(toObject$1(it));
  }
}); // `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe


var sameValue$1 = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

fixRegexpWellKnownSymbolLogic$1('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [// `String.prototype.search` method
  // https://tc39.es/ecma262/#sec-string.prototype.search
  function search(regexp) {
    var O = requireObjectCoercible$1(this);
    var searcher = isNullOrUndefined$1(regexp) ? undefined : getMethod$1(regexp, SEARCH);
    return searcher ? functionCall$1(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString_1$1(O));
  }, // `RegExp.prototype[@@search]` method
  // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
  function (string) {
    var rx = anObject$1(this);
    var S = toString_1$1(string);
    var res = maybeCallNative(nativeSearch, rx, S);
    if (res.done) return res.value;
    var previousLastIndex = rx.lastIndex;
    if (!sameValue$1(previousLastIndex, 0)) rx.lastIndex = 0;
    var result = regexpExecAbstract$1(rx, S);
    if (!sameValue$1(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
    return result === null ? -1 : result.index;
  }];
});

var handlePrototype$1$1 = function handlePrototype$1(CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== arrayForEach$1) try {
    createNonEnumerableProperty$1(CollectionPrototype, 'forEach', arrayForEach$1);
  } catch (error) {
    CollectionPrototype.forEach = arrayForEach$1;
  }
};

for (var COLLECTION_NAME$1$1 in domIterables$1) {
  if (domIterables$1[COLLECTION_NAME$1$1]) {
    handlePrototype$1$1(global_1$1[COLLECTION_NAME$1$1] && global_1$1[COLLECTION_NAME$1$1].prototype);
  }
}

handlePrototype$1$1(domTokenListPrototype$1);
var ITERATOR$7$1 = wellKnownSymbol$1('iterator');
var urlConstructorDetection$1 = !fails$1(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return isPure$1 && !url.toJSON || !searchParams.sort || url.href !== 'http://a/c%20d?a=1&c=3' || searchParams.get('c') !== '3' || String(new URLSearchParams('?a=1')) !== 'a=1' || !searchParams[ITERATOR$7$1] // throws in Edge
  || new URL('https://a@b').username !== 'a' || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b' // not punycoded in Edge
  || new URL('http://тест').host !== 'xn--e1aybc' // not escaped in Chrome 62-
  || new URL('http://a#б').hash !== '#%D0%B1' // fails in Chrome 66-
  || result !== 'a1c3' // throws in Safari
  || new URL('http://x', undefined).host !== 'x';
});

var defineBuiltInAccessor$1 = function defineBuiltInAccessor(target, name, descriptor) {
  if (descriptor.get) makeBuiltIn_1$1(descriptor.get, name, {
    getter: true
  });
  if (descriptor.set) makeBuiltIn_1$1(descriptor.set, name, {
    setter: true
  });
  return objectDefineProperty$1.f(target, name, descriptor);
};

var maxInt$1 = 2147483647; // aka. 0x7FFFFFFF or 2^31-1

var base$1 = 36;
var tMin$1 = 1;
var tMax$1 = 26;
var skew$1 = 38;
var damp$1 = 700;
var initialBias$1 = 72;
var initialN$1 = 128; // 0x80

var delimiter$1 = '-'; // '\x2D'

var regexNonASCII$1 = /[^\0-\u007E]/; // non-ASCII chars

var regexSeparators$1 = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators

var OVERFLOW_ERROR$1 = 'Overflow: input needs wider integers to process';
var baseMinusTMin$1 = base$1 - tMin$1;
var $RangeError$1 = RangeError;
var exec$4$1 = functionUncurryThis$1(regexSeparators$1.exec);
var floor$4$1 = Math.floor;
var fromCharCode$1 = String.fromCharCode;
var charCodeAt$2$1 = functionUncurryThis$1(''.charCodeAt);
var join$3 = functionUncurryThis$1([].join);
var push$7$1 = functionUncurryThis$1([].push);
var replace$4$1 = functionUncurryThis$1(''.replace);
var split$2$1 = functionUncurryThis$1(''.split);
var toLowerCase$2 = functionUncurryThis$1(''.toLowerCase);
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */

var ucs2decode$1 = function ucs2decode(string) {
  var output = [];
  var counter = 0;
  var length = string.length;

  while (counter < length) {
    var value = charCodeAt$2$1(string, counter++);

    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = charCodeAt$2$1(string, counter++);

      if ((extra & 0xFC00) == 0xDC00) {
        // Low surrogate.
        push$7$1(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        push$7$1(output, value);
        counter--;
      }
    } else {
      push$7$1(output, value);
    }
  }

  return output;
};
/**
 * Converts a digit/integer into a basic code point.
 */


var digitToBasic$1 = function digitToBasic(digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */


var adapt$1 = function adapt(delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor$4$1(delta / damp$1) : delta >> 1;
  delta += floor$4$1(delta / numPoints);

  while (delta > baseMinusTMin$1 * tMax$1 >> 1) {
    delta = floor$4$1(delta / baseMinusTMin$1);
    k += base$1;
  }

  return floor$4$1(k + (baseMinusTMin$1 + 1) * delta / (delta + skew$1));
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */


var encode$1 = function encode(input) {
  var output = []; // Convert the input in UCS-2 to an array of Unicode code points.

  input = ucs2decode$1(input); // Cache the length.

  var inputLength = input.length; // Initialize the state.

  var n = initialN$1;
  var delta = 0;
  var bias = initialBias$1;
  var i, currentValue; // Handle the basic code points.

  for (i = 0; i < input.length; i++) {
    currentValue = input[i];

    if (currentValue < 0x80) {
      push$7$1(output, fromCharCode$1(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.

  var handledCPCount = basicLength; // number of code points that have been handled;
  // Finish the basic string with a delimiter unless it's empty.

  if (basicLength) {
    push$7$1(output, delimiter$1);
  } // Main encoding loop:


  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt$1;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];

      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    } // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.


    var handledCPCountPlusOne = handledCPCount + 1;

    if (m - n > floor$4$1((maxInt$1 - delta) / handledCPCountPlusOne)) {
      throw $RangeError$1(OVERFLOW_ERROR$1);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];

      if (currentValue < n && ++delta > maxInt$1) {
        throw $RangeError$1(OVERFLOW_ERROR$1);
      }

      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        var k = base$1;

        while (true) {
          var t = k <= bias ? tMin$1 : k >= bias + tMax$1 ? tMax$1 : k - bias;
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base$1 - t;
          push$7$1(output, fromCharCode$1(digitToBasic$1(t + qMinusT % baseMinusT)));
          q = floor$4$1(qMinusT / baseMinusT);
          k += base$1;
        }

        push$7$1(output, fromCharCode$1(digitToBasic$1(q)));
        bias = adapt$1(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        handledCPCount++;
      }
    }

    delta++;
    n++;
  }

  return join$3(output, '');
};

var stringPunycodeToAscii$1 = function stringPunycodeToAscii(input) {
  var encoded = [];
  var labels = split$2$1(replace$4$1(toLowerCase$2(input), regexSeparators$1, "."), '.');
  var i, label;

  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    push$7$1(encoded, exec$4$1(regexNonASCII$1, label) ? 'xn--' + encode$1(label) : label);
  }

  return join$3(encoded, '.');
};

var defineBuiltIns$1 = function defineBuiltIns(target, src, options) {
  for (var key in src) {
    defineBuiltIn$1(target, key, src[key], options);
  }

  return target;
};

var ITERATOR$8$1 = wellKnownSymbol$1('iterator');
var URL_SEARCH_PARAMS$1 = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR$1 = URL_SEARCH_PARAMS$1 + 'Iterator';
var setInternalState$5$1 = internalState$1.set;
var getInternalParamsState$1 = internalState$1.getterFor(URL_SEARCH_PARAMS$1);
var getInternalIteratorState$1 = internalState$1.getterFor(URL_SEARCH_PARAMS_ITERATOR$1); // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

var getOwnPropertyDescriptor$5$1 = Object.getOwnPropertyDescriptor; // Avoid NodeJS experimental warning

var safeGetBuiltIn$1 = function safeGetBuiltIn(name) {
  if (!descriptors$1) return global_1$1[name];
  var descriptor = getOwnPropertyDescriptor$5$1(global_1$1, name);
  return descriptor && descriptor.value;
};

var nativeFetch$1 = safeGetBuiltIn$1('fetch');
var NativeRequest$1 = safeGetBuiltIn$1('Request');
var Headers$1 = safeGetBuiltIn$1('Headers');
var RequestPrototype$1 = NativeRequest$1 && NativeRequest$1.prototype;
var HeadersPrototype$1 = Headers$1 && Headers$1.prototype;
var RegExp$1$1 = global_1$1.RegExp;
var TypeError$4$1 = global_1$1.TypeError;
var decodeURIComponent$1 = global_1$1.decodeURIComponent;
var encodeURIComponent$1$1 = global_1$1.encodeURIComponent;
var charAt$6$1 = functionUncurryThis$1(''.charAt);
var join$1$1 = functionUncurryThis$1([].join);
var push$8$1 = functionUncurryThis$1([].push);
var replace$5$1 = functionUncurryThis$1(''.replace);
var shift$2 = functionUncurryThis$1([].shift);
var splice$2 = functionUncurryThis$1([].splice);
var split$3$1 = functionUncurryThis$1(''.split);
var stringSlice$8$1 = functionUncurryThis$1(''.slice);
var plus$1 = /\+/g;
var sequences$1 = Array(4);

var percentSequence$1 = function percentSequence(bytes) {
  return sequences$1[bytes - 1] || (sequences$1[bytes - 1] = RegExp$1$1('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode$1 = function percentDecode(sequence) {
  try {
    return decodeURIComponent$1(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize$1 = function deserialize(it) {
  var result = replace$5$1(it, plus$1, ' ');
  var bytes = 4;

  try {
    return decodeURIComponent$1(result);
  } catch (error) {
    while (bytes) {
      result = replace$5$1(result, percentSequence$1(bytes--), percentDecode$1);
    }

    return result;
  }
};

var find$2 = /[!'()~]|%20/g;
var replacements$1 = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer$1 = function replacer(match) {
  return replacements$1[match];
};

var _serialize2 = function serialize(it) {
  return replace$5$1(encodeURIComponent$1$1(it), find$2, replacer$1);
};

var URLSearchParamsIterator$1 = iteratorCreateConstructor$1(function Iterator(params, kind) {
  setInternalState$5$1(this, {
    type: URL_SEARCH_PARAMS_ITERATOR$1,
    iterator: getIterator$1(getInternalParamsState$1(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState$1(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;

  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  }

  return step;
}, true);

var URLSearchParamsState$1 = function URLSearchParamsState(init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject$1(init)) this.parseObject(init);else this.parseQuery(typeof init == 'string' ? charAt$6$1(init, 0) === '?' ? stringSlice$8$1(init, 1) : init : toString_1$1(init));
  }
};

URLSearchParamsState$1.prototype = {
  type: URL_SEARCH_PARAMS$1,
  bindURL: function bindURL(url) {
    this.url = url;
    this.update();
  },
  parseObject: function parseObject(object) {
    var iteratorMethod = getIteratorMethod$1(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator$1(object, iteratorMethod);
      next = iterator.next;

      while (!(step = functionCall$1(next, iterator)).done) {
        entryIterator = getIterator$1(anObject$1(step.value));
        entryNext = entryIterator.next;
        if ((first = functionCall$1(entryNext, entryIterator)).done || (second = functionCall$1(entryNext, entryIterator)).done || !functionCall$1(entryNext, entryIterator).done) throw TypeError$4$1('Expected sequence with length 2');
        push$8$1(this.entries, {
          key: toString_1$1(first.value),
          value: toString_1$1(second.value)
        });
      }
    } else for (var key in object) {
      if (hasOwnProperty_1$1(object, key)) {
        push$8$1(this.entries, {
          key: key,
          value: toString_1$1(object[key])
        });
      }
    }
  },
  parseQuery: function parseQuery(query) {
    if (query) {
      var attributes = split$3$1(query, '&');
      var index = 0;
      var attribute, entry;

      while (index < attributes.length) {
        attribute = attributes[index++];

        if (attribute.length) {
          entry = split$3$1(attribute, '=');
          push$8$1(this.entries, {
            key: deserialize$1(shift$2(entry)),
            value: deserialize$1(join$1$1(entry, '='))
          });
        }
      }
    }
  },
  serialize: function serialize() {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;

    while (index < entries.length) {
      entry = entries[index++];
      push$8$1(result, _serialize2(entry.key) + '=' + _serialize2(entry.value));
    }

    return join$1$1(result, '&');
  },
  update: function update() {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function updateURL() {
    if (this.url) this.url.update();
  }
}; // `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams

var URLSearchParamsConstructor$1 = function URLSearchParams()
/* init */
{
  anInstance$1(this, URLSearchParamsPrototype$1);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  setInternalState$5$1(this, new URLSearchParamsState$1(init));
};

var URLSearchParamsPrototype$1 = URLSearchParamsConstructor$1.prototype;
defineBuiltIns$1(URLSearchParamsPrototype$1, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength$1(arguments.length, 2);
    var state = getInternalParamsState$1(this);
    push$8$1(state.entries, {
      key: toString_1$1(name),
      value: toString_1$1(value)
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function _delete(name) {
    validateArgumentsLength$1(arguments.length, 1);
    var state = getInternalParamsState$1(this);
    var entries = state.entries;
    var key = toString_1$1(name);
    var index = 0;

    while (index < entries.length) {
      if (entries[index].key === key) splice$2(entries, index, 1);else index++;
    }

    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength$1(arguments.length, 1);
    var entries = getInternalParamsState$1(this).entries;
    var key = toString_1$1(name);
    var index = 0;

    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }

    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength$1(arguments.length, 1);
    var entries = getInternalParamsState$1(this).entries;
    var key = toString_1$1(name);
    var result = [];
    var index = 0;

    for (; index < entries.length; index++) {
      if (entries[index].key === key) push$8$1(result, entries[index].value);
    }

    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength$1(arguments.length, 1);
    var entries = getInternalParamsState$1(this).entries;
    var key = toString_1$1(name);
    var index = 0;

    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }

    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength$1(arguments.length, 1);
    var state = getInternalParamsState$1(this);
    var entries = state.entries;
    var found = false;
    var key = toString_1$1(name);
    var val = toString_1$1(value);
    var index = 0;
    var entry;

    for (; index < entries.length; index++) {
      entry = entries[index];

      if (entry.key === key) {
        if (found) splice$2(entries, index--, 1);else {
          found = true;
          entry.value = val;
        }
      }
    }

    if (!found) push$8$1(entries, {
      key: key,
      value: val
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState$1(this);
    arraySort$1(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback
  /* , thisArg */
  ) {
    var entries = getInternalParamsState$1(this).entries;
    var boundFunction = functionBindContext$1(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;

    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator$1(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator$1(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator$1(this, 'entries');
  }
}, {
  enumerable: true
}); // `URLSearchParams.prototype[@@iterator]` method

defineBuiltIn$1(URLSearchParamsPrototype$1, ITERATOR$8$1, URLSearchParamsPrototype$1.entries, {
  name: 'entries'
}); // `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior

defineBuiltIn$1(URLSearchParamsPrototype$1, 'toString', function toString() {
  return getInternalParamsState$1(this).serialize();
}, {
  enumerable: true
});
setToStringTag$1(URLSearchParamsConstructor$1, URL_SEARCH_PARAMS$1);

_export$1({
  global: true,
  constructor: true,
  forced: !urlConstructorDetection$1
}, {
  URLSearchParams: URLSearchParamsConstructor$1
}); // Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`


if (!urlConstructorDetection$1 && isCallable$1(Headers$1)) {
  var headersHas$1 = functionUncurryThis$1(HeadersPrototype$1.has);
  var headersSet$1 = functionUncurryThis$1(HeadersPrototype$1.set);

  var wrapRequestOptions$1 = function wrapRequestOptions(init) {
    if (isObject$1(init)) {
      var body = init.body;
      var headers;

      if (classof$1(body) === URL_SEARCH_PARAMS$1) {
        headers = init.headers ? new Headers$1(init.headers) : new Headers$1();

        if (!headersHas$1(headers, 'content-type')) {
          headersSet$1(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }

        return objectCreate$1(init, {
          body: createPropertyDescriptor$1(0, toString_1$1(body)),
          headers: createPropertyDescriptor$1(0, headers)
        });
      }
    }

    return init;
  };

  if (isCallable$1(nativeFetch$1)) {
    _export$1({
      global: true,
      enumerable: true,
      dontCallGetSet: true,
      forced: true
    }, {
      fetch: function fetch(input
      /* , init */
      ) {
        return nativeFetch$1(input, arguments.length > 1 ? wrapRequestOptions$1(arguments[1]) : {});
      }
    });
  }

  if (isCallable$1(NativeRequest$1)) {
    var RequestConstructor$1 = function Request(input
    /* , init */
    ) {
      anInstance$1(this, RequestPrototype$1);
      return new NativeRequest$1(input, arguments.length > 1 ? wrapRequestOptions$1(arguments[1]) : {});
    };

    RequestPrototype$1.constructor = RequestConstructor$1;
    RequestConstructor$1.prototype = RequestPrototype$1;

    _export$1({
      global: true,
      constructor: true,
      dontCallGetSet: true,
      forced: true
    }, {
      Request: RequestConstructor$1
    });
  }
}

var web_urlSearchParams_constructor$1 = {
  URLSearchParams: URLSearchParamsConstructor$1,
  getState: getInternalParamsState$1
};
var codeAt$1 = stringMultibyte$1.codeAt;
var setInternalState$6$1 = internalState$1.set;
var getInternalURLState$1 = internalState$1.getterFor('URL');
var URLSearchParams$1$1 = web_urlSearchParams_constructor$1.URLSearchParams;
var getInternalSearchParamsState$1 = web_urlSearchParams_constructor$1.getState;
var NativeURL$1 = global_1$1.URL;
var TypeError$5$1 = global_1$1.TypeError;
var parseInt$2 = global_1$1.parseInt;
var floor$5$1 = Math.floor;
var pow$1 = Math.pow;
var charAt$7$1 = functionUncurryThis$1(''.charAt);
var exec$5$1 = functionUncurryThis$1(/./.exec);
var join$2$1 = functionUncurryThis$1([].join);
var numberToString$1$1 = functionUncurryThis$1(1.0.toString);
var pop$1 = functionUncurryThis$1([].pop);
var push$9$1 = functionUncurryThis$1([].push);
var replace$6$1 = functionUncurryThis$1(''.replace);
var shift$1$1 = functionUncurryThis$1([].shift);
var split$4$1 = functionUncurryThis$1(''.split);
var stringSlice$9$1 = functionUncurryThis$1(''.slice);
var toLowerCase$1$1 = functionUncurryThis$1(''.toLowerCase);
var unshift$1 = functionUncurryThis$1([].unshift);
var INVALID_AUTHORITY$1 = 'Invalid authority';
var INVALID_SCHEME$1 = 'Invalid scheme';
var INVALID_HOST$1 = 'Invalid host';
var INVALID_PORT$1 = 'Invalid port';
var ALPHA$1 = /[a-z]/i; // eslint-disable-next-line regexp/no-obscure-range -- safe

var ALPHANUMERIC$1 = /[\d+-.a-z]/i;
var DIGIT$1 = /\d/;
var HEX_START$1 = /^0x/i;
var OCT$1 = /^[0-7]+$/;
var DEC$1 = /^\d+$/;
var HEX$1 = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */

var FORBIDDEN_HOST_CODE_POINT$1 = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT$1 = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE$1 = /^[\u0000-\u0020]+|[\u0000-\u0020]+$/g;
var TAB_AND_NEW_LINE$1 = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */

var EOF$1; // https://url.spec.whatwg.org/#ipv4-number-parser

var parseIPv4$1 = function parseIPv4(input) {
  var parts = split$4$1(input, '.');
  var partsLength, numbers, index, part, radix, number, ipv4;

  if (parts.length && parts[parts.length - 1] == '') {
    parts.length--;
  }

  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];

  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;

    if (part.length > 1 && charAt$7$1(part, 0) == '0') {
      radix = exec$5$1(HEX_START$1, part) ? 16 : 8;
      part = stringSlice$9$1(part, radix == 8 ? 1 : 2);
    }

    if (part === '') {
      number = 0;
    } else {
      if (!exec$5$1(radix == 10 ? DEC$1 : radix == 8 ? OCT$1 : HEX$1, part)) return input;
      number = parseInt$2(part, radix);
    }

    push$9$1(numbers, number);
  }

  for (index = 0; index < partsLength; index++) {
    number = numbers[index];

    if (index == partsLength - 1) {
      if (number >= pow$1(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }

  ipv4 = pop$1(numbers);

  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow$1(256, 3 - index);
  }

  return ipv4;
}; // https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO


var parseIPv6$1 = function parseIPv6(input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function chr() {
    return charAt$7$1(input, pointer);
  };

  if (chr() == ':') {
    if (charAt$7$1(input, 1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }

  while (chr()) {
    if (pieceIndex == 8) return;

    if (chr() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }

    value = length = 0;

    while (length < 4 && exec$5$1(HEX$1, chr())) {
      value = value * 16 + parseInt$2(chr(), 16);
      pointer++;
      length++;
    }

    if (chr() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;

      while (chr()) {
        ipv4Piece = null;

        if (numbersSeen > 0) {
          if (chr() == '.' && numbersSeen < 4) pointer++;else return;
        }

        if (!exec$5$1(DIGIT$1, chr())) return;

        while (exec$5$1(DIGIT$1, chr())) {
          number = parseInt$2(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;else if (ipv4Piece == 0) return;else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }

        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }

      if (numbersSeen != 4) return;
      break;
    } else if (chr() == ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;

    address[pieceIndex++] = value;
  }

  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;

    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;

  return address;
};

var findLongestZeroSequence$1 = function findLongestZeroSequence(ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;

  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }

      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }

  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }

  return maxIndex;
}; // https://url.spec.whatwg.org/#host-serializing


var serializeHost$1 = function serializeHost(host) {
  var result, index, compress, ignore0; // ipv4

  if (typeof host == 'number') {
    result = [];

    for (index = 0; index < 4; index++) {
      unshift$1(result, host % 256);
      host = floor$5$1(host / 256);
    }

    return join$2$1(result, '.'); // ipv6
  } else if (_typeof$1(host) == 'object') {
    result = '';
    compress = findLongestZeroSequence$1(host);

    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;

      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += numberToString$1$1(host[index], 16);
        if (index < 7) result += ':';
      }
    }

    return '[' + result + ']';
  }

  return host;
};

var C0ControlPercentEncodeSet$1 = {};
var fragmentPercentEncodeSet$1 = objectAssign$1({}, C0ControlPercentEncodeSet$1, {
  ' ': 1,
  '"': 1,
  '<': 1,
  '>': 1,
  '`': 1
});
var pathPercentEncodeSet$1 = objectAssign$1({}, fragmentPercentEncodeSet$1, {
  '#': 1,
  '?': 1,
  '{': 1,
  '}': 1
});
var userinfoPercentEncodeSet$1 = objectAssign$1({}, pathPercentEncodeSet$1, {
  '/': 1,
  ':': 1,
  ';': 1,
  '=': 1,
  '@': 1,
  '[': 1,
  '\\': 1,
  ']': 1,
  '^': 1,
  '|': 1
});

var percentEncode$1 = function percentEncode(chr, set) {
  var code = codeAt$1(chr, 0);
  return code > 0x20 && code < 0x7F && !hasOwnProperty_1$1(set, chr) ? chr : encodeURIComponent(chr);
}; // https://url.spec.whatwg.org/#special-scheme


var specialSchemes$1 = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
}; // https://url.spec.whatwg.org/#windows-drive-letter

var isWindowsDriveLetter$1 = function isWindowsDriveLetter(string, normalized) {
  var second;
  return string.length == 2 && exec$5$1(ALPHA$1, charAt$7$1(string, 0)) && ((second = charAt$7$1(string, 1)) == ':' || !normalized && second == '|');
}; // https://url.spec.whatwg.org/#start-with-a-windows-drive-letter


var startsWithWindowsDriveLetter$1 = function startsWithWindowsDriveLetter(string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter$1(stringSlice$9$1(string, 0, 2)) && (string.length == 2 || (third = charAt$7$1(string, 2)) === '/' || third === '\\' || third === '?' || third === '#');
}; // https://url.spec.whatwg.org/#single-dot-path-segment


var isSingleDot$1 = function isSingleDot(segment) {
  return segment === '.' || toLowerCase$1$1(segment) === '%2e';
}; // https://url.spec.whatwg.org/#double-dot-path-segment


var isDoubleDot$1 = function isDoubleDot(segment) {
  segment = toLowerCase$1$1(segment);
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
}; // States:


var SCHEME_START$1 = {};
var SCHEME$1 = {};
var NO_SCHEME$1 = {};
var SPECIAL_RELATIVE_OR_AUTHORITY$1 = {};
var PATH_OR_AUTHORITY$1 = {};
var RELATIVE$1 = {};
var RELATIVE_SLASH$1 = {};
var SPECIAL_AUTHORITY_SLASHES$1 = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES$1 = {};
var AUTHORITY$1 = {};
var HOST$1 = {};
var HOSTNAME$1 = {};
var PORT$1 = {};
var FILE$1 = {};
var FILE_SLASH$1 = {};
var FILE_HOST$1 = {};
var PATH_START$1 = {};
var PATH$1 = {};
var CANNOT_BE_A_BASE_URL_PATH$1 = {};
var QUERY$1 = {};
var FRAGMENT$1 = {};

var URLState$1 = function URLState(url, isBase, base) {
  var urlString = toString_1$1(url);
  var baseState, failure, searchParams;

  if (isBase) {
    failure = this.parse(urlString);
    if (failure) throw TypeError$5$1(failure);
    this.searchParams = null;
  } else {
    if (base !== undefined) baseState = new URLState(base, true);
    failure = this.parse(urlString, null, baseState);
    if (failure) throw TypeError$5$1(failure);
    searchParams = getInternalSearchParamsState$1(new URLSearchParams$1$1());
    searchParams.bindURL(this);
    this.searchParams = searchParams;
  }
};

URLState$1.prototype = {
  type: 'URL',
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function parse(input, stateOverride, base) {
    var url = this;
    var state = stateOverride || SCHEME_START$1;
    var pointer = 0;
    var buffer = '';
    var seenAt = false;
    var seenBracket = false;
    var seenPasswordToken = false;
    var codePoints, chr, bufferCodePoints, failure;
    input = toString_1$1(input);

    if (!stateOverride) {
      url.scheme = '';
      url.username = '';
      url.password = '';
      url.host = null;
      url.port = null;
      url.path = [];
      url.query = null;
      url.fragment = null;
      url.cannotBeABaseURL = false;
      input = replace$6$1(input, LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE$1, '');
    }

    input = replace$6$1(input, TAB_AND_NEW_LINE$1, '');
    codePoints = arrayFrom$1(input);

    while (pointer <= codePoints.length) {
      chr = codePoints[pointer];

      switch (state) {
        case SCHEME_START$1:
          if (chr && exec$5$1(ALPHA$1, chr)) {
            buffer += toLowerCase$1$1(chr);
            state = SCHEME$1;
          } else if (!stateOverride) {
            state = NO_SCHEME$1;
            continue;
          } else return INVALID_SCHEME$1;

          break;

        case SCHEME$1:
          if (chr && (exec$5$1(ALPHANUMERIC$1, chr) || chr == '+' || chr == '-' || chr == '.')) {
            buffer += toLowerCase$1$1(chr);
          } else if (chr == ':') {
            if (stateOverride && (url.isSpecial() != hasOwnProperty_1$1(specialSchemes$1, buffer) || buffer == 'file' && (url.includesCredentials() || url.port !== null) || url.scheme == 'file' && !url.host)) return;
            url.scheme = buffer;

            if (stateOverride) {
              if (url.isSpecial() && specialSchemes$1[url.scheme] == url.port) url.port = null;
              return;
            }

            buffer = '';

            if (url.scheme == 'file') {
              state = FILE$1;
            } else if (url.isSpecial() && base && base.scheme == url.scheme) {
              state = SPECIAL_RELATIVE_OR_AUTHORITY$1;
            } else if (url.isSpecial()) {
              state = SPECIAL_AUTHORITY_SLASHES$1;
            } else if (codePoints[pointer + 1] == '/') {
              state = PATH_OR_AUTHORITY$1;
              pointer++;
            } else {
              url.cannotBeABaseURL = true;
              push$9$1(url.path, '');
              state = CANNOT_BE_A_BASE_URL_PATH$1;
            }
          } else if (!stateOverride) {
            buffer = '';
            state = NO_SCHEME$1;
            pointer = 0;
            continue;
          } else return INVALID_SCHEME$1;

          break;

        case NO_SCHEME$1:
          if (!base || base.cannotBeABaseURL && chr != '#') return INVALID_SCHEME$1;

          if (base.cannotBeABaseURL && chr == '#') {
            url.scheme = base.scheme;
            url.path = arraySliceSimple$1(base.path);
            url.query = base.query;
            url.fragment = '';
            url.cannotBeABaseURL = true;
            state = FRAGMENT$1;
            break;
          }

          state = base.scheme == 'file' ? FILE$1 : RELATIVE$1;
          continue;

        case SPECIAL_RELATIVE_OR_AUTHORITY$1:
          if (chr == '/' && codePoints[pointer + 1] == '/') {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES$1;
            pointer++;
          } else {
            state = RELATIVE$1;
            continue;
          }

          break;

        case PATH_OR_AUTHORITY$1:
          if (chr == '/') {
            state = AUTHORITY$1;
            break;
          } else {
            state = PATH$1;
            continue;
          }

        case RELATIVE$1:
          url.scheme = base.scheme;

          if (chr == EOF$1) {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySliceSimple$1(base.path);
            url.query = base.query;
          } else if (chr == '/' || chr == '\\' && url.isSpecial()) {
            state = RELATIVE_SLASH$1;
          } else if (chr == '?') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySliceSimple$1(base.path);
            url.query = '';
            state = QUERY$1;
          } else if (chr == '#') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySliceSimple$1(base.path);
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT$1;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySliceSimple$1(base.path);
            url.path.length--;
            state = PATH$1;
            continue;
          }

          break;

        case RELATIVE_SLASH$1:
          if (url.isSpecial() && (chr == '/' || chr == '\\')) {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES$1;
          } else if (chr == '/') {
            state = AUTHORITY$1;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            state = PATH$1;
            continue;
          }

          break;

        case SPECIAL_AUTHORITY_SLASHES$1:
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES$1;
          if (chr != '/' || charAt$7$1(buffer, pointer + 1) != '/') continue;
          pointer++;
          break;

        case SPECIAL_AUTHORITY_IGNORE_SLASHES$1:
          if (chr != '/' && chr != '\\') {
            state = AUTHORITY$1;
            continue;
          }

          break;

        case AUTHORITY$1:
          if (chr == '@') {
            if (seenAt) buffer = '%40' + buffer;
            seenAt = true;
            bufferCodePoints = arrayFrom$1(buffer);

            for (var i = 0; i < bufferCodePoints.length; i++) {
              var codePoint = bufferCodePoints[i];

              if (codePoint == ':' && !seenPasswordToken) {
                seenPasswordToken = true;
                continue;
              }

              var encodedCodePoints = percentEncode$1(codePoint, userinfoPercentEncodeSet$1);
              if (seenPasswordToken) url.password += encodedCodePoints;else url.username += encodedCodePoints;
            }

            buffer = '';
          } else if (chr == EOF$1 || chr == '/' || chr == '?' || chr == '#' || chr == '\\' && url.isSpecial()) {
            if (seenAt && buffer == '') return INVALID_AUTHORITY$1;
            pointer -= arrayFrom$1(buffer).length + 1;
            buffer = '';
            state = HOST$1;
          } else buffer += chr;

          break;

        case HOST$1:
        case HOSTNAME$1:
          if (stateOverride && url.scheme == 'file') {
            state = FILE_HOST$1;
            continue;
          } else if (chr == ':' && !seenBracket) {
            if (buffer == '') return INVALID_HOST$1;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PORT$1;
            if (stateOverride == HOSTNAME$1) return;
          } else if (chr == EOF$1 || chr == '/' || chr == '?' || chr == '#' || chr == '\\' && url.isSpecial()) {
            if (url.isSpecial() && buffer == '') return INVALID_HOST$1;
            if (stateOverride && buffer == '' && (url.includesCredentials() || url.port !== null)) return;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PATH_START$1;
            if (stateOverride) return;
            continue;
          } else {
            if (chr == '[') seenBracket = true;else if (chr == ']') seenBracket = false;
            buffer += chr;
          }

          break;

        case PORT$1:
          if (exec$5$1(DIGIT$1, chr)) {
            buffer += chr;
          } else if (chr == EOF$1 || chr == '/' || chr == '?' || chr == '#' || chr == '\\' && url.isSpecial() || stateOverride) {
            if (buffer != '') {
              var port = parseInt$2(buffer, 10);
              if (port > 0xFFFF) return INVALID_PORT$1;
              url.port = url.isSpecial() && port === specialSchemes$1[url.scheme] ? null : port;
              buffer = '';
            }

            if (stateOverride) return;
            state = PATH_START$1;
            continue;
          } else return INVALID_PORT$1;

          break;

        case FILE$1:
          url.scheme = 'file';
          if (chr == '/' || chr == '\\') state = FILE_SLASH$1;else if (base && base.scheme == 'file') {
            if (chr == EOF$1) {
              url.host = base.host;
              url.path = arraySliceSimple$1(base.path);
              url.query = base.query;
            } else if (chr == '?') {
              url.host = base.host;
              url.path = arraySliceSimple$1(base.path);
              url.query = '';
              state = QUERY$1;
            } else if (chr == '#') {
              url.host = base.host;
              url.path = arraySliceSimple$1(base.path);
              url.query = base.query;
              url.fragment = '';
              state = FRAGMENT$1;
            } else {
              if (!startsWithWindowsDriveLetter$1(join$2$1(arraySliceSimple$1(codePoints, pointer), ''))) {
                url.host = base.host;
                url.path = arraySliceSimple$1(base.path);
                url.shortenPath();
              }

              state = PATH$1;
              continue;
            }
          } else {
            state = PATH$1;
            continue;
          }
          break;

        case FILE_SLASH$1:
          if (chr == '/' || chr == '\\') {
            state = FILE_HOST$1;
            break;
          }

          if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter$1(join$2$1(arraySliceSimple$1(codePoints, pointer), ''))) {
            if (isWindowsDriveLetter$1(base.path[0], true)) push$9$1(url.path, base.path[0]);else url.host = base.host;
          }

          state = PATH$1;
          continue;

        case FILE_HOST$1:
          if (chr == EOF$1 || chr == '/' || chr == '\\' || chr == '?' || chr == '#') {
            if (!stateOverride && isWindowsDriveLetter$1(buffer)) {
              state = PATH$1;
            } else if (buffer == '') {
              url.host = '';
              if (stateOverride) return;
              state = PATH_START$1;
            } else {
              failure = url.parseHost(buffer);
              if (failure) return failure;
              if (url.host == 'localhost') url.host = '';
              if (stateOverride) return;
              buffer = '';
              state = PATH_START$1;
            }

            continue;
          } else buffer += chr;

          break;

        case PATH_START$1:
          if (url.isSpecial()) {
            state = PATH$1;
            if (chr != '/' && chr != '\\') continue;
          } else if (!stateOverride && chr == '?') {
            url.query = '';
            state = QUERY$1;
          } else if (!stateOverride && chr == '#') {
            url.fragment = '';
            state = FRAGMENT$1;
          } else if (chr != EOF$1) {
            state = PATH$1;
            if (chr != '/') continue;
          }

          break;

        case PATH$1:
          if (chr == EOF$1 || chr == '/' || chr == '\\' && url.isSpecial() || !stateOverride && (chr == '?' || chr == '#')) {
            if (isDoubleDot$1(buffer)) {
              url.shortenPath();

              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                push$9$1(url.path, '');
              }
            } else if (isSingleDot$1(buffer)) {
              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                push$9$1(url.path, '');
              }
            } else {
              if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter$1(buffer)) {
                if (url.host) url.host = '';
                buffer = charAt$7$1(buffer, 0) + ':'; // normalize windows drive letter
              }

              push$9$1(url.path, buffer);
            }

            buffer = '';

            if (url.scheme == 'file' && (chr == EOF$1 || chr == '?' || chr == '#')) {
              while (url.path.length > 1 && url.path[0] === '') {
                shift$1$1(url.path);
              }
            }

            if (chr == '?') {
              url.query = '';
              state = QUERY$1;
            } else if (chr == '#') {
              url.fragment = '';
              state = FRAGMENT$1;
            }
          } else {
            buffer += percentEncode$1(chr, pathPercentEncodeSet$1);
          }

          break;

        case CANNOT_BE_A_BASE_URL_PATH$1:
          if (chr == '?') {
            url.query = '';
            state = QUERY$1;
          } else if (chr == '#') {
            url.fragment = '';
            state = FRAGMENT$1;
          } else if (chr != EOF$1) {
            url.path[0] += percentEncode$1(chr, C0ControlPercentEncodeSet$1);
          }

          break;

        case QUERY$1:
          if (!stateOverride && chr == '#') {
            url.fragment = '';
            state = FRAGMENT$1;
          } else if (chr != EOF$1) {
            if (chr == "'" && url.isSpecial()) url.query += '%27';else if (chr == '#') url.query += '%23';else url.query += percentEncode$1(chr, C0ControlPercentEncodeSet$1);
          }

          break;

        case FRAGMENT$1:
          if (chr != EOF$1) url.fragment += percentEncode$1(chr, fragmentPercentEncodeSet$1);
          break;
      }

      pointer++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function parseHost(input) {
    var result, codePoints, index;

    if (charAt$7$1(input, 0) == '[') {
      if (charAt$7$1(input, input.length - 1) != ']') return INVALID_HOST$1;
      result = parseIPv6$1(stringSlice$9$1(input, 1, -1));
      if (!result) return INVALID_HOST$1;
      this.host = result; // opaque host
    } else if (!this.isSpecial()) {
      if (exec$5$1(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT$1, input)) return INVALID_HOST$1;
      result = '';
      codePoints = arrayFrom$1(input);

      for (index = 0; index < codePoints.length; index++) {
        result += percentEncode$1(codePoints[index], C0ControlPercentEncodeSet$1);
      }

      this.host = result;
    } else {
      input = stringPunycodeToAscii$1(input);
      if (exec$5$1(FORBIDDEN_HOST_CODE_POINT$1, input)) return INVALID_HOST$1;
      result = parseIPv4$1(input);
      if (result === null) return INVALID_HOST$1;
      this.host = result;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function cannotHaveUsernamePasswordPort() {
    return !this.host || this.cannotBeABaseURL || this.scheme == 'file';
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function includesCredentials() {
    return this.username != '' || this.password != '';
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function isSpecial() {
    return hasOwnProperty_1$1(specialSchemes$1, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function shortenPath() {
    var path = this.path;
    var pathSize = path.length;

    if (pathSize && (this.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter$1(path[0], true))) {
      path.length--;
    }
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function serialize() {
    var url = this;
    var scheme = url.scheme;
    var username = url.username;
    var password = url.password;
    var host = url.host;
    var port = url.port;
    var path = url.path;
    var query = url.query;
    var fragment = url.fragment;
    var output = scheme + ':';

    if (host !== null) {
      output += '//';

      if (url.includesCredentials()) {
        output += username + (password ? ':' + password : '') + '@';
      }

      output += serializeHost$1(host);
      if (port !== null) output += ':' + port;
    } else if (scheme == 'file') output += '//';

    output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join$2$1(path, '/') : '';
    if (query !== null) output += '?' + query;
    if (fragment !== null) output += '#' + fragment;
    return output;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function setHref(href) {
    var failure = this.parse(href);
    if (failure) throw TypeError$5$1(failure);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function getOrigin() {
    var scheme = this.scheme;
    var port = this.port;
    if (scheme == 'blob') try {
      return new URLConstructor$1(scheme.path[0]).origin;
    } catch (error) {
      return 'null';
    }
    if (scheme == 'file' || !this.isSpecial()) return 'null';
    return scheme + '://' + serializeHost$1(this.host) + (port !== null ? ':' + port : '');
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function getProtocol() {
    return this.scheme + ':';
  },
  setProtocol: function setProtocol(protocol) {
    this.parse(toString_1$1(protocol) + ':', SCHEME_START$1);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function getUsername() {
    return this.username;
  },
  setUsername: function setUsername(username) {
    var codePoints = arrayFrom$1(toString_1$1(username));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.username = '';

    for (var i = 0; i < codePoints.length; i++) {
      this.username += percentEncode$1(codePoints[i], userinfoPercentEncodeSet$1);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function getPassword() {
    return this.password;
  },
  setPassword: function setPassword(password) {
    var codePoints = arrayFrom$1(toString_1$1(password));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.password = '';

    for (var i = 0; i < codePoints.length; i++) {
      this.password += percentEncode$1(codePoints[i], userinfoPercentEncodeSet$1);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function getHost() {
    var host = this.host;
    var port = this.port;
    return host === null ? '' : port === null ? serializeHost$1(host) : serializeHost$1(host) + ':' + port;
  },
  setHost: function setHost(host) {
    if (this.cannotBeABaseURL) return;
    this.parse(host, HOST$1);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function getHostname() {
    var host = this.host;
    return host === null ? '' : serializeHost$1(host);
  },
  setHostname: function setHostname(hostname) {
    if (this.cannotBeABaseURL) return;
    this.parse(hostname, HOSTNAME$1);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function getPort() {
    var port = this.port;
    return port === null ? '' : toString_1$1(port);
  },
  setPort: function setPort(port) {
    if (this.cannotHaveUsernamePasswordPort()) return;
    port = toString_1$1(port);
    if (port == '') this.port = null;else this.parse(port, PORT$1);
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function getPathname() {
    var path = this.path;
    return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join$2$1(path, '/') : '';
  },
  setPathname: function setPathname(pathname) {
    if (this.cannotBeABaseURL) return;
    this.path = [];
    this.parse(pathname, PATH_START$1);
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function getSearch() {
    var query = this.query;
    return query ? '?' + query : '';
  },
  setSearch: function setSearch(search) {
    search = toString_1$1(search);

    if (search == '') {
      this.query = null;
    } else {
      if ('?' == charAt$7$1(search, 0)) search = stringSlice$9$1(search, 1);
      this.query = '';
      this.parse(search, QUERY$1);
    }

    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function getSearchParams() {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function getHash() {
    var fragment = this.fragment;
    return fragment ? '#' + fragment : '';
  },
  setHash: function setHash(hash) {
    hash = toString_1$1(hash);

    if (hash == '') {
      this.fragment = null;
      return;
    }

    if ('#' == charAt$7$1(hash, 0)) hash = stringSlice$9$1(hash, 1);
    this.fragment = '';
    this.parse(hash, FRAGMENT$1);
  },
  update: function update() {
    this.query = this.searchParams.serialize() || null;
  }
}; // `URL` constructor
// https://url.spec.whatwg.org/#url-class

var URLConstructor$1 = function URL(url
/* , base */
) {
  var that = anInstance$1(this, URLPrototype$1);
  var base = validateArgumentsLength$1(arguments.length, 1) > 1 ? arguments[1] : undefined;
  var state = setInternalState$6$1(that, new URLState$1(url, false, base));

  if (!descriptors$1) {
    that.href = state.serialize();
    that.origin = state.getOrigin();
    that.protocol = state.getProtocol();
    that.username = state.getUsername();
    that.password = state.getPassword();
    that.host = state.getHost();
    that.hostname = state.getHostname();
    that.port = state.getPort();
    that.pathname = state.getPathname();
    that.search = state.getSearch();
    that.searchParams = state.getSearchParams();
    that.hash = state.getHash();
  }
};

var URLPrototype$1 = URLConstructor$1.prototype;

var accessorDescriptor$1 = function accessorDescriptor(getter, setter) {
  return {
    get: function get() {
      return getInternalURLState$1(this)[getter]();
    },
    set: setter && function (value) {
      return getInternalURLState$1(this)[setter](value);
    },
    configurable: true,
    enumerable: true
  };
};

if (descriptors$1) {
  // `URL.prototype.href` accessors pair
  // https://url.spec.whatwg.org/#dom-url-href
  defineBuiltInAccessor$1(URLPrototype$1, 'href', accessorDescriptor$1('serialize', 'setHref')); // `URL.prototype.origin` getter
  // https://url.spec.whatwg.org/#dom-url-origin

  defineBuiltInAccessor$1(URLPrototype$1, 'origin', accessorDescriptor$1('getOrigin')); // `URL.prototype.protocol` accessors pair
  // https://url.spec.whatwg.org/#dom-url-protocol

  defineBuiltInAccessor$1(URLPrototype$1, 'protocol', accessorDescriptor$1('getProtocol', 'setProtocol')); // `URL.prototype.username` accessors pair
  // https://url.spec.whatwg.org/#dom-url-username

  defineBuiltInAccessor$1(URLPrototype$1, 'username', accessorDescriptor$1('getUsername', 'setUsername')); // `URL.prototype.password` accessors pair
  // https://url.spec.whatwg.org/#dom-url-password

  defineBuiltInAccessor$1(URLPrototype$1, 'password', accessorDescriptor$1('getPassword', 'setPassword')); // `URL.prototype.host` accessors pair
  // https://url.spec.whatwg.org/#dom-url-host

  defineBuiltInAccessor$1(URLPrototype$1, 'host', accessorDescriptor$1('getHost', 'setHost')); // `URL.prototype.hostname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hostname

  defineBuiltInAccessor$1(URLPrototype$1, 'hostname', accessorDescriptor$1('getHostname', 'setHostname')); // `URL.prototype.port` accessors pair
  // https://url.spec.whatwg.org/#dom-url-port

  defineBuiltInAccessor$1(URLPrototype$1, 'port', accessorDescriptor$1('getPort', 'setPort')); // `URL.prototype.pathname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-pathname

  defineBuiltInAccessor$1(URLPrototype$1, 'pathname', accessorDescriptor$1('getPathname', 'setPathname')); // `URL.prototype.search` accessors pair
  // https://url.spec.whatwg.org/#dom-url-search

  defineBuiltInAccessor$1(URLPrototype$1, 'search', accessorDescriptor$1('getSearch', 'setSearch')); // `URL.prototype.searchParams` getter
  // https://url.spec.whatwg.org/#dom-url-searchparams

  defineBuiltInAccessor$1(URLPrototype$1, 'searchParams', accessorDescriptor$1('getSearchParams')); // `URL.prototype.hash` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hash

  defineBuiltInAccessor$1(URLPrototype$1, 'hash', accessorDescriptor$1('getHash', 'setHash'));
} // `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson


defineBuiltIn$1(URLPrototype$1, 'toJSON', function toJSON() {
  return getInternalURLState$1(this).serialize();
}, {
  enumerable: true
}); // `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior

defineBuiltIn$1(URLPrototype$1, 'toString', function toString() {
  return getInternalURLState$1(this).serialize();
}, {
  enumerable: true
});

if (NativeURL$1) {
  var nativeCreateObjectURL$1 = NativeURL$1.createObjectURL;
  var nativeRevokeObjectURL$1 = NativeURL$1.revokeObjectURL; // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL

  if (nativeCreateObjectURL$1) defineBuiltIn$1(URLConstructor$1, 'createObjectURL', functionBindContext$1(nativeCreateObjectURL$1, NativeURL$1)); // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL

  if (nativeRevokeObjectURL$1) defineBuiltIn$1(URLConstructor$1, 'revokeObjectURL', functionBindContext$1(nativeRevokeObjectURL$1, NativeURL$1));
}

setToStringTag$1(URLConstructor$1, 'URL');

_export$1({
  global: true,
  constructor: true,
  forced: !urlConstructorDetection$1,
  sham: !descriptors$1
}, {
  URL: URLConstructor$1
}); // https://url.spec.whatwg.org/#dom-url-tojson


_export$1({
  target: 'URL',
  proto: true,
  enumerable: true
}, {
  toJSON: function toJSON() {
    return functionCall$1(URL.prototype.toString, this);
  }
});

var isPure$1$1 = false; // https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe

var objectKeys$1$1 = Object.keys || function keys(O) {
  return objectKeysInternal$1$1(O, enumBugKeys$1$1);
}; // https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe


var f$a = descriptors$1$1 && !v8PrototypeDefineBug$1$1 ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$1$1(O);
  var props = toIndexedObject$1$1(Properties);
  var keys = objectKeys$1$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;

  while (length > index) {
    objectDefineProperty$1$1.f(O, key = keys[index++], props[key]);
  }

  return O;
};
var objectDefineProperties$1$1 = {
  f: f$a
};
/* global ActiveXObject -- old IE, WSH */

var GT$1$1 = '>';
var LT$1$1 = '<';
var PROTOTYPE$2$1 = 'prototype';
var SCRIPT$1$1 = 'script';
var IE_PROTO$2$1 = sharedKey$1$1('IE_PROTO');

var EmptyConstructor$1$1 = function EmptyConstructor() {
  /* empty */
};

var scriptTag$1$1 = function scriptTag(content) {
  return LT$1$1 + SCRIPT$1$1 + GT$1$1 + content + LT$1$1 + '/' + SCRIPT$1$1 + GT$1$1;
}; // Create object with fake `null` prototype: use ActiveX Object with cleared prototype


var NullProtoObjectViaActiveX$1$1 = function NullProtoObjectViaActiveX(activeXDocument) {
  activeXDocument.write(scriptTag$1$1(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak

  return temp;
}; // Create object with fake `null` prototype: use iframe Object with cleared prototype


var NullProtoObjectViaIFrame$1$1 = function NullProtoObjectViaIFrame() {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1$1('iframe');
  var JS = 'java' + SCRIPT$1$1 + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1$1.appendChild(iframe); // https://github.com/zloirock/core-js/issues/475

  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag$1$1('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
}; // Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug


var activeXDocument$1$1;

var _NullProtoObject = function NullProtoObject() {
  try {
    activeXDocument$1$1 = new ActiveXObject('htmlfile');
  } catch (error) {
    /* ignore */
  }

  _NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument$1$1 ? NullProtoObjectViaActiveX$1$1(activeXDocument$1$1) // old IE
  : NullProtoObjectViaIFrame$1$1() : NullProtoObjectViaActiveX$1$1(activeXDocument$1$1); // WSH

  var length = enumBugKeys$1$1.length;

  while (length--) {
    delete _NullProtoObject[PROTOTYPE$2$1][enumBugKeys$1$1[length]];
  }

  return _NullProtoObject();
};

hiddenKeys$2$1[IE_PROTO$2$1] = true; // `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe

var objectCreate$1$1 = Object.create || function create(O, Properties) {
  var result;

  if (O !== null) {
    EmptyConstructor$1$1[PROTOTYPE$2$1] = anObject$1$1(O);
    result = new EmptyConstructor$1$1();
    EmptyConstructor$1$1[PROTOTYPE$2$1] = null; // add "__proto__" for Object.getPrototypeOf polyfill

    result[IE_PROTO$2$1] = O;
  } else result = _NullProtoObject();

  return Properties === undefined ? result : objectDefineProperties$1$1.f(result, Properties);
};

var defineProperty$9$1 = objectDefineProperty$1$1.f;
var UNSCOPABLES$1$1 = wellKnownSymbol$1$1('unscopables');
var ArrayPrototype$3 = Array.prototype; // Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

if (ArrayPrototype$3[UNSCOPABLES$1$1] == undefined) {
  defineProperty$9$1(ArrayPrototype$3, UNSCOPABLES$1$1, {
    configurable: true,
    value: objectCreate$1$1(null)
  });
} // add a key to Array.prototype[@@unscopables]


var addToUnscopables$1$1 = function addToUnscopables(key) {
  ArrayPrototype$3[UNSCOPABLES$1$1][key] = true;
};

var correctPrototypeGetter$1$1 = !fails$1$1(function () {
  function F() {
    /* empty */
  }

  F.prototype.constructor = null; // eslint-disable-next-line es/no-object-getprototypeof -- required for testing

  return Object.getPrototypeOf(new F()) !== F.prototype;
});
var IE_PROTO$1$1$1 = sharedKey$1$1('IE_PROTO');
var $Object$6 = Object;
var ObjectPrototype$2$1 = $Object$6.prototype; // `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe

var objectGetPrototypeOf$1$1 = correctPrototypeGetter$1$1 ? $Object$6.getPrototypeOf : function (O) {
  var object = toObject$1$1(O);
  if (hasOwnProperty_1$1$1(object, IE_PROTO$1$1$1)) return object[IE_PROTO$1$1$1];
  var constructor = object.constructor;

  if (isCallable$1$1(constructor) && object instanceof constructor) {
    return constructor.prototype;
  }

  return object instanceof $Object$6 ? ObjectPrototype$2$1 : null;
};
var ITERATOR$9 = wellKnownSymbol$1$1('iterator');
var BUGGY_SAFARI_ITERATORS$2$1 = false; // `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object

var IteratorPrototype$3$1, PrototypeOfArrayIteratorPrototype$1$1, arrayIterator$1$1;
/* eslint-disable es/no-array-prototype-keys -- safe */

if ([].keys) {
  arrayIterator$1$1 = [].keys(); // Safari 8 has buggy iterators w/o `next`

  if (!('next' in arrayIterator$1$1)) BUGGY_SAFARI_ITERATORS$2$1 = true;else {
    PrototypeOfArrayIteratorPrototype$1$1 = objectGetPrototypeOf$1$1(objectGetPrototypeOf$1$1(arrayIterator$1$1));
    if (PrototypeOfArrayIteratorPrototype$1$1 !== Object.prototype) IteratorPrototype$3$1 = PrototypeOfArrayIteratorPrototype$1$1;
  }
}

var NEW_ITERATOR_PROTOTYPE$1$1 = !isObject$1$1(IteratorPrototype$3$1) || fails$1$1(function () {
  var test = {}; // FF44- legacy iterators case

  return IteratorPrototype$3$1[ITERATOR$9].call(test) !== test;
});
if (NEW_ITERATOR_PROTOTYPE$1$1) IteratorPrototype$3$1 = {}; // `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator

if (!isCallable$1$1(IteratorPrototype$3$1[ITERATOR$9])) {
  defineBuiltIn$1$1(IteratorPrototype$3$1, ITERATOR$9, function () {
    return this;
  });
}

var iteratorsCore$1$1 = {
  IteratorPrototype: IteratorPrototype$3$1,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$2$1
};
var IteratorPrototype$1$1$1 = iteratorsCore$1$1.IteratorPrototype;

var returnThis$2$1 = function returnThis() {
  return this;
};

var iteratorCreateConstructor$1$1 = function iteratorCreateConstructor(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = objectCreate$1$1(IteratorPrototype$1$1$1, {
    next: createPropertyDescriptor$1$1(+!ENUMERABLE_NEXT, next)
  });
  setToStringTag$1$1(IteratorConstructor, TO_STRING_TAG, false);
  iterators$1$1[TO_STRING_TAG] = returnThis$2$1;
  return IteratorConstructor;
};

var PROPER_FUNCTION_NAME$2$1 = functionName$1$1.PROPER;
var CONFIGURABLE_FUNCTION_NAME$1$1 = functionName$1$1.CONFIGURABLE;
var IteratorPrototype$2$1$1 = iteratorsCore$1$1.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS$1$1$1 = iteratorsCore$1$1.BUGGY_SAFARI_ITERATORS;
var ITERATOR$1$2 = wellKnownSymbol$1$1('iterator');
var KEYS$1$1 = 'keys';
var VALUES$1$1 = 'values';
var ENTRIES$1$1 = 'entries';

var returnThis$1$1$1 = function returnThis$1() {
  return this;
};

var iteratorDefine$1$1 = function iteratorDefine(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  iteratorCreateConstructor$1$1(IteratorConstructor, NAME, next);

  var getIterationMethod = function getIterationMethod(KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS$1$1$1 && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS$1$1:
        return function keys() {
          return new IteratorConstructor(this, KIND);
        };

      case VALUES$1$1:
        return function values() {
          return new IteratorConstructor(this, KIND);
        };

      case ENTRIES$1$1:
        return function entries() {
          return new IteratorConstructor(this, KIND);
        };
    }

    return function () {
      return new IteratorConstructor(this);
    };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$1$2] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS$1$1$1 && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY; // fix native

  if (anyNativeIterator) {
    CurrentIteratorPrototype = objectGetPrototypeOf$1$1(anyNativeIterator.call(new Iterable()));

    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (objectGetPrototypeOf$1$1(CurrentIteratorPrototype) !== IteratorPrototype$2$1$1) {
        if (objectSetPrototypeOf$1$1) {
          objectSetPrototypeOf$1$1(CurrentIteratorPrototype, IteratorPrototype$2$1$1);
        } else if (!isCallable$1$1(CurrentIteratorPrototype[ITERATOR$1$2])) {
          defineBuiltIn$1$1(CurrentIteratorPrototype, ITERATOR$1$2, returnThis$1$1$1);
        }
      } // Set @@toStringTag to native iterators


      setToStringTag$1$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  } // fix Array.prototype.{ values, @@iterator }.name in V8 / FF


  if (PROPER_FUNCTION_NAME$2$1 && DEFAULT == VALUES$1$1 && nativeIterator && nativeIterator.name !== VALUES$1$1) {
    if (CONFIGURABLE_FUNCTION_NAME$1$1) {
      createNonEnumerableProperty$1$1(IterablePrototype, 'name', VALUES$1$1);
    } else {
      INCORRECT_VALUES_NAME = true;

      defaultIterator = function values() {
        return functionCall$1$1(nativeIterator, this);
      };
    }
  } // export additional methods


  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES$1$1),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS$1$1),
      entries: getIterationMethod(ENTRIES$1$1)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS$1$1$1 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$1$1(IterablePrototype, KEY, methods[KEY]);
      }
    } else _export$1$1({
      target: NAME,
      proto: true,
      forced: BUGGY_SAFARI_ITERATORS$1$1$1 || INCORRECT_VALUES_NAME
    }, methods);
  } // define iterator


  if (IterablePrototype[ITERATOR$1$2] !== defaultIterator) {
    defineBuiltIn$1$1(IterablePrototype, ITERATOR$1$2, defaultIterator, {
      name: DEFAULT
    });
  }

  iterators$1$1[NAME] = defaultIterator;
  return methods;
}; // `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject


var createIterResultObject$1$1 = function createIterResultObject(value, done) {
  return {
    value: value,
    done: done
  };
};

var defineProperty$1$2 = objectDefineProperty$1$1.f;
var ARRAY_ITERATOR$1$1 = 'Array Iterator';
var setInternalState$7$1 = internalState$1$1.set;
var getInternalState$4$1 = internalState$1$1.getterFor(ARRAY_ITERATOR$1$1); // `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator

var es_array_iterator$1$1 = iteratorDefine$1$1(Array, 'Array', function (iterated, kind) {
  setInternalState$7$1(this, {
    type: ARRAY_ITERATOR$1$1,
    target: toIndexedObject$1$1(iterated),
    // target
    index: 0,
    // next index
    kind: kind // kind

  }); // `%ArrayIteratorPrototype%.next` method
  // https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$4$1(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;

  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject$1$1(undefined, true);
  }

  if (kind == 'keys') return createIterResultObject$1$1(index, false);
  if (kind == 'values') return createIterResultObject$1$1(target[index], false);
  return createIterResultObject$1$1([index, target[index]], false);
}, 'values'); // argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject

var values$1$1 = iterators$1$1.Arguments = iterators$1$1.Array; // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

addToUnscopables$1$1('keys');
addToUnscopables$1$1('values');
addToUnscopables$1$1('entries'); // V8 ~ Chrome 45- bug

if (descriptors$1$1 && values$1$1.name !== 'values') try {
  defineProperty$1$2(values$1$1, 'name', {
    value: 'values'
  });
} catch (error) {
  /* empty */
}
var $String$5 = String;

var toString_1$1$1 = function toString_1(argument) {
  if (classof$1$1(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String$5(argument);
};

var charAt$8$1 = functionUncurryThis$1$1(''.charAt);
var charCodeAt$3$1 = functionUncurryThis$1$1(''.charCodeAt);
var stringSlice$a$1 = functionUncurryThis$1$1(''.slice);

var createMethod$4$1 = function createMethod(CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString_1$1$1(requireObjectCoercible$1$1($this));
    var position = toIntegerOrInfinity$1$1(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt$3$1(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = charCodeAt$3$1(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? charAt$8$1(S, position) : first : CONVERT_TO_STRING ? stringSlice$a$1(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte$1$1 = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$4$1(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$4$1(true)
};
var charAt$1$1$1 = stringMultibyte$1$1.charAt;
var STRING_ITERATOR$1$1 = 'String Iterator';
var setInternalState$1$1$1 = internalState$1$1.set;
var getInternalState$1$1$1 = internalState$1$1.getterFor(STRING_ITERATOR$1$1); // `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator

iteratorDefine$1$1(String, 'String', function (iterated) {
  setInternalState$1$1$1(this, {
    type: STRING_ITERATOR$1$1,
    string: toString_1$1$1(iterated),
    index: 0
  }); // `%StringIteratorPrototype%.next` method
  // https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState$1$1$1(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject$1$1(undefined, true);
  point = charAt$1$1$1(string, index);
  state.index += point.length;
  return createIterResultObject$1$1(point, false);
}); // iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods

var domIterables$1$1 = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};
var classList$1$1 = documentCreateElement$1$1('span').classList;
var DOMTokenListPrototype$1$1 = classList$1$1 && classList$1$1.constructor && classList$1$1.constructor.prototype;
var domTokenListPrototype$1$1 = DOMTokenListPrototype$1$1 === Object.prototype ? undefined : DOMTokenListPrototype$1$1;
var ITERATOR$2$2 = wellKnownSymbol$1$1('iterator');
var TO_STRING_TAG$5 = wellKnownSymbol$1$1('toStringTag');
var ArrayValues$1$1 = es_array_iterator$1$1.values;

var handlePrototype$2$1 = function handlePrototype(CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$2$2] !== ArrayValues$1$1) try {
      createNonEnumerableProperty$1$1(CollectionPrototype, ITERATOR$2$2, ArrayValues$1$1);
    } catch (error) {
      CollectionPrototype[ITERATOR$2$2] = ArrayValues$1$1;
    }

    if (!CollectionPrototype[TO_STRING_TAG$5]) {
      createNonEnumerableProperty$1$1(CollectionPrototype, TO_STRING_TAG$5, COLLECTION_NAME);
    }

    if (domIterables$1$1[COLLECTION_NAME]) for (var METHOD_NAME in es_array_iterator$1$1) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== es_array_iterator$1$1[METHOD_NAME]) try {
        createNonEnumerableProperty$1$1(CollectionPrototype, METHOD_NAME, es_array_iterator$1$1[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = es_array_iterator$1$1[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME$2$1 in domIterables$1$1) {
  handlePrototype$2$1(global_1$1$1[COLLECTION_NAME$2$1] && global_1$1$1[COLLECTION_NAME$2$1].prototype, COLLECTION_NAME$2$1);
}

handlePrototype$2$1(domTokenListPrototype$1$1, 'DOMTokenList');
var ITERATOR$3$1$1 = wellKnownSymbol$1$1('iterator');
var urlConstructorDetection$1$1 = !fails$1$1(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return isPure$1$1 && !url.toJSON || !searchParams.sort || url.href !== 'http://a/c%20d?a=1&c=3' || searchParams.get('c') !== '3' || String(new URLSearchParams('?a=1')) !== 'a=1' || !searchParams[ITERATOR$3$1$1] // throws in Edge
  || new URL('https://a@b').username !== 'a' || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b' // not punycoded in Edge
  || new URL('http://тест').host !== 'xn--e1aybc' // not escaped in Chrome 62-
  || new URL('http://a#б').hash !== '#%D0%B1' // fails in Chrome 66-
  || result !== 'a1c3' // throws in Safari
  || new URL('http://x', undefined).host !== 'x';
});

var defineBuiltInAccessor$1$1 = function defineBuiltInAccessor(target, name, descriptor) {
  if (descriptor.get) makeBuiltIn_1$1$1(descriptor.get, name, {
    getter: true
  });
  if (descriptor.set) makeBuiltIn_1$1$1(descriptor.set, name, {
    setter: true
  });
  return objectDefineProperty$1$1.f(target, name, descriptor);
};

var $assign$1$1 = Object.assign; // eslint-disable-next-line es/no-object-defineproperty -- required for testing

var defineProperty$2$1$1 = Object.defineProperty;
var concat$4 = functionUncurryThis$1$1([].concat); // `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign

var objectAssign$1$1 = !$assign$1$1 || fails$1$1(function () {
  // should have correct order of operations (Edge bug)
  if (descriptors$1$1 && $assign$1$1({
    b: 1
  }, $assign$1$1(defineProperty$2$1$1({}, 'a', {
    enumerable: true,
    get: function get() {
      defineProperty$2$1$1(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), {
    b: 2
  })).b !== 1) return true; // should work with symbols and should have deterministic property order (V8 bug)

  var A = {};
  var B = {}; // eslint-disable-next-line es/no-symbol -- safe

  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) {
    B[chr] = chr;
  });
  return $assign$1$1({}, A)[symbol] != 7 || objectKeys$1$1($assign$1$1({}, B)).join('') != alphabet;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$1$1(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = objectGetOwnPropertySymbols$1$1.f;
  var propertyIsEnumerable = objectPropertyIsEnumerable$1$1.f;

  while (argumentsLength > index) {
    var S = indexedObject$1$1(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$4(objectKeys$1$1(S), getOwnPropertySymbols(S)) : objectKeys$1$1(S);
    var length = keys.length;
    var j = 0;
    var key;

    while (length > j) {
      key = keys[j++];
      if (!descriptors$1$1 || functionCall$1$1(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  }

  return T;
} : $assign$1$1;

var callWithSafeIterationClosing$1$1 = function callWithSafeIterationClosing(iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$1$1(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose$1$1(iterator, 'throw', error);
  }
};

var $Array$5 = Array; // `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from

var arrayFrom$1$1 = function from(arrayLike
/* , mapfn = undefined, thisArg = undefined */
) {
  var O = toObject$1$1(arrayLike);
  var IS_CONSTRUCTOR = isConstructor$1$1(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = functionBindContext$1$1(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod$1$1(O);
  var index = 0;
  var length, result, step, iterator, next, value; // if the target is not iterable or it's an array with the default iterator - use a simple case

  if (iteratorMethod && !(this === $Array$5 && isArrayIteratorMethod$1$1(iteratorMethod))) {
    iterator = getIterator$1$1(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];

    for (; !(step = functionCall$1$1(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing$1$1(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty$1$1(result, index, value);
    }
  } else {
    length = lengthOfArrayLike$1$1(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array$5(length);

    for (; length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty$1$1(result, index, value);
    }
  }

  result.length = index;
  return result;
};

var $Array$1$1$1 = Array;
var max$6 = Math.max;

var arraySliceSimple$1$1 = function arraySliceSimple(O, start, end) {
  var length = lengthOfArrayLike$1$1(O);
  var k = toAbsoluteIndex$1$1(start, length);
  var fin = toAbsoluteIndex$1$1(end === undefined ? length : end, length);
  var result = $Array$1$1$1(max$6(fin - k, 0));

  for (var n = 0; k < fin; k++, n++) {
    createProperty$1$1(result, n, O[k]);
  }

  result.length = n;
  return result;
};

var maxInt$1$1 = 2147483647; // aka. 0x7FFFFFFF or 2^31-1

var base$1$1 = 36;
var tMin$1$1 = 1;
var tMax$1$1 = 26;
var skew$1$1 = 38;
var damp$1$1 = 700;
var initialBias$1$1 = 72;
var initialN$1$1 = 128; // 0x80

var delimiter$1$1 = '-'; // '\x2D'

var regexNonASCII$1$1 = /[^\0-\u007E]/; // non-ASCII chars

var regexSeparators$1$1 = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators

var OVERFLOW_ERROR$1$1 = 'Overflow: input needs wider integers to process';
var baseMinusTMin$1$1 = base$1$1 - tMin$1$1;
var $RangeError$1$1 = RangeError;
var exec$6$1 = functionUncurryThis$1$1(regexSeparators$1$1.exec);
var floor$6 = Math.floor;
var fromCharCode$1$1 = String.fromCharCode;
var charCodeAt$1$1$1 = functionUncurryThis$1$1(''.charCodeAt);
var join$3$1 = functionUncurryThis$1$1([].join);
var push$a = functionUncurryThis$1$1([].push);
var replace$7$1 = functionUncurryThis$1$1(''.replace);
var split$5 = functionUncurryThis$1$1(''.split);
var toLowerCase$2$1 = functionUncurryThis$1$1(''.toLowerCase);
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */

var ucs2decode$1$1 = function ucs2decode(string) {
  var output = [];
  var counter = 0;
  var length = string.length;

  while (counter < length) {
    var value = charCodeAt$1$1$1(string, counter++);

    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = charCodeAt$1$1$1(string, counter++);

      if ((extra & 0xFC00) == 0xDC00) {
        // Low surrogate.
        push$a(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        push$a(output, value);
        counter--;
      }
    } else {
      push$a(output, value);
    }
  }

  return output;
};
/**
 * Converts a digit/integer into a basic code point.
 */


var digitToBasic$1$1 = function digitToBasic(digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */


var adapt$1$1 = function adapt(delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor$6(delta / damp$1$1) : delta >> 1;
  delta += floor$6(delta / numPoints);

  while (delta > baseMinusTMin$1$1 * tMax$1$1 >> 1) {
    delta = floor$6(delta / baseMinusTMin$1$1);
    k += base$1$1;
  }

  return floor$6(k + (baseMinusTMin$1$1 + 1) * delta / (delta + skew$1$1));
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */


var encode$1$1 = function encode(input) {
  var output = []; // Convert the input in UCS-2 to an array of Unicode code points.

  input = ucs2decode$1$1(input); // Cache the length.

  var inputLength = input.length; // Initialize the state.

  var n = initialN$1$1;
  var delta = 0;
  var bias = initialBias$1$1;
  var i, currentValue; // Handle the basic code points.

  for (i = 0; i < input.length; i++) {
    currentValue = input[i];

    if (currentValue < 0x80) {
      push$a(output, fromCharCode$1$1(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.

  var handledCPCount = basicLength; // number of code points that have been handled;
  // Finish the basic string with a delimiter unless it's empty.

  if (basicLength) {
    push$a(output, delimiter$1$1);
  } // Main encoding loop:


  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt$1$1;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];

      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    } // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.


    var handledCPCountPlusOne = handledCPCount + 1;

    if (m - n > floor$6((maxInt$1$1 - delta) / handledCPCountPlusOne)) {
      throw $RangeError$1$1(OVERFLOW_ERROR$1$1);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];

      if (currentValue < n && ++delta > maxInt$1$1) {
        throw $RangeError$1$1(OVERFLOW_ERROR$1$1);
      }

      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        var k = base$1$1;

        while (true) {
          var t = k <= bias ? tMin$1$1 : k >= bias + tMax$1$1 ? tMax$1$1 : k - bias;
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base$1$1 - t;
          push$a(output, fromCharCode$1$1(digitToBasic$1$1(t + qMinusT % baseMinusT)));
          q = floor$6(qMinusT / baseMinusT);
          k += base$1$1;
        }

        push$a(output, fromCharCode$1$1(digitToBasic$1$1(q)));
        bias = adapt$1$1(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        handledCPCount++;
      }
    }

    delta++;
    n++;
  }

  return join$3$1(output, '');
};

var stringPunycodeToAscii$1$1 = function stringPunycodeToAscii(input) {
  var encoded = [];
  var labels = split$5(replace$7$1(toLowerCase$2$1(input), regexSeparators$1$1, "."), '.');
  var i, label;

  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    push$a(encoded, exec$6$1(regexNonASCII$1$1, label) ? 'xn--' + encode$1$1(label) : label);
  }

  return join$3$1(encoded, '.');
};

var defineBuiltIns$1$1 = function defineBuiltIns(target, src, options) {
  for (var key in src) {
    defineBuiltIn$1$1(target, key, src[key], options);
  }

  return target;
};

var floor$1$1$1 = Math.floor;

var mergeSort$1$1 = function mergeSort(array, comparefn) {
  var length = array.length;
  var middle = floor$1$1$1(length / 2);
  return length < 8 ? insertionSort$1$1(array, comparefn) : merge$1$1(array, mergeSort(arraySliceSimple$1$1(array, 0, middle), comparefn), mergeSort(arraySliceSimple$1$1(array, middle), comparefn), comparefn);
};

var insertionSort$1$1 = function insertionSort(array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];

    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }

    if (j !== i++) array[j] = element;
  }

  return array;
};

var merge$1$1 = function merge(array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
  }

  return array;
};

var arraySort$1$1 = mergeSort$1$1;
var ITERATOR$4$1$1 = wellKnownSymbol$1$1('iterator');
var URL_SEARCH_PARAMS$1$1 = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR$1$1 = URL_SEARCH_PARAMS$1$1 + 'Iterator';
var setInternalState$2$1$1 = internalState$1$1.set;
var getInternalParamsState$1$1 = internalState$1$1.getterFor(URL_SEARCH_PARAMS$1$1);
var getInternalIteratorState$1$1 = internalState$1$1.getterFor(URL_SEARCH_PARAMS_ITERATOR$1$1); // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

var getOwnPropertyDescriptor$6$1 = Object.getOwnPropertyDescriptor; // Avoid NodeJS experimental warning

var safeGetBuiltIn$1$1 = function safeGetBuiltIn(name) {
  if (!descriptors$1$1) return global_1$1$1[name];
  var descriptor = getOwnPropertyDescriptor$6$1(global_1$1$1, name);
  return descriptor && descriptor.value;
};

var nativeFetch$1$1 = safeGetBuiltIn$1$1('fetch');
var NativeRequest$1$1 = safeGetBuiltIn$1$1('Request');
var Headers$1$1 = safeGetBuiltIn$1$1('Headers');
var RequestPrototype$1$1 = NativeRequest$1$1 && NativeRequest$1$1.prototype;
var HeadersPrototype$1$1 = Headers$1$1 && Headers$1$1.prototype;
var RegExp$2$1 = global_1$1$1.RegExp;
var TypeError$1$2 = global_1$1$1.TypeError;
var decodeURIComponent$1$1 = global_1$1$1.decodeURIComponent;
var encodeURIComponent$1$1$1 = global_1$1$1.encodeURIComponent;
var charAt$2$1$1 = functionUncurryThis$1$1(''.charAt);
var join$1$1$1 = functionUncurryThis$1$1([].join);
var push$1$1$1 = functionUncurryThis$1$1([].push);
var replace$1$1$1 = functionUncurryThis$1$1(''.replace);
var shift$2$1 = functionUncurryThis$1$1([].shift);
var splice$1$1 = functionUncurryThis$1$1([].splice);
var split$1$1$1 = functionUncurryThis$1$1(''.split);
var stringSlice$1$1$1 = functionUncurryThis$1$1(''.slice);
var plus$1$1 = /\+/g;
var sequences$1$1 = Array(4);

var percentSequence$1$1 = function percentSequence(bytes) {
  return sequences$1$1[bytes - 1] || (sequences$1$1[bytes - 1] = RegExp$2$1('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode$1$1 = function percentDecode(sequence) {
  try {
    return decodeURIComponent$1$1(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize$1$1 = function deserialize(it) {
  var result = replace$1$1$1(it, plus$1$1, ' ');
  var bytes = 4;

  try {
    return decodeURIComponent$1$1(result);
  } catch (error) {
    while (bytes) {
      result = replace$1$1$1(result, percentSequence$1$1(bytes--), percentDecode$1$1);
    }

    return result;
  }
};

var find$1$1 = /[!'()~]|%20/g;
var replacements$1$1 = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer$1$1 = function replacer(match) {
  return replacements$1$1[match];
};

var _serialize = function serialize(it) {
  return replace$1$1$1(encodeURIComponent$1$1$1(it), find$1$1, replacer$1$1);
};

var URLSearchParamsIterator$1$1 = iteratorCreateConstructor$1$1(function Iterator(params, kind) {
  setInternalState$2$1$1(this, {
    type: URL_SEARCH_PARAMS_ITERATOR$1$1,
    iterator: getIterator$1$1(getInternalParamsState$1$1(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState$1$1(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;

  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  }

  return step;
}, true);

var URLSearchParamsState$1$1 = function URLSearchParamsState(init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject$1$1(init)) this.parseObject(init);else this.parseQuery(typeof init == 'string' ? charAt$2$1$1(init, 0) === '?' ? stringSlice$1$1$1(init, 1) : init : toString_1$1$1(init));
  }
};

URLSearchParamsState$1$1.prototype = {
  type: URL_SEARCH_PARAMS$1$1,
  bindURL: function bindURL(url) {
    this.url = url;
    this.update();
  },
  parseObject: function parseObject(object) {
    var iteratorMethod = getIteratorMethod$1$1(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator$1$1(object, iteratorMethod);
      next = iterator.next;

      while (!(step = functionCall$1$1(next, iterator)).done) {
        entryIterator = getIterator$1$1(anObject$1$1(step.value));
        entryNext = entryIterator.next;
        if ((first = functionCall$1$1(entryNext, entryIterator)).done || (second = functionCall$1$1(entryNext, entryIterator)).done || !functionCall$1$1(entryNext, entryIterator).done) throw TypeError$1$2('Expected sequence with length 2');
        push$1$1$1(this.entries, {
          key: toString_1$1$1(first.value),
          value: toString_1$1$1(second.value)
        });
      }
    } else for (var key in object) {
      if (hasOwnProperty_1$1$1(object, key)) {
        push$1$1$1(this.entries, {
          key: key,
          value: toString_1$1$1(object[key])
        });
      }
    }
  },
  parseQuery: function parseQuery(query) {
    if (query) {
      var attributes = split$1$1$1(query, '&');
      var index = 0;
      var attribute, entry;

      while (index < attributes.length) {
        attribute = attributes[index++];

        if (attribute.length) {
          entry = split$1$1$1(attribute, '=');
          push$1$1$1(this.entries, {
            key: deserialize$1$1(shift$2$1(entry)),
            value: deserialize$1$1(join$1$1$1(entry, '='))
          });
        }
      }
    }
  },
  serialize: function serialize() {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;

    while (index < entries.length) {
      entry = entries[index++];
      push$1$1$1(result, _serialize(entry.key) + '=' + _serialize(entry.value));
    }

    return join$1$1$1(result, '&');
  },
  update: function update() {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function updateURL() {
    if (this.url) this.url.update();
  }
}; // `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams

var URLSearchParamsConstructor$1$1 = function URLSearchParams()
/* init */
{
  anInstance$1$1(this, URLSearchParamsPrototype$1$1);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  setInternalState$2$1$1(this, new URLSearchParamsState$1$1(init));
};

var URLSearchParamsPrototype$1$1 = URLSearchParamsConstructor$1$1.prototype;
defineBuiltIns$1$1(URLSearchParamsPrototype$1$1, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength$1$1(arguments.length, 2);
    var state = getInternalParamsState$1$1(this);
    push$1$1$1(state.entries, {
      key: toString_1$1$1(name),
      value: toString_1$1$1(value)
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function _delete(name) {
    validateArgumentsLength$1$1(arguments.length, 1);
    var state = getInternalParamsState$1$1(this);
    var entries = state.entries;
    var key = toString_1$1$1(name);
    var index = 0;

    while (index < entries.length) {
      if (entries[index].key === key) splice$1$1(entries, index, 1);else index++;
    }

    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength$1$1(arguments.length, 1);
    var entries = getInternalParamsState$1$1(this).entries;
    var key = toString_1$1$1(name);
    var index = 0;

    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }

    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength$1$1(arguments.length, 1);
    var entries = getInternalParamsState$1$1(this).entries;
    var key = toString_1$1$1(name);
    var result = [];
    var index = 0;

    for (; index < entries.length; index++) {
      if (entries[index].key === key) push$1$1$1(result, entries[index].value);
    }

    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength$1$1(arguments.length, 1);
    var entries = getInternalParamsState$1$1(this).entries;
    var key = toString_1$1$1(name);
    var index = 0;

    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }

    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength$1$1(arguments.length, 1);
    var state = getInternalParamsState$1$1(this);
    var entries = state.entries;
    var found = false;
    var key = toString_1$1$1(name);
    var val = toString_1$1$1(value);
    var index = 0;
    var entry;

    for (; index < entries.length; index++) {
      entry = entries[index];

      if (entry.key === key) {
        if (found) splice$1$1(entries, index--, 1);else {
          found = true;
          entry.value = val;
        }
      }
    }

    if (!found) push$1$1$1(entries, {
      key: key,
      value: val
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState$1$1(this);
    arraySort$1$1(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback
  /* , thisArg */
  ) {
    var entries = getInternalParamsState$1$1(this).entries;
    var boundFunction = functionBindContext$1$1(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;

    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator$1$1(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator$1$1(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator$1$1(this, 'entries');
  }
}, {
  enumerable: true
}); // `URLSearchParams.prototype[@@iterator]` method

defineBuiltIn$1$1(URLSearchParamsPrototype$1$1, ITERATOR$4$1$1, URLSearchParamsPrototype$1$1.entries, {
  name: 'entries'
}); // `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior

defineBuiltIn$1$1(URLSearchParamsPrototype$1$1, 'toString', function toString() {
  return getInternalParamsState$1$1(this).serialize();
}, {
  enumerable: true
});
setToStringTag$1$1(URLSearchParamsConstructor$1$1, URL_SEARCH_PARAMS$1$1);

_export$1$1({
  global: true,
  constructor: true,
  forced: !urlConstructorDetection$1$1
}, {
  URLSearchParams: URLSearchParamsConstructor$1$1
}); // Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`


if (!urlConstructorDetection$1$1 && isCallable$1$1(Headers$1$1)) {
  var headersHas$1$1 = functionUncurryThis$1$1(HeadersPrototype$1$1.has);
  var headersSet$1$1 = functionUncurryThis$1$1(HeadersPrototype$1$1.set);

  var wrapRequestOptions$1$1 = function wrapRequestOptions(init) {
    if (isObject$1$1(init)) {
      var body = init.body;
      var headers;

      if (classof$1$1(body) === URL_SEARCH_PARAMS$1$1) {
        headers = init.headers ? new Headers$1$1(init.headers) : new Headers$1$1();

        if (!headersHas$1$1(headers, 'content-type')) {
          headersSet$1$1(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }

        return objectCreate$1$1(init, {
          body: createPropertyDescriptor$1$1(0, toString_1$1$1(body)),
          headers: createPropertyDescriptor$1$1(0, headers)
        });
      }
    }

    return init;
  };

  if (isCallable$1$1(nativeFetch$1$1)) {
    _export$1$1({
      global: true,
      enumerable: true,
      dontCallGetSet: true,
      forced: true
    }, {
      fetch: function fetch(input
      /* , init */
      ) {
        return nativeFetch$1$1(input, arguments.length > 1 ? wrapRequestOptions$1$1(arguments[1]) : {});
      }
    });
  }

  if (isCallable$1$1(NativeRequest$1$1)) {
    var RequestConstructor$1$1 = function Request(input
    /* , init */
    ) {
      anInstance$1$1(this, RequestPrototype$1$1);
      return new NativeRequest$1$1(input, arguments.length > 1 ? wrapRequestOptions$1$1(arguments[1]) : {});
    };

    RequestPrototype$1$1.constructor = RequestConstructor$1$1;
    RequestConstructor$1$1.prototype = RequestPrototype$1$1;

    _export$1$1({
      global: true,
      constructor: true,
      dontCallGetSet: true,
      forced: true
    }, {
      Request: RequestConstructor$1$1
    });
  }
}

var web_urlSearchParams_constructor$1$1 = {
  URLSearchParams: URLSearchParamsConstructor$1$1,
  getState: getInternalParamsState$1$1
};
var codeAt$1$1 = stringMultibyte$1$1.codeAt;
var setInternalState$3$1$1 = internalState$1$1.set;
var getInternalURLState$1$1 = internalState$1$1.getterFor('URL');
var URLSearchParams$1$1$1 = web_urlSearchParams_constructor$1$1.URLSearchParams;
var getInternalSearchParamsState$1$1 = web_urlSearchParams_constructor$1$1.getState;
var NativeURL$1$1 = global_1$1$1.URL;
var TypeError$2$2 = global_1$1$1.TypeError;
var parseInt$1$1 = global_1$1$1.parseInt;
var floor$2$1$1 = Math.floor;
var pow$1$1 = Math.pow;
var charAt$3$1$1 = functionUncurryThis$1$1(''.charAt);
var exec$1$1$1 = functionUncurryThis$1$1(/./.exec);
var join$2$1$1 = functionUncurryThis$1$1([].join);
var numberToString$2$1 = functionUncurryThis$1$1(1.0.toString);
var pop$1$1 = functionUncurryThis$1$1([].pop);
var push$2$1$1 = functionUncurryThis$1$1([].push);
var replace$2$1$1 = functionUncurryThis$1$1(''.replace);
var shift$1$1$1 = functionUncurryThis$1$1([].shift);
var split$2$1$1 = functionUncurryThis$1$1(''.split);
var stringSlice$2$1$1 = functionUncurryThis$1$1(''.slice);
var toLowerCase$1$1$1 = functionUncurryThis$1$1(''.toLowerCase);
var unshift$1$1 = functionUncurryThis$1$1([].unshift);
var INVALID_AUTHORITY$1$1 = 'Invalid authority';
var INVALID_SCHEME$1$1 = 'Invalid scheme';
var INVALID_HOST$1$1 = 'Invalid host';
var INVALID_PORT$1$1 = 'Invalid port';
var ALPHA$1$1 = /[a-z]/i; // eslint-disable-next-line regexp/no-obscure-range -- safe

var ALPHANUMERIC$1$1 = /[\d+-.a-z]/i;
var DIGIT$1$1 = /\d/;
var HEX_START$1$1 = /^0x/i;
var OCT$1$1 = /^[0-7]+$/;
var DEC$1$1 = /^\d+$/;
var HEX$1$1 = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */

var FORBIDDEN_HOST_CODE_POINT$1$1 = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT$1$1 = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE$1$1 = /^[\u0000-\u0020]+|[\u0000-\u0020]+$/g;
var TAB_AND_NEW_LINE$1$1 = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */

var EOF$1$1; // https://url.spec.whatwg.org/#ipv4-number-parser

var parseIPv4$1$1 = function parseIPv4(input) {
  var parts = split$2$1$1(input, '.');
  var partsLength, numbers, index, part, radix, number, ipv4;

  if (parts.length && parts[parts.length - 1] == '') {
    parts.length--;
  }

  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];

  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;

    if (part.length > 1 && charAt$3$1$1(part, 0) == '0') {
      radix = exec$1$1$1(HEX_START$1$1, part) ? 16 : 8;
      part = stringSlice$2$1$1(part, radix == 8 ? 1 : 2);
    }

    if (part === '') {
      number = 0;
    } else {
      if (!exec$1$1$1(radix == 10 ? DEC$1$1 : radix == 8 ? OCT$1$1 : HEX$1$1, part)) return input;
      number = parseInt$1$1(part, radix);
    }

    push$2$1$1(numbers, number);
  }

  for (index = 0; index < partsLength; index++) {
    number = numbers[index];

    if (index == partsLength - 1) {
      if (number >= pow$1$1(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }

  ipv4 = pop$1$1(numbers);

  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow$1$1(256, 3 - index);
  }

  return ipv4;
}; // https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO


var parseIPv6$1$1 = function parseIPv6(input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function chr() {
    return charAt$3$1$1(input, pointer);
  };

  if (chr() == ':') {
    if (charAt$3$1$1(input, 1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }

  while (chr()) {
    if (pieceIndex == 8) return;

    if (chr() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }

    value = length = 0;

    while (length < 4 && exec$1$1$1(HEX$1$1, chr())) {
      value = value * 16 + parseInt$1$1(chr(), 16);
      pointer++;
      length++;
    }

    if (chr() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;

      while (chr()) {
        ipv4Piece = null;

        if (numbersSeen > 0) {
          if (chr() == '.' && numbersSeen < 4) pointer++;else return;
        }

        if (!exec$1$1$1(DIGIT$1$1, chr())) return;

        while (exec$1$1$1(DIGIT$1$1, chr())) {
          number = parseInt$1$1(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;else if (ipv4Piece == 0) return;else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }

        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }

      if (numbersSeen != 4) return;
      break;
    } else if (chr() == ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;

    address[pieceIndex++] = value;
  }

  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;

    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;

  return address;
};

var findLongestZeroSequence$1$1 = function findLongestZeroSequence(ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;

  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }

      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }

  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }

  return maxIndex;
}; // https://url.spec.whatwg.org/#host-serializing


var serializeHost$1$1 = function serializeHost(host) {
  var result, index, compress, ignore0; // ipv4

  if (typeof host == 'number') {
    result = [];

    for (index = 0; index < 4; index++) {
      unshift$1$1(result, host % 256);
      host = floor$2$1$1(host / 256);
    }

    return join$2$1$1(result, '.'); // ipv6
  } else if (_typeof(host) == 'object') {
    result = '';
    compress = findLongestZeroSequence$1$1(host);

    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;

      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += numberToString$2$1(host[index], 16);
        if (index < 7) result += ':';
      }
    }

    return '[' + result + ']';
  }

  return host;
};

var C0ControlPercentEncodeSet$1$1 = {};
var fragmentPercentEncodeSet$1$1 = objectAssign$1$1({}, C0ControlPercentEncodeSet$1$1, {
  ' ': 1,
  '"': 1,
  '<': 1,
  '>': 1,
  '`': 1
});
var pathPercentEncodeSet$1$1 = objectAssign$1$1({}, fragmentPercentEncodeSet$1$1, {
  '#': 1,
  '?': 1,
  '{': 1,
  '}': 1
});
var userinfoPercentEncodeSet$1$1 = objectAssign$1$1({}, pathPercentEncodeSet$1$1, {
  '/': 1,
  ':': 1,
  ';': 1,
  '=': 1,
  '@': 1,
  '[': 1,
  '\\': 1,
  ']': 1,
  '^': 1,
  '|': 1
});

var percentEncode$1$1 = function percentEncode(chr, set) {
  var code = codeAt$1$1(chr, 0);
  return code > 0x20 && code < 0x7F && !hasOwnProperty_1$1$1(set, chr) ? chr : encodeURIComponent(chr);
}; // https://url.spec.whatwg.org/#special-scheme


var specialSchemes$1$1 = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
}; // https://url.spec.whatwg.org/#windows-drive-letter

var isWindowsDriveLetter$1$1 = function isWindowsDriveLetter(string, normalized) {
  var second;
  return string.length == 2 && exec$1$1$1(ALPHA$1$1, charAt$3$1$1(string, 0)) && ((second = charAt$3$1$1(string, 1)) == ':' || !normalized && second == '|');
}; // https://url.spec.whatwg.org/#start-with-a-windows-drive-letter


var startsWithWindowsDriveLetter$1$1 = function startsWithWindowsDriveLetter(string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter$1$1(stringSlice$2$1$1(string, 0, 2)) && (string.length == 2 || (third = charAt$3$1$1(string, 2)) === '/' || third === '\\' || third === '?' || third === '#');
}; // https://url.spec.whatwg.org/#single-dot-path-segment


var isSingleDot$1$1 = function isSingleDot(segment) {
  return segment === '.' || toLowerCase$1$1$1(segment) === '%2e';
}; // https://url.spec.whatwg.org/#double-dot-path-segment


var isDoubleDot$1$1 = function isDoubleDot(segment) {
  segment = toLowerCase$1$1$1(segment);
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
}; // States:


var SCHEME_START$1$1 = {};
var SCHEME$1$1 = {};
var NO_SCHEME$1$1 = {};
var SPECIAL_RELATIVE_OR_AUTHORITY$1$1 = {};
var PATH_OR_AUTHORITY$1$1 = {};
var RELATIVE$1$1 = {};
var RELATIVE_SLASH$1$1 = {};
var SPECIAL_AUTHORITY_SLASHES$1$1 = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES$1$1 = {};
var AUTHORITY$1$1 = {};
var HOST$1$1 = {};
var HOSTNAME$1$1 = {};
var PORT$1$1 = {};
var FILE$1$1 = {};
var FILE_SLASH$1$1 = {};
var FILE_HOST$1$1 = {};
var PATH_START$1$1 = {};
var PATH$1$1 = {};
var CANNOT_BE_A_BASE_URL_PATH$1$1 = {};
var QUERY$1$1 = {};
var FRAGMENT$1$1 = {};

var URLState$1$1 = function URLState(url, isBase, base) {
  var urlString = toString_1$1$1(url);
  var baseState, failure, searchParams;

  if (isBase) {
    failure = this.parse(urlString);
    if (failure) throw TypeError$2$2(failure);
    this.searchParams = null;
  } else {
    if (base !== undefined) baseState = new URLState(base, true);
    failure = this.parse(urlString, null, baseState);
    if (failure) throw TypeError$2$2(failure);
    searchParams = getInternalSearchParamsState$1$1(new URLSearchParams$1$1$1());
    searchParams.bindURL(this);
    this.searchParams = searchParams;
  }
};

URLState$1$1.prototype = {
  type: 'URL',
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function parse(input, stateOverride, base) {
    var url = this;
    var state = stateOverride || SCHEME_START$1$1;
    var pointer = 0;
    var buffer = '';
    var seenAt = false;
    var seenBracket = false;
    var seenPasswordToken = false;
    var codePoints, chr, bufferCodePoints, failure;
    input = toString_1$1$1(input);

    if (!stateOverride) {
      url.scheme = '';
      url.username = '';
      url.password = '';
      url.host = null;
      url.port = null;
      url.path = [];
      url.query = null;
      url.fragment = null;
      url.cannotBeABaseURL = false;
      input = replace$2$1$1(input, LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE$1$1, '');
    }

    input = replace$2$1$1(input, TAB_AND_NEW_LINE$1$1, '');
    codePoints = arrayFrom$1$1(input);

    while (pointer <= codePoints.length) {
      chr = codePoints[pointer];

      switch (state) {
        case SCHEME_START$1$1:
          if (chr && exec$1$1$1(ALPHA$1$1, chr)) {
            buffer += toLowerCase$1$1$1(chr);
            state = SCHEME$1$1;
          } else if (!stateOverride) {
            state = NO_SCHEME$1$1;
            continue;
          } else return INVALID_SCHEME$1$1;

          break;

        case SCHEME$1$1:
          if (chr && (exec$1$1$1(ALPHANUMERIC$1$1, chr) || chr == '+' || chr == '-' || chr == '.')) {
            buffer += toLowerCase$1$1$1(chr);
          } else if (chr == ':') {
            if (stateOverride && (url.isSpecial() != hasOwnProperty_1$1$1(specialSchemes$1$1, buffer) || buffer == 'file' && (url.includesCredentials() || url.port !== null) || url.scheme == 'file' && !url.host)) return;
            url.scheme = buffer;

            if (stateOverride) {
              if (url.isSpecial() && specialSchemes$1$1[url.scheme] == url.port) url.port = null;
              return;
            }

            buffer = '';

            if (url.scheme == 'file') {
              state = FILE$1$1;
            } else if (url.isSpecial() && base && base.scheme == url.scheme) {
              state = SPECIAL_RELATIVE_OR_AUTHORITY$1$1;
            } else if (url.isSpecial()) {
              state = SPECIAL_AUTHORITY_SLASHES$1$1;
            } else if (codePoints[pointer + 1] == '/') {
              state = PATH_OR_AUTHORITY$1$1;
              pointer++;
            } else {
              url.cannotBeABaseURL = true;
              push$2$1$1(url.path, '');
              state = CANNOT_BE_A_BASE_URL_PATH$1$1;
            }
          } else if (!stateOverride) {
            buffer = '';
            state = NO_SCHEME$1$1;
            pointer = 0;
            continue;
          } else return INVALID_SCHEME$1$1;

          break;

        case NO_SCHEME$1$1:
          if (!base || base.cannotBeABaseURL && chr != '#') return INVALID_SCHEME$1$1;

          if (base.cannotBeABaseURL && chr == '#') {
            url.scheme = base.scheme;
            url.path = arraySliceSimple$1$1(base.path);
            url.query = base.query;
            url.fragment = '';
            url.cannotBeABaseURL = true;
            state = FRAGMENT$1$1;
            break;
          }

          state = base.scheme == 'file' ? FILE$1$1 : RELATIVE$1$1;
          continue;

        case SPECIAL_RELATIVE_OR_AUTHORITY$1$1:
          if (chr == '/' && codePoints[pointer + 1] == '/') {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES$1$1;
            pointer++;
          } else {
            state = RELATIVE$1$1;
            continue;
          }

          break;

        case PATH_OR_AUTHORITY$1$1:
          if (chr == '/') {
            state = AUTHORITY$1$1;
            break;
          } else {
            state = PATH$1$1;
            continue;
          }

        case RELATIVE$1$1:
          url.scheme = base.scheme;

          if (chr == EOF$1$1) {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySliceSimple$1$1(base.path);
            url.query = base.query;
          } else if (chr == '/' || chr == '\\' && url.isSpecial()) {
            state = RELATIVE_SLASH$1$1;
          } else if (chr == '?') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySliceSimple$1$1(base.path);
            url.query = '';
            state = QUERY$1$1;
          } else if (chr == '#') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySliceSimple$1$1(base.path);
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT$1$1;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySliceSimple$1$1(base.path);
            url.path.length--;
            state = PATH$1$1;
            continue;
          }

          break;

        case RELATIVE_SLASH$1$1:
          if (url.isSpecial() && (chr == '/' || chr == '\\')) {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES$1$1;
          } else if (chr == '/') {
            state = AUTHORITY$1$1;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            state = PATH$1$1;
            continue;
          }

          break;

        case SPECIAL_AUTHORITY_SLASHES$1$1:
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES$1$1;
          if (chr != '/' || charAt$3$1$1(buffer, pointer + 1) != '/') continue;
          pointer++;
          break;

        case SPECIAL_AUTHORITY_IGNORE_SLASHES$1$1:
          if (chr != '/' && chr != '\\') {
            state = AUTHORITY$1$1;
            continue;
          }

          break;

        case AUTHORITY$1$1:
          if (chr == '@') {
            if (seenAt) buffer = '%40' + buffer;
            seenAt = true;
            bufferCodePoints = arrayFrom$1$1(buffer);

            for (var i = 0; i < bufferCodePoints.length; i++) {
              var codePoint = bufferCodePoints[i];

              if (codePoint == ':' && !seenPasswordToken) {
                seenPasswordToken = true;
                continue;
              }

              var encodedCodePoints = percentEncode$1$1(codePoint, userinfoPercentEncodeSet$1$1);
              if (seenPasswordToken) url.password += encodedCodePoints;else url.username += encodedCodePoints;
            }

            buffer = '';
          } else if (chr == EOF$1$1 || chr == '/' || chr == '?' || chr == '#' || chr == '\\' && url.isSpecial()) {
            if (seenAt && buffer == '') return INVALID_AUTHORITY$1$1;
            pointer -= arrayFrom$1$1(buffer).length + 1;
            buffer = '';
            state = HOST$1$1;
          } else buffer += chr;

          break;

        case HOST$1$1:
        case HOSTNAME$1$1:
          if (stateOverride && url.scheme == 'file') {
            state = FILE_HOST$1$1;
            continue;
          } else if (chr == ':' && !seenBracket) {
            if (buffer == '') return INVALID_HOST$1$1;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PORT$1$1;
            if (stateOverride == HOSTNAME$1$1) return;
          } else if (chr == EOF$1$1 || chr == '/' || chr == '?' || chr == '#' || chr == '\\' && url.isSpecial()) {
            if (url.isSpecial() && buffer == '') return INVALID_HOST$1$1;
            if (stateOverride && buffer == '' && (url.includesCredentials() || url.port !== null)) return;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PATH_START$1$1;
            if (stateOverride) return;
            continue;
          } else {
            if (chr == '[') seenBracket = true;else if (chr == ']') seenBracket = false;
            buffer += chr;
          }

          break;

        case PORT$1$1:
          if (exec$1$1$1(DIGIT$1$1, chr)) {
            buffer += chr;
          } else if (chr == EOF$1$1 || chr == '/' || chr == '?' || chr == '#' || chr == '\\' && url.isSpecial() || stateOverride) {
            if (buffer != '') {
              var port = parseInt$1$1(buffer, 10);
              if (port > 0xFFFF) return INVALID_PORT$1$1;
              url.port = url.isSpecial() && port === specialSchemes$1$1[url.scheme] ? null : port;
              buffer = '';
            }

            if (stateOverride) return;
            state = PATH_START$1$1;
            continue;
          } else return INVALID_PORT$1$1;

          break;

        case FILE$1$1:
          url.scheme = 'file';
          if (chr == '/' || chr == '\\') state = FILE_SLASH$1$1;else if (base && base.scheme == 'file') {
            if (chr == EOF$1$1) {
              url.host = base.host;
              url.path = arraySliceSimple$1$1(base.path);
              url.query = base.query;
            } else if (chr == '?') {
              url.host = base.host;
              url.path = arraySliceSimple$1$1(base.path);
              url.query = '';
              state = QUERY$1$1;
            } else if (chr == '#') {
              url.host = base.host;
              url.path = arraySliceSimple$1$1(base.path);
              url.query = base.query;
              url.fragment = '';
              state = FRAGMENT$1$1;
            } else {
              if (!startsWithWindowsDriveLetter$1$1(join$2$1$1(arraySliceSimple$1$1(codePoints, pointer), ''))) {
                url.host = base.host;
                url.path = arraySliceSimple$1$1(base.path);
                url.shortenPath();
              }

              state = PATH$1$1;
              continue;
            }
          } else {
            state = PATH$1$1;
            continue;
          }
          break;

        case FILE_SLASH$1$1:
          if (chr == '/' || chr == '\\') {
            state = FILE_HOST$1$1;
            break;
          }

          if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter$1$1(join$2$1$1(arraySliceSimple$1$1(codePoints, pointer), ''))) {
            if (isWindowsDriveLetter$1$1(base.path[0], true)) push$2$1$1(url.path, base.path[0]);else url.host = base.host;
          }

          state = PATH$1$1;
          continue;

        case FILE_HOST$1$1:
          if (chr == EOF$1$1 || chr == '/' || chr == '\\' || chr == '?' || chr == '#') {
            if (!stateOverride && isWindowsDriveLetter$1$1(buffer)) {
              state = PATH$1$1;
            } else if (buffer == '') {
              url.host = '';
              if (stateOverride) return;
              state = PATH_START$1$1;
            } else {
              failure = url.parseHost(buffer);
              if (failure) return failure;
              if (url.host == 'localhost') url.host = '';
              if (stateOverride) return;
              buffer = '';
              state = PATH_START$1$1;
            }

            continue;
          } else buffer += chr;

          break;

        case PATH_START$1$1:
          if (url.isSpecial()) {
            state = PATH$1$1;
            if (chr != '/' && chr != '\\') continue;
          } else if (!stateOverride && chr == '?') {
            url.query = '';
            state = QUERY$1$1;
          } else if (!stateOverride && chr == '#') {
            url.fragment = '';
            state = FRAGMENT$1$1;
          } else if (chr != EOF$1$1) {
            state = PATH$1$1;
            if (chr != '/') continue;
          }

          break;

        case PATH$1$1:
          if (chr == EOF$1$1 || chr == '/' || chr == '\\' && url.isSpecial() || !stateOverride && (chr == '?' || chr == '#')) {
            if (isDoubleDot$1$1(buffer)) {
              url.shortenPath();

              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                push$2$1$1(url.path, '');
              }
            } else if (isSingleDot$1$1(buffer)) {
              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                push$2$1$1(url.path, '');
              }
            } else {
              if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter$1$1(buffer)) {
                if (url.host) url.host = '';
                buffer = charAt$3$1$1(buffer, 0) + ':'; // normalize windows drive letter
              }

              push$2$1$1(url.path, buffer);
            }

            buffer = '';

            if (url.scheme == 'file' && (chr == EOF$1$1 || chr == '?' || chr == '#')) {
              while (url.path.length > 1 && url.path[0] === '') {
                shift$1$1$1(url.path);
              }
            }

            if (chr == '?') {
              url.query = '';
              state = QUERY$1$1;
            } else if (chr == '#') {
              url.fragment = '';
              state = FRAGMENT$1$1;
            }
          } else {
            buffer += percentEncode$1$1(chr, pathPercentEncodeSet$1$1);
          }

          break;

        case CANNOT_BE_A_BASE_URL_PATH$1$1:
          if (chr == '?') {
            url.query = '';
            state = QUERY$1$1;
          } else if (chr == '#') {
            url.fragment = '';
            state = FRAGMENT$1$1;
          } else if (chr != EOF$1$1) {
            url.path[0] += percentEncode$1$1(chr, C0ControlPercentEncodeSet$1$1);
          }

          break;

        case QUERY$1$1:
          if (!stateOverride && chr == '#') {
            url.fragment = '';
            state = FRAGMENT$1$1;
          } else if (chr != EOF$1$1) {
            if (chr == "'" && url.isSpecial()) url.query += '%27';else if (chr == '#') url.query += '%23';else url.query += percentEncode$1$1(chr, C0ControlPercentEncodeSet$1$1);
          }

          break;

        case FRAGMENT$1$1:
          if (chr != EOF$1$1) url.fragment += percentEncode$1$1(chr, fragmentPercentEncodeSet$1$1);
          break;
      }

      pointer++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function parseHost(input) {
    var result, codePoints, index;

    if (charAt$3$1$1(input, 0) == '[') {
      if (charAt$3$1$1(input, input.length - 1) != ']') return INVALID_HOST$1$1;
      result = parseIPv6$1$1(stringSlice$2$1$1(input, 1, -1));
      if (!result) return INVALID_HOST$1$1;
      this.host = result; // opaque host
    } else if (!this.isSpecial()) {
      if (exec$1$1$1(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT$1$1, input)) return INVALID_HOST$1$1;
      result = '';
      codePoints = arrayFrom$1$1(input);

      for (index = 0; index < codePoints.length; index++) {
        result += percentEncode$1$1(codePoints[index], C0ControlPercentEncodeSet$1$1);
      }

      this.host = result;
    } else {
      input = stringPunycodeToAscii$1$1(input);
      if (exec$1$1$1(FORBIDDEN_HOST_CODE_POINT$1$1, input)) return INVALID_HOST$1$1;
      result = parseIPv4$1$1(input);
      if (result === null) return INVALID_HOST$1$1;
      this.host = result;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function cannotHaveUsernamePasswordPort() {
    return !this.host || this.cannotBeABaseURL || this.scheme == 'file';
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function includesCredentials() {
    return this.username != '' || this.password != '';
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function isSpecial() {
    return hasOwnProperty_1$1$1(specialSchemes$1$1, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function shortenPath() {
    var path = this.path;
    var pathSize = path.length;

    if (pathSize && (this.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter$1$1(path[0], true))) {
      path.length--;
    }
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function serialize() {
    var url = this;
    var scheme = url.scheme;
    var username = url.username;
    var password = url.password;
    var host = url.host;
    var port = url.port;
    var path = url.path;
    var query = url.query;
    var fragment = url.fragment;
    var output = scheme + ':';

    if (host !== null) {
      output += '//';

      if (url.includesCredentials()) {
        output += username + (password ? ':' + password : '') + '@';
      }

      output += serializeHost$1$1(host);
      if (port !== null) output += ':' + port;
    } else if (scheme == 'file') output += '//';

    output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join$2$1$1(path, '/') : '';
    if (query !== null) output += '?' + query;
    if (fragment !== null) output += '#' + fragment;
    return output;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function setHref(href) {
    var failure = this.parse(href);
    if (failure) throw TypeError$2$2(failure);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function getOrigin() {
    var scheme = this.scheme;
    var port = this.port;
    if (scheme == 'blob') try {
      return new URLConstructor$1$1(scheme.path[0]).origin;
    } catch (error) {
      return 'null';
    }
    if (scheme == 'file' || !this.isSpecial()) return 'null';
    return scheme + '://' + serializeHost$1$1(this.host) + (port !== null ? ':' + port : '');
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function getProtocol() {
    return this.scheme + ':';
  },
  setProtocol: function setProtocol(protocol) {
    this.parse(toString_1$1$1(protocol) + ':', SCHEME_START$1$1);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function getUsername() {
    return this.username;
  },
  setUsername: function setUsername(username) {
    var codePoints = arrayFrom$1$1(toString_1$1$1(username));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.username = '';

    for (var i = 0; i < codePoints.length; i++) {
      this.username += percentEncode$1$1(codePoints[i], userinfoPercentEncodeSet$1$1);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function getPassword() {
    return this.password;
  },
  setPassword: function setPassword(password) {
    var codePoints = arrayFrom$1$1(toString_1$1$1(password));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.password = '';

    for (var i = 0; i < codePoints.length; i++) {
      this.password += percentEncode$1$1(codePoints[i], userinfoPercentEncodeSet$1$1);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function getHost() {
    var host = this.host;
    var port = this.port;
    return host === null ? '' : port === null ? serializeHost$1$1(host) : serializeHost$1$1(host) + ':' + port;
  },
  setHost: function setHost(host) {
    if (this.cannotBeABaseURL) return;
    this.parse(host, HOST$1$1);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function getHostname() {
    var host = this.host;
    return host === null ? '' : serializeHost$1$1(host);
  },
  setHostname: function setHostname(hostname) {
    if (this.cannotBeABaseURL) return;
    this.parse(hostname, HOSTNAME$1$1);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function getPort() {
    var port = this.port;
    return port === null ? '' : toString_1$1$1(port);
  },
  setPort: function setPort(port) {
    if (this.cannotHaveUsernamePasswordPort()) return;
    port = toString_1$1$1(port);
    if (port == '') this.port = null;else this.parse(port, PORT$1$1);
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function getPathname() {
    var path = this.path;
    return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join$2$1$1(path, '/') : '';
  },
  setPathname: function setPathname(pathname) {
    if (this.cannotBeABaseURL) return;
    this.path = [];
    this.parse(pathname, PATH_START$1$1);
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function getSearch() {
    var query = this.query;
    return query ? '?' + query : '';
  },
  setSearch: function setSearch(search) {
    search = toString_1$1$1(search);

    if (search == '') {
      this.query = null;
    } else {
      if ('?' == charAt$3$1$1(search, 0)) search = stringSlice$2$1$1(search, 1);
      this.query = '';
      this.parse(search, QUERY$1$1);
    }

    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function getSearchParams() {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function getHash() {
    var fragment = this.fragment;
    return fragment ? '#' + fragment : '';
  },
  setHash: function setHash(hash) {
    hash = toString_1$1$1(hash);

    if (hash == '') {
      this.fragment = null;
      return;
    }

    if ('#' == charAt$3$1$1(hash, 0)) hash = stringSlice$2$1$1(hash, 1);
    this.fragment = '';
    this.parse(hash, FRAGMENT$1$1);
  },
  update: function update() {
    this.query = this.searchParams.serialize() || null;
  }
}; // `URL` constructor
// https://url.spec.whatwg.org/#url-class

var URLConstructor$1$1 = function URL(url
/* , base */
) {
  var that = anInstance$1$1(this, URLPrototype$1$1);
  var base = validateArgumentsLength$1$1(arguments.length, 1) > 1 ? arguments[1] : undefined;
  var state = setInternalState$3$1$1(that, new URLState$1$1(url, false, base));

  if (!descriptors$1$1) {
    that.href = state.serialize();
    that.origin = state.getOrigin();
    that.protocol = state.getProtocol();
    that.username = state.getUsername();
    that.password = state.getPassword();
    that.host = state.getHost();
    that.hostname = state.getHostname();
    that.port = state.getPort();
    that.pathname = state.getPathname();
    that.search = state.getSearch();
    that.searchParams = state.getSearchParams();
    that.hash = state.getHash();
  }
};

var URLPrototype$1$1 = URLConstructor$1$1.prototype;

var accessorDescriptor$1$1 = function accessorDescriptor(getter, setter) {
  return {
    get: function get() {
      return getInternalURLState$1$1(this)[getter]();
    },
    set: setter && function (value) {
      return getInternalURLState$1$1(this)[setter](value);
    },
    configurable: true,
    enumerable: true
  };
};

if (descriptors$1$1) {
  // `URL.prototype.href` accessors pair
  // https://url.spec.whatwg.org/#dom-url-href
  defineBuiltInAccessor$1$1(URLPrototype$1$1, 'href', accessorDescriptor$1$1('serialize', 'setHref')); // `URL.prototype.origin` getter
  // https://url.spec.whatwg.org/#dom-url-origin

  defineBuiltInAccessor$1$1(URLPrototype$1$1, 'origin', accessorDescriptor$1$1('getOrigin')); // `URL.prototype.protocol` accessors pair
  // https://url.spec.whatwg.org/#dom-url-protocol

  defineBuiltInAccessor$1$1(URLPrototype$1$1, 'protocol', accessorDescriptor$1$1('getProtocol', 'setProtocol')); // `URL.prototype.username` accessors pair
  // https://url.spec.whatwg.org/#dom-url-username

  defineBuiltInAccessor$1$1(URLPrototype$1$1, 'username', accessorDescriptor$1$1('getUsername', 'setUsername')); // `URL.prototype.password` accessors pair
  // https://url.spec.whatwg.org/#dom-url-password

  defineBuiltInAccessor$1$1(URLPrototype$1$1, 'password', accessorDescriptor$1$1('getPassword', 'setPassword')); // `URL.prototype.host` accessors pair
  // https://url.spec.whatwg.org/#dom-url-host

  defineBuiltInAccessor$1$1(URLPrototype$1$1, 'host', accessorDescriptor$1$1('getHost', 'setHost')); // `URL.prototype.hostname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hostname

  defineBuiltInAccessor$1$1(URLPrototype$1$1, 'hostname', accessorDescriptor$1$1('getHostname', 'setHostname')); // `URL.prototype.port` accessors pair
  // https://url.spec.whatwg.org/#dom-url-port

  defineBuiltInAccessor$1$1(URLPrototype$1$1, 'port', accessorDescriptor$1$1('getPort', 'setPort')); // `URL.prototype.pathname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-pathname

  defineBuiltInAccessor$1$1(URLPrototype$1$1, 'pathname', accessorDescriptor$1$1('getPathname', 'setPathname')); // `URL.prototype.search` accessors pair
  // https://url.spec.whatwg.org/#dom-url-search

  defineBuiltInAccessor$1$1(URLPrototype$1$1, 'search', accessorDescriptor$1$1('getSearch', 'setSearch')); // `URL.prototype.searchParams` getter
  // https://url.spec.whatwg.org/#dom-url-searchparams

  defineBuiltInAccessor$1$1(URLPrototype$1$1, 'searchParams', accessorDescriptor$1$1('getSearchParams')); // `URL.prototype.hash` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hash

  defineBuiltInAccessor$1$1(URLPrototype$1$1, 'hash', accessorDescriptor$1$1('getHash', 'setHash'));
} // `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson


defineBuiltIn$1$1(URLPrototype$1$1, 'toJSON', function toJSON() {
  return getInternalURLState$1$1(this).serialize();
}, {
  enumerable: true
}); // `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior

defineBuiltIn$1$1(URLPrototype$1$1, 'toString', function toString() {
  return getInternalURLState$1$1(this).serialize();
}, {
  enumerable: true
});

if (NativeURL$1$1) {
  var nativeCreateObjectURL$1$1 = NativeURL$1$1.createObjectURL;
  var nativeRevokeObjectURL$1$1 = NativeURL$1$1.revokeObjectURL; // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL

  if (nativeCreateObjectURL$1$1) defineBuiltIn$1$1(URLConstructor$1$1, 'createObjectURL', functionBindContext$1$1(nativeCreateObjectURL$1$1, NativeURL$1$1)); // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL

  if (nativeRevokeObjectURL$1$1) defineBuiltIn$1$1(URLConstructor$1$1, 'revokeObjectURL', functionBindContext$1$1(nativeRevokeObjectURL$1$1, NativeURL$1$1));
}

setToStringTag$1$1(URLConstructor$1$1, 'URL');

_export$1$1({
  global: true,
  constructor: true,
  forced: !urlConstructorDetection$1$1,
  sham: !descriptors$1$1
}, {
  URL: URLConstructor$1$1
});

var getJson = function getJson(url) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.origin;
  return function (headers, queryParams) {
    return fetchHandler("".concat(origin).concat(url) + (!!queryParams ? "?".concat(new URLSearchParams(queryParams)) : ''), {
      method: 'GET',
      headers: headers !== null && headers !== void 0 ? headers : {},
      credentials: 'same-origin'
    }, 30000);
  };
};

var $filter$1 = arrayIteration$1.filter;
var HAS_SPECIES_SUPPORT$2$1 = arrayMethodHasSpeciesSupport$1('filter'); // `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species

_export$1({
  target: 'Array',
  proto: true,
  forced: !HAS_SPECIES_SUPPORT$2$1
}, {
  filter: function filter(callbackfn
  /* , thisArg */
  ) {
    return $filter$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
}); // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors


_export$1({
  target: 'Object',
  stat: true,
  sham: !descriptors$1
}, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject$1(object);
    var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor$1.f;
    var keys = ownKeys$1(O);
    var result = {};
    var index = 0;
    var key, descriptor;

    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty$1(result, key, descriptor);
    }

    return result;
  }
});

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/**
 * safely send post request by json
 */


var postJson = function postJson(url) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.origin;
  return function (requestBody, headers) {
    return fetchHandler("".concat(origin).concat(url), {
      method: 'POST',
      headers: _objectSpread2(_objectSpread2({}, headers), {}, {
        'Content-Type': 'application/json; charset=utf-8'
      }),
      body: JSON.stringify(requestBody),
      credentials: 'same-origin'
    }, 30000);
  };
};
/**
 * safely send post request by json
 */


var patchJson = function patchJson(url) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.origin;
  return function (requestBody, headers) {
    return fetchHandler("".concat(origin).concat(url), {
      method: 'PATCH',
      headers: _objectSpread2(_objectSpread2({}, headers), {}, {
        'Content-Type': 'application/json; charset=utf-8'
      }),
      body: JSON.stringify(requestBody),
      credentials: 'same-origin'
    }, 30000);
  };
};

var ULRequest = {
  getJson: getJson,
  postJson: postJson,
  patchJson: patchJson
};

var ULRequestUniversalLoginApiClient = function ULRequestUniversalLoginApiClient(ulApiOrigin) {
  _classCallCheck(this, ULRequestUniversalLoginApiClient);

  _defineProperty(this, "signIn", void 0);

  _defineProperty(this, "initialOtpLogin", void 0);

  _defineProperty(this, "otpLogin", void 0);

  _defineProperty(this, "oauth", void 0);

  _defineProperty(this, "initialForgotPassword", void 0);

  _defineProperty(this, "forgotPasswordEmail", void 0);

  _defineProperty(this, "forgotPasswordPhone", void 0);

  _defineProperty(this, "initialChangePassword", void 0);

  _defineProperty(this, "changePassword", void 0);

  _defineProperty(this, "initialSignup", void 0);

  _defineProperty(this, "signup", void 0);

  _defineProperty(this, "deleteAccount", void 0);

  _defineProperty(this, "getChannels", void 0);

  _defineProperty(this, "generateOtp", void 0);

  _defineProperty(this, "verifyOtp", void 0);

  _defineProperty(this, "refreshToken", void 0);

  _defineProperty(this, "sendAuthedOtp", void 0);

  _defineProperty(this, "verifyOtpV2", void 0);

  _defineProperty(this, "verifyAuthedOtp", void 0);

  _defineProperty(this, "initializePhoneAssociation", void 0);

  _defineProperty(this, "verifyPhoneAssociation", void 0);

  _defineProperty(this, "signInCallback", void 0);

  _defineProperty(this, "validateToken", void 0);

  this.signIn = ULRequest.postJson('/ul/api/v1/signin', ulApiOrigin);
  this.initialOtpLogin = ULRequest.getJson('/ul/api/v1/signin/otp', ulApiOrigin);
  this.otpLogin = ULRequest.postJson('/ul/api/v1/signin/otp', ulApiOrigin);
  this.oauth = ULRequest.postJson('/ul/api/v1/oauth', ulApiOrigin);
  this.initialForgotPassword = ULRequest.getJson('/ul/api/v1/forgot-password', ulApiOrigin);
  this.forgotPasswordEmail = ULRequest.postJson('/ul/api/v1/forgot-password/email', ulApiOrigin);
  this.forgotPasswordPhone = ULRequest.postJson('/ul/api/v1/forgot-password/phone', ulApiOrigin);
  this.initialChangePassword = ULRequest.getJson('/ul/api/v1/change-password', ulApiOrigin);
  this.changePassword = ULRequest.postJson('/ul/api/v1/change-password', ulApiOrigin);
  this.initialSignup = ULRequest.getJson('/ul/api/v1/signup', ulApiOrigin);
  this.signup = ULRequest.postJson('/ul/api/v1/signup', ulApiOrigin);
  this.deleteAccount = ULRequest.patchJson('/ul/api/v1/account/delete', ulApiOrigin);
  this.getChannels = ULRequest.getJson('/ul/api/v1/mfa/citi/getChannels', ulApiOrigin);
  this.generateOtp = ULRequest.postJson('/ul/api/v1/mfa/citi/generateOtp', ulApiOrigin);
  this.verifyOtp = ULRequest.postJson('/ul/api/v1/mfa/citi/verifyOtp', ulApiOrigin);
  this.refreshToken = ULRequest.postJson('/partner/token/refresh', ulApiOrigin);

  this.sendAuthedOtp = function (headers) {
    return ULRequest.postJson('/ul/api/v1/otp/sendAuthed', ulApiOrigin)({}, headers);
  };

  this.verifyOtpV2 = ULRequest.postJson('/ul/api/v1/otp/verify', ulApiOrigin);
  this.verifyAuthedOtp = ULRequest.postJson('/ul/api/v1/otp/verifyAuthed', ulApiOrigin);
  this.initializePhoneAssociation = ULRequest.getJson('/ul/api/v1/associate/phone', ulApiOrigin);
  this.verifyPhoneAssociation = ULRequest.postJson('/ul/api/v1/associate/phone', ulApiOrigin);
  this.signInCallback = ULRequest.postJson('/ul/api/v1/signin/callbackAction', ulApiOrigin);
  this.validateToken = ULRequest.postJson('/ul/api/v1/validate/token', ulApiOrigin);
}
/**
 * @inheritdoc
 */
;

var ResponseCode;

(function (ResponseCode) {
  ResponseCode[ResponseCode["Successful"] = 1] = "Successful";
  ResponseCode[ResponseCode["UsernameNotFound"] = 2] = "UsernameNotFound";
  ResponseCode[ResponseCode["InvalidPhoneNumber"] = 3] = "InvalidPhoneNumber";
  ResponseCode[ResponseCode["PasswordIsInCorrect"] = 4] = "PasswordIsInCorrect";
  ResponseCode[ResponseCode["UserLocked"] = 5] = "UserLocked";
  ResponseCode[ResponseCode["NeedCaptcha"] = 7] = "NeedCaptcha";
  ResponseCode[ResponseCode["NeedOtp"] = 8] = "NeedOtp";
  ResponseCode[ResponseCode["CaptchaVerificationFailed"] = 9] = "CaptchaVerificationFailed";
  ResponseCode[ResponseCode["InvalidCredentials"] = 10] = "InvalidCredentials";
  ResponseCode[ResponseCode["OtpVerificationFailed"] = 11] = "OtpVerificationFailed";
  ResponseCode[ResponseCode["UsernameExists"] = 12] = "UsernameExists";
  ResponseCode[ResponseCode["PasswordAlreadyUsed"] = 13] = "PasswordAlreadyUsed";
  ResponseCode[ResponseCode["NeedPhoneAssociation"] = 14] = "NeedPhoneAssociation";
  ResponseCode[ResponseCode["PhoneAssociationFailed"] = 15] = "PhoneAssociationFailed";
  ResponseCode[ResponseCode["DidNotMeetCriteria"] = 16] = "DidNotMeetCriteria";
  ResponseCode[ResponseCode["Unauthenticated"] = 17] = "Unauthenticated";
  ResponseCode[ResponseCode["ErrorOccurred"] = 20] = "ErrorOccurred";
  ResponseCode[ResponseCode["InvalidQueryParameter"] = 21] = "InvalidQueryParameter";
  ResponseCode[ResponseCode["FeatureNotEnabled"] = 22] = "FeatureNotEnabled";
  ResponseCode[ResponseCode["GetPartnerTokenFailed"] = 23] = "GetPartnerTokenFailed";
  ResponseCode[ResponseCode["AllowDeletion"] = 24] = "AllowDeletion";
  ResponseCode[ResponseCode["UpComingBooking"] = 25] = "UpComingBooking";
  ResponseCode[ResponseCode["PastBookingTooRecent"] = 26] = "PastBookingTooRecent";
  ResponseCode[ResponseCode["HasSpecialRole"] = 27] = "HasSpecialRole";
  ResponseCode[ResponseCode["DeletionIncomplete"] = 28] = "DeletionIncomplete";
  ResponseCode[ResponseCode["PartnerClaimTokenNotFound"] = 29] = "PartnerClaimTokenNotFound";
  ResponseCode[ResponseCode["OtpVerificationLimitExceeded"] = 30] = "OtpVerificationLimitExceeded";
  ResponseCode[ResponseCode["OtpNotRequired"] = 36] = "OtpNotRequired";
  ResponseCode[ResponseCode["CouldNotSendEmail"] = 32] = "CouldNotSendEmail";
  ResponseCode[ResponseCode["CouldNotSendOtp"] = 37] = "CouldNotSendOtp";
  ResponseCode[ResponseCode["PhoneAlreadyVerified"] = 38] = "PhoneAlreadyVerified";
  ResponseCode[ResponseCode["MagicLinkSent"] = 39] = "MagicLinkSent";
})(ResponseCode || (ResponseCode = {}));

var OtpType;

(function (OtpType) {
  OtpType["Phone"] = "phone";
  OtpType["Email"] = "email";
  OtpType["Push"] = "push";
  OtpType["Text"] = "text";
  OtpType["EmailAndPush"] = "email_push";
})(OtpType || (OtpType = {}));

var GdprEraseStatus;

(function (GdprEraseStatus) {
  GdprEraseStatus[GdprEraseStatus["Error"] = -1] = "Error";
  GdprEraseStatus[GdprEraseStatus["AllowDeletion"] = 0] = "AllowDeletion";
  GdprEraseStatus[GdprEraseStatus["UpComingBooking"] = 1] = "UpComingBooking";
  GdprEraseStatus[GdprEraseStatus["PastBookingTooRecent"] = 2] = "PastBookingTooRecent";
  GdprEraseStatus[GdprEraseStatus["HasSpecialRole"] = 3] = "HasSpecialRole";
  GdprEraseStatus[GdprEraseStatus["DeletionIncomplete"] = 4] = "DeletionIncomplete";
})(GdprEraseStatus || (GdprEraseStatus = {}));

var OtpChannelStatus;

(function (OtpChannelStatus) {
  OtpChannelStatus["Success"] = "Success";
  OtpChannelStatus["Failure"] = "Failure";
})(OtpChannelStatus || (OtpChannelStatus = {}));

var ResponseAction;

(function (ResponseAction) {
  ResponseAction["Success"] = "success";
  ResponseAction["ForceLogout"] = "forcelogout";
})(ResponseAction || (ResponseAction = {}));

var RefreshTokenService = /*#__PURE__*/function () {
  function RefreshTokenService(currentDomain) {
    _classCallCheck$1(this, RefreshTokenService);

    _defineProperty$2(this, "ulClient", void 0);

    this.ulClient = new ULRequestUniversalLoginApiClient(currentDomain);
  }

  _createClass(RefreshTokenService, [{
    key: "refreshToken",
    value: function () {
      var _refreshToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.ulClient.refreshToken();

              case 3:
                response = _context.sent;

                if (!response.success) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", ResponseAction.Success);

              case 6:
                if (!(!!response.error || response.statusCode === HTTP_UNAUTHORIZED || (response === null || response === void 0 ? void 0 : response.data.responseCode) === ResponseCode.Unauthenticated || (response === null || response === void 0 ? void 0 : response.data.responseCode) === ResponseCode.ErrorOccurred)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", ResponseAction.ForceLogout);

              case 8:
                return _context.abrupt("return", ResponseAction.Success);

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ResponseAction.ForceLogout);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 11]]);
      }));

      function refreshToken() {
        return _refreshToken.apply(this, arguments);
      }

      return refreshToken;
    }()
  }]);

  return RefreshTokenService;
}();

function useRefreshTokenOnTime(config, refreshAt, currentDomain, listener) {
  if (!config.name) config.name = 'refresh-token-timer';
  var refreshTokenService = new RefreshTokenService(currentDomain);

  var _useIdleTimer = $(_objectSpread2$1(_objectSpread2$1({}, config), {}, {
    onMessage: function () {
      var _onMessage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                listener(data);
                _context.t0 = data.action.type;
                _context.next = _context.t0 === CALL_REFRESH ? 4 : _context.t0 === CALL_LOGOUT ? 7 : 9;
                break;

              case 4:
                _context.next = 6;
                return refreshCallHandler(data.action.payload.timerId, data.action.payload.callBack, data.action.payload.callRefreshTokenOnAll, data.action.payload.force);

              case 6:
                return _context.abrupt("break", 9);

              case 7:
                if (otherProps.isLeader()) {
                  dispatch({
                    type: LOGOUT,
                    payload: {
                      timerId: data.action.payload.timerId
                    }
                  }, true);
                }

                return _context.abrupt("break", 9);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function onMessage(_x) {
        return _onMessage.apply(this, arguments);
      }

      return onMessage;
    }(),
    timers: Z
  })),
      message = _useIdleTimer.message,
      otherProps = _objectWithoutProperties(_useIdleTimer, ["message"]);

  function refreshCallHandler(_x2, _x3, _x4, _x5) {
    return _refreshCallHandler.apply(this, arguments);
  }

  function _refreshCallHandler() {
    _refreshCallHandler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(timer, callback, callRefreshTokenOnAll, force) {
      var refreshTokenResponseAction;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(otherProps.isLeader() || force)) {
                _context2.next = 16;
                break;
              }

              _context2.next = 3;
              return refreshTokenService.refreshToken('');

            case 3:
              refreshTokenResponseAction = _context2.sent;
              _context2.t0 = refreshTokenResponseAction;
              _context2.next = _context2.t0 === ResponseAction.Success ? 7 : _context2.t0 === ResponseAction.ForceLogout ? 11 : 13;
              break;

            case 7:
              !callRefreshTokenOnAll && callback();
              dispatch({
                type: REFRESH
              }, true);
              otherProps.reset();
              return _context2.abrupt("break", 16);

            case 11:
              dispatch({
                type: LOGOUT,
                payload: {
                  timerId: timer
                }
              }, true);
              return _context2.abrupt("break", 16);

            case 13:
              !callRefreshTokenOnAll && callback();
              dispatch({
                type: REFRESH
              }, true);
              otherProps.reset();

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _refreshCallHandler.apply(this, arguments);
  }

  var dispatch = createDispatch(message);

  var getRoundElapsedTime = function getRoundElapsedTime() {
    return Math.round(otherProps.getElapsedTime() / 1000) * 1000;
  };

  var canCallRefresh = function canCallRefresh() {
    return getRoundElapsedTime() > refreshAt;
  };

  var showInfo = function showInfo() {
    return {
      elapsedTime: getRoundElapsedTime(),
      isRefreshCallReady: canCallRefresh()
    };
  };

  return _objectSpread2$1({
    dispatch: dispatch,
    canCallRefresh: canCallRefresh,
    showInfo: showInfo
  }, otherProps);
}

var defaultValue$1 = {
  timeout: 30000,
  refreshAt: 28000,
  name: 'refresh-token',
  interval: 1000,
  currentDomain: '',
  onRefreshToken: function onRefreshToken() {},
  onForcedLogout: function onForcedLogout() {},
  onIdlePrompt: function onIdlePrompt() {}
};

function useRefresh() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultValue$1;
  verifyTimerProps(props);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      info = _useState2[0],
      setInfo = _useState2[1];

  var config = baseConfiguration({
    timeout: props.timeout,
    name: props.name
  });

  var _useRefreshTokenOnTim = useRefreshTokenOnTime(config, props.refreshAt, props.currentDomain),
      reset = _useRefreshTokenOnTim.reset,
      canCallRefresh = _useRefreshTokenOnTim.canCallRefresh,
      showInfo = _useRefreshTokenOnTim.showInfo,
      isLeader = _useRefreshTokenOnTim.isLeader;

  useEffect(function () {
    var timer = setInterval(function () {
      setInfo(_objectSpread2$1(_objectSpread2$1({}, showInfo()), {}, {
        isLeader: isLeader()
      }));
      callRefreshCallBackAndReset();
    }, props.interval);
    return function () {
      return clearInterval(timer);
    };
  }, [canCallRefresh, props.interval, reset]);
  return {
    info: info
  };

  function callRefreshCallBackAndReset() {
    if (canCallRefresh()) {
      props.onRefreshToken();
      reset();
    }
  }
}

var isAFunction = function isAFunction(val) {
  return typeof val === 'function';
}; // this listener consume all dispatched method at self and every tab
// if one tab is refreshing all tab will listen and same for log
// if one tab refreshed all tab will re-starts it's timer count


var logoutAndRefreshTimerListener = function logoutAndRefreshTimerListener(props) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
      var _data$action;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if ((_data$action = data.action) === null || _data$action === void 0 ? void 0 : _data$action.type) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", undefined);

            case 2:
              _context.t0 = data.action.type;
              _context.next = _context.t0 === LOGOUT ? 5 : _context.t0 === REFRESH ? 10 : _context.t0 === PROMPTCLOSE ? 14 : 18;
              break;

            case 5:
              _context.next = 7;
              return new Promise(function (r) {
                return setTimeout(r, 0);
              });

            case 7:
              // to delay the event so broadcast won't break
              isAFunction(props.logoutCallback) && props.logoutCallback();
              clearInterval(data.action.payload.timerId);
              return _context.abrupt("break", 19);

            case 10:
              _context.next = 12;
              return new Promise(function (r) {
                return setTimeout(r, 0);
              });

            case 12:
              // to delay the event so broadcast won't break
              isAFunction(props.refreshCallback) && props.refreshCallback();
              return _context.abrupt("break", 19);

            case 14:
              _context.next = 16;
              return new Promise(function (r) {
                return setTimeout(r, 0);
              });

            case 16:
              // to delay the event so broadcast won't break
              isAFunction(props.promptCloseCallback) && props.promptCloseCallback();
              return _context.abrupt("break", 19);

            case 18:
              return _context.abrupt("return", undefined);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var LAST_REFRESH_TIME = 'lastRefreshTime';

var defaultRefreshAt = function defaultRefreshAt(timeout) {
  return timeout * 0.3;
};

var defaultValue$2 = {
  timeout: 1000 * 60 * 10,
  refreshAt: defaultRefreshAt(1000 * 60 * 10),
  idleThreshold: 1000 * 60 * 2,
  promptTimeout: 1000 * 60 * 8,
  name: 'refresh-and-logout-timer',
  interval: 1000 * 30,
  currentDomain: '',
  onRefreshToken: function onRefreshToken() {},
  onForcedLogout: function onForcedLogout() {},
  onIdlePrompt: function onIdlePrompt() {},
  onPromptClose: function onPromptClose() {},
  callRefreshTokenOnAll: false,
  debug: false
};
var timerInfo = null;

var setCurrentTimeToLocalStorage = function setCurrentTimeToLocalStorage(date) {
  localStorage.setItem(LAST_REFRESH_TIME, (date !== null && date !== void 0 ? date : new Date()).toISOString());
};

var clearLocalStorage = function clearLocalStorage() {
  localStorage.removeItem(LAST_REFRESH_TIME);
};

function useRefreshAndLogoutTimer() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultValue$2;
  verifyTimerProps(props);
  var timeout = props.timeout,
      refreshAt = props.refreshAt,
      promptTimeout = props.promptTimeout,
      name = props.name,
      currentDomain = props.currentDomain,
      callRefreshTokenOnAll = props.callRefreshTokenOnAll,
      onRefreshToken = props.onRefreshToken,
      onForcedLogout = props.onForcedLogout,
      onIdlePrompt = props.onIdlePrompt,
      onPromptClose = props.onPromptClose;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      info = _useState2[0],
      setInfo = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      lastRefreshTime = _useState4[0],
      setLastRefreshTime = _useState4[1];

  function onActiveAsync() {
    return _onActiveAsync.apply(this, arguments);
  }

  function _onActiveAsync() {
    _onActiveAsync = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var newLastRefreshTime;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (lastRefreshTime.getTime() + refreshAt <= Date.now()) {
                dispatch({
                  type: CALL_REFRESH,
                  payload: {
                    timerId: timerInfo,
                    callBack: onRefreshTokenCall,
                    callRefreshTokenOnAll: callRefreshTokenOnAll
                  }
                }, true);
                reset();
                newLastRefreshTime = new Date();
                setLastRefreshTime(newLastRefreshTime);
                setCurrentTimeToLocalStorage(newLastRefreshTime);
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _onActiveAsync.apply(this, arguments);
  }

  var refreshConfig = function refreshConfig() {
    return baseConfiguration({
      timeout: promptTimeout,
      name: name + REFRESH,
      onActive: onActiveAsync,
      onPrompt: function onPrompt() {
        callPause();
        onIdlePrompt({
          end: end,
          getRemainingTime: getRemainingTime,
          continue: toContinue
        });
      }
    });
  };

  var logoutConfig = useMemo(function () {
    return baseConfiguration({
      timeout: timeout,
      name: name + LOGOUT
    });
  }, []); // hook look after for logout

  var _useForceLogOutOnTime = useForceLogOutOnTime(logoutConfig),
      isForceLogout = _useForceLogOutOnTime.isForceLogout,
      logoutReset = _useForceLogOutOnTime.activate,
      logoutInfo = _useForceLogOutOnTime.showInfo,
      logoutDispatch = _useForceLogOutOnTime.dispatch;

  var refreshTimerListener = useCallback(logoutAndRefreshTimerListener({
    logoutCallback: onForcedLogoutCall,
    refreshCallback: callRefreshTokenOnAll && onRefreshTokenCall,
    promptCloseCallback: onPromptClose
  }), []); // hook look after for refresh

  var _useRefreshTokenOnTim = useRefreshTokenOnTime(refreshConfig(), refreshAt || defaultRefreshAt(timeout), currentDomain, refreshTimerListener),
      dispatch = _useRefreshTokenOnTim.dispatch,
      reset = _useRefreshTokenOnTim.reset,
      showInfoForRefresh = _useRefreshTokenOnTim.showInfo,
      isLeader = _useRefreshTokenOnTim.isLeader; // try sync last refresh time from local storage


  function syncLastRefreshTimeFromLocalStorage() {
    try {
      var parsedLastRefreshTime = Date.parse(localStorage.getItem(LAST_REFRESH_TIME)); // if last refresh time is valid and last refresh time is not too old

      if (parsedLastRefreshTime && parsedLastRefreshTime + timeout > Date.now()) {
        setLastRefreshTime(new Date(parsedLastRefreshTime));
      } else {
        var newLastRefreshTime = new Date();
        setLastRefreshTime(newLastRefreshTime);
        setCurrentTimeToLocalStorage(newLastRefreshTime);
      }
    } catch (e) {
      var _newLastRefreshTime = new Date();

      setLastRefreshTime(_newLastRefreshTime);
      setCurrentTimeToLocalStorage(_newLastRefreshTime);
    }
  }

  useEffect(syncLastRefreshTimeFromLocalStorage, []);

  function setIntervalLogic() {
    // avoid set more timer when it's got render 1st time and/or getting too old lastRefreshTimer
    if (!lastRefreshTime || lastRefreshTime.getTime() + timeout < Date.now()) {
      return;
    }

    var timer = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var idleInSec, intervalSafety;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              idleInSec = logoutInfo().userIdleFor * 1000;
              intervalSafety = (props.interval || defaultValue$2.interval) / 2;

              if (idleInSec <= (props.idleThreshold || defaultValue$2.idleThreshold) && lastRefreshTime.getTime() + refreshAt - intervalSafety <= Date.now()) {
                callRefresh(timerInfo);
              }

              if (props.debug) {
                setInfo(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, logoutInfo()), showInfoForRefresh()), {}, {
                  isLeader: isLeader()
                }));
              }

              if (isForceLogout() && isLeader()) {
                callLogout(timer);
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), props.interval || defaultValue$2.interval);
    timerInfo = timer;
    return function () {
      clearInterval(timer);
    };
  }

  useEffect(setIntervalLogic, [props.interval, lastRefreshTime]);

  var toContinue = function toContinue() {
    callResume();
    callPromptClose();
    callRefresh(timerInfo, true);
  };

  var end = function end() {
    callLogout(timerInfo);
  };

  var getRemainingTime = function getRemainingTime() {
    var remaingingTime = timeout / 1000 - logoutInfo().userIdleFor;

    if (remaingingTime > 0) {
      return remaingingTime;
    } // close the modal before


    onPromptClose(); // every tab will call by its own so no broadcast for force logout here

    onForcedLogoutCall();
    return 0;
  };

  return {
    info: info,
    lastRefreshTime: lastRefreshTime,
    end: end,
    getRemainingTime: getRemainingTime,
    continue: toContinue
  };

  function callPromptClose() {
    dispatch({
      type: PROMPTCLOSE
    }, true);
  }

  function callLogout(timer) {
    dispatch({
      type: CALL_LOGOUT,
      payload: {
        timerId: timer
      }
    }, true);
  }

  function onRefreshTokenCall() {
    var newLastRefreshTime = new Date();
    setLastRefreshTime(newLastRefreshTime);
    setCurrentTimeToLocalStorage(newLastRefreshTime);
    logoutReset();
    onRefreshToken();
  }

  function onForcedLogoutCall() {
    clearLocalStorage();
    onForcedLogout();
  }

  function callRefresh(timer) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    dispatch({
      type: CALL_REFRESH,
      payload: {
        timerId: timer,
        callBack: onRefreshTokenCall,
        callRefreshTokenOnAll: callRefreshTokenOnAll,
        force: force
      }
    }, true);
  }

  function callResume() {
    logoutDispatch({
      type: RESUME
    }, true);
  }

  function callPause() {
    logoutDispatch({
      type: PAUSE
    }, true);
  }
}

export { useRefresh as a, useRefreshAndLogoutTimer as b, useLogout as u };
